/* eslint-disable */
export default {
  'ALBANIA': 'Z100',
  'ANDORRA': 'Z101',
  'AUSTRIA': 'Z102',
  'BELGIO': 'Z103',
  'BULGARIA': 'Z104',
  'CECOSLOVACCHIA': 'Z105',
  'CITTA\' DEL VATICANO': 'Z106',
  'DANIMARCA': 'Z107',
  'FAER OER (ISOLE)': 'Z108',
  'FINLANDIA': 'Z109',
  'FRANCIA': 'Z110',
  'GERMANIA REPUBBLICA DEMOCRATICA': 'Z111',
  'GERMANIA': 'Z112',
  'GIBILTERRA': 'Z113',
  'GRAN BRETAGNA': 'Z114',
  'GRECIA': 'Z115',
  'IRLANDA=EIRE': 'Z116',
  'ISLANDA': 'Z117',
  'IUGOSLAVIA': 'Z118',
  'LIECHTENSTEIN': 'Z119',
  'LUSSEMBURGO': 'Z120',
  'MALTA': 'Z121',
  'MAN (ISOLA)': 'Z122',
  'MONACO': 'Z123',
  'NORMANNE (ISOLE)=ISOLE DEL CANALE': 'Z124',
  'NORVEGIA': 'Z125',
  'PAESI BASSI': 'Z126',
  'POLONIA': 'Z127',
  'PORTOGALLO': 'Z128',
  'ROMANIA': 'Z129',
  'SAN MARINO': 'Z130',
  'SPAGNA': 'Z131',
  'SVEZIA': 'Z132',
  'SVIZZERA': 'Z133',
  'UNGHERIA': 'Z134',
  'UNIONE REPUBBLICHE SOCIALISTE SOVIETICHE': 'Z135',
  'GEORGIA': 'Z254',
  'ARMENIA': 'Z252',
  'UCRAINA': 'Z138',
  'BIELORUSSIA=RUSSIA BIANCA': 'Z139',
  'MOLDAVIA': 'Z140',
  'AZERBAIGIAN': 'Z253',
  'KIRGHIZISTAN': 'Z256',
  'UZBEKISTAN': 'Z259',
  'ESTONIA': 'Z144',
  'LETTONIA': 'Z145',
  'LITUANIA': 'Z146',
  'TAGIKISTAN': 'Z257',
  'MACEDONIA': 'Z148',
  'CROAZIA': 'Z149',
  'SLOVENIA': 'Z150',
  'TURKEMENISTAN': 'Z258',
  'KAZAKISTAN': 'Z255',
  'BOSNIA ERZEGOVINA': 'Z153',
  'RUSSIA': 'Z154',
  'SLOVACCHIA': 'Z155',
  'CECA REPUBBLICA': 'Z156',
  'SERBIA E MONTENEGRO': 'Z157',
  'SERBIA': 'Z158',
  'MONTENEGRO': 'Z159',
  'KOSOVO': 'Z160',
  'TERRITORI PALESTINESI': 'Z161',
  'AFGHANISTAN': 'Z200',
  'ARABIA MERIDIONALE FEDERAZIONE': 'Z201',
  'ARABIA MERIDIONALE PROTETTORATO': 'Z202',
  'ARABIA SAUDITA': 'Z203',
  'BAHREIN': 'Z204',
  'BHUTAN': 'Z205',
  'BIRMANIA': 'Z206',
  'BRUNEI': 'Z207',
  'CAMBOGIA': 'Z208',
  'SRI LANKA': 'Z209',
  'CINA REPUBBLICA POPOLARE': 'Z210',
  'CIPRO': 'Z211',
  'COCOS (ISOLE)': 'Z212',
  'COREA DEL SUD': 'Z213',
  'COREA DEL NORD': 'Z214',
  'EMIRATI ARABI UNITI': 'Z215',
  'FILIPPINE': 'Z216',
  'REPUBBLICA DELLA CINA NAZIONALE=TAIWAN': 'Z217',
  'GAZA (TERRITORIO DI)': 'Z218',
  'GIAPPONE': 'Z219',
  'GIORDANIA': 'Z220',
  'HONG KONG': 'Z221',
  'INDIA': 'Z222',
  'INDONESIA': 'Z223',
  'IRAN': 'Z224',
  'IRAQ': 'Z225',
  'ISRAELE': 'Z226',
  'KUWAIT': 'Z227',
  'LAOS': 'Z228',
  'LIBANO': 'Z229',
  'MALAYSIA': 'Z247',
  'MACAO': 'Z231',
  'MALDIVE': 'Z232',
  'MONGOLIA': 'Z233',
  'NEPAL': 'Z234',
  'OMAN': 'Z235',
  'PAKISTAN': 'Z236',
  'QATAR': 'Z237',
  'RYUKYU (ISOLE)': 'Z238',
  'SIKKIM': 'Z239',
  'SIRIA': 'Z240',
  'THAILANDIA': 'Z241',
  'TIMOR (ISOLA)': 'Z242',
  'TURCHIA': 'Z243',
  'VIETNAM DEL SUD': 'Z244',
  'VIETNAM DEL NORD': 'Z245',
  'YEMEN': 'Z246',
  'SINGAPORE': 'Z248',
  'BANGLADESH': 'Z249',
  'YEMEN REPUBBLICA DEMOCRATICA POPOLARE': 'Z250',
  'VIETNAM': 'Z251',
  'NAMIBIA': 'Z300',
  'ALGERIA': 'Z301',
  'ANGOLA': 'Z302',
  'BASUTOLAND-SUD AFRICA BRITANNICO': 'Z303',
  'BECIUANIA-SUD AFRICA BRITANNICO': 'Z304',
  'BURUNDI': 'Z305',
  'CAMERUN': 'Z306',
  'CAPO VERDE': 'Z307',
  'CENTRAFRICANA REPUBBLICA': 'Z308',
  'CIAD': 'Z309',
  'COMORE': 'Z310',
  'CONGO REPUBBLICA POPOLARE': 'Z311',
  'CONGO REPUBBLICA DEMOCRATICA': 'Z312',
  'COSTA D\'AVORIO': 'Z313',
  'BENIN': 'Z314',
  'ETIOPIA': 'Z315',
  'GABON': 'Z316',
  'GAMBIA': 'Z317',
  'GHANA': 'Z318',
  'GUINEA': 'Z319',
  'GUINEA BISSAU': 'Z320',
  'GUINEA EQUATORIALE': 'Z321',
  'KENYA': 'Z322',
  'IFNI': 'Z323',
  'LA REUNION (ISOLA)': 'Z324',
  'LIBERIA': 'Z325',
  'LIBIA': 'Z326',
  'MADAGASCAR': 'Z327',
  'MALAWI': 'Z328',
  'MALI': 'Z329',
  'MAROCCO': 'Z330',
  'MAURITANIA': 'Z331',
  'MAURIZIO': 'Z332',
  'MOZAMBICO': 'Z333',
  'NIGER': 'Z334',
  'NIGERIA': 'Z335',
  'EGITTO': 'Z336',
  'ZIMBABWE': 'Z337',
  'RUANDA': 'Z338',
  'SAHARA SPAGNOLO': 'Z339',
  'SANT\'ELENA (ISOLA)': 'Z340',
  'SAO TOME\' E PRINCIPE': 'Z341',
  'SEICELLE': 'Z342',
  'SENEGAL': 'Z343',
  'SIERRA LEONE': 'Z344',
  'SOMALIA': 'Z345',
  'TERRITORIO FRANCESE DEGLI AFAR E DEGLI ISSA': 'Z346',
  'SUD AFRICA': 'Z347',
  'SUDAN': 'Z348',
  'SWAZILAND': 'Z349',
  'TANGANICA': 'Z350',
  'TOGO': 'Z351',
  'TUNISIA': 'Z352',
  'UGANDA': 'Z353',
  'BURKINA': 'Z354',
  'ZAMBIA': 'Z355',
  'ZANZIBAR': 'Z356',
  'TANZANIA': 'Z357',
  'BOTSWANA': 'Z358',
  'LESOTHO': 'Z359',
  'MAYOTTE (ISOLA)': 'Z360',
  'GIBUTI': 'Z361',
  'SAHARA MERIDIONALE': 'Z362',
  'SAHARA SETTENTRIONALE': 'Z363',
  'BOPHUTHATSWANA': 'Z364',
  'TRANSKEI': 'Z365',
  'VENDA': 'Z366',
  'CISKEI': 'Z367',
  'ERITREA': 'Z368',
  'NYASALAND': 'Z369',
  'CONGO BELGA': 'Z370',
  'BERMUDA (ISOLE)': 'Z400',
  'CANADA': 'Z401',
  'GROENLANDIA': 'Z402',
  'SAINT PIERRE ET MIQUELON (ISOLE)': 'Z403',
  'STATI UNITI D\'AMERICA': 'Z404',
  'ANTILLE BRITANNICHE': 'Z523',
  'ANTILLE OLANDESI': 'Z501',
  'BAHAMA': 'Z502',
  'COSTA RICA': 'Z503',
  'CUBA': 'Z504',
  'REPUBBLICA DOMINICANA': 'Z505',
  'EL SALVADOR': 'Z506',
  'GIAMAICA': 'Z507',
  'GUADALUPA': 'Z508',
  'GUATEMALA': 'Z509',
  'HAITI': 'Z510',
  'HONDURAS': 'Z511',
  'BELIZE': 'Z512',
  'MARTINICA': 'Z513',
  'MESSICO': 'Z514',
  'NICARAGUA': 'Z515',
  'PANAMA\'': 'Z516',
  'PANAMA ZONA DEL CANALE': 'Z517',
  'PUERTO RICO': 'Z518',
  'TURKS E CAICOS (ISOLE)': 'Z519',
  'VERGINI AMERICANE (ISOLE)': 'Z520',
  'BARBADOS': 'Z522',
  'GRENADA': 'Z524',
  'VERGINI BRITANNICHE (ISOLE)': 'Z525',
  'DOMINICA': 'Z526',
  'SAINT LUCIA': 'Z527',
  'SAINT VINCENT E GRENADINE': 'Z528',
  'ANGUILLA (ISOLA)': 'Z529',
  'CAYMAN (ISOLE)': 'Z530',
  'MONTSERRAT': 'Z531',
  'ANTIGUA E BARBUDA': 'Z532',
  'SAINT KITTS E NEVIS=SAINT CHRISTOPHER E NEVIS': 'Z533',
  'ARGENTINA': 'Z600',
  'BOLIVIA': 'Z601',
  'BRASILE': 'Z602',
  'CILE': 'Z603',
  'COLOMBIA': 'Z604',
  'ECUADOR': 'Z605',
  'GUYANA': 'Z606',
  'GUAYANA=GUIANA FRANCESE': 'Z607',
  'SURINAME': 'Z608',
  'MALVINE=FALKLAND (ISOLE)': 'Z609',
  'PARAGUAY': 'Z610',
  'PERU\'': 'Z611',
  'TRINIDAD E TOBAGO': 'Z612',
  'URUGUAY': 'Z613',
  'VENEZUELA': 'Z614',
  'AUSTRALIA': 'Z700',
  'CAROLINE (ISOLE)=STATI FEDERATI DI MICRONESIA': 'Z701',
  'CHRISTMAS (ISOLA)': 'Z702',
  'COOK (ISOLE)': 'Z703',
  'FIGI=VITI': 'Z704',
  'GILBERT E ELLICE (ISOLE)': 'Z705',
  'GUAM (ISOLA)': 'Z706',
  'IRIAN OCCIDENTALE': 'Z707',
  'MACQUARIE (ISOLE)': 'Z708',
  'MARCUS (ISOLE)': 'Z709',
  'MARIANNE (ISOLE)': 'Z710',
  'MARSHALL': 'Z711',
  'MIDWAY (ISOLE)': 'Z712',
  'NAURU': 'Z713',
  'NIUE=SAVAGE (ISOLE)': 'Z714',
  'NORFOLK (ISOLE E ISOLE DEL MAR DEI CORALLI)': 'Z715',
  'NUOVA CALEDONIA (ISOLE E DIPENDENZE)': 'Z716',
  'NUOVE EBRIDI (ISOLE CONDOMINIO FRANCO-INGLESE)': 'Z717',
  'NUOVA GUINEA': 'Z718',
  'NUOVA ZELANDA': 'Z719',
  'PAPUASIA': 'Z720',
  'ISOLE CILENE (PASQUA E SALA Y GOMEZ)': 'Z721',
  'PITCAIRN (E DIPENDENZE)': 'Z722',
  'POLINESIA FRANCESE (ISOLE)': 'Z723',
  'SALOMONE': 'Z724',
  'SAMOA AMERICANE (ISOLE)': 'Z725',
  'SAMOA': 'Z726',
  'TOKELAU=ISOLE DELL\'UNIONE': 'Z727',
  'TONGA=ISOLE DEGLI AMICI': 'Z728',
  'WALLIS E FUTUNA (ISOLE)': 'Z729',
  'PAPUA NUOVA GUINEA': 'Z730',
  'KIRIBATI': 'Z731',
  'TUVALU': 'Z732',
  'VANUATU': 'Z733',
  'PALAU': 'G258',
  'MICRONESIA STATI FEDERATI': 'Z735',
  'DIPENDENZE CANADESI': 'Z800',
  'DIPENDENZE NORVEGESI ARTICHE': 'Z801',
  'DIPENDENZE RUSSE': 'Z802',
  'DIPENDENZE AUSTRALIANE': 'Z900',
  'DIPENDENZE BRITANNICHE': 'Z901',
  'DIPENDENZE FRANCESI': 'Z902',
  'DIPENDENZE NEOZELANDESI': 'Z903',
  'DIPENDENZE NORVEGESI ANTARTICHE': 'Z904',
  'DIPENDENZE STATUNITENSI': 'Z905',
  'DIPENDENZE SUDAFRICANE': 'Z906',
  'ABANO TERME': 'A001',
  'ABBADIA CERRETO': 'A004',
  'ABBADIA LARIANA': 'A005',
  'ABBADIA SAN SALVATORE': 'A006',
  'ABBASANTA': 'A007',
  'ABBATEGGIO': 'A008',
  'ABBIATEGRASSO': 'A010',
  'ABETONE': 'A012',
  'ABRIOLA': 'A013',
  'ACATE': 'A014',
  'ACCADIA': 'A015',
  'ACCEGLIO': 'A016',
  'ACCETTURA': 'A017',
  'ACCIANO': 'A018',
  'ACCUMOLI': 'A019',
  'ACERENZA': 'A020',
  'CERMES-TSCHERMS': 'A022',
  'ACERNO': 'A023',
  'ACERRA': 'A024',
  'ACI BONACCORSI': 'A025',
  'ACI CASTELLO': 'A026',
  'ACI CATENA': 'A027',
  'ACIREALE': 'A028',
  'ACI SANT\'ANTONIO': 'A029',
  'ACQUACANINA': 'A031',
  'ACQUAFONDATA': 'A032',
  'ACQUAFORMOSA': 'A033',
  'ACQUAFREDDA': 'A034',
  'ACQUALAGNA': 'A035',
  'ACQUANEGRA SUL CHIESE': 'A038',
  'ACQUANEGRA CREMONESE': 'A039',
  'ACQUAPENDENTE': 'A040',
  'ACQUAPPESA': 'A041',
  'ACQUARICA DEL CAPO': 'A042',
  'ACQUARO': 'A043',
  'ACQUASANTA TERME': 'A044',
  'ACQUASPARTA': 'A045',
  'ACQUAVIVA PICENA': 'A047',
  'ACQUAVIVA DELLE FONTI': 'A048',
  'ACQUAVIVA PLATANI': 'A049',
  'ACQUAVIVA COLLECROCE': 'A050',
  'ACQUAVIVA D\'ISERNIA': 'A051',
  'ACQUI TERME': 'A052',
  'ACRI': 'A053',
  'ACUTO': 'A054',
  'ADELFIA': 'A055',
  'ADRANO': 'A056',
  'ADRARA SAN MARTINO': 'A057',
  'ADRARA SAN ROCCO': 'A058',
  'ADRIA': 'A059',
  'ADRO': 'A060',
  'AFFI': 'A061',
  'AFFILE': 'A062',
  'AFRAGOLA': 'A064',
  'AFRICO': 'A065',
  'AGAZZANO': 'A067',
  'AGEROLA': 'A068',
  'AGGIUS': 'A069',
  'AGIRA': 'A070',
  'AGLIANA': 'A071',
  'AGLIANO TERME': 'A072',
  'AGLIE\'': 'A074',
  'AGNA': 'A075',
  'AGNADELLO': 'A076',
  'AGNANA CALABRA': 'A077',
  'AGNONE': 'A080',
  'VILLA LATINA': 'A081',
  'AGNOSINE': 'A082',
  'AGORDO': 'A083',
  'AGOSTA': 'A084',
  'AGRA': 'A085',
  'AGRATE BRIANZA': 'A087',
  'AGRATE CONTURBIA': 'A088',
  'AGRIGENTO': 'A089',
  'AGROPOLI': 'A091',
  'AGUGLIANO': 'A092',
  'AGUGLIARO': 'A093',
  'AYAS': 'A094',
  'AICURZIO': 'A096',
  'AIDOMAGGIORE': 'A097',
  'AIDONE': 'A098',
  'AIELLI': 'A100',
  'AIELLO DEL SABATO': 'A101',
  'AIELLO CALABRO': 'A102',
  'AIELLO DEL FRIULI': 'A103',
  'AIETA': 'A105',
  'AILANO': 'A106',
  'AILOCHE': 'A107',
  'AYMAVILLES': 'A108',
  'AIRASCA': 'A109',
  'AIROLA': 'A110',
  'AIROLE': 'A111',
  'AIRUNO': 'A112',
  'AISONE': 'A113',
  'ALA\' DEI SARDI': 'A115',
  'ALA': 'A116',
  'ALA DI STURA': 'A117',
  'ALAGNA': 'A118',
  'ALAGNA VALSESIA': 'A119',
  'ALANNO': 'A120',
  'ALANO DI PIAVE': 'A121',
  'ALASSIO': 'A122',
  'ALATRI': 'A123',
  'ALBA': 'A124',
  'ALBA ADRIATICA': 'A125',
  'ALBAGIARA': 'A126',
  'ALBAIRATE': 'A127',
  'ALBANELLA': 'A128',
  'ALBANO SANT\'ALESSANDRO': 'A129',
  'ALBANO VERCELLESE': 'A130',
  'ALBANO DI LUCANIA': 'A131',
  'ALBANO LAZIALE': 'A132',
  'ALBAREDO ARNABOLDI': 'A134',
  'ALBAREDO PER SAN MARCO': 'A135',
  'ALBAREDO D\'ADIGE': 'A137',
  'ALBARETO': 'A138',
  'ALBARETTO DELLA TORRE': 'A139',
  'ALBAVILLA': 'A143',
  'ALBENGA': 'A145',
  'ALBERA LIGURE': 'A146',
  'ALBEROBELLO': 'A149',
  'ALBERONA': 'A150',
  'ALBESE CON CASSANO': 'A153',
  'ALBETTONE': 'A154',
  'ALBI': 'A155',
  'ALBIANO D\'IVREA': 'A157',
  'ALBIANO': 'A158',
  'ALBIATE': 'A159',
  'ALBIDONA': 'A160',
  'ALBIGNASEGO': 'A161',
  'ALBINEA': 'A162',
  'ALBINO': 'A163',
  'ALBIOLO': 'A164',
  'ALBISSOLA MARINA': 'A165',
  'ALBISOLA SUPERIORE': 'A166',
  'ALBIZZATE': 'A167',
  'ALBONESE': 'A171',
  'ALBOSAGGIA': 'A172',
  'ALBUGNANO': 'A173',
  'ALBUZZANO': 'A175',
  'ALCAMO': 'A176',
  'ALCARA LI FUSI': 'A177',
  'ALDENO': 'A178',
  'ALDINO * ALDEIN': 'A179',
  'ALES': 'A180',
  'ALESSANDRIA DELLA ROCCA': 'A181',
  'ALESSANDRIA': 'A182',
  'ALESSANDRIA DEL CARRETTO': 'A183',
  'ALESSANO': 'A184',
  'ALEZIO': 'A185',
  'ALFANO': 'A186',
  'ALFEDENA': 'A187',
  'ALFIANELLO': 'A188',
  'ALFIANO NATTA': 'A189',
  'ALFONSINE': 'A191',
  'ALGHERO': 'A192',
  'ALGUA': 'A193',
  'ALI\'': 'A194',
  'ALIA': 'A195',
  'ALIANO': 'A196',
  'ALICE BEL COLLE': 'A197',
  'ALICE CASTELLO': 'A198',
  'ALICE SUPERIORE': 'A199',
  'ALIFE': 'A200',
  'ALI\' TERME': 'A201',
  'ALIMENA': 'A202',
  'ALIMINUSA': 'A203',
  'ALLAI': 'A204',
  'ALLEIN': 'A205',
  'ALLEGHE': 'A206',
  'ALLERONA': 'A207',
  'ALLISTE': 'A208',
  'ALLUMIERE': 'A210',
  'ALLUVIONI CAMBIO\'': 'A211',
  'ALME\'': 'A214',
  'VILLA D\'ALME\'': 'A215',
  'ALMENNO SAN BARTOLOMEO': 'A216',
  'ALMENNO SAN SALVATORE': 'A217',
  'ALMESE': 'A218',
  'ALONTE': 'A220',
  'ALPETTE': 'A221',
  'ALPIGNANO': 'A222',
  'ALSENO': 'A223',
  'ALSERIO': 'A224',
  'ALTAMURA': 'A225',
  'ALTARE': 'A226',
  'ALTAVILLA MONFERRATO': 'A227',
  'ALTAVILLA IRPINA': 'A228',
  'ALTAVILLA MILICIA': 'A229',
  'ALTAVILLA SILENTINA': 'A230',
  'ALTAVILLA VICENTINA': 'A231',
  'ALTIDONA': 'A233',
  'ALTILIA': 'A234',
  'ALTINO': 'A235',
  'ALTISSIMO': 'A236',
  'ALTIVOLE': 'A237',
  'ALTO': 'A238',
  'ALTOFONTE': 'A239',
  'ALTOMONTE': 'A240',
  'ALTOPASCIO': 'A241',
  'ALVIANO': 'A242',
  'ALVIGNANO': 'A243',
  'ALVITO': 'A244',
  'ALZANO SCRIVIA': 'A245',
  'ALZANO LOMBARDO': 'A246',
  'ALZATE BRIANZA': 'A249',
  'AMALFI': 'A251',
  'AMANDOLA': 'A252',
  'AMANTEA': 'A253',
  'AMARO': 'A254',
  'AMARONI': 'A255',
  'AMASENO': 'A256',
  'AMATO': 'A257',
  'AMATRICE': 'A258',
  'AMBIVERE': 'A259',
  'AMBLAR': 'A260',
  'AMEGLIA': 'A261',
  'AMELIA': 'A262',
  'AMENDOLARA': 'A263',
  'AMENO': 'A264',
  'AMOROSI': 'A265',
  'CORTINA D\'AMPEZZO': 'A266',
  'AMPEZZO': 'A267',
  'ANACAPRI': 'A268',
  'ANAGNI': 'A269',
  'ANCARANO': 'A270',
  'ANCONA': 'A271',
  'ANDALI': 'A272',
  'ANDALO VALTELLINO': 'A273',
  'ANDALO': 'A274',
  'ANDEZENO': 'A275',
  'ANDORA': 'A278',
  'ANDORNO MICCA': 'A280',
  'ANDRANO': 'A281',
  'ANDRATE': 'A282',
  'ANDREIS': 'A283',
  'ANDRETTA': 'A284',
  'ANDRIA': 'A285',
  'ANDRIANO * ANDRIAN': 'A286',
  'ANELA': 'A287',
  'ANFO': 'A288',
  'ANGERA': 'A290',
  'ANGHIARI': 'A291',
  'ANGIARI': 'A292',
  'ANGOLO TERME': 'A293',
  'ANGRI': 'A294',
  'ANGROGNA': 'A295',
  'ANGUILLARA VENETA': 'A296',
  'ANGUILLARA SABAZIA': 'A297',
  'ANNICCO': 'A299',
  'CASTELLO DI ANNONE': 'A300',
  'ANNONE DI BRIANZA': 'A301',
  'ANNONE VENETO': 'A302',
  'ANOIA': 'A303',
  'ANTEGNATE': 'A304',
  'ANTEY-SAINT-ANDRE\'': 'A305',
  'ANTERIVO * ALTREI': 'A306',
  'LA MAGDELEINE': 'A308',
  'ANTICOLI CORRADO': 'A309',
  'FIUGGI': 'A310',
  'ANTIGNANO': 'A312',
  'ANTILLO': 'A313',
  'ANTONIMINA': 'A314',
  'ANTRODOCO': 'A315',
  'ANTRONA SCHIERANCO': 'A317',
  'ANVERSA DEGLI ABRUZZI': 'A318',
  'ANZANO DEL PARCO': 'A319',
  'ANZANO DI PUGLIA': 'A320',
  'ANZI': 'A321',
  'ANZIO': 'A323',
  'ANZOLA DELL\'EMILIA': 'A324',
  'ANZOLA D\'OSSOLA': 'A325',
  'AOSTA': 'A326',
  'APECCHIO': 'A327',
  'APICE': 'A328',
  'APIRO': 'A329',
  'APOLLOSA': 'A330',
  'APPIANO SULLA STRADA DEL VINO * EPPAN AN DER WEINSTRASSE': 'A332',
  'APPIANO GENTILE': 'A333',
  'APPIGNANO': 'A334',
  'APPIGNANO DEL TRONTO': 'A335',
  'APRICA': 'A337',
  'APRICALE': 'A338',
  'APRICENA': 'A339',
  'APRIGLIANO': 'A340',
  'APRILIA': 'A341',
  'AQUARA': 'A343',
  'AQUILA D\'ARROSCIA': 'A344',
  'L\'AQUILA': 'A345',
  'AQUILEIA': 'A346',
  'AQUILONIA': 'A347',
  'AQUINO': 'A348',
  'ARADEO': 'A350',
  'ARAGONA': 'A351',
  'ARAMENGO': 'A352',
  'ARBA': 'A354',
  'TORTOLI\'': 'A355',
  'ARBOREA': 'A357',
  'ARBORIO': 'A358',
  'ARBUS': 'A359',
  'ARCADE': 'A360',
  'ARCE': 'A363',
  'ARCENE': 'A365',
  'ARCEVIA': 'A366',
  'ARCHI': 'A367',
  'SAN NICOLO\' D\'ARCIDANO': 'A368',
  'ARCIDOSSO': 'A369',
  'ARCINAZZO ROMANO': 'A370',
  'ARCISATE': 'A371',
  'ARCO': 'A372',
  'ARCOLA': 'A373',
  'ARCOLE': 'A374',
  'ARCONATE': 'A375',
  'ARCORE': 'A376',
  'ARCUGNANO': 'A377',
  'ARDARA': 'A379',
  'ARDAULI': 'A380',
  'ARDENNO': 'A382',
  'ARDESIO': 'A383',
  'ARDORE': 'A385',
  'ARENA': 'A386',
  'ARENA PO': 'A387',
  'ARENZANO': 'A388',
  'ARESE': 'A389',
  'AREZZO': 'A390',
  'ARGEGNO': 'A391',
  'ARGELATO': 'A392',
  'ARGENTA': 'A393',
  'ARGENTERA': 'A394',
  'ARGUELLO': 'A396',
  'ARGUSTO': 'A397',
  'ARI': 'A398',
  'ARIANO IRPINO': 'A399',
  'ARIANO NEL POLESINE': 'A400',
  'ARICCIA': 'A401',
  'ARIELLI': 'A402',
  'ARIENZO': 'A403',
  'ARIGNANO': 'A405',
  'ARITZO': 'A407',
  'ARIZZANO': 'A409',
  'ARLENA DI CASTRO': 'A412',
  'ARLUNO': 'A413',
  'ARMENO': 'A414',
  'ARMENTO': 'A415',
  'ARMO': 'A417',
  'ARMUNGIA': 'A419',
  'ARNARA': 'A421',
  'ARNASCO': 'A422',
  'ARNAD': 'A424',
  'ARNESANO': 'A425',
  'AROLA': 'A427',
  'ARONA': 'A429',
  'AROSIO': 'A430',
  'ARPAIA': 'A431',
  'ARPAISE': 'A432',
  'ARPINO': 'A433',
  'ARQUA\' PETRARCA': 'A434',
  'ARQUA\' POLESINE': 'A435',
  'ARQUATA SCRIVIA': 'A436',
  'ARQUATA DEL TRONTO': 'A437',
  'ARRE': 'A438',
  'ARRONE': 'A439',
  'ARZAGO D\'ADDA': 'A440',
  'ARSAGO SEPRIO': 'A441',
  'ARSIE\'': 'A443',
  'ARSIERO': 'A444',
  'ARSITA': 'A445',
  'ARSOLI': 'A446',
  'ARTA TERME': 'A447',
  'ARTEGNA': 'A448',
  'ARTENA': 'A449',
  'ARTOGNE': 'A451',
  'ARVIER': 'A452',
  'ARZACHENA': 'A453',
  'ARZANA': 'A454',
  'ARZANO': 'A455',
  'ARZENE': 'A456',
  'ARZERGRANDE': 'A458',
  'ARZIGNANO': 'A459',
  'ASCEA': 'A460',
  'ASCIANO': 'A461',
  'ASCOLI PICENO': 'A462',
  'ASCOLI SATRIANO': 'A463',
  'ASCREA': 'A464',
  'ASIAGO': 'A465',
  'ASIGLIANO VERCELLESE': 'A466',
  'ASIGLIANO VENETO': 'A467',
  'SINALUNGA': 'A468',
  'ASOLA': 'A470',
  'ASOLO': 'A471',
  'CASPERIA': 'A472',
  'ASSAGO': 'A473',
  'ASSEMINI': 'A474',
  'ASSISI': 'A475',
  'ASSO': 'A476',
  'ASSOLO': 'A477',
  'ASSORO': 'A478',
  'ASTI': 'A479',
  'ASUNI': 'A480',
  'ATELETA': 'A481',
  'ATELLA': 'A482',
  'ATENA LUCANA': 'A484',
  'ATESSA': 'A485',
  'ATINA': 'A486',
  'ATRANI': 'A487',
  'ATRI': 'A488',
  'ATRIPALDA': 'A489',
  'ATTIGLIANO': 'A490',
  'ATTIMIS': 'A491',
  'ATZARA': 'A492',
  'AUDITORE': 'A493',
  'AUGUSTA': 'A494',
  'AULETTA': 'A495',
  'AULLA': 'A496',
  'AURANO': 'A497',
  'AURIGO': 'A499',
  'AURONZO DI CADORE': 'A501',
  'AUSONIA': 'A502',
  'AUSTIS': 'A503',
  'AVEGNO': 'A506',
  'AVELENGO * HAFLING': 'A507',
  'AVELLA': 'A508',
  'AVELLINO': 'A509',
  'AVERARA': 'A511',
  'AVERSA': 'A512',
  'AVETRANA': 'A514',
  'AVEZZANO': 'A515',
  'AVIANO': 'A516',
  'AVIATICO': 'A517',
  'AVIGLIANA': 'A518',
  'AVIGLIANO': 'A519',
  'AVIO': 'A520',
  'AVISE': 'A521',
  'AVOLA': 'A522',
  'AVOLASCA': 'A523',
  'AZEGLIO': 'A525',
  'AZZANELLO': 'A526',
  'AZZANO D\'ASTI': 'A527',
  'AZZANO SAN PAOLO': 'A528',
  'AZZANO MELLA': 'A529',
  'AZZANO DECIMO': 'A530',
  'AZZATE': 'A531',
  'AZZIO': 'A532',
  'AZZONE': 'A533',
  'BACENO': 'A534',
  'BACOLI': 'A535',
  'BADALUCCO': 'A536',
  'BADIA * ABTEI': 'A537',
  'BADIA PAVESE': 'A538',
  'BADIA POLESINE': 'A539',
  'BADIA CALAVENA': 'A540',
  'BADIA TEDALDA': 'A541',
  'BADOLATO': 'A542',
  'BAGALADI': 'A544',
  'BAGHERIA': 'A546',
  'BAGNACAVALLO': 'A547',
  'BAGNARIA': 'A550',
  'BAGNARA DI ROMAGNA': 'A551',
  'BAGNARA CALABRA': 'A552',
  'BAGNARIA ARSA': 'A553',
  'BAGNASCO': 'A555',
  'BAGNATICA': 'A557',
  'PORRETTA TERME': 'A558',
  'CASCIANA TERME': 'A559',
  'BAGNI DI LUCCA': 'A560',
  'MONTECATINI-TERME': 'A561',
  'SAN GIULIANO TERME': 'A562',
  'BAGNO A RIPOLI': 'A564',
  'BAGNO DI ROMAGNA': 'A565',
  'BAGNOLI IRPINO': 'A566',
  'BAGNOLI DEL TRIGNO': 'A567',
  'BAGNOLI DI SOPRA': 'A568',
  'BAGNOLO MELLA': 'A569',
  'BAGNOLO CREMASCO': 'A570',
  'BAGNOLO PIEMONTE': 'A571',
  'BAGNOLO DEL SALENTO': 'A572',
  'BAGNOLO IN PIANO': 'A573',
  'BAGNOLO DI PO': 'A574',
  'BAGNOLO SAN VITO': 'A575',
  'BAGNONE': 'A576',
  'BAGNOREGIO': 'A577',
  'BAGOLINO': 'A578',
  'BAIA E LATINA': 'A579',
  'BAIANO': 'A580',
  'BAIARDO': 'A581',
  'BAIRO': 'A584',
  'BAISO': 'A586',
  'BALANGERO': 'A587',
  'BALDICHIERI D\'ASTI': 'A588',
  'BALDISSERO D\'ALBA': 'A589',
  'BALDISSERO CANAVESE': 'A590',
  'BALDISSERO TORINESE': 'A591',
  'BALESTRATE': 'A592',
  'BALESTRINO': 'A593',
  'BALLABIO': 'A594',
  'BALLAO': 'A597',
  'BALME': 'A599',
  'BALMUCCIA': 'A600',
  'BALOCCO': 'A601',
  'BALSORANO': 'A603',
  'BALVANO': 'A604',
  'BALZOLA': 'A605',
  'BANARI': 'A606',
  'BANCHETTE': 'A607',
  'VILLA VERDE': 'A609',
  'BANNIO ANZINO': 'A610',
  'BANZI': 'A612',
  'BAONE': 'A613',
  'BARADILI': 'A614',
  'BARAGIANO': 'A615',
  'BARANELLO': 'A616',
  'BARANO D\'ISCHIA': 'A617',
  'BARANZATE': 'A618',
  'BARASSO': 'A619',
  'BARATILI SAN PIETRO': 'A621',
  'BARBANIA': 'A625',
  'BARBARA': 'A626',
  'BARBARANO VICENTINO': 'A627',
  'BARBARANO ROMANO': 'A628',
  'BARBARESCO': 'A629',
  'BARBARIGA': 'A630',
  'BARBATA': 'A631',
  'BARBERINO DI MUGELLO': 'A632',
  'BARBERINO VAL D\'ELSA': 'A633',
  'BARBIANELLO': 'A634',
  'BARBIANO * BARBIAN': 'A635',
  'BARBONA': 'A637',
  'BARCELLONA POZZO DI GOTTO': 'A638',
  'BARCHI': 'A639',
  'BARCIS': 'A640',
  'BARD': 'A643',
  'BARDELLO': 'A645',
  'BARDI': 'A646',
  'BARDINETO': 'A647',
  'BARDOLINO': 'A650',
  'BARDONECCHIA': 'A651',
  'BAREGGIO': 'A652',
  'BARENGO': 'A653',
  'BARESSA': 'A655',
  'BARETE': 'A656',
  'BARGA': 'A657',
  'BARGAGLI': 'A658',
  'BARGE': 'A660',
  'BARGHE': 'A661',
  'BARI': 'A662',
  'BARI SARDO': 'A663',
  'BARIANO': 'A664',
  'BARICELLA': 'A665',
  'BARILE': 'A666',
  'BARISCIANO': 'A667',
  'BARLASSINA': 'A668',
  'BARLETTA': 'A669',
  'BARNI': 'A670',
  'BAROLO': 'A671',
  'BARONE CANAVESE': 'A673',
  'BARONISSI': 'A674',
  'BARRAFRANCA': 'A676',
  'BARRALI': 'A677',
  'BARREA': 'A678',
  'BARUMINI': 'A681',
  'BARZAGO': 'A683',
  'BARZANA': 'A684',
  'BARZANO\'': 'A686',
  'BARZIO': 'A687',
  'BASALUZZO': 'A689',
  'BASCAPE\'': 'A690',
  'BASCHI': 'A691',
  'BASCIANO': 'A692',
  'BASELGA DI PINE\'': 'A694',
  'BASELICE': 'A696',
  'BASIANO': 'A697',
  'BASICO\'': 'A698',
  'BASIGLIO': 'A699',
  'BASILIANO': 'A700',
  'VASANELLO': 'A701',
  'BASSANO BRESCIANO': 'A702',
  'BASSANO DEL GRAPPA': 'A703',
  'BASSANO ROMANO': 'A704',
  'TRONZANO LAGO MAGGIORE': 'A705',
  'BASSANO IN TEVERINA': 'A706',
  'BASSIANO': 'A707',
  'BASSIGNANA': 'A708',
  'BASTIA MONDOVI\'': 'A709',
  'BASTIA UMBRA': 'A710',
  'BASTIDA DE\' DOSSI': 'A711',
  'BASTIDA PANCARANA': 'A712',
  'BASTIGLIA': 'A713',
  'BATTAGLIA TERME': 'A714',
  'BATTIFOLLO': 'A716',
  'BATTIPAGLIA': 'A717',
  'BATTUDA': 'A718',
  'BAUCINA': 'A719',
  'BOVILLE ERNICA': 'A720',
  'BAULADU': 'A721',
  'BAUNEI': 'A722',
  'BAVENO': 'A725',
  'BAZZANO': 'A726',
  'BEDERO VALCUVIA': 'A728',
  'BEDIZZOLE': 'A729',
  'BEDOLLO': 'A730',
  'BEDONIA': 'A731',
  'BEDULITA': 'A732',
  'BEE': 'A733',
  'BEINASCO': 'A734',
  'BEINETTE': 'A735',
  'BELCASTRO': 'A736',
  'BELFIORE': 'A737',
  'BELFORTE MONFERRATO': 'A738',
  'BELFORTE DEL CHIENTI': 'A739',
  'BELFORTE ALL\'ISAURO': 'A740',
  'BELGIOIOSO': 'A741',
  'BELGIRATE': 'A742',
  'BELLA': 'A743',
  'BELLAGIO': 'A744',
  'BELLANO': 'A745',
  'BELLANTE': 'A746',
  'BELLARIA-IGEA MARINA': 'A747',
  'BELLEGRA': 'A749',
  'BELLINO': 'A750',
  'BELLINZAGO LOMBARDO': 'A751',
  'BELLINZAGO NOVARESE': 'A752',
  'BELLONA': 'A755',
  'BELLOSGUARDO': 'A756',
  'BELLUNO': 'A757',
  'BELLUSCO': 'A759',
  'BELMONTE PICENO': 'A760',
  'BELMONTE DEL SANNIO': 'A761',
  'BELMONTE CALABRO': 'A762',
  'BELMONTE CASTELLO': 'A763',
  'BELMONTE MEZZAGNO': 'A764',
  'BELMONTE IN SABINA': 'A765',
  'BELPASSO': 'A766',
  'BELSITO': 'A768',
  'BELVEDERE OSTRENSE': 'A769',
  'BELVEGLIO': 'A770',
  'LIZZANO IN BELVEDERE': 'A771',
  'BELVEDERE DI SPINELLO': 'A772',
  'BELVEDERE MARITTIMO': 'A773',
  'BELVEDERE LANGHE': 'A774',
  'BELVI': 'A776',
  'BEMA': 'A777',
  'BENE LARIO': 'A778',
  'BENE VAGIENNA': 'A779',
  'BENESTARE': 'A780',
  'BENETUTTI': 'A781',
  'BENEVELLO': 'A782',
  'BENEVENTO': 'A783',
  'BENNA': 'A784',
  'BENTIVOGLIO': 'A785',
  'BERBENNO': 'A786',
  'BERBENNO DI VALTELLINA': 'A787',
  'BERCETO': 'A788',
  'BERCHIDDA': 'A789',
  'BEREGAZZO CON FIGLIARO': 'A791',
  'BEREGUARDO': 'A792',
  'BERGAMASCO': 'A793',
  'BERGAMO': 'A794',
  'BERGANTINO': 'A795',
  'BERGEGGI': 'A796',
  'BERGOLO': 'A798',
  'BERLINGO': 'A799',
  'BERNALDA': 'A801',
  'BERNAREGGIO': 'A802',
  'BERNATE TICINO': 'A804',
  'BERNEZZO': 'A805',
  'BERRA': 'A806',
  'BERSONE': 'A808',
  'BERTINORO': 'A809',
  'BERTIOLO': 'A810',
  'BERTONICO': 'A811',
  'BERZANO DI SAN PIETRO': 'A812',
  'BERZANO DI TORTONA': 'A813',
  'BERZO SAN FERMO': 'A815',
  'BERZO DEMO': 'A816',
  'BERZO INFERIORE': 'A817',
  'BESANA IN BRIANZA': 'A818',
  'BESANO': 'A819',
  'BESATE': 'A820',
  'BESENELLO': 'A821',
  'BESENZONE': 'A823',
  'BESNATE': 'A825',
  'BESOZZO': 'A826',
  'BESSUDE': 'A827',
  'BETTOLA': 'A831',
  'BETTONA': 'A832',
  'BEURA CARDEZZA': 'A834',
  'BEVAGNA': 'A835',
  'BEVERINO': 'A836',
  'BEVILACQUA': 'A837',
  'BEZZECCA': 'A839',
  'BIANCAVILLA': 'A841',
  'BIANCHI': 'A842',
  'BIANCO': 'A843',
  'BIANDRATE': 'A844',
  'BIANDRONNO': 'A845',
  'BIANZANO': 'A846',
  'BIANZE\'': 'A847',
  'BIANZONE': 'A848',
  'BIASSONO': 'A849',
  'BIBBIANO': 'A850',
  'BIBBIENA': 'A851',
  'BIBBONA': 'A852',
  'BIBIANA': 'A853',
  'BICCARI': 'A854',
  'BICINICCO': 'A855',
  'BIDONI\'': 'A856',
  'BLERA': 'A857',
  'BIELLA': 'A859',
  'BIENNO': 'A861',
  'BIENO': 'A862',
  'BIENTINA': 'A864',
  'BIGARELLO': 'A866',
  'BINAGO': 'A870',
  'BINASCO': 'A872',
  'BINETTO': 'A874',
  'BIOGLIO': 'A876',
  'BIONAZ': 'A877',
  'BIONE': 'A878',
  'BIRORI': 'A880',
  'BISACCIA': 'A881',
  'BISACQUINO': 'A882',
  'BISCEGLIE': 'A883',
  'BISEGNA': 'A884',
  'BISENTI': 'A885',
  'BISIGNANO': 'A887',
  'BISTAGNO': 'A889',
  'BISUSCHIO': 'A891',
  'BITETTO': 'A892',
  'BITONTO': 'A893',
  'BITRITTO': 'A894',
  'BITTI': 'A895',
  'BIVONA': 'A896',
  'BIVONGI': 'A897',
  'BIZZARONE': 'A898',
  'BLEGGIO INFERIORE': 'A901',
  'BLEGGIO SUPERIORE': 'A902',
  'BLELLO': 'A903',
  'BLESSAGNO': 'A904',
  'BLEVIO': 'A905',
  'BOARA PISANI': 'A906',
  'BOBBIO': 'A909',
  'BOBBIO PELLICE': 'A910',
  'BOCA': 'A911',
  'BOCCHIGLIERO': 'A912',
  'BOCCIOLETO': 'A914',
  'BOCENAGO': 'A916',
  'BODIO LOMNAGO': 'A918',
  'BOFFALORA D\'ADDA': 'A919',
  'BOFFALORA SOPRA TICINO': 'A920',
  'BOGLIASCO': 'A922',
  'BOGNANCO': 'A925',
  'BOGOGNO': 'A929',
  'BOJANO': 'A930',
  'BOISSANO': 'A931',
  'BOLANO': 'A932',
  'BOLBENO': 'A933',
  'BOLGARE': 'A937',
  'BOLLATE': 'A940',
  'BOLLENGO': 'A941',
  'NOVA SIRI': 'A942',
  'BOLOGNA': 'A944',
  'BOLOGNANO': 'A945',
  'BOLOGNETTA': 'A946',
  'BOLOGNOLA': 'A947',
  'BOLOTANA': 'A948',
  'BOLSENA': 'A949',
  'BOLTIERE': 'A950',
  'BOLZANO-BOZEN': 'A952',
  'BOLZANO NOVARESE': 'A953',
  'BOLZANO VICENTINO': 'A954',
  'BOMARZO': 'A955',
  'BOMBA': 'A956',
  'BOMPENSIERE': 'A957',
  'BOMPIETRO': 'A958',
  'BOMPORTO': 'A959',
  'BONARCADO': 'A960',
  'BONASSOLA': 'A961',
  'BONATE SOTTO': 'A962',
  'BONATE SOPRA': 'A963',
  'BONAVIGO': 'A964',
  'BONDENO': 'A965',
  'BONDO': 'A967',
  'BONDONE': 'A968',
  'BONEA': 'A970',
  'BONEFRO': 'A971',
  'BONEMERSE': 'A972',
  'BONIFATI': 'A973',
  'BONITO': 'A975',
  'BONNANARO': 'A976',
  'BONO': 'M219',
  'BONORVA': 'A978',
  'BONVICINO': 'A979',
  'BORBONA': 'A981',
  'BORCA DI CADORE': 'A982',
  'BORDANO': 'A983',
  'BORDIGHERA': 'A984',
  'BORDOLANO': 'A986',
  'BORE': 'A987',
  'BORETTO': 'A988',
  'BORGARELLO': 'A989',
  'BORGARO TORINESE': 'A990',
  'BORGETTO': 'A991',
  'BORGHETTO DI VARA': 'A992',
  'BORGHETTO D\'ARROSCIA': 'A993',
  'BORGHETTO LODIGIANO': 'A995',
  'BORGO VELINO': 'A996',
  'BORGHETTO BORBERA': 'A998',
  'BORGHETTO SANTO SPIRITO': 'A999',
  'BORGHI': 'B001',
  'BORGIA': 'B002',
  'BORGIALLO': 'B003',
  'BORGIO VEREZZI': 'B005',
  'BORGO VALSUGANA': 'B006',
  'BORGO A MOZZANO': 'B007',
  'BORGOROSE': 'B008',
  'BORGO D\'ALE': 'B009',
  'BORGO DI TERZO': 'B010',
  'BORGOFORTE': 'B011',
  'MOTTEGGIANA': 'B012',
  'BORGOFRANCO SUL PO': 'B013',
  'SUARDI': 'B014',
  'BORGOFRANCO D\'IVREA': 'B015',
  'BORGOLAVEZZARO': 'B016',
  'BORGO SAN GIOVANNI': 'B017',
  'BORGOMALE': 'B018',
  'BORGOMANERO': 'B019',
  'BORGOMARO': 'B020',
  'BORGOMASINO': 'B021',
  'BORGONE SUSA': 'B024',
  'BORGONOVO VAL TIDONE': 'B025',
  'BORGO PACE': 'B026',
  'BORGO PRIOLO': 'B028',
  'BORGORATTO ALESSANDRINO': 'B029',
  'BORGORATTO MORMOROLO': 'B030',
  'BORGORICCO': 'B031',
  'BORGO SAN DALMAZZO': 'B033',
  'FIDENZA': 'B034',
  'BORGO SAN GIACOMO': 'B035',
  'BORGO SAN LORENZO': 'B036',
  'BORGO SAN MARTINO': 'B037',
  'BORGO SAN SIRO': 'B038',
  'BORGOSATOLLO': 'B040',
  'BORGOSESIA': 'B041',
  'BORGO VAL DI TARO': 'B042',
  'BORGO TICINO': 'B043',
  'BORGO TOSSIGNANO': 'B044',
  'BORGO VERCELLI': 'B046',
  'BORMIDA': 'B048',
  'BORMIO': 'B049',
  'BORNASCO': 'B051',
  'BORNO': 'B054',
  'BORONEDDU': 'B055',
  'BORORE': 'B056',
  'BORRELLO': 'B057',
  'BORRIANA': 'B058',
  'BORSO DEL GRAPPA': 'B061',
  'BORTIGALI': 'B062',
  'BORTIGIADAS': 'B063',
  'BORUTTA': 'B064',
  'BORZONASCA': 'B067',
  'BOSA': 'B068',
  'BOSARO': 'B069',
  'BOSCHI SANT\'ANNA': 'B070',
  'BOSCO MARENGO': 'B071',
  'BOSCO CHIESANUOVA': 'B073',
  'BOSCONERO': 'B075',
  'BOSCOREALE': 'B076',
  'BOSCOTRECASE': 'B077',
  'BOSENTINO': 'B078',
  'BOSIA': 'B079',
  'BOSIO': 'B080',
  'BOSISIO PARINI': 'B081',
  'BOSNASCO': 'B082',
  'BOSSICO': 'B083',
  'BOSSOLASCO': 'B084',
  'BOTRICELLO': 'B085',
  'BOTRUGNO': 'B086',
  'BOTTANUCO': 'B088',
  'BOTTICINO': 'B091',
  'BOTTIDDA': 'B094',
  'BOVA': 'B097',
  'BOVALINO': 'B098',
  'BOVA MARINA': 'B099',
  'BOVEGNO': 'B100',
  'BOVES': 'B101',
  'BOVEZZO': 'B102',
  'BOVINO': 'B104',
  'BOVISIO-MASCIAGO': 'B105',
  'BOVOLENTA': 'B106',
  'BOVOLONE': 'B107',
  'BOZZOLE': 'B109',
  'BOZZOLO': 'B110',
  'BRA': 'B111',
  'BRACCA': 'B112',
  'BRACCIANO': 'B114',
  'BRACIGLIANO': 'B115',
  'BRAIES * PRAGS': 'B116',
  'BRALLO DI PREGOLA': 'B117',
  'BRANCALEONE': 'B118',
  'BRANDICO': 'B120',
  'BRANDIZZO': 'B121',
  'BRANZI': 'B123',
  'BRAONE': 'B124',
  'BREBBIA': 'B126',
  'BREDA DI PIAVE': 'B128',
  'CASTELVERDE': 'B129',
  'BREGANO': 'B131',
  'BREGANZE': 'B132',
  'BREGNANO': 'B134',
  'BREGUZZO': 'B135',
  'BREIA': 'B136',
  'BREMBATE': 'B137',
  'BREMBATE DI SOPRA': 'B138',
  'BREMBILLA': 'B140',
  'BREMBIO': 'B141',
  'BREME': 'B142',
  'BRENDOLA': 'B143',
  'BRENNA': 'B144',
  'BRENNERO * BRENNER': 'B145',
  'BRENO': 'B149',
  'BRENTA': 'B150',
  'BRENTINO BELLUNO': 'B152',
  'BRENTONICO': 'B153',
  'BRENZONE': 'B154',
  'BRESCELLO': 'B156',
  'BRESCIA': 'B157',
  'BRESIMO': 'B158',
  'BRESSANA BOTTARONE': 'B159',
  'BRESSANONE * BRIXEN': 'B160',
  'BRESSANVIDO': 'B161',
  'BRESSO': 'B162',
  'BREZ': 'B165',
  'BREZZO DI BEDERO': 'B166',
  'BRIAGLIA': 'B167',
  'BRIATICO': 'B169',
  'BRICHERASIO': 'B171',
  'BRIENNO': 'B172',
  'BRIENZA': 'B173',
  'BRIGA ALTA': 'B175',
  'BRIGA NOVARESE': 'B176',
  'BRIGNANO GERA D\'ADDA': 'B178',
  'BRIGNANO-FRASCATA': 'B179',
  'BRINDISI': 'B180',
  'BRINDISI MONTAGNA': 'B181',
  'BRINZIO': 'B182',
  'BRIONA': 'B183',
  'BRIONE': 'B185',
  'BRIOSCO': 'B187',
  'BRISIGHELLA': 'B188',
  'BRISSAGO-VALTRAVAGLIA': 'B191',
  'BRISSOGNE': 'B192',
  'BRITTOLI': 'B193',
  'BRIVIO': 'B194',
  'BROCCOSTELLA': 'B195',
  'BROGLIANO': 'B196',
  'BROGNATURO': 'B197',
  'BROLO': 'B198',
  'BRONDELLO': 'B200',
  'BRONI': 'B201',
  'BRONTE': 'B202',
  'BRONZOLO * BRANZOLL': 'B203',
  'BROSSASCO': 'B204',
  'BROSSO': 'B205',
  'BROVELLO-CARPUGNINO': 'B207',
  'BROZOLO': 'B209',
  'BRUGHERIO': 'B212',
  'BRUGINE': 'B213',
  'BRUGNATO': 'B214',
  'BRUGNERA': 'B215',
  'BRUINO': 'B216',
  'BRUMANO': 'B217',
  'BRUNATE': 'B218',
  'BRUNELLO': 'B219',
  'BRUNICO * BRUNECK': 'B220',
  'BRUNO': 'B221',
  'BRUSAPORTO': 'B223',
  'BRUSASCO': 'B225',
  'BRUSCIANO': 'B227',
  'BRUSIMPIANO': 'B228',
  'BRUSNENGO': 'B229',
  'BRUSSON': 'B230',
  'BRUZOLO': 'B232',
  'BRUZZANO ZEFFIRIO': 'B234',
  'BUBBIANO': 'B235',
  'BUBBIO': 'B236',
  'BUCCHERI': 'B237',
  'BUCCHIANICO': 'B238',
  'BUCCIANO': 'B239',
  'BUCCINASCO': 'B240',
  'BUCCINO': 'B242',
  'BUCINE': 'B243',
  'BUDDUSO\'': 'B246',
  'BUDOIA': 'B247',
  'BUDONI': 'B248',
  'BUDRIO': 'B249',
  'BUGGERRU': 'B250',
  'BUGGIANO': 'B251',
  'BUGLIO IN MONTE': 'B255',
  'BUGNARA': 'B256',
  'BUGUGGIATE': 'B258',
  'BUJA': 'B259',
  'BULCIAGO': 'B261',
  'BULGAROGRASSO': 'B262',
  'BULTEI': 'B264',
  'BULZI': 'B265',
  'BUONABITACOLO': 'B266',
  'BUONALBERGO': 'B267',
  'MONTEBELLO SUL SANGRO': 'B268',
  'BUONCONVENTO': 'B269',
  'BUONVICINO': 'B270',
  'BURAGO DI MOLGORA': 'B272',
  'BURCEI': 'B274',
  'BURGIO': 'B275',
  'BURGOS': 'B276',
  'BURIASCO': 'B278',
  'BUROLO': 'B279',
  'BURONZO': 'B280',
  'BUSACHI': 'B281',
  'BUSALLA': 'B282',
  'BUSANA': 'B283',
  'BUSANO': 'B284',
  'BUSCA': 'B285',
  'BUSCATE': 'B286',
  'BUSCEMI': 'B287',
  'BUSETO PALIZZOLO': 'B288',
  'BUSNAGO': 'B289',
  'BUSSERO': 'B292',
  'BUSSETO': 'B293',
  'BUSSI SUL TIRINO': 'B294',
  'BUSSO': 'B295',
  'BUSSOLENGO': 'B296',
  'BUSSOLENO': 'B297',
  'BUSTO ARSIZIO': 'B300',
  'BUSTO GAROLFO': 'B301',
  'BUTERA': 'B302',
  'BUTI': 'B303',
  'BUTTAPIETRA': 'B304',
  'BUTTIGLIERA ALTA': 'B305',
  'BUTTIGLIERA D\'ASTI': 'B306',
  'BUTTRIO': 'B309',
  'SAN PAOLO D\'ARGON': 'B310',
  'CABELLA LIGURE': 'B311',
  'CASTELLO CABIAGLIO': 'B312',
  'CABIATE': 'B313',
  'CABRAS': 'B314',
  'CACCAMO': 'B315',
  'POGGIO SANNITA': 'B317',
  'CACCURI': 'B319',
  'CA\' D\'ANDREA': 'B320',
  'CADEGLIANO-VICONAGO': 'B326',
  'CADELBOSCO DI SOPRA': 'B328',
  'CADEO': 'B332',
  'CADERZONE': 'B335',
  'CADONEGHE': 'B345',
  'CADORAGO': 'B346',
  'CADREZZATE': 'B347',
  'CAERANO DI SAN MARCO': 'B349',
  'CAFASSE': 'B350',
  'CAGGIANO': 'B351',
  'CAGLI': 'B352',
  'CAGLIARI': 'B354',
  'CAGLIO': 'B355',
  'CAGNANO VARANO': 'B357',
  'CAGNANO AMITERNO': 'B358',
  'CAGNO': 'B359',
  'CAGNO\'': 'B360',
  'CAIANELLO': 'B361',
  'CAIAZZO': 'B362',
  'CAINES * KUENS': 'B364',
  'CAINO': 'B365',
  'CAIOLO': 'B366',
  'CAIRANO': 'B367',
  'CAIRATE': 'B368',
  'CAIRO MONTENOTTE': 'B369',
  'CAIVANO': 'B371',
  'CALABRITTO': 'B374',
  'CALALZO DI CADORE': 'B375',
  'CALAMANDRANA': 'B376',
  'CALAMONACI': 'B377',
  'CALANGIANUS': 'B378',
  'CALANNA': 'B379',
  'CALASCA-CASTIGLIONE': 'B380',
  'CALASCIBETTA': 'B381',
  'CALASCIO': 'B382',
  'CALASETTA': 'B383',
  'CALATABIANO': 'B384',
  'CALATAFIMI SEGESTA': 'B385',
  'CALAVINO': 'B386',
  'LUNGAVILLA': 'B387',
  'CALCATA': 'B388',
  'CALCERANICA AL LAGO': 'B389',
  'CALCI': 'B390',
  'CALCIANO': 'B391',
  'CALCINAIA': 'B392',
  'CALCINATE': 'B393',
  'CALCINATO': 'B394',
  'CALCIO': 'B395',
  'CALCO': 'B396',
  'CALDARO SULLA STRADA DEL VINO * KALTERN AN DER WEINSTRASSE': 'B397',
  'CALDAROLA': 'B398',
  'CALDERARA DI RENO': 'B399',
  'CALDES': 'B400',
  'CALDIERO': 'B402',
  'CALDOGNO': 'B403',
  'CALDONAZZO': 'B404',
  'CALENDASCO': 'B405',
  'CALENZANO': 'B406',
  'CALESTANO': 'B408',
  'CALICE LIGURE': 'B409',
  'CALICE AL CORNOVIGLIO': 'B410',
  'CALIMERA': 'B413',
  'CALITRI': 'B415',
  'CALIZZANO': 'B416',
  'CALLABIANA': 'B417',
  'CALLIANO': 'B419',
  'CALOLZIOCORTE': 'B423',
  'CALOPEZZATI': 'B424',
  'CALOSSO': 'B425',
  'CALOVETO': 'B426',
  'CALTABELLOTTA': 'B427',
  'CALTAGIRONE': 'B428',
  'CALTANISSETTA': 'B429',
  'CALTAVUTURO': 'B430',
  'CALTIGNAGA': 'B431',
  'CALTO': 'B432',
  'CALTRANO': 'B433',
  'CALUSCO D\'ADDA': 'B434',
  'CALUSO': 'B435',
  'CALVAGESE DELLA RIVIERA': 'B436',
  'CALVANICO': 'B437',
  'CALVATONE': 'B439',
  'CALVELLO': 'B440',
  'CALVENE': 'B441',
  'CALVENZANO': 'B442',
  'CALVERA': 'B443',
  'CALVI': 'B444',
  'CALVI RISORTA': 'B445',
  'CALVI DELL\'UMBRIA': 'B446',
  'CALVIGNANO': 'B447',
  'CALVIGNASCO': 'B448',
  'CALVISANO': 'B450',
  'CALVIZZANO': 'B452',
  'CAMAGNA MONFERRATO': 'B453',
  'CAMAIORE': 'B455',
  'CAMAIRAGO': 'B456',
  'CAMANDONA': 'B457',
  'CAMASTRA': 'B460',
  'CAMBIAGO': 'B461',
  'CAMBIANO': 'B462',
  'CAMBIASCA': 'B463',
  'CAMBURZANO': 'B465',
  'SANT\'ELENA SANNITA': 'B466',
  'CAMERANA': 'B467',
  'CAMERANO': 'B468',
  'CAMERANO CASASCO': 'B469',
  'CAMERATA PICENA': 'B470',
  'CAMERATA CORNELLO': 'B471',
  'CAMERATA NUOVA': 'B472',
  'CAMERI': 'B473',
  'CAMERINO': 'B474',
  'CAMEROTA': 'B476',
  'CAMIGLIANO': 'B477',
  'CAMINATA': 'B479',
  'CAMINI': 'B481',
  'CAMINO': 'B482',
  'CAMINO AL TAGLIAMENTO': 'B483',
  'CAMISANO': 'B484',
  'CAMISANO VICENTINO': 'B485',
  'CAMMARATA': 'B486',
  'CAMO': 'B489',
  'CAMOGLI': 'B490',
  'CHAMOIS': 'B491',
  'CAMPAGNA': 'B492',
  'CAMPAGNA LUPIA': 'B493',
  'CASTEL CAMPAGNANO': 'B494',
  'CAMPAGNANO DI ROMA': 'B496',
  'CAMPAGNATICO': 'B497',
  'CAMPAGNOLA CREMASCA': 'B498',
  'CAMPAGNOLA EMILIA': 'B499',
  'CAMPANA': 'B500',
  'CAMPARADA': 'B501',
  'CAMPEGINE': 'B502',
  'CAMPELLO SUL CLITUNNO': 'B504',
  'CAMPERTOGNO': 'B505',
  'CAMPI SALENTINA': 'B506',
  'CAMPI BISENZIO': 'B507',
  'CAMPIGLIA CERVO': 'B508',
  'CAMPIGLIA MARITTIMA': 'B509',
  'VALPRATO SOANA': 'B510',
  'CAMPIGLIA DEI BERICI': 'B511',
  'CAMPIGLIONE FENILE': 'B512',
  'CAMPIONE D\'ITALIA': 'B513',
  'CAMPITELLO DI FASSA': 'B514',
  'CAMPLI': 'B515',
  'CAMPO CALABRO': 'B516',
  'CAMPOBASSO': 'B519',
  'CAMPOBELLO DI LICATA': 'B520',
  'CAMPOBELLO DI MAZARA': 'B521',
  'CAMPOCHIARO': 'B522',
  'CAMPODARSEGO': 'B524',
  'CAMPODENNO': 'B525',
  'CAMPO DI GIOVE': 'B526',
  'CAMPODIMELE': 'B527',
  'CAMPODIPIETRA': 'B528',
  'CAMPO DI TRENS * FREIENFELD': 'B529',
  'CAMPODOLCINO': 'B530',
  'CAMPODORO': 'B531',
  'CAMPOFELICE DI ROCCELLA': 'B532',
  'CAMPOFELICE DI FITALIA': 'B533',
  'CAMPOFILONE': 'B534',
  'CAMPOFIORITO': 'B535',
  'CAMPOFORMIDO': 'B536',
  'CAMPOFRANCO': 'B537',
  'CAMPO LIGURE': 'B538',
  'CAMPOGALLIANO': 'B539',
  'CHAMPORCHER': 'B540',
  'CAMPOLATTARO': 'B541',
  'CAMPOLI DEL MONTE TABURNO': 'B542',
  'CAMPOLI APPENNINO': 'B543',
  'CAMPOLIETO': 'B544',
  'CAMPOLONGO MAGGIORE': 'B546',
  'CAMPOLONGO SUL BRENTA': 'B547',
  'CAMPOMAGGIORE': 'B549',
  'CAMPOMARINO': 'B550',
  'CAMPOMORONE': 'B551',
  'CAMPO NELL\'ELBA': 'B553',
  'CAMPONOGARA': 'B554',
  'CAMPORA': 'B555',
  'CAMPOREALE': 'B556',
  'CAMPORGIANO': 'B557',
  'CAMPOROSSO': 'B559',
  'CAMPOROTONDO ETNEO': 'B561',
  'CAMPOROTONDO DI FIASTRONE': 'B562',
  'CAMPOSAMPIERO': 'B563',
  'CAMPO SAN MARTINO': 'B564',
  'CAMPOSANO': 'B565',
  'CAMPOSANTO': 'B566',
  'CAMPOSPINOSO': 'B567',
  'CAMPOTOSTO': 'B569',
  'CAMPO TURES * SAND IN TAUFERS': 'B570',
  'CAMUGNANO': 'B572',
  'CANALE': 'M222',
  'CANALE D\'AGORDO': 'B574',
  'CANALE MONTERANO': 'B576',
  'CANAL SAN BOVO': 'B577',
  'CANARO': 'B578',
  'CANAZEI': 'B579',
  'CANCELLARA': 'B580',
  'CANCELLO ED ARNONE': 'B581',
  'CANDA': 'B582',
  'CANDELA': 'B584',
  'CANDELO': 'B586',
  'CANDIA LOMELLINA': 'B587',
  'CANDIA CANAVESE': 'B588',
  'CANDIANA': 'B589',
  'CANDIDA': 'B590',
  'CANDIDONI': 'B591',
  'CANDIOLO': 'B592',
  'CANEGRATE': 'B593',
  'CANELLI': 'B594',
  'ORVINIO': 'B595',
  'CANEPINA': 'B597',
  'CANEVA': 'B598',
  'CANEVINO': 'B599',
  'CANICATTI\'': 'B602',
  'CANICATTINI BAGNI': 'B603',
  'CANINO': 'B604',
  'CANISCHIO': 'B605',
  'CANISTRO': 'B606',
  'CANNA': 'B607',
  'CANNALONGA': 'B608',
  'CANNARA': 'B609',
  'CANNERO RIVIERA': 'B610',
  'CANNETO SULL\'OGLIO': 'B612',
  'CANNETO PAVESE': 'B613',
  'CANNOBIO': 'B615',
  'CANNOLE': 'B616',
  'CANOLO': 'B617',
  'CANONICA D\'ADDA': 'B618',
  'CANOSA DI PUGLIA': 'B619',
  'CANOSA SANNITA': 'B620',
  'CANOSIO': 'B621',
  'CANSANO': 'B624',
  'CANTAGALLO': 'B626',
  'CANTALICE': 'B627',
  'CANTALUPA': 'B628',
  'CANTALUPO LIGURE': 'B629',
  'CANTALUPO NEL SANNIO': 'B630',
  'CANTALUPO IN SABINA': 'B631',
  'MANDELA': 'B632',
  'CANTARANA': 'B633',
  'CANTELLO': 'B634',
  'CANTERANO': 'B635',
  'CANTIANO': 'B636',
  'CANTOIRA': 'B637',
  'CANTU\'': 'B639',
  'CANZANO': 'B640',
  'CANZO': 'B641',
  'CAORLE': 'B642',
  'CAORSO': 'B643',
  'CAPACCIO': 'B644',
  'CAPACI': 'B645',
  'CAPALBIO': 'B646',
  'CAPANNOLI': 'B647',
  'CAPANNORI': 'B648',
  'CAPENA': 'B649',
  'CAPERGNANICA': 'B650',
  'CAPESTRANO': 'B651',
  'CAPIAGO INTIMIANO': 'B653',
  'CAPISTRANO': 'B655',
  'CAPISTRELLO': 'B656',
  'CAPITIGNANO': 'B658',
  'CAPIZZI': 'B660',
  'CAPIZZONE': 'B661',
  'PONTE NELLE ALPI': 'B662',
  'CAPODIMONTE': 'B663',
  'CAPO DI PONTE': 'B664',
  'CAPO D\'ORLANDO': 'B666',
  'CAPODRISE': 'B667',
  'CAPOLIVERI': 'B669',
  'CAPOLONA': 'B670',
  'CAPONAGO': 'B671',
  'CAPORCIANO': 'B672',
  'CAPOSELE': 'B674',
  'CAPOTERRA': 'B675',
  'CAPOVALLE': 'B676',
  'CAPPADOCIA': 'B677',
  'CAPPELLA MAGGIORE': 'B678',
  'CAPPELLA CANTONE': 'B679',
  'CAPPELLA DE\' PICENARDI': 'B680',
  'CAPPELLE SUL TAVO': 'B681',
  'CAPRACOTTA': 'B682',
  'CAPRAIA E LIMITE': 'B684',
  'CAPRAIA ISOLA': 'B685',
  'CAPRALBA': 'B686',
  'CAPRANICA PRENESTINA': 'B687',
  'CAPRANICA': 'B688',
  'MARZABOTTO': 'B689',
  'CAPRARICA DI LECCE': 'B690',
  'CAPRAROLA': 'B691',
  'CAPRAUNA': 'B692',
  'CAPRESE MICHELANGELO': 'B693',
  'CAPREZZO': 'B694',
  'CAPRI LEONE': 'B695',
  'CAPRI': 'B696',
  'CAPRIANA': 'B697',
  'CAPRIANO DEL COLLE': 'B698',
  'CAPRIATA D\'ORBA': 'B701',
  'CAPRIATE SAN GERVASIO': 'B703',
  'CAPRIATI A VOLTURNO': 'B704',
  'CAPRIE': 'B705',
  'CAPRIGLIA IRPINA': 'B706',
  'CAPRIGLIO': 'B707',
  'CAPRILE': 'B708',
  'CAPRINO VERONESE': 'B709',
  'CAPRINO BERGAMASCO': 'B710',
  'CAPRIOLO': 'B711',
  'CAPRIVA DEL FRIULI': 'B712',
  'CAPUA': 'B715',
  'CAPURSO': 'B716',
  'CARAFFA DI CATANZARO': 'B717',
  'CARAFFA DEL BIANCO': 'B718',
  'CARAGLIO': 'B719',
  'CARAMAGNA PIEMONTE': 'B720',
  'CARAMANICO TERME': 'B722',
  'CARANO': 'B723',
  'CARAPELLE': 'B724',
  'CARAPELLE CALVISIO': 'B725',
  'CARASCO': 'B726',
  'CARASSAI': 'B727',
  'CARATE BRIANZA': 'B729',
  'CARATE URIO': 'B730',
  'CARAVAGGIO': 'B731',
  'CARAVATE': 'B732',
  'CARAVINO': 'B733',
  'CARAVONICA': 'B734',
  'CARBOGNANO': 'B735',
  'CARBONARA SCRIVIA': 'B736',
  'VILLASIMIUS': 'B738',
  'CARBONARA DI PO': 'B739',
  'CARBONARA DI NOLA': 'B740',
  'CARBONARA AL TICINO': 'B741',
  'CARBONATE': 'B742',
  'CARBONE': 'B743',
  'CARBONERA': 'B744',
  'CARBONIA': 'B745',
  'CARCARE': 'B748',
  'CARCERI': 'B749',
  'CARCOFORO': 'B752',
  'CARDANO AL CAMPO': 'B754',
  'CARDE\'': 'B755',
  'CARDETO': 'B756',
  'CARDINALE': 'B758',
  'CARDITO': 'B759',
  'CAREGGINE': 'B760',
  'CAREMA': 'B762',
  'CARENNO': 'B763',
  'CARENTINO': 'B765',
  'CARERI': 'B766',
  'CARESANA': 'B767',
  'CARESANABLOT': 'B768',
  'CAREZZANO': 'B769',
  'CARFIZZI': 'B771',
  'CARGEGHE': 'B772',
  'CARIATI': 'B774',
  'CARIFE': 'B776',
  'CARIGNANO': 'B777',
  'CARIMATE': 'B778',
  'CARINARO': 'B779',
  'CARINI': 'B780',
  'CARINOLA': 'B781',
  'CARISIO': 'B782',
  'CARISOLO': 'B783',
  'CARLANTINO': 'B784',
  'CARLAZZO': 'B785',
  'CARLENTINI': 'B787',
  'CARLINO': 'B788',
  'CARLOFORTE': 'B789',
  'CARLOPOLI': 'B790',
  'CARMAGNOLA': 'B791',
  'CARMIANO': 'B792',
  'CARMIGNANO': 'B794',
  'CARMIGNANO DI BRENTA': 'B795',
  'CARNAGO': 'B796',
  'CARNATE': 'B798',
  'CORNEDO ALL\'ISARCO * KARNEID': 'B799',
  'CAROBBIO DEGLI ANGELI': 'B801',
  'CAROLEI': 'B802',
  'CARONA': 'B803',
  'CARONIA': 'B804',
  'CARONNO PERTUSELLA': 'B805',
  'CARONNO VARESINO': 'B807',
  'CAROSINO': 'B808',
  'CAROVIGNO': 'B809',
  'CAROVILLI': 'B810',
  'CARPANETO PIACENTINO': 'B812',
  'CARPANZANO': 'B813',
  'CARPASIO': 'B814',
  'CARPEGNA': 'B816',
  'CARPENEDOLO': 'B817',
  'CARPENETO': 'B818',
  'CARPI': 'B819',
  'CARPIANO': 'B820',
  'CARPIGNANO SALENTINO': 'B822',
  'CARPIGNANO SESIA': 'B823',
  'CURA CARPIGNANO': 'B824',
  'CARPINETI': 'B825',
  'CARPINETO SINELLO': 'B826',
  'CARPINETO DELLA NORA': 'B827',
  'CARPINETO ROMANO': 'B828',
  'CARPINO': 'B829',
  'CARPINONE': 'B830',
  'CARRARA': 'B832',
  'CARRE\'': 'B835',
  'CARREGA LIGURE': 'B836',
  'CARRO': 'B838',
  'CARRODANO': 'B839',
  'CARROSIO': 'B840',
  'CARRU\'': 'B841',
  'CARSOLI': 'B842',
  'CARTIGLIANO': 'B844',
  'CARTIGNANO': 'B845',
  'CARTOCETO': 'B846',
  'CARTOSIO': 'B847',
  'CARTURA': 'B848',
  'CARUGATE': 'B850',
  'CARUGO': 'B851',
  'CARUNCHIO': 'B853',
  'CARVICO': 'B854',
  'CARZANO': 'B856',
  'CASABONA': 'B857',
  'CASACALENDA': 'B858',
  'CASACANDITELLA': 'B859',
  'CASAGIOVE': 'B860',
  'CASALANGUIDA': 'B861',
  'CASALATTICO': 'B862',
  'CASALBELTRAME': 'B864',
  'CASALBORDINO': 'B865',
  'CASALBORE': 'B866',
  'CASALBORGONE': 'B867',
  'CASALBUONO': 'B868',
  'CASALBUTTANO ED UNITI': 'B869',
  'CASAL CERMELLI': 'B870',
  'CASALCIPRANO': 'B871',
  'CASAL DI PRINCIPE': 'B872',
  'CASALDUNI': 'B873',
  'CASALE LITTA': 'B875',
  'CASALE CORTE CERRO': 'B876',
  'CASALE DI SCODOSIA': 'B877',
  'CASALE MARITTIMO': 'B878',
  'CASALE SUL SILE': 'B879',
  'CASALECCHIO DI RENO': 'B880',
  'CASALE CREMASCO VIDOLASCO': 'B881',
  'CASALEGGIO BOIRO': 'B882',
  'CASALEGGIO NOVARA': 'B883',
  'CASALE MONFERRATO': 'B885',
  'CASALEONE': 'B886',
  'CASALETTO LODIGIANO': 'B887',
  'CASALETTO SPARTANO': 'B888',
  'CASALETTO CEREDANO': 'B889',
  'CASALETTO DI SOPRA': 'B890',
  'CASALETTO VAPRIO': 'B891',
  'CASALFIUMANESE': 'B892',
  'CASALGRANDE': 'B893',
  'CASALGRASSO': 'B894',
  'CASAL VELINO': 'B895',
  'CASALINCONTRADA': 'B896',
  'CASALINO': 'B897',
  'CASALMAGGIORE': 'B898',
  'CASALMAIOCCO': 'B899',
  'CASALMORANO': 'B900',
  'CASALMORO': 'B901',
  'CASALNOCETO': 'B902',
  'VILLAPIANA': 'B903',
  'CASALNUOVO MONTEROTARO': 'B904',
  'CASALNUOVO DI NAPOLI': 'B905',
  'SAN PAOLO ALBANESE': 'B906',
  'CASALOLDO': 'B907',
  'CASALPUSTERLENGO': 'B910',
  'CASALROMANO': 'B911',
  'CASALSERUGO': 'B912',
  'POZZAGLIO ED UNITI': 'B914',
  'TRINITAPOLI': 'B915',
  'CASALUCE': 'B916',
  'CASALVECCHIO DI PUGLIA': 'B917',
  'CASALVECCHIO SICULO': 'B918',
  'CASALVIERI': 'B919',
  'CASALVOLONE': 'B920',
  'CASALZUIGNO': 'B921',
  'CASAMARCIANO': 'B922',
  'CASAMASSIMA': 'B923',
  'CASAMICCIOLA TERME': 'B924',
  'CASANDRINO': 'B925',
  'CASANOVA LERRONE': 'B927',
  'CASANOVA ELVO': 'B928',
  'CASANOVA LONATI': 'B929',
  'CASAPE': 'B932',
  'CASAPINTA': 'B933',
  'CASAPROTA': 'B934',
  'CASAPULLA': 'B935',
  'CASARANO': 'B936',
  'CASARGO': 'B937',
  'CASARILE': 'B938',
  'CASARZA LIGURE': 'B939',
  'CASARSA DELLA DELIZIA': 'B940',
  'CASASCO': 'B941',
  'CASASCO D\'INTELVI': 'B942',
  'CASATENOVO': 'B943',
  'CASATISMA': 'B945',
  'CASAVATORE': 'B946',
  'CASAZZA': 'B947',
  'CASCIA': 'B948',
  'CASCIAGO': 'B949',
  'CASCINA': 'B950',
  'SAN GIACOMO VERCELLESE': 'B952',
  'CASCINETTE D\'IVREA': 'B953',
  'CASEI GEROLA': 'B954',
  'CASELETTE': 'B955',
  'CASELLA': 'B956',
  'CASELLE LURANI': 'B958',
  'CASELLE IN PITTARI': 'B959',
  'CASELLE TORINESE': 'B960',
  'CASELLE LANDI': 'B961',
  'SCANDICCI': 'B962',
  'CASERTA': 'B963',
  'CASIER': 'B965',
  'CASIGNANA': 'B966',
  'CASINA': 'B967',
  'CASTELSILANO': 'B968',
  'CASTEL DI CASIO': 'B969',
  'CASIRATE D\'ADDA': 'B971',
  'CASLINO D\'ERBA': 'B974',
  'CASNATE CON BERNATE': 'B977',
  'CASNIGO': 'B978',
  'CASOLA IN LUNIGIANA': 'B979',
  'CASOLA DI NAPOLI': 'B980',
  'CASOLA VALSENIO': 'B982',
  'CASOLE BRUZIO': 'B983',
  'CASOLE D\'ELSA': 'B984',
  'CASOLI': 'B985',
  'CASORATE SEMPIONE': 'B987',
  'CASORATE PRIMO': 'B988',
  'CASOREZZO': 'B989',
  'CASORIA': 'B990',
  'CASORZO': 'B991',
  'CASPOGGIO': 'B993',
  'CASSACCO': 'B994',
  'CASSAGO BRIANZA': 'B996',
  'CASSANO IRPINO': 'B997',
  'CASSANO DELLE MURGE': 'B998',
  'CASSANO VALCUVIA': 'B999',
  'CASSANO JONIO': 'C002',
  'CASSANO D\'ADDA': 'C003',
  'CASSANO MAGNAGO': 'C004',
  'CASSANO SPINOLA': 'C005',
  'CASSARO': 'C006',
  'CASSIGLIO': 'C007',
  'PERO': 'C013',
  'CASSINA DE\' PECCHI': 'C014',
  'CASSINA RIZZARDI': 'C020',
  'CASSINASCO': 'C022',
  'CASSINA VALSASSINA': 'C024',
  'CASSINE': 'C027',
  'CASSINELLE': 'C030',
  'CASSINETTA DI LUGAGNANO': 'C033',
  'CASSINO': 'C034',
  'CASSOLA': 'C037',
  'CASSOLNOVO': 'C038',
  'CASTEL CASTAGNA': 'C040',
  'CASTAGNARO': 'C041',
  'CASTAGNETO CARDUCCI': 'C044',
  'CASTAGNETO PO': 'C045',
  'CASTAGNITO': 'C046',
  'CASTAGNOLE MONFERRATO': 'C047',
  'CASTAGNOLE PIEMONTE': 'C048',
  'CASTAGNOLE LANZE': 'C049',
  'CASTANA': 'C050',
  'CASTELL\'UMBERTO': 'C051',
  'CASTANO PRIMO': 'C052',
  'CASTEGGIO': 'C053',
  'CASTEGNATO': 'C055',
  'CASTEGNERO': 'C056',
  'CASTELBALDO': 'C057',
  'CASTEL BARONIA': 'C058',
  'CASTELBELFORTE': 'C059',
  'CASTELBELLINO': 'C060',
  'CASTELBELLO-CIARDES * KASTELBELL-TSCHARS': 'C062',
  'CASTELBIANCO': 'C063',
  'CASTEL BOGLIONE': 'C064',
  'CASTEL BOLOGNESE': 'C065',
  'CASTELBOTTACCIO': 'C066',
  'CASTELBUONO': 'C067',
  'CASTELCIVITA': 'C069',
  'SERVIGLIANO': 'C070',
  'CASTEL COLONNA': 'C071',
  'CASTELCOVATI': 'C072',
  'CASTELCUCCO': 'C073',
  'CASTELDACCIA': 'C074',
  'CASTEL D\'AIANO': 'C075',
  'CASTEL D\'ARIO': 'C076',
  'CASTEL D\'AZZANO': 'C078',
  'CASTELLI CALEPIO': 'C079',
  'CASTELDELCI': 'C080',
  'CASTELDELFINO': 'C081',
  'CASTEL DEL GIUDICE': 'C082',
  'CASTEL DEL MONTE': 'C083',
  'CASTEL DEL PIANO': 'C085',
  'CASTEL DEL RIO': 'C086',
  'CASTELDIDONE': 'C089',
  'CASTEL DI IERI': 'C090',
  'CASTEL DI IUDICA': 'C091',
  'CASTEL DI LAMA': 'C093',
  'CASTEL DI LUCIO': 'C094',
  'CASTEL DI SANGRO': 'C096',
  'CASTEL DI SASSO': 'C097',
  'CASTEL DI TORA': 'C098',
  'CASTELFIDARDO': 'C100',
  'CASTELFIORENTINO': 'C101',
  'CASTEL FOCOGNANO': 'C102',
  'CASTELFONDO': 'C103',
  'CASTELFORTE': 'C104',
  'CASTELFRANCI': 'C105',
  'CASTELFRANCO IN MISCANO': 'C106',
  'CASTELFRANCO EMILIA': 'C107',
  'CASTROLIBERO': 'C108',
  'CASTEL VITTORIO': 'C110',
  'CASTELFRANCO VENETO': 'C111',
  'CASTELFRANCO DI SOPRA': 'C112',
  'CASTELFRANCO DI SOTTO': 'C113',
  'CASTEL FRENTANO': 'C114',
  'CASTEL GABBIANO': 'C115',
  'CASTEL GANDOLFO': 'C116',
  'CASTEL GIORGIO': 'C117',
  'CASTEL GOFFREDO': 'C118',
  'CASTELGOMBERTO': 'C119',
  'CASTELGRANDE': 'C120',
  'CASTEL GUELFO DI BOLOGNA': 'C121',
  'CASTELGUGLIELMO': 'C122',
  'CASTELGUIDONE': 'C123',
  'CASTELLABATE': 'C125',
  'CASTELLAFIUME': 'C126',
  'CASTELL\'ALFERO': 'C127',
  'CASTELLALTO': 'C128',
  'CASTELLAMMARE DI STABIA': 'C129',
  'CASTELLAMMARE DEL GOLFO': 'C130',
  'CASTELLAMONTE': 'C133',
  'CASTELLANA GROTTE': 'C134',
  'CASTELLANA SICULA': 'C135',
  'CASTELLANETA': 'C136',
  'CASTELLANIA': 'C137',
  'CASTELLANZA': 'C139',
  'CASTELLAR': 'C140',
  'CASTELLARANO': 'C141',
  'CASTELLAR GUIDOBONO': 'C142',
  'CASTELLARO': 'C143',
  'CASTELL\'ARQUATO': 'C145',
  'CASTELLAVAZZO': 'C146',
  'CASTELL\'AZZARA': 'C147',
  'CASTELLAZZO BORMIDA': 'C148',
  'CASTELLAZZO NOVARESE': 'C149',
  'CASTELLEONE DI SUASA': 'C152',
  'CASTELLEONE': 'C153',
  'CASTELLERO': 'C154',
  'CASTELLETTO CERVO': 'C155',
  'CASTELLETTO D\'ERRO': 'C156',
  'CASTELLETTO DI BRANDUZZO': 'C157',
  'CASTELLETTO D\'ORBA': 'C158',
  'CASTELLETTO MERLI': 'C160',
  'CASTELLETTO MOLINA': 'C161',
  'CASTELLETTO MONFERRATO': 'C162',
  'CASTELLETTO STURA': 'C165',
  'CASTELLETTO SOPRA TICINO': 'C166',
  'CASTELLETTO UZZONE': 'C167',
  'CASTELLI': 'C169',
  'CASTELLINA IN CHIANTI': 'C172',
  'CASTELLINALDO': 'C173',
  'CASTELLINA MARITTIMA': 'C174',
  'CASTELLINO DEL BIFERNO': 'C175',
  'CASTELLINO TANARO': 'C176',
  'CASTELLIRI': 'C177',
  'CASTELLO DEL MATESE': 'C178',
  'CASTELVECCANA': 'C181',
  'CASTEL CONDINO': 'C183',
  'CASTELLO D\'AGOGNA': 'C184',
  'CASTELLO D\'ARGILE': 'C185',
  'CASTELLO DELL\'ACQUA': 'C186',
  'CASTELLO DI BRIANZA': 'C187',
  'CASTELLO DI CISTERNA': 'C188',
  'CASTELLO-MOLINA DI FIEMME': 'C189',
  'CASTELLO DI GODEGO': 'C190',
  'CASTELLO DI SERRAVALLE': 'C191',
  'CASTELLO TESINO': 'C194',
  'CASTELLUCCHIO': 'C195',
  'CASTELMAURO': 'C197',
  'CASTELLUCCIO DEI SAURI': 'C198',
  'CASTELLUCCIO INFERIORE': 'C199',
  'CASTELVERRINO': 'C200',
  'CASTELLUCCIO SUPERIORE': 'C201',
  'CASTELLUCCIO VALMAGGIORE': 'C202',
  'CASTEL MADAMA': 'C203',
  'CASTEL MAGGIORE': 'C204',
  'CASTELMAGNO': 'C205',
  'CASTELMARTE': 'C206',
  'CASTELMASSA': 'C207',
  'CASTEL MELLA': 'C208',
  'CASTELMEZZANO': 'C209',
  'CASTELMOLA': 'C210',
  'CASTEL MORRONE': 'C211',
  'CASTELNOVETTO': 'C213',
  'CASTELNUOVO DI CEVA': 'C214',
  'CASTELNOVO BARIANO': 'C215',
  'CASTELNUOVO': 'C216',
  'CASTELNOVO DEL FRIULI': 'C217',
  'CASTELNOVO DI SOTTO': 'C218',
  'CASTELNOVO NE\' MONTI': 'C219',
  'CASTELNUOVO BOZZENTE': 'C220',
  'CASTELNUOVO DELLA DAUNIA': 'C222',
  'CASTELNUOVO PARANO': 'C223',
  'CASTELNUOVO DI FARFA': 'C224',
  'CASTELNUOVO DEL GARDA': 'C225',
  'CASTELNUOVO BELBO': 'C226',
  'CASTELNUOVO BERARDENGA': 'C227',
  'CASTELNUOVO BOCCA D\'ADDA': 'C228',
  'CASTELNUOVO BORMIDA': 'C229',
  'CASTELNUOVO CALCEA': 'C230',
  'CASTELNUOVO CILENTO': 'C231',
  'CASTELNUOVO DON BOSCO': 'C232',
  'CASTELNUOVO DI CONZA': 'C235',
  'CASTELNUOVO DI GARFAGNANA': 'C236',
  'CASTELNUOVO DI PORTO': 'C237',
  'CASTELNUOVO MAGRA': 'C240',
  'CASTELNUOVO NIGRA': 'C241',
  'CASTELNUOVO RANGONE': 'C242',
  'CASTELNUOVO SCRIVIA': 'C243',
  'CASTELNUOVO VAL DI CECINA': 'C244',
  'CASTELPAGANO': 'C245',
  'CASTELPETROSO': 'C246',
  'CASTELPIZZUTO': 'C247',
  'CASTELPLANIO': 'C248',
  'CASTELPOTO': 'C250',
  'CASTELRAIMONDO': 'C251',
  'CASTEL RITALDI': 'C252',
  'CASTEL ROCCHERO': 'C253',
  'CASTELROTTO * KASTELRUTH': 'C254',
  'CASTEL ROZZONE': 'C255',
  'CASTEL SAN GIORGIO': 'C259',
  'CASTEL SAN GIOVANNI': 'C261',
  'CASTEL SAN LORENZO': 'C262',
  'CASTEL SAN NICCOLO\'': 'C263',
  'CASTEL SAN PIETRO TERME': 'C265',
  'CASTEL SAN PIETRO ROMANO': 'C266',
  'CASTELSANTANGELO SUL NERA': 'C267',
  'CASTEL SANT\'ANGELO': 'C268',
  'CASTEL SANT\'ELIA': 'C269',
  'CASTEL SAN VINCENZO': 'C270',
  'CASTELSARACENO': 'C271',
  'CASTELSARDO': 'C272',
  'CASTELSEPRIO': 'C273',
  'CASTELSPINA': 'C274',
  'CASTELTERMINI': 'C275',
  'CASTELVECCHIO DI ROCCA BARBENA': 'C276',
  'CASTELVECCHIO CALVISIO': 'C278',
  'CASTELVECCHIO SUBEQUO': 'C279',
  'CASTELVENERE': 'C280',
  'VERRES': 'C282',
  'CASTELVETERE SUL CALORE': 'C283',
  'CASTELVETERE IN VAL FORTORE': 'C284',
  'CAULONIA': 'C285',
  'CASTELVETRANO': 'C286',
  'CASTELVETRO DI MODENA': 'C287',
  'CASTELVETRO PIACENTINO': 'C288',
  'CASTEL VISCARDO': 'C289',
  'CASTELVISCONTI': 'C290',
  'CASTEL VOLTURNO': 'C291',
  'CASTENASO': 'C292',
  'CASTENEDOLO': 'C293',
  'CHATILLON': 'C294',
  'CASTIGLIONE DEI PEPOLI': 'C296',
  'CASTIGLIONE DI SICILIA': 'C297',
  'CASTIGLIONE MESSER MARINO': 'C298',
  'CASTIGLIONE D\'INTELVI': 'C299',
  'CASTIGLIONE OLONA': 'C300',
  'CASTIGLIONE COSENTINO': 'C301',
  'CASTIGLIONE CHIAVARESE': 'C302',
  'CASTIGLIONE DI GARFAGNANA': 'C303',
  'CASTIGLIONE D\'ADDA': 'C304',
  'CASTIGLIONE DEL GENOVESI': 'C306',
  'CASTIGLIONE TORINESE': 'C307',
  'CASTIGLIONE A CASAURIA': 'C308',
  'CASTIGLIONE DEL LAGO': 'C309',
  'CASTIGLIONE DELLA PESCAIA': 'C310',
  'COLLEDARA': 'C311',
  'CASTIGLIONE DELLE STIVIERE': 'C312',
  'CASTIGLIONE D\'ORCIA': 'C313',
  'CASTIGLIONE FALLETTO': 'C314',
  'CASTIGLIONE IN TEVERINA': 'C315',
  'CASTIGLIONE MESSER RAIMONDO': 'C316',
  'CASTIGLIONE TINELLA': 'C317',
  'CASTIGLION FIBOCCHI': 'C318',
  'CASTIGLION FIORENTINO': 'C319',
  'CASTIGNANO': 'C321',
  'CASTILENTI': 'C322',
  'CASTINO': 'C323',
  'CASTIONE DELLA PRESOLANA': 'C324',
  'CASTIONE ANDEVENNO': 'C325',
  'CASTIONS DI STRADA': 'C327',
  'CASTIRAGA VIDARDO': 'C329',
  'CASTO': 'C330',
  'CASTORANO': 'C331',
  'CASTREZZATO': 'C332',
  'CASTRI DI LECCE': 'C334',
  'CASTRIGNANO DE\' GRECI': 'C335',
  'CASTRIGNANO DEL CAPO': 'C336',
  'CASTRO': 'M261',
  'CASTRO DEI VOLSCI': 'C338',
  'CASTROCARO TERME E TERRA DEL SOLE': 'C339',
  'CASTROCIELO': 'C340',
  'CASTROFILIPPO': 'C341',
  'ENNA': 'C342',
  'CASTRONNO': 'C343',
  'CASTRONOVO DI SICILIA': 'C344',
  'CASTRONUOVO DI SANT\'ANDREA': 'C345',
  'CASTROPIGNANO': 'C346',
  'CASTROREALE': 'C347',
  'CASTROREGIO': 'C348',
  'CASTROVILLARI': 'C349',
  'CATANIA': 'C351',
  'CATANZARO': 'C352',
  'CATENANUOVA': 'C353',
  'CATIGNANO': 'C354',
  'CATTOLICA ERACLEA': 'C356',
  'CATTOLICA': 'C357',
  'CAUTANO': 'C359',
  'CAVA MANARA': 'C360',
  'CAVA DE\' TIRRENI': 'C361',
  'CAVACURTA': 'C362',
  'CAVAGLIA\'': 'C363',
  'CAVAGLIETTO': 'C364',
  'CAVAGLIO D\'AGOGNA': 'C365',
  'CAVAGLIO-SPOCCIA': 'C367',
  'CAVAGNOLO': 'C369',
  'CAVAION VERONESE': 'C370',
  'CAVALESE': 'C372',
  'CAVALLASCA': 'C374',
  'CAVALLERLEONE': 'C375',
  'CAVALLERMAGGIORE': 'C376',
  'CAVALLINO': 'C377',
  'CAVALLIRIO': 'C378',
  'CAVARENO': 'C380',
  'CAVARGNA': 'C381',
  'CAVARIA CON PREMEZZO': 'C382',
  'CAVARZERE': 'C383',
  'CAVASO DEL TOMBA': 'C384',
  'CAVASSO NUOVO': 'C385',
  'CAVATORE': 'C387',
  'JESOLO': 'C388',
  'CAVAZZO CARNICO': 'C389',
  'CAVE': 'C390',
  'CAVEDAGO': 'C392',
  'CAVEDINE': 'C393',
  'CAVENAGO D\'ADDA': 'C394',
  'CAVENAGO DI BRIANZA': 'C395',
  'CAVERNAGO': 'C396',
  'CAVEZZO': 'C398',
  'CAVIZZANA': 'C400',
  'CAVOUR': 'C404',
  'CAVRIAGO': 'C405',
  'CAVRIANA': 'C406',
  'CAVRIGLIA': 'C407',
  'CAZZAGO SAN MARTINO': 'C408',
  'CAZZAGO BRABBIA': 'C409',
  'CAZZANO SANT\'ANDREA': 'C410',
  'CAZZANO DI TRAMIGNA': 'C412',
  'CECCANO': 'C413',
  'CECIMA': 'C414',
  'CECINA': 'C415',
  'CEDEGOLO': 'C417',
  'CEDRASCO': 'C418',
  'CEFALA\' DIANA': 'C420',
  'CEFALU\'': 'C421',
  'CEGGIA': 'C422',
  'CEGLIE MESSAPICA': 'C424',
  'CELANO': 'C426',
  'CELENZA SUL TRIGNO': 'C428',
  'CELENZA VALFORTORE': 'C429',
  'CELICO': 'C430',
  'CELLA MONTE': 'C432',
  'CELLA DATI': 'C435',
  'CELLAMARE': 'C436',
  'CELLARA': 'C437',
  'CELLARENGO': 'C438',
  'CELLATICA': 'C439',
  'CELLE ENOMONDO': 'C440',
  'CELLE DI MACRA': 'C441',
  'CELLE SAN VITO': 'C442',
  'CELLE LIGURE': 'C443',
  'CELLE DI BULGHERIA': 'C444',
  'CELLENO': 'C446',
  'CELLERE': 'C447',
  'CELLINO SAN MARCO': 'C448',
  'CELLINO ATTANASIO': 'C449',
  'CELLIO': 'C450',
  'CEMBRA': 'C452',
  'CENADI': 'C453',
  'CENATE SOPRA': 'C456',
  'CENATE SOTTO': 'C457',
  'CENCENIGHE AGORDINO': 'C458',
  'CENE': 'C459',
  'CENESELLI': 'C461',
  'CENGIO': 'C463',
  'CENTALLO': 'C466',
  'CENTA SAN NICOLO\'': 'C467',
  'CENTO': 'C469',
  'CENTOLA': 'C470',
  'CENTURIPE': 'C471',
  'CENTRACHE': 'C472',
  'CEPAGATTI': 'C474',
  'CEPPALONI': 'C476',
  'CEPPO MORELLI': 'C478',
  'CEPRANO': 'C479',
  'CERAMI': 'C480',
  'CERANESI': 'C481',
  'CERANO D\'INTELVI': 'C482',
  'CERANO': 'C483',
  'CERANOVA': 'C484',
  'CERASO': 'C485',
  'CERCEMAGGIORE': 'C486',
  'CERCENASCO': 'C487',
  'CERCEPICCOLA': 'C488',
  'CERCHIARA DI CALABRIA': 'C489',
  'CERCHIO': 'C492',
  'CERCINO': 'C493',
  'CERCIVENTO': 'C494',
  'CERCOLA': 'C495',
  'CERDA': 'C496',
  'CERES': 'C497',
  'CEREA': 'C498',
  'CEREGNANO': 'C500',
  'CERENZIA': 'C501',
  'CERESARA': 'C502',
  'CERESETO': 'C503',
  'CERESOLE D\'ALBA': 'C504',
  'CERESOLE REALE': 'C505',
  'CERETE': 'C506',
  'CERRETO GRUE': 'C507',
  'CERETTO LOMELLINA': 'C508',
  'CERGNAGO': 'C509',
  'CERIALE': 'C510',
  'CERIANA': 'C511',
  'CERIANO LAGHETTO': 'C512',
  'CERIGNALE': 'C513',
  'CERIGNOLA': 'C514',
  'CERISANO': 'C515',
  'CERMENATE': 'C516',
  'CERMIGNANO': 'C517',
  'CERRETO LAZIALE': 'C518',
  'CERNOBBIO': 'C520',
  'CERNUSCO LOMBARDONE': 'C521',
  'CERNUSCO SUL NAVIGLIO': 'C523',
  'CERRETO D\'ESI': 'C524',
  'CERRETO SANNITA': 'C525',
  'CERRETO CASTELLO': 'C526',
  'CERRETO DI SPOLETO': 'C527',
  'CERRETO D\'ASTI': 'C528',
  'CERRETO GUIDI': 'C529',
  'CERRETTO LANGHE': 'C530',
  'CERRINA': 'C531',
  'CERRIONE': 'C532',
  'CERRO TANARO': 'C533',
  'CERRO AL VOLTURNO': 'C534',
  'CERRO AL LAMBRO': 'C536',
  'CERRO MAGGIORE': 'C537',
  'CERRO VERONESE': 'C538',
  'CERSOSIMO': 'C539',
  'CERTALDO': 'C540',
  'CERTOSA DI PAVIA': 'C541',
  'CERVA': 'C542',
  'CERVARA DI ROMA': 'C543',
  'CERVARESE SANTA CROCE': 'C544',
  'CERVARO': 'C545',
  'CERVASCA': 'C547',
  'CERVATTO': 'C548',
  'CERVENO': 'C549',
  'CERVERE': 'C550',
  'CERVESINA': 'C551',
  'CERVETERI': 'C552',
  'CERVIA': 'C553',
  'CERVICATI': 'C554',
  'CERVIGNANO D\'ADDA': 'C555',
  'CERVIGNANO DEL FRIULI': 'C556',
  'CERVINARA': 'C557',
  'CERVINO': 'C558',
  'CERVO': 'C559',
  'CERZETO': 'C560',
  'CESA': 'C561',
  'LENTIAI': 'C562',
  'CESANA BRIANZA': 'C563',
  'CESANA TORINESE': 'C564',
  'CESANO BOSCONE': 'C565',
  'CESANO MADERNO': 'C566',
  'CESARA': 'C567',
  'CESARO\'': 'C568',
  'CESATE': 'C569',
  'CESENA': 'C573',
  'CESENATICO': 'C574',
  'CESINALI': 'C576',
  'CESIOMAGGIORE': 'C577',
  'CESIO': 'C578',
  'CESSALTO': 'C580',
  'CESSANITI': 'C581',
  'CESSAPALOMBO': 'C582',
  'CESSOLE': 'C583',
  'CETARA': 'C584',
  'CETO': 'C585',
  'CETONA': 'C587',
  'CETRARO': 'C588',
  'CEVA': 'C589',
  'CEVO': 'C591',
  'CHALLAND-SAINT-ANSELME': 'C593',
  'CHALLAND-SAINT-VICTOR': 'C594',
  'CHAMBAVE': 'C595',
  'CHAMPDEPRAZ': 'C596',
  'CHARVENSOD': 'C598',
  'CHERASCO': 'C599',
  'CHEREMULE': 'C600',
  'CHIALAMBERTO': 'C604',
  'CHIAMPO': 'C605',
  'CHIANCHE': 'C606',
  'CHIANCIANO TERME': 'C608',
  'CHIANNI': 'C609',
  'CHIANOCCO': 'C610',
  'CHIARAMONTE GULFI': 'C612',
  'CHIARAMONTI': 'C613',
  'CHIARANO': 'C614',
  'CHIARAVALLE': 'C615',
  'CHIARAVALLE CENTRALE': 'C616',
  'CHIARI': 'C618',
  'CHIAROMONTE': 'C619',
  'CHIAUCI': 'C620',
  'CHIAVARI': 'C621',
  'CHIAVENNA': 'C623',
  'CHIAVERANO': 'C624',
  'CHIENES * KIENS': 'C625',
  'CHIERI': 'C627',
  'CHIESA IN VALMALENCO': 'C628',
  'CHIESANUOVA': 'C629',
  'CHIES D\'ALPAGO': 'C630',
  'CHIESINA UZZANESE': 'C631',
  'CHIETI': 'C632',
  'CHIEUTI': 'C633',
  'CHIEVE': 'C634',
  'CHIGNOLO D\'ISOLA': 'C635',
  'CHIGNOLO PO': 'C637',
  'CHIOGGIA': 'C638',
  'CHIOMONTE': 'C639',
  'CHIONS': 'C640',
  'CHIOPRIS VISCONE': 'C641',
  'CHITIGNANO': 'C648',
  'CHIUDUNO': 'C649',
  'CHIUPPANO': 'C650',
  'CHIURO': 'C651',
  'CHIUSA * KLAUSEN': 'C652',
  'CHIUSA DI PESIO': 'C653',
  'CHIUSA SCLAFANI': 'C654',
  'CHIUSA SAN MICHELE': 'C655',
  'CHIUSAFORTE': 'C656',
  'CHIUSANICO': 'C657',
  'CHIUSANO D\'ASTI': 'C658',
  'CHIUSANO DI SAN DOMENICO': 'C659',
  'CHIUSAVECCHIA': 'C660',
  'CHIUSDINO': 'C661',
  'CHIUSI': 'C662',
  'CHIUSI DELLA VERNA': 'C663',
  'CHIVASSO': 'C665',
  'CIANCIANA': 'C668',
  'CANOSSA': 'C669',
  'CROCETTA DEL MONTELLO': 'C670',
  'CIBIANA DI CADORE': 'C672',
  'CICAGNA': 'C673',
  'CICALA': 'C674',
  'CICCIANO': 'C675',
  'CICERALE': 'C676',
  'CICILIANO': 'C677',
  'CICOGNOLO': 'C678',
  'CICONIO': 'C679',
  'CIGLIANO': 'C680',
  'CIGLIE\'': 'C681',
  'CIGOGNOLA': 'C684',
  'CIGOLE': 'C685',
  'CILAVEGNA': 'C686',
  'CIMADOLMO': 'C689',
  'CIMBERGO': 'C691',
  'CIMEGO': 'C694',
  'CIMINA\'': 'C695',
  'CIMINNA': 'C696',
  'CIMITILE': 'C697',
  'TAVERNOLE SUL MELLA': 'C698',
  'CIMOLAIS': 'C699',
  'CIMONE': 'C700',
  'CINAGLIO': 'C701',
  'CINETO ROMANO': 'C702',
  'CINGIA DE\' BOTTI': 'C703',
  'CINGOLI': 'C704',
  'CINIGIANO': 'C705',
  'CINISELLO BALSAMO': 'C707',
  'CINISI': 'C708',
  'CINO': 'C709',
  'CINQUEFRONDI': 'C710',
  'CINTANO': 'C711',
  'CINTE TESINO': 'C712',
  'CINTO EUGANEO': 'C713',
  'CINTO CAOMAGGIORE': 'C714',
  'CINZANO': 'C715',
  'CIORLANO': 'C716',
  'SANTA MARIA DEL CEDRO': 'C717',
  'CIPRESSA': 'C718',
  'CIRCELLO': 'C719',
  'CIRIE\'': 'C722',
  'CIRIGLIANO': 'C723',
  'CIRIMIDO': 'C724',
  'CIRO\'': 'C725',
  'CIRO\' MARINA': 'C726',
  'CIS': 'C727',
  'CISANO BERGAMASCO': 'C728',
  'CISANO SUL NEVA': 'C729',
  'CISERANO': 'C730',
  'CISLAGO': 'C732',
  'CISLIANO': 'C733',
  'CISMON DEL GRAPPA': 'C734',
  'CISON DI VALMARINO': 'C735',
  'CISSONE': 'C738',
  'CISTERNA D\'ASTI': 'C739',
  'CISTERNA DI LATINA': 'C740',
  'CISTERNINO': 'C741',
  'CITERNA': 'C742',
  'CITTADELLA': 'C743',
  'CITTA\' DELLA PIEVE': 'C744',
  'CITTA\' DI CASTELLO': 'C745',
  'CITTADUCALE': 'C746',
  'CITTANOVA': 'C747',
  'CITTAREALE': 'C749',
  'CITTA\' SANT\'ANGELO': 'C750',
  'CITTIGLIO': 'C751',
  'CIVATE': 'C752',
  'CIVENNA': 'C754',
  'CIVEZZA': 'C755',
  'CIVEZZANO': 'C756',
  'CIVIASCO': 'C757',
  'CIVIDALE DEL FRIULI': 'C758',
  'CIVIDATE AL PIANO': 'C759',
  'CIVIDATE CAMUNO': 'C760',
  'CIVITA': 'C763',
  'CIVITACAMPOMARANO': 'C764',
  'CIVITA CASTELLANA': 'C765',
  'CIVITA D\'ANTINO': 'C766',
  'LANUVIO': 'C767',
  'CIVITALUPARELLA': 'C768',
  'CIVITANOVA DEL SANNIO': 'C769',
  'CIVITANOVA MARCHE': 'C770',
  'CIVITAQUANA': 'C771',
  'DURONIA': 'C772',
  'CIVITAVECCHIA': 'C773',
  'CIVITELLA IN VAL DI CHIANA': 'C774',
  'CIVITELLA MESSER RAIMONDO': 'C776',
  'CIVITELLA DI ROMAGNA': 'C777',
  'CIVITELLA ALFEDENA': 'C778',
  'CIVITELLA CASANOVA': 'C779',
  'CIVITELLA D\'AGLIANO': 'C780',
  'CIVITELLA DEL TRONTO': 'C781',
  'CIVITELLA PAGANICO': 'C782',
  'CIVITELLA ROVETO': 'C783',
  'CIVITELLA SAN PAOLO': 'C784',
  'CIVO': 'C785',
  'CLAINO CON OSTENO': 'C787',
  'UBIALE CLANEZZO': 'C789',
  'CLAUT': 'C790',
  'CLAUZETTO': 'C791',
  'CLAVESANA': 'C792',
  'CLAVIERE': 'C793',
  'CLES': 'C794',
  'CLETO': 'C795',
  'CLIVIO': 'C796',
  'CLOZ': 'C797',
  'CLUSONE': 'C800',
  'COASSOLO TORINESE': 'C801',
  'COAZZE': 'C803',
  'COAZZOLO': 'C804',
  'COCCAGLIO': 'C806',
  'COCCONATO': 'C807',
  'COCQUIO-TREVISAGO': 'C810',
  'COCULLO': 'C811',
  'CODEVIGO': 'C812',
  'CODEVILLA': 'C813',
  'CODIGORO': 'C814',
  'CODOGNE\'': 'C815',
  'CODOGNO': 'C816',
  'CODROIPO': 'C817',
  'CODRONGIANUS': 'C818',
  'COGGIOLA': 'C819',
  'COGLIATE': 'C820',
  'COGNE': 'C821',
  'COGOLETO': 'C823',
  'COGOLLO DEL CENGIO': 'C824',
  'COGORNO': 'C826',
  'COLAZZA': 'C829',
  'COLBORDOLO': 'C830',
  'COLERE': 'C835',
  'COLFELICE': 'C836',
  'COLI': 'C838',
  'COLICO': 'C839',
  'COLLAGNA': 'C840',
  'COLLALTO SABINO': 'C841',
  'COLLARMELE': 'C844',
  'COLLAZZONE': 'C845',
  'COLLE SANNITA': 'C846',
  'COLLE DI VAL D\'ELSA': 'C847',
  'COLLE UMBERTO': 'C848',
  'COLLEBEATO': 'C850',
  'COLLE BRIANZA': 'C851',
  'COLLECCHIO': 'C852',
  'COLLECORVINO': 'C853',
  'COLLE D\'ANCHISE': 'C854',
  'COLLEDIMACINE': 'C855',
  'COLLEDIMEZZO': 'C856',
  'COLLE DI TORA': 'C857',
  'COLLEFERRO': 'C858',
  'COLLEGIOVE': 'C859',
  'COLLEGNO': 'C860',
  'COLLELONGO': 'C862',
  'COLLEPARDO': 'C864',
  'COLLEPASSO': 'C865',
  'COLLEPIETRO': 'C866',
  'COLLERETTO CASTELNUOVO': 'C867',
  'COLLERETTO GIACOSA': 'C868',
  'COLLESALVETTI': 'C869',
  'COLLE SAN MAGNO': 'C870',
  'COLLESANO': 'C871',
  'COLLE SANTA LUCIA': 'C872',
  'COLLETORTO': 'C875',
  'COLLEVECCHIO': 'C876',
  'COLLI DEL TRONTO': 'C877',
  'COLLI A VOLTURNO': 'C878',
  'COLLIANO': 'C879',
  'COLLI SUL VELINO': 'C880',
  'COLLINAS': 'C882',
  'COLLIO': 'C883',
  'COLLOBIANO': 'C884',
  'COLLOREDO DI MONTE ALBANO': 'C885',
  'COLMURANO': 'C886',
  'COLOBRARO': 'C888',
  'COLOGNA VENETA': 'C890',
  'COLOGNE': 'C893',
  'COLOGNO AL SERIO': 'C894',
  'COLOGNO MONZESE': 'C895',
  'COLOGNOLA AI COLLI': 'C897',
  'COLONNA': 'C900',
  'COLONNELLA': 'C901',
  'COLONNO': 'C902',
  'COLORINA': 'C903',
  'COLORNO': 'C904',
  'COLOSIMI': 'C905',
  'COLTURANO': 'C908',
  'COLZATE': 'C910',
  'COMABBIO': 'C911',
  'COMACCHIO': 'C912',
  'COMANO': 'C915',
  'COMAZZO': 'C917',
  'COMEGLIANS': 'C918',
  'SANTO STEFANO DI CADORE': 'C919',
  'COMELICO SUPERIORE': 'C920',
  'COMERIO': 'C922',
  'COMEZZANO-CIZZAGO': 'C925',
  'COMIGNAGO': 'C926',
  'COMISO': 'C927',
  'COMITINI': 'C928',
  'COMIZIANO': 'C929',
  'COMMESSAGGIO': 'C930',
  'COMMEZZADURA': 'C931',
  'COMO': 'C933',
  'COMPIANO': 'C934',
  'COMUNANZA': 'C935',
  'VALSOLDA': 'C936',
  'COMUN NUOVO': 'C937',
  'CONA': 'C938',
  'CONCA DELLA CAMPANIA': 'C939',
  'CONCA DEI MARINI': 'C940',
  'CONCA CASALE': 'C941',
  'CONCAMARISE': 'C943',
  'CONCEI': 'C944',
  'CONCERVIANO': 'C946',
  'CONCESIO': 'C948',
  'CONCO': 'C949',
  'CONCORDIA SAGITTARIA': 'C950',
  'CONCORDIA SULLA SECCHIA': 'C951',
  'CONCOREZZO': 'C952',
  'CONDINO': 'C953',
  'CONDOFURI': 'C954',
  'CONDOVE': 'C955',
  'CONDRO\'': 'C956',
  'CONEGLIANO': 'C957',
  'CONFIENZA': 'C958',
  'CONFIGNI': 'C959',
  'CONFLENTI': 'C960',
  'CONIOLO': 'C962',
  'CONSELICE': 'C963',
  'CONSELVE': 'C964',
  'CONSIGLIO DI RUMO': 'C965',
  'CONTESSA ENTELLINA': 'C968',
  'CONTIGLIANO': 'C969',
  'CONTRADA': 'C971',
  'CONTROGUERRA': 'C972',
  'CONTRONE': 'C973',
  'CONTURSI TERME': 'C974',
  'CONVERSANO': 'C975',
  'CONZA DELLA CAMPANIA': 'C976',
  'CONZANO': 'C977',
  'COPERTINO': 'C978',
  'COPIANO': 'C979',
  'COPPARO': 'C980',
  'CORANA': 'C982',
  'CORATO': 'C983',
  'CORBARA': 'C984',
  'CORBETTA': 'C986',
  'CORBOLA': 'C987',
  'CORCHIANO': 'C988',
  'CORCIANO': 'C990',
  'CORDENONS': 'C991',
  'CORDIGNANO': 'C992',
  'CORDOVADO': 'C993',
  'COREDO': 'C994',
  'COREGLIA LIGURE': 'C995',
  'COREGLIA ANTELMINELLI': 'C996',
  'CORENO AUSONIO': 'C998',
  'CORFINIO': 'C999',
  'CORI': 'D003',
  'CORIANO': 'D004',
  'CORIGLIANO CALABRO': 'D005',
  'CORIGLIANO D\'OTRANTO': 'D006',
  'CORINALDO': 'D007',
  'CORIO': 'D008',
  'CORLEONE': 'D009',
  'CORLETO PERTICARA': 'D010',
  'CORLETO MONFORTE': 'D011',
  'COURMAYEUR': 'D012',
  'CORMANO': 'D013',
  'CORMONS': 'D014',
  'CORNA IMAGNA': 'D015',
  'CORNALBA': 'D016',
  'CORNALE': 'D017',
  'CORNAREDO': 'D018',
  'CORNATE D\'ADDA': 'D019',
  'CORNEDO VICENTINO': 'D020',
  'CORNEGLIANO LAUDENSE': 'D021',
  'CORNELIANO D\'ALBA': 'D022',
  'TARQUINIA': 'D024',
  'CORNIGLIO': 'D026',
  'CORNO DI ROSAZZO': 'D027',
  'CORNO GIOVINE': 'D028',
  'CORNOVECCHIO': 'D029',
  'CORNUDA': 'D030',
  'MORIMONDO': 'D033',
  'CORREGGIO': 'D037',
  'CORREZZANA': 'D038',
  'CORREZZOLA': 'D040',
  'CORRIDO': 'D041',
  'CORRIDONIA': 'D042',
  'CORROPOLI': 'D043',
  'CORSANO': 'D044',
  'CORSICO': 'D045',
  'CORSIONE': 'D046',
  'CORTACCIA SULLA STRADA DEL VINO * KURTATSCH AN DER WEINSTRASSE': 'D048',
  'CORTALE': 'D049',
  'CORTANDONE': 'D050',
  'CORTANZE': 'D051',
  'CORTAZZONE': 'D052',
  'CORTE BRUGNATELLA': 'D054',
  'CORTE DE\' CORTESI CON CIGNONE': 'D056',
  'CORTE DE\' FRATI': 'D057',
  'CORTE FRANCA': 'D058',
  'CORTEMAGGIORE': 'D061',
  'CORTEMILIA': 'D062',
  'CORTENO GOLGI': 'D064',
  'CORTENOVA': 'D065',
  'CORTENUOVA': 'D066',
  'CORTEOLONA': 'D067',
  'CORTE PALASIO': 'D068',
  'CORTIGLIONE': 'D072',
  'CORTINA SULLA STRADA DEL VINO * KURTINIG AN DER WEINSTRASSE': 'D075',
  'CORTINO': 'D076',
  'CORTONA': 'D077',
  'CORVARA': 'D078',
  'CORVARA IN BADIA * CORVARA': 'D079',
  'CORVINO SAN QUIRICO': 'D081',
  'CORZANO': 'D082',
  'COSEANO': 'D085',
  'COSENZA': 'D086',
  'COSIO DI ARROSCIA': 'D087',
  'COSIO VALTELLINO': 'D088',
  'COSOLETO': 'D089',
  'COSSANO CANAVESE': 'D092',
  'COSSANO BELBO': 'D093',
  'COSSATO': 'D094',
  'COSSERIA': 'D095',
  'COSSIGNANO': 'D096',
  'COSSOGNO': 'D099',
  'COSSOINE': 'D100',
  'COSSOMBRATO': 'D101',
  'COSTA VESCOVATO': 'D102',
  'COSTA VALLE IMAGNA': 'D103',
  'COSTA DI ROVIGO': 'D105',
  'COSTABISSARA': 'D107',
  'COSTACCIARO': 'D108',
  'COSTA DE\' NOBILI': 'D109',
  'COSTA DI MEZZATE': 'D110',
  'COSTA SERINA': 'D111',
  'COSTA MASNAGA': 'D112',
  'COSTANZANA': 'D113',
  'COSTARAINERA': 'D114',
  'COSTA VOLPINO': 'D117',
  'COSTERMANO': 'D118',
  'COSTIGLIOLE D\'ASTI': 'D119',
  'COSTIGLIOLE SALUZZO': 'D120',
  'COTIGNOLA': 'D121',
  'CROTONE': 'D122',
  'COTRONEI': 'D123',
  'COTTANELLO': 'D124',
  'COVO': 'D126',
  'COZZO': 'D127',
  'CRACO': 'D128',
  'CRANDOLA VALSASSINA': 'D131',
  'CRAVAGLIANA': 'D132',
  'CRAVANZANA': 'D133',
  'CRAVEGGIA': 'D134',
  'CREAZZO': 'D136',
  'CRECCHIO': 'D137',
  'CREDARO': 'D139',
  'CREDERA RUBBIANO': 'D141',
  'CREMA': 'D142',
  'CREMELLA': 'D143',
  'CREMENAGA': 'D144',
  'CREMENO': 'D145',
  'CREMIA': 'D147',
  'CREMOLINO': 'D149',
  'CREMONA': 'D150',
  'CREMOSANO': 'D151',
  'CRESCENTINO': 'D154',
  'CRESPADORO': 'D156',
  'CRESPANO DEL GRAPPA': 'D157',
  'CRESPELLANO': 'D158',
  'CRESPIATICA': 'D159',
  'CRESPINA': 'D160',
  'CRESPINO': 'D161',
  'CRESSA': 'D162',
  'CREVACUORE': 'D165',
  'CREVALCORE': 'D166',
  'CREVOLADOSSOLA': 'D168',
  'CRISPANO': 'D170',
  'CRISPIANO': 'D171',
  'CRISSOLO': 'D172',
  'CROCEFIESCHI': 'D175',
  'CRODO': 'D177',
  'CROGNALETO': 'D179',
  'CROPALATI': 'D180',
  'CROPANI': 'D181',
  'CROSA': 'D182',
  'CROSIA': 'D184',
  'CROSIO DELLA VALLE': 'D185',
  'CROTTA D\'ADDA': 'D186',
  'CROVA': 'D187',
  'CROVIANA': 'D188',
  'CRUCOLI': 'D189',
  'CUASSO AL MONTE': 'D192',
  'VERONELLA': 'D193',
  'CUCCARO MONFERRATO': 'D194',
  'CUCCARO VETERE': 'D195',
  'CUCCIAGO': 'D196',
  'CUCEGLIO': 'D197',
  'CUGGIONO': 'D198',
  'CUGLIATE-FABIASCO': 'D199',
  'CUGLIERI': 'D200',
  'CUGNOLI': 'D201',
  'CUMIANA': 'D202',
  'CUMIGNANO SUL NAVIGLIO': 'D203',
  'CUNARDO': 'D204',
  'CUNEO': 'D205',
  'CUNEVO': 'D206',
  'CUNICO': 'D207',
  'CUORGNE\'': 'D208',
  'CUPELLO': 'D209',
  'CUPRA MARITTIMA': 'D210',
  'CUPRAMONTANA': 'D211',
  'CURCURIS': 'D214',
  'CUREGGIO': 'D216',
  'CURIGLIA CON MONTEVIASCO': 'D217',
  'CURINGA': 'D218',
  'CURINO': 'D219',
  'CURNO': 'D221',
  'CURON VENOSTA * GRAUN IM VINSCHGAU': 'D222',
  'CURSI': 'D223',
  'CURSOLO-ORASSO': 'D225',
  'CURTAROLO': 'D226',
  'CURTATONE': 'D227',
  'CURTI': 'D228',
  'CUSAGO': 'D229',
  'CUSANO MUTRI': 'D230',
  'CUSANO MILANINO': 'D231',
  'CUSINO': 'D232',
  'CUSIO': 'D233',
  'CUSTONACI': 'D234',
  'CUTIGLIANO': 'D235',
  'CUTRO': 'D236',
  'CUTROFIANO': 'D237',
  'CUVEGLIO': 'D238',
  'CUVIO': 'D239',
  'DAIANO': 'D243',
  'DAIRAGO': 'D244',
  'DALMINE': 'D245',
  'DAMBEL': 'D246',
  'DANTA DI CADORE': 'D247',
  'DAONE': 'D248',
  'DARE\'': 'D250',
  'DARFO BOARIO TERME': 'D251',
  'DASA\'': 'D253',
  'DAVAGNA': 'D255',
  'DAVERIO': 'D256',
  'DAVOLI': 'D257',
  'DAZIO': 'D258',
  'DECIMOMANNU': 'D259',
  'DECIMOPUTZU': 'D260',
  'DECOLLATURA': 'D261',
  'DEGO': 'D264',
  'DEIVA MARINA': 'D265',
  'DELEBIO': 'D266',
  'DELIA': 'D267',
  'DELIANUOVA': 'D268',
  'DELICETO': 'D269',
  'DELLO': 'D270',
  'DEMONTE': 'D271',
  'DENICE': 'D272',
  'DENNO': 'D273',
  'DERNICE': 'D277',
  'DEROVERE': 'D278',
  'DERUTA': 'D279',
  'DERVIO': 'D280',
  'DESANA': 'D281',
  'DESENZANO DEL GARDA': 'D284',
  'DESIO': 'D286',
  'DESULO': 'D287',
  'DIAMANTE': 'D289',
  'SCIGLIANO': 'D290',
  'DIANO D\'ALBA': 'D291',
  'TEGGIANO': 'D292',
  'DIANO ARENTINO': 'D293',
  'DIANO CASTELLO': 'D296',
  'DIANO MARINA': 'D297',
  'DIANO SAN PIETRO': 'D298',
  'DICOMANO': 'D299',
  'DIGNANO': 'D300',
  'DIMARO': 'D302',
  'DINAMI': 'D303',
  'DIPIGNANO': 'D304',
  'DISO': 'D305',
  'DIVIGNANO': 'D309',
  'DIZZASCO': 'D310',
  'DOBBIACO * TOBLACH': 'D311',
  'DOBERDO\' DEL LAGO': 'D312',
  'DOGLIANI': 'D314',
  'DOGLIOLA': 'D315',
  'DOGNA': 'D316',
  'DOLCE\'': 'D317',
  'DOLCEACQUA': 'D318',
  'DOLCEDO': 'D319',
  'DOLEGNA DEL COLLIO': 'D321',
  'DOLIANOVA': 'D323',
  'SAN DORLIGO DELLA VALLE': 'D324',
  'DOLO': 'D325',
  'DOLZAGO': 'D327',
  'DOMANICO': 'D328',
  'DOMASO': 'D329',
  'DOMEGGE DI CADORE': 'D330',
  'DOMICELLA': 'D331',
  'DOMODOSSOLA': 'D332',
  'DOMUS DE MARIA': 'D333',
  'DOMUSNOVAS': 'D334',
  'DON': 'D336',
  'DONNAS': 'D338',
  'DONATO': 'D339',
  'DONGO': 'D341',
  'DONORI': 'D344',
  'DORGALI': 'D345',
  'DORIO': 'D346',
  'DORMELLETTO': 'D347',
  'DORNO': 'D348',
  'DORSINO': 'D349',
  'DORZANO': 'D350',
  'DOSOLO': 'D351',
  'DOSSENA': 'D352',
  'DOSSO DEL LIRO': 'D355',
  'DOUES': 'D356',
  'DOVADOLA': 'D357',
  'DOVERA': 'D358',
  'DOZZA': 'D360',
  'DRAGONI': 'D361',
  'DRAPIA': 'D364',
  'DRENA': 'D365',
  'DRENCHIA': 'D366',
  'DRESANO': 'D367',
  'DREZZO': 'D369',
  'DRIZZONA': 'D370',
  'DRO': 'D371',
  'DRONERO': 'D372',
  'DRUENTO': 'D373',
  'DRUOGNO': 'D374',
  'DUALCHI': 'D376',
  'DUBINO': 'D377',
  'DUEVILLE': 'D379',
  'DUGENTA': 'D380',
  'DUINO-AURISINA': 'D383',
  'DUMENZA': 'D384',
  'DUNO': 'D385',
  'DURAZZANO': 'D386',
  'DUSINO SAN MICHELE': 'D388',
  'EBOLI': 'D390',
  'EDOLO': 'D391',
  'EGNA * NEUMARKT': 'D392',
  'ELICE': 'D394',
  'ELINI': 'D395',
  'ELLO': 'D398',
  'ELMAS': 'D399',
  'ELVA': 'D401',
  'EMARESE': 'D402',
  'EMPOLI': 'D403',
  'ENDINE GAIANO': 'D406',
  'ENEGO': 'D407',
  'ENEMONZO': 'D408',
  'ENTRACQUE': 'D410',
  'ENTRATICO': 'D411',
  'ENVIE': 'D412',
  'EPISCOPIA': 'D414',
  'ERACLEA': 'D415',
  'ERBA': 'D416',
  'ERBE\'': 'D419',
  'ERBEZZO': 'D420',
  'ERBUSCO': 'D421',
  'ERCHIE': 'D422',
  'ERICE': 'D423',
  'ERLI': 'D424',
  'ERTO E CASSO': 'D426',
  'ERVE': 'D428',
  'ESANATOGLIA': 'D429',
  'ESCALAPLANO': 'D430',
  'ESCOLCA': 'D431',
  'EXILLES': 'D433',
  'ESINE': 'D434',
  'ESINO LARIO': 'D436',
  'ESPERIA': 'D440',
  'ESPORLATU': 'D441',
  'ESTE': 'D442',
  'ESTERZILI': 'D443',
  'ETROUBLES': 'D444',
  'EUPILIO': 'D445',
  'FABBRICA CURONE': 'D447',
  'FABBRICHE DI VALLICO': 'D449',
  'FABBRICO': 'D450',
  'FABRIANO': 'D451',
  'FABRICA DI ROMA': 'D452',
  'FABRIZIA': 'D453',
  'FABRO': 'D454',
  'FAEDIS': 'D455',
  'FAEDO VALTELLINO': 'D456',
  'FAEDO': 'D457',
  'FAENZA': 'D458',
  'FAETO': 'D459',
  'FAGAGNA': 'D461',
  'FAGGETO LARIO': 'D462',
  'FAGGIANO': 'D463',
  'FAGNANO CASTELLO': 'D464',
  'FAGNANO ALTO': 'D465',
  'FAGNANO OLONA': 'D467',
  'FAI DELLA PAGANELLA': 'D468',
  'FAICCHIO': 'D469',
  'FALCADE': 'D470',
  'FALCIANO DEL MASSICO': 'D471',
  'FALCONARA MARITTIMA': 'D472',
  'FALCONARA ALBANESE': 'D473',
  'FALCONE': 'D474',
  'FALERIA': 'D475',
  'FALERNA': 'D476',
  'FALERONE': 'D477',
  'FALLO': 'D480',
  'FALMENTA': 'D481',
  'FALOPPIO': 'D482',
  'FALVATERRA': 'D483',
  'FALZES * PFALZEN': 'D484',
  'FANANO': 'D486',
  'FANNA': 'D487',
  'FANO': 'D488',
  'FANO ADRIANO': 'D489',
  'FARA GERA D\'ADDA': 'D490',
  'FARA OLIVANA CON SOLA': 'D491',
  'FARA NOVARESE': 'D492',
  'FARA IN SABINA': 'D493',
  'FARA FILIORUM PETRI': 'D494',
  'FARA SAN MARTINO': 'D495',
  'FARA VICENTINO': 'D496',
  'FARDELLA': 'D497',
  'FARIGLIANO': 'D499',
  'FARINDOLA': 'D501',
  'FARINI': 'D502',
  'FARNESE': 'D503',
  'FARRA D\'ISONZO': 'D504',
  'FARRA DI SOLIGO': 'D505',
  'FARRA D\'ALPAGO': 'D506',
  'FASANO': 'D508',
  'FASCIA': 'D509',
  'FAUGLIA': 'D510',
  'FAULE': 'D511',
  'FAVALE DI MALVARO': 'D512',
  'VALSINNI': 'D513',
  'FAVARA': 'D514',
  'FAVER': 'D516',
  'FAVIGNANA': 'D518',
  'FAVRIA': 'D520',
  'ORCO FEGLINO': 'D522',
  'FEISOGLIO': 'D523',
  'FELETTO': 'D524',
  'FELINO': 'D526',
  'FELITTO': 'D527',
  'FELIZZANO': 'D528',
  'FELONICA': 'D529',
  'FELTRE': 'D530',
  'FENEGRO\'': 'D531',
  'FENESTRELLE': 'D532',
  'FENIS': 'D537',
  'FERENTILLO': 'D538',
  'FERENTINO': 'D539',
  'FERLA': 'D540',
  'FERMIGNANO': 'D541',
  'FERMO': 'D542',
  'FERNO': 'D543',
  'FEROLETO ANTICO': 'D544',
  'FEROLETO DELLA CHIESA': 'D545',
  'PIANOPOLI': 'D546',
  'FERRANDINA': 'D547',
  'FERRARA': 'D548',
  'FERRARA DI MONTE BALDO': 'D549',
  'FERRAZZANO': 'D550',
  'FERRERA DI VARESE': 'D551',
  'FERRERA ERBOGNONE': 'D552',
  'MONCENISIO': 'D553',
  'FERRERE': 'D554',
  'FERRIERE': 'D555',
  'FERRUZZANO': 'D557',
  'FRACONALTO': 'D559',
  'FIAMIGNANO': 'D560',
  'FIANO ROMANO': 'D561',
  'FIANO': 'D562',
  'FIASTRA': 'D564',
  'FIAVE\'': 'D565',
  'POGGIO SAN VICINO': 'D566',
  'FICARAZZI': 'D567',
  'FICAROLO': 'D568',
  'FICARRA': 'D569',
  'FICULLE': 'D570',
  'FIE\' ALLO SCILIAR * VOELS AM SCHLERN': 'D571',
  'FIERA DI PRIMIERO': 'D572',
  'FIEROZZO': 'D573',
  'FIESCO': 'D574',
  'FIESOLE': 'D575',
  'FIESSE': 'D576',
  'FIESSO UMBERTIANO': 'D577',
  'FIESSO D\'ARTICO': 'D578',
  'FIGINO SERENZA': 'D579',
  'FIGLINE VEGLIATURO': 'D582',
  'FIGLINE VALDARNO': 'D583',
  'GONNOSNO\'': 'D585',
  'FILACCIANO': 'D586',
  'FILADELFIA': 'D587',
  'FILAGO': 'D588',
  'FILANDARI': 'D589',
  'FILATTIERA': 'D590',
  'FILETTINO': 'D591',
  'FILETTO': 'D592',
  'FILIANO': 'D593',
  'FILIGHERA': 'D594',
  'FILIGNANO': 'D595',
  'FILOGASO': 'D596',
  'FILOTTRANO': 'D597',
  'FINALE EMILIA': 'D599',
  'FINALE LIGURE': 'D600',
  'FINO DEL MONTE': 'D604',
  'FINO MORNASCO': 'D605',
  'FIORANO AL SERIO': 'D606',
  'FIORANO MODENESE': 'D607',
  'FIORANO CANAVESE': 'D608',
  'FIORDIMONTE': 'D609',
  'FIORENZUOLA D\'ARDA': 'D611',
  'FIRENZE': 'D612',
  'FIRENZUOLA': 'D613',
  'FIRMO': 'D614',
  'FISCIANO': 'D615',
  'FIUMALBO': 'D617',
  'FIUMARA': 'D619',
  'FIUME VENETO': 'D621',
  'FIUMEDINISI': 'D622',
  'FIUMEFREDDO DI SICILIA': 'D623',
  'FIUMEFREDDO BRUZIO': 'D624',
  'FIUMICELLO': 'D627',
  'FIUMINATA': 'D628',
  'FIVIZZANO': 'D629',
  'FLAIBANO': 'D630',
  'FLAVON': 'D631',
  'FLERO': 'D634',
  'FLORESTA': 'D635',
  'FLORIDIA': 'D636',
  'FLORINAS': 'D637',
  'FLUMERI': 'D638',
  'FLUMINIMAGGIORE': 'D639',
  'FLUSSIO': 'D640',
  'FOBELLO': 'D641',
  'FOGGIA': 'D643',
  'FOGLIANISE': 'D644',
  'FOGLIANO REDIPUGLIA': 'D645',
  'FOGLIZZO': 'D646',
  'FOIANO DELLA CHIANA': 'D649',
  'FOIANO DI VAL FORTORE': 'D650',
  'FOLGARIA': 'D651',
  'FOLIGNANO': 'D652',
  'FOLIGNO': 'D653',
  'FOLLINA': 'D654',
  'FOLLO': 'D655',
  'FOLLONICA': 'D656',
  'FOMBIO': 'D660',
  'FONDACHELLI-FANTINA': 'D661',
  'FONDI': 'D662',
  'FONDO': 'D663',
  'FONNI': 'D665',
  'FONTAINEMORE': 'D666',
  'FONTANA LIRI': 'D667',
  'FONTANELICE': 'D668',
  'FONTANAFREDDA': 'D670',
  'FONTANAROSA': 'D671',
  'FONTANELLA': 'D672',
  'FONTANELLATO': 'D673',
  'FONTANELLE': 'D674',
  'FONTANETO D\'AGOGNA': 'D675',
  'FONTANETTO PO': 'D676',
  'FONTANIGORDA': 'D677',
  'FONTANILE': 'D678',
  'FONTANIVA': 'D679',
  'FONTE': 'D680',
  'FONTECCHIO': 'D681',
  'FONTECHIARI': 'D682',
  'FONTEGRECA': 'D683',
  'FONTENO': 'D684',
  'FONTEVIVO': 'D685',
  'FONZASO': 'D686',
  'FOPPOLO': 'D688',
  'FORANO': 'D689',
  'SAN GIOVANNI TEATINO': 'D690',
  'FORCE': 'D691',
  'FORCHIA': 'D693',
  'FORCOLA': 'D694',
  'FORDONGIANUS': 'D695',
  'FORENZA': 'D696',
  'FORESTO SPARSO': 'D697',
  'FORGARIA NEL FRIULI': 'D700',
  'FORINO': 'D701',
  'FORIO': 'D702',
  'FORLI\' DEL SANNIO': 'D703',
  'FORLI\'': 'D704',
  'FORLIMPOPOLI': 'D705',
  'FORMAZZA': 'D706',
  'FORMELLO': 'D707',
  'FORMIA': 'D708',
  'FORMICOLA': 'D709',
  'FORMIGARA': 'D710',
  'FORMIGINE': 'D711',
  'FORMIGLIANA': 'D712',
  'FORMIGNANA': 'D713',
  'FORNACE': 'D714',
  'FORNELLI': 'D715',
  'TONEZZA DEL CIMONE': 'D717',
  'FORNI AVOLTRI': 'D718',
  'FORNI DI SOPRA': 'D719',
  'FORNI DI SOTTO': 'D720',
  'FORNO CANAVESE': 'D725',
  'FORNO DI ZOLDO': 'D726',
  'FORNOVO SAN GIOVANNI': 'D727',
  'FORNOVO DI TARO': 'D728',
  'FORTE DEI MARMI': 'D730',
  'FORTEZZA * FRANZENSFESTE': 'D731',
  'FORTUNAGO': 'D732',
  'FORZA D\'AGRO\'': 'D733',
  'FOSCIANDORA': 'D734',
  'FOSDINOVO': 'D735',
  'FOSSA': 'D736',
  'FOSSALTO': 'D737',
  'FOSSACESIA': 'D738',
  'FOSSALTA DI PIAVE': 'D740',
  'FOSSALTA DI PORTOGRUARO': 'D741',
  'FOSSANO': 'D742',
  'FOSSATO SERRALTA': 'D744',
  'FOSSATO DI VICO': 'D745',
  'MONTEBELLO IONICO': 'D746',
  'FOSSO\'': 'D748',
  'FOSSOMBRONE': 'D749',
  'FOZA': 'D750',
  'FRABOSA SOPRANA': 'D751',
  'FRABOSA SOTTANA': 'D752',
  'FRAGAGNANO': 'D754',
  'FRAGNETO L\'ABATE': 'D755',
  'FRAGNETO MONFORTE': 'D756',
  'FRAINE': 'D757',
  'FRAMURA': 'D758',
  'FRANCAVILLA BISIO': 'D759',
  'FRANCAVILLA D\'ETE': 'D760',
  'FRANCAVILLA FONTANA': 'D761',
  'FRANCAVILLA ANGITOLA': 'D762',
  'FRANCAVILLA AL MARE': 'D763',
  'FRANCAVILLA MARITTIMA': 'D764',
  'FRANCAVILLA DI SICILIA': 'D765',
  'FRANCAVILLA IN SINNI': 'D766',
  'FRANCICA': 'D767',
  'FRANCOFONTE': 'D768',
  'FRANCOLISE': 'D769',
  'FRASCARO': 'D770',
  'FRASCAROLO': 'D771',
  'FRASCATI': 'D773',
  'FRASCINETO': 'D774',
  'FRASSILONGO': 'D775',
  'FRASSINELLE POLESINE': 'D776',
  'FRASSINELLO MONFERRATO': 'D777',
  'FRASSINETO PO': 'D780',
  'FRASSINETTO': 'D781',
  'FRASSINO': 'D782',
  'FRASSINORO': 'D783',
  'FRASSO TELESINO': 'D784',
  'FRASSO SABINO': 'D785',
  'UMBERTIDE': 'D786',
  'FRATTA TODINA': 'D787',
  'FRATTA POLESINE': 'D788',
  'FRATTAMAGGIORE': 'D789',
  'FRATTAMINORE': 'D790',
  'FRATTE ROSA': 'D791',
  'FRAZZANO\'': 'D793',
  'FREGONA': 'D794',
  'FRESAGRANDINARIA': 'D796',
  'FRESONARA': 'D797',
  'FRIGENTO': 'D798',
  'FRIGNANO': 'D799',
  'VILLA DI BRIANO': 'D801',
  'FRINCO': 'D802',
  'FRISA': 'D803',
  'FRISANCO': 'D804',
  'FRONT': 'D805',
  'FRONTINO': 'D807',
  'FRONTONE': 'D808',
  'FROSINONE': 'D810',
  'FROSOLONE': 'D811',
  'FROSSASCO': 'D812',
  'FRUGAROLO': 'D813',
  'FUBINE': 'D814',
  'FUCECCHIO': 'D815',
  'FUIPIANO VALLE IMAGNA': 'D817',
  'FUMANE': 'D818',
  'FUMONE': 'D819',
  'FUNES * VILLNOESS': 'D821',
  'FURCI': 'D823',
  'FURCI SICULO': 'D824',
  'FURNARI': 'D825',
  'FURORE': 'D826',
  'FURTEI': 'D827',
  'FUSCALDO': 'D828',
  'FUSIGNANO': 'D829',
  'FUSINE': 'D830',
  'FUTANI': 'D832',
  'GABBIONETA BINANUOVA': 'D834',
  'GABIANO': 'D835',
  'GABICCE MARE': 'D836',
  'GABY': 'D839',
  'GADESCO PIEVE DELMONA': 'D841',
  'GADONI': 'D842',
  'GAETA': 'D843',
  'GAGGI': 'D844',
  'GAGGIANO': 'D845',
  'GAGGIO MONTANO': 'D847',
  'GAGLIANICO': 'D848',
  'GAGLIANO CASTELFERRATO': 'D849',
  'GAGLIANO ATERNO': 'D850',
  'GAGLIANO DEL CAPO': 'D851',
  'GAGLIATO': 'D852',
  'GAGLIOLE': 'D853',
  'GAIARINE': 'D854',
  'GAIBA': 'D855',
  'GAIOLA': 'D856',
  'GAIOLE IN CHIANTI': 'D858',
  'GAIRO': 'D859',
  'GAIS * GAIS': 'D860',
  'GALATI MAMERTINO': 'D861',
  'GALATINA': 'D862',
  'GALATONE': 'D863',
  'GALATRO': 'D864',
  'GALBIATE': 'D865',
  'GALEATA': 'D867',
  'GALGAGNANO': 'D868',
  'GALLARATE': 'D869',
  'GALLESE': 'D870',
  'GALLIATE LOMBARDO': 'D871',
  'GALLIATE': 'D872',
  'GALLIAVOLA': 'D873',
  'GALLICANO': 'D874',
  'GALLICANO NEL LAZIO': 'D875',
  'GALLICCHIO': 'D876',
  'GALLIERA': 'D878',
  'GALLIERA VENETA': 'D879',
  'GALLINARO': 'D881',
  'GALLIO': 'D882',
  'GALLIPOLI': 'D883',
  'GALLO MATESE': 'D884',
  'GALLODORO': 'D885',
  'GALLUCCIO': 'D886',
  'GALTELLI': 'D888',
  'GALZIGNANO TERME': 'D889',
  'GAMALERO': 'D890',
  'GAMBARA': 'D891',
  'GAMBARANA': 'D892',
  'GAMBASCA': 'D894',
  'GAMBASSI TERME': 'D895',
  'GAMBATESA': 'D896',
  'GAMBELLARA': 'D897',
  'GAMBERALE': 'D898',
  'GAMBETTOLA': 'D899',
  'GAMBOLO\'': 'D901',
  'GAMBUGLIANO': 'D902',
  'GANDELLINO': 'D903',
  'GANDINO': 'D905',
  'GANDOSSO': 'D906',
  'GANGI': 'D907',
  'GARAGUSO': 'D909',
  'GARBAGNA': 'D910',
  'GARBAGNA NOVARESE': 'D911',
  'GARBAGNATE MILANESE': 'D912',
  'GARBAGNATE MONASTERO': 'D913',
  'GARDA': 'D915',
  'GARDONE RIVIERA': 'D917',
  'GARDONE VAL TROMPIA': 'D918',
  'GARESSIO': 'D920',
  'GARGALLO': 'D921',
  'GARGAZZONE * GARGAZON': 'D923',
  'GARGNANO': 'D924',
  'GARLASCO': 'D925',
  'GARLATE': 'D926',
  'GARLENDA': 'D927',
  'GARNIGA TERME': 'D928',
  'GARZENO': 'D930',
  'GARZIGLIANA': 'D931',
  'GASPERINA': 'D932',
  'GASSINO TORINESE': 'D933',
  'GATTATICO': 'D934',
  'GATTEO': 'D935',
  'GATTICO': 'D937',
  'GATTINARA': 'D938',
  'GAVARDO': 'D940',
  'GAVAZZANA': 'D941',
  'GAVELLO': 'D942',
  'GAVERINA TERME': 'D943',
  'GAVI': 'D944',
  'GAVIGNANO': 'D945',
  'GAVIRATE': 'D946',
  'GAVOI': 'D947',
  'GAVORRANO': 'D948',
  'GAZOLDO DEGLI IPPOLITI': 'D949',
  'GAZZADA SCHIANNO': 'D951',
  'GAZZANIGA': 'D952',
  'GAZZO PADOVANO': 'D956',
  'GAZZO VERONESE': 'D957',
  'GAZZOLA': 'D958',
  'GAZZUOLO': 'D959',
  'GELA': 'D960',
  'GEMMANO': 'D961',
  'GEMONA DEL FRIULI': 'D962',
  'GEMONIO': 'D963',
  'GENAZZANO': 'D964',
  'GENGA': 'D965',
  'GENIVOLTA': 'D966',
  'GENOLA': 'D967',
  'GENONI': 'D968',
  'GENOVA': 'D969',
  'GENURI': 'D970',
  'GENZANO DI LUCANIA': 'D971',
  'GENZANO DI ROMA': 'D972',
  'GENZONE': 'D973',
  'GERA LARIO': 'D974',
  'GERACE': 'D975',
  'LOCRI': 'D976',
  'GERACI SICULO': 'D977',
  'GERANO': 'D978',
  'GERENZAGO': 'D980',
  'GERENZANO': 'D981',
  'GERGEI': 'D982',
  'GERMAGNANO': 'D983',
  'GERMAGNO': 'D984',
  'GERMASINO': 'D986',
  'GERMIGNAGA': 'D987',
  'GEROCARNE': 'D988',
  'GEROLA ALTA': 'D990',
  'GEROSA': 'D991',
  'GERRE DE\' CAPRIOLI': 'D993',
  'GESICO': 'D994',
  'GESSATE': 'D995',
  'GESSOPALENA': 'D996',
  'GESTURI': 'D997',
  'GESUALDO': 'D998',
  'GHEDI': 'D999',
  'GHEMME': 'E001',
  'GHIFFA': 'E003',
  'GHILARZA': 'E004',
  'GHISALBA': 'E006',
  'GHISLARENGO': 'E007',
  'GIACCIANO CON BARUCHELLA': 'E008',
  'GIAGLIONE': 'E009',
  'GIANICO': 'E010',
  'GIANO VETUSTO': 'E011',
  'GIANO DELL\'UMBRIA': 'E012',
  'GIARDINELLO': 'E013',
  'GIARDINI-NAXOS': 'E014',
  'GIAROLE': 'E015',
  'GIARRATANA': 'E016',
  'GIARRE': 'E017',
  'GIAVE': 'E019',
  'GIAVENO': 'E020',
  'GIAVERA DEL MONTELLO': 'E021',
  'GIBA': 'E022',
  'GIBELLINA': 'E023',
  'GIFFLENGA': 'E024',
  'GIFFONE': 'E025',
  'GIFFONI SEI CASALI': 'E026',
  'GIFFONI VALLE PIANA': 'E027',
  'GIGNESE': 'E028',
  'GIGNOD': 'E029',
  'GILDONE': 'E030',
  'GIMIGLIANO': 'E031',
  'GINESTRA': 'E033',
  'GINESTRA DEGLI SCHIAVONI': 'E034',
  'GINOSA': 'E036',
  'GIOI': 'E037',
  'GIOIA DEL COLLE': 'E038',
  'GIOIA SANNITICA': 'E039',
  'GIOIA DEI MARSI': 'E040',
  'GIOIA TAURO': 'E041',
  'GIOIOSA MAREA': 'E043',
  'GIOIOSA IONICA': 'E044',
  'GIOVE': 'E045',
  'GIOVINAZZO': 'E047',
  'GIOVO': 'E048',
  'GIRASOLE': 'E049',
  'GIRIFALCO': 'E050',
  'GIRONICO': 'E051',
  'GISSI': 'E052',
  'GIUGGIANELLO': 'E053',
  'GIUGLIANO IN CAMPANIA': 'E054',
  'GIULIANA': 'E055',
  'GIULIANO TEATINO': 'E056',
  'GIULIANO DI ROMA': 'E057',
  'GIULIANOVA': 'E058',
  'GIUNCUGNANO': 'E059',
  'GIUNGANO': 'E060',
  'GIURDIGNANO': 'E061',
  'GIUSSAGO': 'E062',
  'GIUSSANO': 'E063',
  'GIUSTENICE': 'E064',
  'GIUSTINO': 'E065',
  'GIUSVALLA': 'E066',
  'GIVOLETTO': 'E067',
  'GIZZERIA': 'E068',
  'GLORENZA * GLURNS': 'E069',
  'SESTA GODANO': 'E070',
  'GODEGA DI SANT\'URBANO': 'E071',
  'GODIASCO': 'E072',
  'GODRANO': 'E074',
  'GOITO': 'E078',
  'GOLASECCA': 'E079',
  'GOLFERENZO': 'E081',
  'GOMBITO': 'E082',
  'GONARS': 'E083',
  'GONI': 'E084',
  'GONNOSFANADIGA': 'E085',
  'GONNESA': 'E086',
  'GONNOSCODINA': 'E087',
  'GONNOSTRAMATZA': 'E088',
  'GONZAGA': 'E089',
  'GORDONA': 'E090',
  'GORGA': 'E091',
  'GORGO AL MONTICANO': 'E092',
  'GORGOGLIONE': 'E093',
  'GORGONZOLA': 'E094',
  'GORIANO SICOLI': 'E096',
  'GORIZIA': 'E098',
  'GORLAGO': 'E100',
  'GORLA MAGGIORE': 'E101',
  'GORLA MINORE': 'E102',
  'GORLE': 'E103',
  'GORNATE-OLONA': 'E104',
  'GORNO': 'E106',
  'GORO': 'E107',
  'GORRETO': 'E109',
  'GORZEGNO': 'E111',
  'GOSALDO': 'E113',
  'GOSSOLENGO': 'E114',
  'GOTTASECCA': 'E115',
  'GOTTOLENGO': 'E116',
  'GOVONE': 'E118',
  'GOZZANO': 'E120',
  'GRADARA': 'E122',
  'GRADISCA D\'ISONZO': 'E124',
  'GRADO': 'E125',
  'GRADOLI': 'E126',
  'GRAFFIGNANA': 'E127',
  'GRAFFIGNANO': 'E128',
  'GRAGLIA': 'E130',
  'GRAGNANO': 'E131',
  'GRAGNANO TREBBIENSE': 'E132',
  'GRAMMICHELE': 'E133',
  'GRANA': 'E134',
  'GRANAGLIONE': 'E135',
  'GRANAROLO DELL\'EMILIA': 'E136',
  'GRANCONA': 'E138',
  'GRANDATE': 'E139',
  'GRANDOLA ED UNITI': 'E141',
  'GRANITI': 'E142',
  'GRANOZZO CON MONTICELLO': 'E143',
  'GRANTOLA': 'E144',
  'GRANTORTO': 'E145',
  'GRANZE': 'E146',
  'GRASSANO': 'E147',
  'GRASSOBBIO': 'E148',
  'GRATTERI': 'E149',
  'GRAUNO': 'E150',
  'GRAVEDONA': 'E151',
  'GRAVELLONA LOMELLINA': 'E152',
  'GRAVELLONA TOCE': 'E153',
  'GRAVERE': 'E154',
  'GRAVINA IN PUGLIA': 'E155',
  'GRAVINA DI CATANIA': 'E156',
  'GRAZZANISE': 'E158',
  'GRAZZANO BADOGLIO': 'E159',
  'GRECCIO': 'E160',
  'GRECI': 'E161',
  'GREGGIO': 'E163',
  'GREMIASCO': 'E164',
  'GRESSAN': 'E165',
  'GRESSONEY-LA-TRINITE\'': 'E167',
  'GRESSONEY-SAINT-JEAN': 'E168',
  'GREVE IN CHIANTI': 'E169',
  'GREZZAGO': 'E170',
  'GREZZANA': 'E171',
  'GRIANTE': 'E172',
  'GRICIGNANO DI AVERSA': 'E173',
  'GRIGNASCO': 'E177',
  'GRIGNO': 'E178',
  'GRIMACCO': 'E179',
  'GRIMALDI': 'E180',
  'GRINZANE CAVOUR': 'E182',
  'GRISIGNANO DI ZOCCO': 'E184',
  'GRISOLIA': 'E185',
  'GRIZZANA MORANDI': 'E187',
  'GROGNARDO': 'E188',
  'GROMO': 'E189',
  'GRONDONA': 'E191',
  'GRONE': 'E192',
  'GRONTARDO': 'E193',
  'GROPELLO CAIROLI': 'E195',
  'GROPPARELLO': 'E196',
  'GROSCAVALLO': 'E199',
  'GROSIO': 'E200',
  'GROSOTTO': 'E201',
  'GROSSETO': 'E202',
  'GROSSO': 'E203',
  'GROTTAFERRATA': 'E204',
  'GROTTAGLIE': 'E205',
  'GROTTAMINARDA': 'E206',
  'GROTTAMMARE': 'E207',
  'GROTTAZZOLINA': 'E208',
  'GROTTE': 'E209',
  'GROTTE DI CASTRO': 'E210',
  'GROTTERIA': 'E212',
  'GROTTOLE': 'E213',
  'GROTTOLELLA': 'E214',
  'GRUARO': 'E215',
  'GRUGLIASCO': 'E216',
  'GRUMELLO CREMONESE ED UNITI': 'E217',
  'GRUMELLO DEL MONTE': 'E219',
  'GRUMENTO NOVA': 'E221',
  'GRUMES': 'E222',
  'GRUMO APPULA': 'E223',
  'GRUMO NEVANO': 'E224',
  'GRUMOLO DELLE ABBADESSE': 'E226',
  'GUAGNANO': 'E227',
  'GUALDO': 'E228',
  'GUALDO CATTANEO': 'E229',
  'GUALDO TADINO': 'E230',
  'GUALTIERI': 'E232',
  'GUALTIERI SICAMINO\'': 'E233',
  'GUAMAGGIORE': 'E234',
  'GUANZATE': 'E235',
  'GUARCINO': 'E236',
  'GUARDABOSONE': 'E237',
  'GUARDAMIGLIO': 'E238',
  'GUARDAVALLE': 'E239',
  'GUARDA VENETA': 'E240',
  'GUARDEA': 'E241',
  'GUARDIA PIEMONTESE': 'E242',
  'GUARDIAGRELE': 'E243',
  'GUARDIALFIERA': 'E244',
  'GUARDIA LOMBARDI': 'E245',
  'GUARDIA PERTICARA': 'E246',
  'GUARDIAREGIA': 'E248',
  'GUARDIA SANFRAMONDI': 'E249',
  'GUARDISTALLO': 'E250',
  'GUARENE': 'E251',
  'GUASILA': 'E252',
  'GUASTALLA': 'E253',
  'GUAZZORA': 'E255',
  'GUBBIO': 'E256',
  'GUDO VISCONTI': 'E258',
  'GUGLIONESI': 'E259',
  'GUIDIZZOLO': 'E261',
  'GUIDONIA': 'E263',
  'GUIGLIA': 'E264',
  'SIZIANO': 'E265',
  'GUILMI': 'E266',
  'GURRO': 'E269',
  'GUSPINI': 'E270',
  'GUSSAGO': 'E271',
  'GUSSOLA': 'E272',
  'HONE': 'E273',
  'JACURSO': 'E274',
  'IDRO': 'E280',
  'IGLESIAS': 'E281',
  'IGLIANO': 'E282',
  'ILBONO': 'E283',
  'ILLASI': 'E284',
  'ILLORAI': 'E285',
  'IMBERSAGO': 'E287',
  'IMER': 'E288',
  'IMOLA': 'E289',
  'IMPERIA': 'E290',
  'IMPRUNETA': 'E291',
  'INARZO': 'E292',
  'INCISA SCAPACCINO': 'E295',
  'INCISA IN VAL D\'ARNO': 'E296',
  'INCUDINE': 'E297',
  'INDUNO OLONA': 'E299',
  'INGRIA': 'E301',
  'INTRAGNA': 'E304',
  'INTROBIO': 'E305',
  'INTROD': 'E306',
  'INTRODACQUA': 'E307',
  'INTROZZO': 'E308',
  'INVERIGO': 'E309',
  'INVERNO E MONTELEONE': 'E310',
  'INVERSO PINASCA': 'E311',
  'INVERUNO': 'E313',
  'INVORIO': 'E314',
  'INZAGO': 'E317',
  'JOLANDA DI SAVOIA': 'E320',
  'IONADI': 'E321',
  'IRGOLI': 'E323',
  'IRMA': 'E325',
  'IRSINA': 'E326',
  'ISASCA': 'E327',
  'ISCA SULLO IONIO': 'E328',
  'ISCHIA': 'E331',
  'ISCHIA DI CASTRO': 'E330',
  'ISCHITELLA': 'E332',
  'ISEO': 'E333',
  'ISERA': 'E334',
  'ISERNIA': 'E335',
  'ISILI': 'E336',
  'ISNELLO': 'E337',
  'ISOLA D\'ASTI': 'E338',
  'ISOLA CAPO RIZZUTO': 'E339',
  'ISOLA DEL LIRI': 'E340',
  'ISOLA DEL CANTONE': 'E341',
  'MADESIMO': 'E342',
  'ISOLA DEL GRAN SASSO D\'ITALIA': 'E343',
  'ISOLABELLA': 'E345',
  'ISOLABONA': 'E346',
  'ISOLA DEL GIGLIO': 'E348',
  'ISOLA DELLA SCALA': 'E349',
  'ISOLA DELLE FEMMINE': 'E350',
  'ISOLA DEL PIANO': 'E351',
  'ISOLA DI FONDRA': 'E353',
  'ISOLA VICENTINA': 'E354',
  'ISOLA DOVARESE': 'E356',
  'ISOLA RIZZA': 'E358',
  'ISOLA SANT\'ANTONIO': 'E360',
  'ISOLE TREMITI': 'E363',
  'ISORELLA': 'E364',
  'ISPANI': 'E365',
  'ISPICA': 'E366',
  'ISPRA': 'E367',
  'ISSIGLIO': 'E368',
  'ISSIME': 'E369',
  'ISSO': 'E370',
  'ISSOGNE': 'E371',
  'VASTO': 'E372',
  'ISTRANA': 'E373',
  'ITALA': 'E374',
  'ITRI': 'E375',
  'ITTIREDDU': 'E376',
  'ITTIRI': 'E377',
  'IVANO FRACENA': 'E378',
  'IVREA': 'E379',
  'IZANO': 'E380',
  'JELSI': 'E381',
  'JENNE': 'E382',
  'JERAGO CON ORAGO': 'E386',
  'JERZU': 'E387',
  'JESI': 'E388',
  'JOPPOLO': 'E389',
  'JOPPOLO GIANCAXIO': 'E390',
  'JOVENCAN': 'E391',
  'LABICO': 'E392',
  'LABRO': 'E393',
  'LA CASSA': 'E394',
  'LACCHIARELLA': 'E395',
  'LACCO AMENO': 'E396',
  'LACEDONIA': 'E397',
  'LACES * LATSCH': 'E398',
  'LACONI': 'E400',
  'LAERRU': 'E401',
  'LAGANADI': 'E402',
  'LAGHI': 'E403',
  'LAGLIO': 'E405',
  'LAGNASCO': 'E406',
  'LAGO': 'E407',
  'LAGONEGRO': 'E409',
  'LAGOSANTO': 'E410',
  'LAGUNDO * ALGUND': 'E412',
  'LAJATICO': 'E413',
  'LAIGUEGLIA': 'E414',
  'LAINATE': 'E415',
  'LAINO': 'E416',
  'LAINO BORGO': 'E417',
  'LAINO CASTELLO': 'E419',
  'LAION * LAJEN': 'E420',
  'LAIVES * LEIFERS': 'E421',
  'LALLIO': 'E422',
  'LA LOGGIA': 'E423',
  'LAMA DEI PELIGNI': 'E424',
  'LA MADDALENA': 'E425',
  'LAMA MOCOGNO': 'E426',
  'LAMBRUGO': 'E428',
  'LAMON': 'E429',
  'LA MORRA': 'E430',
  'LAMPEDUSA E LINOSA': 'E431',
  'LAMPORECCHIO': 'E432',
  'LAMPORO': 'E433',
  'LANA * LANA': 'E434',
  'LANCIANO': 'E435',
  'LANDIONA': 'E436',
  'LANDRIANO': 'E437',
  'LANGHIRANO': 'E438',
  'LANGOSCO': 'E439',
  'LANUSEI': 'E441',
  'LANZADA': 'E443',
  'LANZO D\'INTELVI': 'E444',
  'LANZO TORINESE': 'E445',
  'LAPEDONA': 'E447',
  'LAPIO': 'E448',
  'LAPPANO': 'E450',
  'LARCIANO': 'E451',
  'LARDARO': 'E452',
  'LARDIRAGO': 'E454',
  'LARI': 'E455',
  'LARINO': 'E456',
  'LASA * LAAS': 'E457',
  'LA SALLE': 'E458',
  'LASCARI': 'E459',
  'LASINO': 'E461',
  'LASNIGO': 'E462',
  'LA SPEZIA': 'E463',
  'LAS PLASSAS': 'E464',
  'LASTEBASSE': 'E465',
  'LASTRA A SIGNA': 'E466',
  'LATERA': 'E467',
  'LATERINA': 'E468',
  'LATERZA': 'E469',
  'LA THUILE': 'E470',
  'LATIANO': 'E471',
  'LATINA': 'E472',
  'LATISANA': 'E473',
  'LATRONICO': 'E474',
  'LATTARICO': 'E475',
  'LAUCO': 'E476',
  'LAUREANA DI BORRELLO': 'E479',
  'LAUREANA CILENTO': 'E480',
  'LAUREGNO * LAUREIN': 'E481',
  'LAURENZANA': 'E482',
  'LAURIA': 'E483',
  'LAURIANO': 'E484',
  'LAURINO': 'E485',
  'LAURITO': 'E486',
  'LAURO': 'E487',
  'LAVAGNA': 'E488',
  'LAVAGNO': 'E489',
  'LA VALLE AGORDINA': 'E490',
  'LA VALLE * WENGEN': 'E491',
  'LAVARONE': 'E492',
  'LAVELLO': 'E493',
  'LAVENA PONTE TRESA': 'E494',
  'LAVENO-MOMBELLO': 'E496',
  'LAVENONE': 'E497',
  'LAVIANO': 'E498',
  'LAVIS': 'E500',
  'LAZISE': 'E502',
  'LAZZATE': 'E504',
  'LECCE NEI MARSI': 'E505',
  'LECCE': 'E506',
  'LECCO': 'E507',
  'LEFFE': 'E509',
  'LEGGIUNO': 'E510',
  'LEGNAGO': 'E512',
  'LEGNANO': 'E514',
  'LEGNARO': 'E515',
  'LEI': 'E517',
  'LEINI\'': 'E518',
  'LEIVI': 'E519',
  'LEMIE': 'E520',
  'LENDINARA': 'E522',
  'LENI': 'E523',
  'LENNA': 'E524',
  'LENNO': 'E525',
  'LENO': 'E526',
  'LENOLA': 'E527',
  'LENTA': 'E528',
  'OSMATE': 'E529',
  'LENTATE SUL SEVESO': 'E530',
  'LENTELLA': 'E531',
  'LENTINI': 'E532',
  'LEONESSA': 'E535',
  'LEONFORTE': 'E536',
  'LEPORANO': 'E537',
  'LEQUILE': 'E538',
  'LEQUIO TANARO': 'E539',
  'LEQUIO BERRIA': 'E540',
  'LERCARA FRIDDI': 'E541',
  'LERICI': 'E542',
  'LERMA': 'E543',
  'LESA': 'E544',
  'LESEGNO': 'E546',
  'LESIGNANO DE\' BAGNI': 'E547',
  'TERENZO': 'E548',
  'LESINA': 'E549',
  'LESMO': 'E550',
  'LESSOLO': 'E551',
  'LESSONA': 'E552',
  'LESTIZZA': 'E553',
  'LETINO': 'E554',
  'LETOJANNI': 'E555',
  'LETTERE': 'E557',
  'LETTOMANOPPELLO': 'E558',
  'LETTOPALENA': 'E559',
  'LEVANTO': 'E560',
  'LEVATE': 'E562',
  'LEVERANO': 'E563',
  'LEVICE': 'E564',
  'LEVICO TERME': 'E565',
  'LEVONE': 'E566',
  'LEZZENO': 'E569',
  'LIBERI': 'E570',
  'LIBRIZZI': 'E571',
  'LICATA': 'E573',
  'LICCIANA NARDI': 'E574',
  'LICENZA': 'E576',
  'LICODIA EUBEA': 'E578',
  'LIERNA': 'E581',
  'LIGNANA': 'E583',
  'LIGNANO SABBIADORO': 'E584',
  'LIGONCHIO': 'E585',
  'LIGOSULLO': 'E586',
  'LILLIANES': 'E587',
  'LIMANA': 'E588',
  'LIMATOLA': 'E589',
  'LIMBADI': 'E590',
  'LIMBIATE': 'E591',
  'LIMENA': 'E592',
  'LIMIDO COMASCO': 'E593',
  'LIMINA': 'E594',
  'LIMONE SUL GARDA': 'E596',
  'LIMONE PIEMONTE': 'E597',
  'LIMOSANO': 'E599',
  'LINAROLO': 'E600',
  'LINGUAGLOSSA': 'E602',
  'LIONI': 'E605',
  'LIPARI': 'E606',
  'LIPOMO': 'E607',
  'LIRIO': 'E608',
  'LISCATE': 'E610',
  'LISCIA': 'E611',
  'LISCIANO NICCONE': 'E613',
  'LISIGNAGO': 'E614',
  'LISIO': 'E615',
  'LISSONE': 'E617',
  'MILENA': 'E618',
  'LIVERI': 'E620',
  'LIVIGNO': 'E621',
  'LIVINALLONGO DEL COL DI LANA': 'E622',
  'LIVO': 'E624',
  'LIVORNO': 'E625',
  'LIVORNO FERRARIS': 'E626',
  'LIVRAGA': 'E627',
  'LIZZANELLO': 'E629',
  'LIZZANO': 'E630',
  'LOANO': 'E632',
  'LOAZZOLO': 'E633',
  'LOCANA': 'E635',
  'LOCATE VARESINO': 'E638',
  'LOCATE DI TRIULZI': 'E639',
  'LOCATELLO': 'E640',
  'LOCERI': 'E644',
  'LOCOROTONDO': 'E645',
  'LOCULI': 'E646',
  'LODE\'': 'E647',
  'LODI': 'E648',
  'LODINE': 'E649',
  'LODI VECCHIO': 'E651',
  'LODRINO': 'E652',
  'LOGRATO': 'E654',
  'LOIANO': 'E655',
  'LOMAGNA': 'E656',
  'LOMASO': 'E658',
  'LOMAZZO': 'E659',
  'LOMBARDORE': 'E660',
  'LOMBRIASCO': 'E661',
  'LOMELLO': 'E662',
  'LONA LASES': 'E664',
  'LONATE CEPPINO': 'E665',
  'LONATE POZZOLO': 'E666',
  'LONATO': 'E667',
  'LONDA': 'E668',
  'LONGANO': 'E669',
  'LONGARE': 'E671',
  'LONGARONE': 'E672',
  'LONGHENA': 'E673',
  'LONGI': 'E674',
  'LONGIANO': 'E675',
  'LONGOBARDI': 'E677',
  'LONGOBUCCO': 'E678',
  'LONGONE AL SEGRINO': 'E679',
  'PORTO AZZURRO': 'E680',
  'LONGONE SABINO': 'E681',
  'LONIGO': 'E682',
  'LORANZE\'': 'E683',
  'LOREGGIA': 'E684',
  'LOREGLIA': 'E685',
  'LORENZAGO DI CADORE': 'E687',
  'LORENZANA': 'E688',
  'LOREO': 'E689',
  'LORETO': 'E690',
  'LORETO APRUTINO': 'E691',
  'LORIA': 'E692',
  'LORO CIUFFENNA': 'E693',
  'LORO PICENO': 'E694',
  'LORSICA': 'E695',
  'LOSINE': 'E698',
  'LOTZORAI': 'E700',
  'LOVERE': 'E704',
  'LOVERO': 'E705',
  'LOZIO': 'E706',
  'LOZZA': 'E707',
  'LOZZO DI CADORE': 'E708',
  'LOZZO ATESTINO': 'E709',
  'LOZZOLO': 'E711',
  'LU': 'E712',
  'LUBRIANO': 'E713',
  'LUCCA SICULA': 'E714',
  'LUCCA': 'E715',
  'LUCERA': 'E716',
  'LUCIGNANO': 'E718',
  'LUCINASCO': 'E719',
  'LUCITO': 'E722',
  'LUCO DEI MARSI': 'E723',
  'LUCOLI': 'E724',
  'LUGAGNANO VAL D\'ARDA': 'E726',
  'LUGNACCO': 'E727',
  'LUGNANO IN TEVERINA': 'E729',
  'LUGO': 'E730',
  'LUGO DI VICENZA': 'E731',
  'LUINO': 'E734',
  'LUISAGO': 'E735',
  'LULA': 'E736',
  'LUMARZO': 'E737',
  'LUMEZZANE': 'E738',
  'LUNAMATRONA': 'E742',
  'LUNANO': 'E743',
  'LUNGRO': 'E745',
  'LUOGOSANO': 'E746',
  'LUOGOSANTO': 'E747',
  'LUPARA': 'E748',
  'LURAGO D\'ERBA': 'E749',
  'LURAGO MARINONE': 'E750',
  'LURANO': 'E751',
  'LURAS': 'E752',
  'LURATE CACCIVIO': 'E753',
  'LUSCIANO': 'E754',
  'LUSERNA': 'E756',
  'LUSERNA SAN GIOVANNI': 'E758',
  'LUSERNETTA': 'E759',
  'LUSEVERA': 'E760',
  'LUSIA': 'E761',
  'LUSIANA': 'E762',
  'LUSIGLIE\'': 'E763',
  'LUSON * LUESEN': 'E764',
  'LUSTRA': 'E767',
  'LUVINATE': 'E769',
  'LUZZANA': 'E770',
  'LUZZARA': 'E772',
  'LUZZI': 'E773',
  'MACCAGNO': 'E775',
  'MACCASTORNA': 'E777',
  'MACCHIA D\'ISERNIA': 'E778',
  'MACCHIAGODENA': 'E779',
  'MACCHIA VALFORTORE': 'E780',
  'MACELLO': 'E782',
  'MACERATA': 'E783',
  'MACERATA CAMPANIA': 'E784',
  'MACERATA FELTRIA': 'E785',
  'MACHERIO': 'E786',
  'MACLODIO': 'E787',
  'MACOMER': 'E788',
  'MACRA': 'E789',
  'MACUGNAGA': 'E790',
  'MADDALONI': 'E791',
  'MADIGNANO': 'E793',
  'MADONE': 'E794',
  'MADONNA DEL SASSO': 'E795',
  'MAENZA': 'E798',
  'MAFALDA': 'E799',
  'MAGASA': 'E800',
  'MAGENTA': 'E801',
  'MAGGIORA': 'E803',
  'MAGHERNO': 'E804',
  'MAGIONE': 'E805',
  'MAGISANO': 'E806',
  'MAGLIANO DI TENNA': 'E807',
  'MAGLIANO ALPI': 'E808',
  'MAGLIANO ALFIERI': 'E809',
  'MAGLIANO IN TOSCANA': 'E810',
  'MAGLIANO DE\' MARSI': 'E811',
  'MAGLIANO SABINA': 'E812',
  'MAGLIANO ROMANO': 'E813',
  'MAGLIANO VETERE': 'E814',
  'MAGLIE': 'E815',
  'MAGLIOLO': 'E816',
  'MAGLIONE': 'E817',
  'MAGNACAVALLO': 'E818',
  'MAGNAGO': 'E819',
  'MAGNANO IN RIVIERA': 'E820',
  'MAGNANO': 'E821',
  'MAGOMADAS': 'E825',
  'MAGRE\' SULLA STRADA DEL VINO * MARGREID AN DER WEINSTRASSE': 'E829',
  'MAGREGLIO': 'E830',
  'MAJANO': 'E833',
  'MAIDA': 'E834',
  'MAIERA\'': 'E835',
  'MAIERATO': 'E836',
  'MAIOLATI SPONTINI': 'E837',
  'MAIOLO': 'E838',
  'MAIORI': 'E839',
  'MAIRAGO': 'E840',
  'MAIRANO': 'E841',
  'MAISSANA': 'E842',
  'MALAGNINO': 'E843',
  'MALALBERGO': 'E844',
  'MALBORGHETTO-VALBRUNA': 'E847',
  'MALCESINE': 'E848',
  'MALE\'': 'E850',
  'MALEGNO': 'E851',
  'MALEO': 'E852',
  'MALESCO': 'E853',
  'MALETTO': 'E854',
  'MALFA': 'E855',
  'MALGESSO': 'E856',
  'MALGRATE': 'E858',
  'MALITO': 'E859',
  'MALLARE': 'E860',
  'MALLES VENOSTA * MALS': 'E862',
  'MALNATE': 'E863',
  'MALO': 'E864',
  'MALONNO': 'E865',
  'MALOSCO': 'E866',
  'MALTIGNANO': 'E868',
  'MALVAGNA': 'E869',
  'MALVICINO': 'E870',
  'MALVITO': 'E872',
  'MAMMOLA': 'E873',
  'MAMOIADA': 'E874',
  'MANCIANO': 'E875',
  'MANDANICI': 'E876',
  'MANDAS': 'E877',
  'MANDATORICCIO': 'E878',
  'MANDELLO DEL LARIO': 'E879',
  'MANDELLO VITTA': 'E880',
  'MANDURIA': 'E882',
  'MANERBA DEL GARDA': 'E883',
  'MANERBIO': 'E884',
  'MANFREDONIA': 'E885',
  'MANGO': 'E887',
  'MANGONE': 'E888',
  'MANIAGO': 'E889',
  'MANOCALZATI': 'E891',
  'MANOPPELLO': 'E892',
  'MANSUE\'': 'E893',
  'MANTA': 'E894',
  'MANTELLO': 'E896',
  'MANTOVA': 'E897',
  'MANZANO': 'E898',
  'MANZIANA': 'E900',
  'MAPELLO': 'E901',
  'MARA': 'E902',
  'MARACALAGONIS': 'E903',
  'MARANELLO': 'E904',
  'MARANO SUL PANARO': 'E905',
  'MARANO DI NAPOLI': 'E906',
  'MARANO TICINO': 'E907',
  'MARANO EQUO': 'E908',
  'MARANO LAGUNARE': 'E910',
  'MARANO DI VALPOLICELLA': 'E911',
  'MARANO VICENTINO': 'E912',
  'MARANO MARCHESATO': 'E914',
  'MARANO PRINCIPATO': 'E915',
  'MARANZANA': 'E917',
  'MARATEA': 'E919',
  'MARCALLO CON CASONE': 'E921',
  'MARCARIA': 'E922',
  'MARCEDUSA': 'E923',
  'MARCELLINA': 'E924',
  'MARCELLINARA': 'E925',
  'MARCETELLI': 'E927',
  'MARCHENO': 'E928',
  'MARCHIROLO': 'E929',
  'MARCIANA': 'E930',
  'MARCIANA MARINA': 'E931',
  'MARCIANISE': 'E932',
  'MARCIANO DELLA CHIANA': 'E933',
  'MARCIGNAGO': 'E934',
  'MARCON': 'E936',
  'MAREBBE * ENNEBERG': 'E938',
  'MARENE': 'E939',
  'MARENO DI PIAVE': 'E940',
  'MARENTINO': 'E941',
  'MARETTO': 'E944',
  'MARGARITA': 'E945',
  'MARGHERITA DI SAVOIA': 'E946',
  'MARGNO': 'E947',
  'MARIANA MANTOVANA': 'E949',
  'MARIANO COMENSE': 'E951',
  'MARIANO DEL FRIULI': 'E952',
  'MARIANOPOLI': 'E953',
  'MARIGLIANELLA': 'E954',
  'MARIGLIANO': 'E955',
  'MARINA DI GIOIOSA IONICA': 'E956',
  'MARINEO': 'E957',
  'MARINO': 'E958',
  'MARLENGO * MARLING': 'E959',
  'MARLIANA': 'E960',
  'MARMENTINO': 'E961',
  'MARMIROLO': 'E962',
  'MARMORA': 'E963',
  'MARNATE': 'E965',
  'MARONE': 'E967',
  'MAROPATI': 'E968',
  'MAROSTICA': 'E970',
  'MARRADI': 'E971',
  'MARRUBIU': 'E972',
  'MARSAGLIA': 'E973',
  'MARSALA': 'E974',
  'MARSCIANO': 'E975',
  'MARSICO NUOVO': 'E976',
  'MARSICOVETERE': 'E977',
  'MARTA': 'E978',
  'MARTANO': 'E979',
  'MARTELLAGO': 'E980',
  'MARTELLO * MARTELL': 'E981',
  'MARTIGNACCO': 'E982',
  'MARTIGNANA DI PO': 'E983',
  'MARTIGNANO': 'E984',
  'MARTINA FRANCA': 'E986',
  'MARTINENGO': 'E987',
  'MARTINIANA PO': 'E988',
  'MARTINSICURO': 'E989',
  'MARTIRANO': 'E990',
  'MARTIRANO LOMBARDO': 'E991',
  'MARTIS': 'E992',
  'MARTONE': 'E993',
  'MARUDO': 'E994',
  'MARUGGIO': 'E995',
  'MARZANO DI NOLA': 'E997',
  'MARZANO APPIO': 'E998',
  'MARZANO': 'E999',
  'MARZI': 'F001',
  'MARZIO': 'F002',
  'MASATE': 'F003',
  'MASCALI': 'F004',
  'MASCALUCIA': 'F005',
  'MASCHITO': 'F006',
  'MASCIAGO PRIMO': 'F007',
  'MASER': 'F009',
  'MASERA': 'F010',
  'MASERA\' DI PADOVA': 'F011',
  'MASERADA SUL PIAVE': 'F012',
  'MASI': 'F013',
  'MASIO': 'F015',
  'MASI TORELLO': 'F016',
  'MASLIANICO': 'F017',
  'MASON VICENTINO': 'F019',
  'MASONE': 'F020',
  'MASSA FERMANA': 'F021',
  'MASSA D\'ALBE': 'F022',
  'MASSA': 'F023',
  'MASSA MARTANA': 'F024',
  'MASSA E COZZILE': 'F025',
  'MASSA FISCAGLIA': 'F026',
  'MASSAFRA': 'F027',
  'MASSALENGO': 'F028',
  'MASSA LOMBARDA': 'F029',
  'MASSA LUBRENSE': 'F030',
  'MASSA MARITTIMA': 'F032',
  'MASSANZAGO': 'F033',
  'MASSAROSA': 'F035',
  'MASSAZZA': 'F037',
  'MASSELLO': 'F041',
  'MASSERANO': 'F042',
  'SAN MARCO EVANGELISTA': 'F043',
  'MASSIGNANO': 'F044',
  'MASSIMENO': 'F045',
  'MASSIMINO': 'F046',
  'MASSINO VISCONTI': 'F047',
  'MASSIOLA': 'F048',
  'MASULLAS': 'F050',
  'MATELICA': 'F051',
  'MATERA': 'F052',
  'MATHI': 'F053',
  'MATINO': 'F054',
  'MATRICE': 'F055',
  'MATTIE': 'F058',
  'MATTINATA': 'F059',
  'MAZARA DEL VALLO': 'F061',
  'MAZZANO': 'F063',
  'MAZZANO ROMANO': 'F064',
  'MAZZARINO': 'F065',
  'MAZZARRA\' SANT\'ANDREA': 'F066',
  'MAZZE\'': 'F067',
  'MAZZIN': 'F068',
  'MAZZO DI VALTELLINA': 'F070',
  'MEANA SARDO': 'F073',
  'MEANA DI SUSA': 'F074',
  'MEDA': 'F078',
  'MEDE': 'F080',
  'MEDEA': 'F081',
  'MEDESANO': 'F082',
  'MEDICINA': 'F083',
  'MEDIGLIA': 'F084',
  'MEDOLAGO': 'F085',
  'MEDOLE': 'F086',
  'MEDOLLA': 'F087',
  'MEDUNA DI LIVENZA': 'F088',
  'MEDUNO': 'F089',
  'MEGLIADINO SAN FIDENZIO': 'F091',
  'MEGLIADINO SAN VITALE': 'F092',
  'MEINA': 'F093',
  'MEL': 'F094',
  'MELARA': 'F095',
  'MELAZZO': 'F096',
  'MELDOLA': 'F097',
  'MELE': 'F098',
  'MELEGNANO': 'F100',
  'MELENDUGNO': 'F101',
  'MELETI': 'F102',
  'MELFI': 'F104',
  'MELICUCCA\'': 'F105',
  'MELICUCCO': 'F106',
  'MELILLI': 'F107',
  'MELISSA': 'F108',
  'MELISSANO': 'F109',
  'MELITO IRPINO': 'F110',
  'MELITO DI NAPOLI': 'F111',
  'MELITO DI PORTO SALVO': 'F112',
  'MELIZZANO': 'F113',
  'MELLE': 'F114',
  'MELLO': 'F115',
  'SILEA': 'F116',
  'MELPIGNANO': 'F117',
  'MELTINA * MOELTEN': 'F118',
  'MELZO': 'F119',
  'MENAGGIO': 'F120',
  'MENAROLA': 'F121',
  'MENCONICO': 'F122',
  'MENDATICA': 'F123',
  'MENDICINO': 'F125',
  'MENFI': 'F126',
  'MENTANA': 'F127',
  'MEOLO': 'F130',
  'MERANA': 'F131',
  'MERANO * MERAN': 'F132',
  'MERATE': 'F133',
  'MERCALLO': 'F134',
  'MERCATELLO SUL METAURO': 'F135',
  'MERCATINO CONCA': 'F136',
  'NOVAFELTRIA': 'F137',
  'MERCATO SAN SEVERINO': 'F138',
  'MERCATO SARACENO': 'F139',
  'MERCENASCO': 'F140',
  'MERCOGLIANO': 'F141',
  'MERETO DI TOMBA': 'F144',
  'MERGO': 'F145',
  'MERGOZZO': 'F146',
  'MERI\'': 'F147',
  'MERLARA': 'F148',
  'MERLINO': 'F149',
  'MERONE': 'F151',
  'MESAGNE': 'F152',
  'MESE': 'F153',
  'MESENZANA': 'F154',
  'MESERO': 'F155',
  'MESOLA': 'F156',
  'MESORACA': 'F157',
  'MESSINA': 'F158',
  'MESTRINO': 'F161',
  'META': 'F162',
  'MEUGLIANO': 'F164',
  'MEZZAGO': 'F165',
  'MEZZANA MORTIGLIENGO': 'F167',
  'MEZZANA': 'F168',
  'MEZZANA BIGLI': 'F170',
  'MEZZANA RABATTONE': 'F171',
  'MEZZANE DI SOTTO': 'F172',
  'MEZZANEGO': 'F173',
  'MEZZANI': 'F174',
  'MEZZANINO': 'F175',
  'MEZZANO': 'F176',
  'MEZZEGRA': 'F181',
  'MEZZENILE': 'F182',
  'MEZZOCORONA': 'F183',
  'MEZZOJUSO': 'F184',
  'MEZZOLDO': 'F186',
  'MEZZOLOMBARDO': 'F187',
  'MEZZOMERICO': 'F188',
  'MIAGLIANO': 'F189',
  'MIANE': 'F190',
  'MIASINO': 'F191',
  'MIAZZINA': 'F192',
  'MICIGLIANO': 'F193',
  'MIGGIANO': 'F194',
  'MIGLIANICO': 'F196',
  'MIGLIARINO': 'F198',
  'MIGLIARO': 'F199',
  'MIGLIERINA': 'F200',
  'MIGLIONICO': 'F201',
  'MIGNANEGO': 'F202',
  'MIGNANO MONTE LUNGO': 'F203',
  'MILANO': 'F205',
  'MILAZZO': 'F206',
  'MILETO': 'F207',
  'MILIS': 'F208',
  'MILITELLO IN VAL DI CATANIA': 'F209',
  'MILITELLO ROSMARINO': 'F210',
  'MILLESIMO': 'F213',
  'MILO': 'F214',
  'MILZANO': 'F216',
  'MINEO': 'F217',
  'MINERBE': 'F218',
  'MINERBIO': 'F219',
  'MINERVINO MURGE': 'F220',
  'MINERVINO DI LECCE': 'F221',
  'MINORI': 'F223',
  'MINTURNO': 'F224',
  'MINUCCIANO': 'F225',
  'MIOGLIA': 'F226',
  'MIRA': 'F229',
  'MIRABELLA ECLANO': 'F230',
  'MIRABELLA IMBACCARI': 'F231',
  'MIRABELLO MONFERRATO': 'F232',
  'MIRABELLO SANNITICO': 'F233',
  'MIRABELLO': 'F235',
  'MIRADOLO TERME': 'F238',
  'MIRANDA': 'F239',
  'MIRANDOLA': 'F240',
  'MIRANO': 'F241',
  'MIRTO': 'F242',
  'MISANO DI GERA D\'ADDA': 'F243',
  'MISANO ADRIATICO': 'F244',
  'MISILMERI': 'F246',
  'MISINTO': 'F247',
  'MISSAGLIA': 'F248',
  'MISSANELLO': 'F249',
  'MISTERBIANCO': 'F250',
  'MISTRETTA': 'F251',
  'MOASCA': 'F254',
  'MOCONESI': 'F256',
  'MODENA': 'F257',
  'MODICA': 'F258',
  'MODIGLIANA': 'F259',
  'TAVAZZANO CON VILLAVESCO': 'F260',
  'MODOLO': 'F261',
  'MODUGNO': 'F262',
  'MOENA': 'F263',
  'MOGGIO': 'F265',
  'MOGGIO UDINESE': 'F266',
  'MOGLIA': 'F267',
  'MOGLIANO': 'F268',
  'MOGLIANO VENETO': 'F269',
  'MOGORELLA': 'F270',
  'RUINAS': 'F271',
  'MOGORO': 'F272',
  'MOIANO': 'F274',
  'MOIMACCO': 'F275',
  'MOIO DE\' CALVI': 'F276',
  'MOIO ALCANTARA': 'F277',
  'MOIO DELLA CIVITELLA': 'F278',
  'MOIOLA': 'F279',
  'MOLA DI BARI': 'F280',
  'MOLARE': 'F281',
  'MOLAZZANA': 'F283',
  'MOLFETTA': 'F284',
  'MOLINA DI LEDRO': 'F286',
  'MOLINARA': 'F287',
  'MOLINELLA': 'F288',
  'MOLINI DI TRIORA': 'F290',
  'MOLINO DEI TORTI': 'F293',
  'MOLISE': 'F294',
  'MOLITERNO': 'F295',
  'MOLLIA': 'F297',
  'PORTO EMPEDOCLE': 'F299',
  'MOLOCHIO': 'F301',
  'MOLTENO': 'F304',
  'MOLTRASIO': 'F305',
  'MOLVENA': 'F306',
  'MOLVENO': 'F307',
  'MOMBALDONE': 'F308',
  'MOMBARCARO': 'F309',
  'MOMBAROCCIO': 'F310',
  'MOMBARUZZO': 'F311',
  'MOMBASIGLIO': 'F312',
  'MOMBELLO MONFERRATO': 'F313',
  'MOMBELLO DI TORINO': 'F315',
  'MOMBERCELLI': 'F316',
  'MOMO': 'F317',
  'MOMPANTERO': 'F318',
  'MOMPEO': 'F319',
  'MOMPERONE': 'F320',
  'MONACILIONI': 'F322',
  'MONALE': 'F323',
  'MONASTERACE': 'F324',
  'MONASTERO BORMIDA': 'F325',
  'MONASTERO DI VASCO': 'F326',
  'MONASTERO DI LANZO': 'F327',
  'MONASTEROLO DEL CASTELLO': 'F328',
  'MONASTEROLO CASOTTO': 'F329',
  'MONASTEROLO DI SAVIGLIANO': 'F330',
  'MONASTIER DI TREVISO': 'F332',
  'MONASTIR': 'F333',
  'MONCALIERI': 'F335',
  'MONCALVO': 'F336',
  'MONCESTINO': 'F337',
  'MONCHIERO': 'F338',
  'MONCHIO DELLE CORTI': 'F340',
  'MONCLASSICO': 'F341',
  'MONCRIVELLO': 'F342',
  'MONCUCCO TORINESE': 'F343',
  'MONDAINO': 'F346',
  'MONDAVIO': 'F347',
  'MONDOLFO': 'F348',
  'MONDOVI\'': 'F351',
  'MONDRAGONE': 'F352',
  'MONEGLIA': 'F354',
  'MONESIGLIO': 'F355',
  'MONFALCONE': 'F356',
  'SERRAMAZZONI': 'F357',
  'MONFORTE D\'ALBA': 'F358',
  'MONFORTE SAN GIORGIO': 'F359',
  'MONFUMO': 'F360',
  'MONGARDINO': 'F361',
  'MONGHIDORO': 'F363',
  'MONGIANA': 'F364',
  'MONGIARDINO LIGURE': 'F365',
  'MONTJOVET': 'F367',
  'MONGIUFFI MELIA': 'F368',
  'MONGRANDO': 'F369',
  'MONGRASSANO': 'F370',
  'MONGUELFO-TESIDO * WELSBERG-TAISTEN': 'F371',
  'MONGUZZO': 'F372',
  'MONIGA DEL GARDA': 'F373',
  'MONLEALE': 'F374',
  'MONNO': 'F375',
  'MONOPOLI': 'F376',
  'MONREALE': 'F377',
  'MONRUPINO': 'F378',
  'MONSAMPIETRO MORICO': 'F379',
  'MONSAMPOLO DEL TRONTO': 'F380',
  'MONSANO': 'F381',
  'MONSELICE': 'F382',
  'MONSERRATO': 'F383',
  'MONSUMMANO TERME': 'F384',
  'MONTA\'': 'F385',
  'MONTABONE': 'F386',
  'MONTACUTO': 'F388',
  'MONTAFIA': 'F390',
  'MONTAGANO': 'F391',
  'MONTAGNA * MONTAN': 'F392',
  'MONTAGNA IN VALTELLINA': 'F393',
  'MONTAGNANA': 'F394',
  'MONTAGNAREALE': 'F395',
  'MONTAGNE': 'F396',
  'MONTAGUTO': 'F397',
  'MONTAIONE': 'F398',
  'MONTALBANO JONICO': 'F399',
  'MONTALBANO ELICONA': 'F400',
  'OSTRA': 'F401',
  'MONTALCINO': 'F402',
  'MONTALDEO': 'F403',
  'MONTALDO BORMIDA': 'F404',
  'MONTALDO DI MONDOVI\'': 'F405',
  'MONTALTO LIGURE': 'F406',
  'MONTALDO TORINESE': 'F407',
  'MONTALDO ROERO': 'F408',
  'MONTALDO SCARAMPI': 'F409',
  'MONTALE': 'F410',
  'MONTALENGHE': 'F411',
  'MONTALLEGRO': 'F414',
  'MONTALTO DELLE MARCHE': 'F415',
  'MONTALTO UFFUGO': 'F416',
  'MONTALTO PAVESE': 'F417',
  'MONTALTO DI CASTRO': 'F419',
  'MONTALTO DORA': 'F420',
  'MONTANARO': 'F422',
  'MONTANASO LOMBARDO': 'F423',
  'MONTANERA': 'F424',
  'MONTANO ANTILIA': 'F426',
  'MONTANO LUCINO': 'F427',
  'MONTAPPONE': 'F428',
  'MONTAQUILA': 'F429',
  'MONTASOLA': 'F430',
  'MONTAURO': 'F432',
  'MONTAZZOLI': 'F433',
  'MONTE CREMASCO': 'F434',
  'MONTE ARGENTARIO': 'F437',
  'MONTEBELLO DELLA BATTAGLIA': 'F440',
  'MONTEBELLO DI BERTONA': 'F441',
  'MONTEBELLO VICENTINO': 'F442',
  'MONTEBELLUNA': 'F443',
  'MONTEBRUNO': 'F445',
  'MONTEBUONO': 'F446',
  'MONTECALVO IRPINO': 'F448',
  'MONTECALVO VERSIGGIA': 'F449',
  'MONTECALVO IN FOGLIA': 'F450',
  'MONTECARLO': 'F452',
  'MONTECAROTTO': 'F453',
  'MONTECASSIANO': 'F454',
  'MONTECASTELLO': 'F455',
  'MONTE CASTELLO DI VIBIO': 'F456',
  'MONTECASTRILLI': 'F457',
  'MONTECATINI VAL DI CECINA': 'F458',
  'MONTE CAVALLO': 'F460',
  'MONTECCHIA DI CROSARA': 'F461',
  'MONTECCHIO': 'F462',
  'MONTECCHIO EMILIA': 'F463',
  'MONTECCHIO MAGGIORE': 'F464',
  'MONTECCHIO PRECALCINO': 'F465',
  'MONTE CERIGNONE': 'F467',
  'MONTECHIARO D\'ASTI': 'F468',
  'MONTECHIARO D\'ACQUI': 'F469',
  'MONTICHIARI': 'F471',
  'MONTECHIARUGOLO': 'F473',
  'MONTECICCARDO': 'F474',
  'MONTECILFONE': 'F475',
  'MONTE COLOMBO': 'F476',
  'MONTECOMPATRI': 'F477',
  'MONTECOPIOLO': 'F478',
  'MONTECORICE': 'F479',
  'MONTECORVINO PUGLIANO': 'F480',
  'MONTECORVINO ROVELLA': 'F481',
  'MONTECOSARO': 'F482',
  'MONTECRESTESE': 'F483',
  'MONTECRETO': 'F484',
  'MONTE DI MALO': 'F486',
  'MONTEDINOVE': 'F487',
  'MONTE DI PROCIDA': 'F488',
  'MONTEDORO': 'F489',
  'MONTEFALCIONE': 'F491',
  'MONTEFALCO': 'F492',
  'MONTEFALCONE APPENNINO': 'F493',
  'MONTEFALCONE DI VAL FORTORE': 'F494',
  'MONTEFALCONE NEL SANNIO': 'F495',
  'MONTEFANO': 'F496',
  'MONTEFELCINO': 'F497',
  'MONTEFERRANTE': 'F498',
  'MONTEFIASCONE': 'F499',
  'MONTEFINO': 'F500',
  'MONTEFIORE DELL\'ASO': 'F501',
  'MONTEFIORE CONCA': 'F502',
  'MONTEFIORINO': 'F503',
  'MONTEFLAVIO': 'F504',
  'MONTEFORTE IRPINO': 'F506',
  'MONTEFORTE CILENTO': 'F507',
  'MONTEFORTE D\'ALPONE': 'F508',
  'MONTEFORTINO': 'F509',
  'MONTEFRANCO': 'F510',
  'MONTEFREDANE': 'F511',
  'MONTEFUSCO': 'F512',
  'MONTEGABBIONE': 'F513',
  'MONTEGALDA': 'F514',
  'MONTEGALDELLA': 'F515',
  'MONTEGALLO': 'F516',
  'MONTE GIBERTO': 'F517',
  'MONTEGIOCO': 'F518',
  'MONTEGIORDANO': 'F519',
  'MONTEGIORGIO': 'F520',
  'MONTEGRANARO': 'F522',
  'MONTEGRIDOLFO': 'F523',
  'MONTE GRIMANO TERME': 'F524',
  'MONTEGRINO VALTRAVAGLIA': 'F526',
  'MONTEGROSSO D\'ASTI': 'F527',
  'MONTEGROSSO PIAN LATTE': 'F528',
  'MONTEGROTTO TERME': 'F529',
  'MONTEIASI': 'F531',
  'MONTE ISOLA': 'F532',
  'MONTELABBATE': 'F533',
  'MONTELANICO': 'F534',
  'MONTELAPIANO': 'F535',
  'MONTELEONE DI FERMO': 'F536',
  'VIBO VALENTIA': 'F537',
  'MONTELEONE DI PUGLIA': 'F538',
  'MONTELEONE DI SPOLETO': 'F540',
  'MONTELEONE SABINO': 'F541',
  'MONTELEONE ROCCA DORIA': 'F542',
  'MONTELEONE D\'ORVIETO': 'F543',
  'MONTELEPRE': 'F544',
  'MONTELIBRETTI': 'F545',
  'MONTELLA': 'F546',
  'MONTELLO': 'F547',
  'MONTELONGO': 'F548',
  'MONTELPARO': 'F549',
  'MONTELUPO ALBESE': 'F550',
  'MONTELUPO FIORENTINO': 'F551',
  'MONTELUPONE': 'F552',
  'MONTEMAGGIORE BELSITO': 'F553',
  'MONTEMAGGIORE AL METAURO': 'F555',
  'MONTEMAGNO': 'F556',
  'SANT\'ARCANGELO TRIMONTE': 'F557',
  'MONTEMALE DI CUNEO': 'F558',
  'MONTEMARANO': 'F559',
  'MONTEMARCIANO': 'F560',
  'MONTE MARENZO': 'F561',
  'MONTEMARZINO': 'F562',
  'MONTEMESOLA': 'F563',
  'MONTEMEZZO': 'F564',
  'MONTEMIGNAIO': 'F565',
  'MONTEMILETTO': 'F566',
  'POLLENZA': 'F567',
  'MONTEMILONE': 'F568',
  'MONTEMITRO': 'F569',
  'MONTEMONACO': 'F570',
  'MONTEMURLO': 'F572',
  'MONTEMURRO': 'F573',
  'MONTENARS': 'F574',
  'MONTENERO DI BISACCIA': 'F576',
  'MONTENERODOMO': 'F578',
  'MONTENERO SABINO': 'F579',
  'MONTENERO VAL COCCHIARA': 'F580',
  'OSTRA VETERE': 'F581',
  'MONTEODORISIO': 'F582',
  'ROSETO DEGLI ABRUZZI': 'F585',
  'MONTEPAONE': 'F586',
  'MONTEPARANO': 'F587',
  'MONTE PORZIO': 'F589',
  'MONTE PORZIO CATONE': 'F590',
  'MONTEPRANDONE': 'F591',
  'MONTEPULCIANO': 'F592',
  'MONTERADO': 'F593',
  'MONTERCHI': 'F594',
  'MONTEREALE': 'F595',
  'MONTEREALE VALCELLINA': 'F596',
  'MONTERENZIO': 'F597',
  'MONTERIGGIONI': 'F598',
  'MONTE RINALDO': 'F599',
  'MONTE ROBERTO': 'F600',
  'MONTERODUNI': 'F601',
  'MONTE ROMANO': 'F603',
  'MONTERONI DI LECCE': 'F604',
  'MONTERONI D\'ARBIA': 'F605',
  'MONTEROSI': 'F606',
  'MONTEROSSO CALABRO': 'F607',
  'MONTEROSSO GRANA': 'F608',
  'MONTEROSSO AL MARE': 'F609',
  'MONTEROSSO ALMO': 'F610',
  'MONTEROTONDO': 'F611',
  'MONTEROTONDO MARITTIMO': 'F612',
  'MONTERUBBIANO': 'F614',
  'MONTE SAN BIAGIO': 'F616',
  'MONTE SAN GIACOMO': 'F618',
  'MONTE SAN GIOVANNI IN SABINA': 'F619',
  'MONTE SAN GIOVANNI CAMPANO': 'F620',
  'MONTE SAN GIUSTO': 'F621',
  'MONTE SAN MARTINO': 'F622',
  'MONTESANO SALENTINO': 'F623',
  'MONTESANO SULLA MARCELLANA': 'F625',
  'MONTE SAN PIETRANGELI': 'F626',
  'MONTE SAN PIETRO': 'F627',
  'MONTE SAN SAVINO': 'F628',
  'MONTE SANTA MARIA TIBERINA': 'F629',
  'MONTE SANT\'ANGELO': 'F631',
  'POTENZA PICENA': 'F632',
  'MONTE SAN VITO': 'F635',
  'MONTESARCHIO': 'F636',
  'MONTESCAGLIOSO': 'F637',
  'MONTESCANO': 'F638',
  'MONTESCHENO': 'F639',
  'MONTESCUDAIO': 'F640',
  'MONTESCUDO': 'F641',
  'MONTESE': 'F642',
  'MONTESEGALE': 'F644',
  'MONTESILVANO': 'F646',
  'MONTESPERTOLI': 'F648',
  'MONTEU DA PO': 'F651',
  'MONTE URANO': 'F653',
  'MONTEU ROERO': 'F654',
  'MONTEVAGO': 'F655',
  'MONTEVARCHI': 'F656',
  'MONTEVECCHIA': 'F657',
  'MONTEVEGLIO': 'F659',
  'MONTEVERDE': 'F660',
  'MONTEVERDI MARITTIMO': 'F661',
  'MONTEVIALE': 'F662',
  'MONTE VIDON COMBATTE': 'F664',
  'MONTE VIDON CORRADO': 'F665',
  'MONTEZEMOLO': 'F666',
  'MONTI': 'F667',
  'MONTIANO': 'F668',
  'MONTICELLO D\'ALBA': 'F669',
  'MONTICELLI PAVESE': 'F670',
  'MONTICELLI D\'ONGINA': 'F671',
  'MONTICELLI BRUSATI': 'F672',
  'MONTICELLO BRIANZA': 'F674',
  'MONTICELLO CONTE OTTO': 'F675',
  'MONTICIANO': 'F676',
  'MONTIERI': 'F677',
  'MONTIGNOSO': 'F679',
  'MONTIRONE': 'F680',
  'MONTODINE': 'F681',
  'MONTOGGIO': 'F682',
  'MONTONE': 'F685',
  'MONTOPOLI IN VAL D\'ARNO': 'F686',
  'MONTOPOLI DI SABINA': 'F687',
  'MONTORFANO': 'F688',
  'MONTORIO NEI FRENTANI': 'F689',
  'MONTORIO AL VOMANO': 'F690',
  'MONTORIO ROMANO': 'F692',
  'MONTORO INFERIORE': 'F693',
  'MONTORO SUPERIORE': 'F694',
  'MONTORSO VICENTINO': 'F696',
  'MONTOTTONE': 'F697',
  'MONTRESTA': 'F698',
  'MONTU\' BECCARIA': 'F701',
  'MONVALLE': 'F703',
  'MONZA': 'F704',
  'MONZAMBANO': 'F705',
  'MONZUNO': 'F706',
  'MORANO PO': 'F707',
  'MORANO CALABRO': 'F708',
  'MORANSENGO': 'F709',
  'MORARO': 'F710',
  'MORAZZONE': 'F711',
  'MORBEGNO': 'F712',
  'MORBELLO': 'F713',
  'MORCIANO DI ROMAGNA': 'F715',
  'MORCIANO DI LEUCA': 'F716',
  'MORCONE': 'F717',
  'MORDANO': 'F718',
  'MORENGO': 'F720',
  'MORES': 'F721',
  'MORESCO': 'F722',
  'MORETTA': 'F723',
  'MORFASSO': 'F724',
  'MORGANO': 'F725',
  'MORGEX': 'F726',
  'MORGONGIORI': 'F727',
  'MORI': 'F728',
  'MORIAGO DELLA BATTAGLIA': 'F729',
  'MORICONE': 'F730',
  'MORIGERATI': 'F731',
  'MORINO': 'F732',
  'MORIONDO TORINESE': 'F733',
  'MORLUPO': 'F734',
  'MORMANNO': 'F735',
  'MORNAGO': 'F736',
  'MORNESE': 'F737',
  'MORNICO AL SERIO': 'F738',
  'MORNICO LOSANA': 'F739',
  'MOROLO': 'F740',
  'MOROZZO': 'F743',
  'MORRA DE SANCTIS': 'F744',
  'MORRO D\'ALBA': 'F745',
  'MORRO REATINO': 'F746',
  'MORRO D\'ORO': 'F747',
  'MORRONE DEL SANNIO': 'F748',
  'MORROVALLE': 'F749',
  'MORSANO AL TAGLIAMENTO': 'F750',
  'MORSASCO': 'F751',
  'MORTARA': 'F754',
  'MORTEGLIANO': 'F756',
  'MORTERONE': 'F758',
  'MORUZZO': 'F760',
  'MOSCAZZANO': 'F761',
  'MOSCHIANO': 'F762',
  'MOSCIANO SANT\'ANGELO': 'F764',
  'MOSCUFO': 'F765',
  'MOSO IN PASSIRIA * MOOS IN PASSEIER': 'F766',
  'MOSSA': 'F767',
  'MOSSANO': 'F768',
  'MOTTA DI LIVENZA': 'F770',
  'MOTTA BALUFFI': 'F771',
  'MOTTA CAMASTRA': 'F772',
  'MOTTA D\'AFFERMO': 'F773',
  'MOTTA DE\' CONTI': 'F774',
  'MOTTAFOLLONE': 'F775',
  'MOTTALCIATA': 'F776',
  'MOTTA MONTECORVINO': 'F777',
  'MOTTA SAN GIOVANNI': 'F779',
  'MOTTA SANTA LUCIA': 'F780',
  'MOTTA SANT\'ANASTASIA': 'F781',
  'MOTTA VISCONTI': 'F783',
  'MOTTOLA': 'F784',
  'MOZZAGROGNA': 'F785',
  'MOZZANICA': 'F786',
  'MOZZATE': 'F788',
  'MOZZECANE': 'F789',
  'MOZZO': 'F791',
  'MUCCIA': 'F793',
  'MUGGIA': 'F795',
  'MUGGIO\'': 'F797',
  'MUGNANO DEL CARDINALE': 'F798',
  'MUGNANO DI NAPOLI': 'F799',
  'MULAZZANO': 'F801',
  'MULAZZO': 'F802',
  'VILLA POMA': 'F804',
  'MURA': 'F806',
  'MURAVERA': 'F808',
  'MURAZZANO': 'F809',
  'SALCEDO': 'F810',
  'MURELLO': 'F811',
  'MURIALDO': 'F813',
  'MURISENGO': 'F814',
  'MURLO': 'F815',
  'MURO LECCESE': 'F816',
  'MURO LUCANO': 'F817',
  'MUROS': 'F818',
  'MUSCOLINE': 'F820',
  'MUSEI': 'F822',
  'MUSILE DI PIAVE': 'F826',
  'MUSSO': 'F828',
  'MUSSOLENTE': 'F829',
  'MUSSOMELI': 'F830',
  'PINETO': 'F831',
  'MUZZANA DEL TURGNANO': 'F832',
  'MUZZANO': 'F833',
  'NAGO-TORBOLE': 'F835',
  'NALLES * NALS': 'F836',
  'NANNO': 'F837',
  'NANTO': 'F838',
  'NAPOLI': 'F839',
  'NARBOLIA': 'F840',
  'NARCAO': 'F841',
  'NARDO\'': 'F842',
  'NARDODIPACE': 'F843',
  'NARNI': 'F844',
  'NARO': 'F845',
  'NARZOLE': 'F846',
  'NASINO': 'F847',
  'NASO': 'F848',
  'NATURNO * NATURNS': 'F849',
  'NAVE': 'F851',
  'NAVELLI': 'F852',
  'NAVE SAN ROCCO': 'F853',
  'NAZ-SCIAVES * NATZ-SCHABS': 'F856',
  'NAZZANO': 'F857',
  'NE': 'F858',
  'NEBBIUNO': 'F859',
  'NEGRAR': 'F861',
  'NEIRONE': 'F862',
  'NEIVE': 'F863',
  'NEMBRO': 'F864',
  'NEMI': 'F865',
  'NEMOLI': 'F866',
  'NEONELI': 'F867',
  'NEPI': 'F868',
  'NERETO': 'F870',
  'NEROLA': 'F871',
  'NERVESA DELLA BATTAGLIA': 'F872',
  'NERVIANO': 'F874',
  'NESPOLO': 'F876',
  'NESSO': 'F877',
  'NETRO': 'F878',
  'NETTUNO': 'F880',
  'NEVIANO': 'F881',
  'NEVIANO DEGLI ARDUINI': 'F882',
  'NEVIGLIE': 'F883',
  'NIARDO': 'F884',
  'NIBBIANO': 'F885',
  'NIBBIOLA': 'F886',
  'NIBIONNO': 'F887',
  'NICHELINO': 'F889',
  'NICOLOSI': 'F890',
  'NICORVO': 'F891',
  'NICOSIA': 'F892',
  'NICOTERA': 'F893',
  'NIELLA BELBO': 'F894',
  'NIELLA TANARO': 'F895',
  'NIMIS': 'F898',
  'NISCEMI': 'F899',
  'NISSORIA': 'F900',
  'NIZZA DI SICILIA': 'F901',
  'NIZZA MONFERRATO': 'F902',
  'NOALE': 'F904',
  'NOASCA': 'F906',
  'NOCARA': 'F907',
  'NOCCIANO': 'F908',
  'NOCERA TERINESE': 'F910',
  'NOCERA UMBRA': 'F911',
  'NOCERA INFERIORE': 'F912',
  'NOCERA SUPERIORE': 'F913',
  'NOCETO': 'F914',
  'NOCI': 'F915',
  'NOCIGLIA': 'F916',
  'NOEPOLI': 'F917',
  'NOGARA': 'F918',
  'NOGAREDO': 'F920',
  'NOGAROLE ROCCA': 'F921',
  'NOGAROLE VICENTINO': 'F922',
  'NOICATTARO': 'F923',
  'NOLA': 'F924',
  'NOLE': 'F925',
  'NOLI': 'F926',
  'NOMAGLIO': 'F927',
  'NOMI': 'F929',
  'NONANTOLA': 'F930',
  'NONE': 'F931',
  'NONIO': 'F932',
  'NORAGUGUME': 'F933',
  'NORBELLO': 'F934',
  'NORCIA': 'F935',
  'NORMA': 'F937',
  'NOSATE': 'F939',
  'PONTE NOSSA': 'F941',
  'NOTARESCO': 'F942',
  'NOTO': 'F943',
  'NOVA MILANESE': 'F944',
  'NOVALEDO': 'F947',
  'NOVALESA': 'F948',
  'NOVA LEVANTE * WELSCHNOFEN': 'F949',
  'NOVA PONENTE * DEUTSCHNOFEN': 'F950',
  'NOVARA DI SICILIA': 'F951',
  'NOVARA': 'F952',
  'NOVATE MILANESE': 'F955',
  'NOVATE MEZZOLA': 'F956',
  'NOVE': 'F957',
  'NOVEDRATE': 'F958',
  'NOVELLARA': 'F960',
  'NOVELLO': 'F961',
  'NOVENTA PADOVANA': 'F962',
  'NOVENTA DI PIAVE': 'F963',
  'NOVENTA VICENTINA': 'F964',
  'NOVI LIGURE': 'F965',
  'NOVI DI MODENA': 'F966',
  'NOVI VELIA': 'F967',
  'NOVIGLIO': 'F968',
  'NOVOLI': 'F970',
  'NUCETTO': 'F972',
  'NUGHEDU SANTA VITTORIA': 'F974',
  'NUGHEDU SAN NICOLO\'': 'F975',
  'NULE': 'F976',
  'NULVI': 'F977',
  'NUMANA': 'F978',
  'NUORO': 'F979',
  'NURACHI': 'F980',
  'NURAGUS': 'F981',
  'NURALLAO': 'F982',
  'NURAMINIS': 'F983',
  'NURECI': 'F985',
  'NURRI': 'F986',
  'NUS': 'F987',
  'NUSCO': 'F988',
  'NUVOLENTO': 'F989',
  'NUVOLERA': 'F990',
  'NUXIS': 'F991',
  'OCCHIEPPO INFERIORE': 'F992',
  'OCCHIEPPO SUPERIORE': 'F993',
  'OCCHIOBELLO': 'F994',
  'OCCIMIANO': 'F995',
  'OCRE': 'F996',
  'ODALENGO GRANDE': 'F997',
  'ODALENGO PICCOLO': 'F998',
  'ODERZO': 'F999',
  'ODOLO': 'G001',
  'OFENA': 'G002',
  'OFFAGNA': 'G003',
  'OFFANENGO': 'G004',
  'OFFIDA': 'G005',
  'OFFLAGA': 'G006',
  'OGGEBBIO': 'G007',
  'OGGIONA CON SANTO STEFANO': 'G008',
  'OGGIONO': 'G009',
  'OGLIANICO': 'G010',
  'OGLIASTRO CILENTO': 'G011',
  'OYACE': 'G012',
  'OLBIA': 'G015',
  'OLCENENGO': 'G016',
  'OLDENICO': 'G018',
  'OLEGGIO': 'G019',
  'OLEGGIO CASTELLO': 'G020',
  'OLEVANO DI LOMELLINA': 'G021',
  'OLEVANO ROMANO': 'G022',
  'OLEVANO SUL TUSCIANO': 'G023',
  'OLGIATE COMASCO': 'G025',
  'OLGIATE MOLGORA': 'G026',
  'OLGIATE OLONA': 'G028',
  'OLGINATE': 'G030',
  'OLIENA': 'G031',
  'OLIVA GESSI': 'G032',
  'OLIVADI': 'G034',
  'OLIVERI': 'G036',
  'OLIVETO LUCANO': 'G037',
  'OLIVETO CITRA': 'G039',
  'OLIVETO LARIO': 'G040',
  'OLIVETTA SAN MICHELE': 'G041',
  'OLIVOLA': 'G042',
  'OLLASTRA': 'G043',
  'OLLOLAI': 'G044',
  'OLLOMONT': 'G045',
  'OLMEDO': 'G046',
  'OLMENETA': 'G047',
  'OLMO GENTILE': 'G048',
  'OLMO AL BREMBO': 'G049',
  'OLTRE IL COLLE': 'G050',
  'OLTRESSENDA ALTA': 'G054',
  'OLTRONA DI SAN MAMETTE': 'G056',
  'OLZAI': 'G058',
  'OME': 'G061',
  'OMEGNA': 'G062',
  'OMIGNANO': 'G063',
  'ONANI': 'G064',
  'ONANO': 'G065',
  'ONCINO': 'G066',
  'ONETA': 'G068',
  'ONIFAI': 'G070',
  'ONIFERI': 'G071',
  'ONO SAN PIETRO': 'G074',
  'ONORE': 'G075',
  'ONZO': 'G076',
  'OPERA': 'G078',
  'OPI': 'G079',
  'OPPEANO': 'G080',
  'OPPIDO LUCANO': 'G081',
  'OPPIDO MAMERTINA': 'G082',
  'ORA * AUER': 'G083',
  'ORANI': 'G084',
  'ORATINO': 'G086',
  'ORBASSANO': 'G087',
  'ORBETELLO': 'G088',
  'ORCIANO DI PESARO': 'G089',
  'ORCIANO PISANO': 'G090',
  'ORERO': 'G093',
  'ORGIANO': 'G095',
  'PIEVE FISSIRAGA': 'G096',
  'ORGOSOLO': 'G097',
  'ORIA': 'G098',
  'ORICOLA': 'G102',
  'ORIGGIO': 'G103',
  'ORINO': 'G105',
  'ORIO LITTA': 'G107',
  'ORIO AL SERIO': 'G108',
  'ORIO CANAVESE': 'G109',
  'ORIOLO': 'G110',
  'ORIOLO ROMANO': 'G111',
  'ORISTANO': 'G113',
  'ORMEA': 'G114',
  'ORMELLE': 'G115',
  'ORNAGO': 'G116',
  'ORNAVASSO': 'G117',
  'ORNICA': 'G118',
  'OROSEI': 'G119',
  'OROTELLI': 'G120',
  'ORRIA': 'G121',
  'ORROLI': 'G122',
  'ORSAGO': 'G123',
  'ORSARA BORMIDA': 'G124',
  'ORSARA DI PUGLIA': 'G125',
  'ORSENIGO': 'G126',
  'ORSOGNA': 'G128',
  'ORSOMARSO': 'G129',
  'ORTA DI ATELLA': 'G130',
  'ORTA NOVA': 'G131',
  'ORTACESUS': 'G133',
  'ORTA SAN GIULIO': 'G134',
  'ORTE': 'G135',
  'ORTELLE': 'G136',
  'ORTEZZANO': 'G137',
  'ORTIGNANO RAGGIOLO': 'G139',
  'ORTISEI * SANKT ULRICH': 'G140',
  'ORTONA': 'G141',
  'ORTONA DEI MARSI': 'G142',
  'ORTONOVO': 'G143',
  'ORTOVERO': 'G144',
  'ORTUCCHIO': 'G145',
  'ORTUERI': 'G146',
  'ORUNE': 'G147',
  'ORVIETO': 'G148',
  'ORZINUOVI': 'G149',
  'ORZIVECCHI': 'G150',
  'OSASCO': 'G151',
  'OSASIO': 'G152',
  'OSCHIRI': 'G153',
  'OSIDDA': 'G154',
  'OSIGLIA': 'G155',
  'OSILO': 'G156',
  'OSIMO': 'G157',
  'OSINI': 'G158',
  'OSIO SOPRA': 'G159',
  'OSIO SOTTO': 'G160',
  'OSNAGO': 'G161',
  'OSOPPO': 'G163',
  'OSPEDALETTI': 'G164',
  'OSPEDALETTO D\'ALPINOLO': 'G165',
  'OSPEDALETTO LODIGIANO': 'G166',
  'OSPEDALETTO EUGANEO': 'G167',
  'OSPEDALETTO': 'G168',
  'OSPITALE DI CADORE': 'G169',
  'OSPITALETTO': 'G170',
  'OSSAGO LODIGIANO': 'G171',
  'OSSANA': 'G173',
  'OSSI': 'G178',
  'OSSIMO': 'G179',
  'OSSONA': 'G181',
  'OSSUCCIO': 'G182',
  'OSTANA': 'G183',
  'OSTELLATO': 'G184',
  'OSTIANO': 'G185',
  'OSTIGLIA': 'G186',
  'OSTUNI': 'G187',
  'OTRANTO': 'G188',
  'OTRICOLI': 'G189',
  'OTTAVIANO': 'G190',
  'OTTANA': 'G191',
  'OTTATI': 'G192',
  'OTTIGLIO': 'G193',
  'OTTOBIANO': 'G194',
  'OTTONE': 'G195',
  'OULX': 'G196',
  'OVADA': 'G197',
  'OVARO': 'G198',
  'OVIGLIO': 'G199',
  'OVINDOLI': 'G200',
  'OVODDA': 'G201',
  'OZEGNA': 'G202',
  'OZIERI': 'G203',
  'OZZANO MONFERRATO': 'G204',
  'OZZANO DELL\'EMILIA': 'G205',
  'OZZERO': 'G206',
  'PABILLONIS': 'G207',
  'PACECO': 'G208',
  'PACE DEL MELA': 'G209',
  'PACENTRO': 'G210',
  'PACHINO': 'G211',
  'PACIANO': 'G212',
  'PADENGHE SUL GARDA': 'G213',
  'PADERGNONE': 'G214',
  'PADERNA': 'G215',
  'PADERNO FRANCIACORTA': 'G217',
  'PADERNO D\'ADDA': 'G218',
  'PADERNO DUGNANO': 'G220',
  'PADERNO DEL GRAPPA': 'G221',
  'PADERNO PONCHIELLI': 'G222',
  'ROBBIATE': 'G223',
  'PADOVA': 'G224',
  'PADRIA': 'G225',
  'PADULA': 'G226',
  'PADULI': 'G227',
  'PAESANA': 'G228',
  'PAESE': 'G229',
  'PAGANI': 'G230',
  'PAGANICO SABINO': 'G232',
  'PAGAZZANO': 'G233',
  'PAGLIARA': 'G234',
  'PAGLIETA': 'G237',
  'PAGNACCO': 'G238',
  'PAGNO': 'G240',
  'PAGNONA': 'G241',
  'PAGO DEL VALLO DI LAURO': 'G242',
  'PAGO VEIANO': 'G243',
  'PAISCO LOVENO': 'G247',
  'PAITONE': 'G248',
  'PALADINA': 'G249',
  'PALAGANO': 'G250',
  'PALAGIANELLO': 'G251',
  'PALAGIANO': 'G252',
  'PALAGONIA': 'G253',
  'PALAIA': 'G254',
  'PALANZANO': 'G255',
  'PALATA': 'G257',
  'PALAZZAGO': 'G259',
  'PALAZZO PIGNANO': 'G260',
  'PALAZZO SAN GERVASIO': 'G261',
  'PALAZZO CANAVESE': 'G262',
  'PALAZZO ADRIANO': 'G263',
  'PALAZZOLO SULL\'OGLIO': 'G264',
  'PALAZZOLO VERCELLESE': 'G266',
  'PALAZZOLO ACREIDE': 'G267',
  'PALAZZOLO DELLO STELLA': 'G268',
  'PALAZZUOLO SUL SENIO': 'G270',
  'PALENA': 'G271',
  'PALERMITI': 'G272',
  'PALERMO': 'G273',
  'PALESTRINA': 'G274',
  'PALESTRO': 'G275',
  'PALIANO': 'G276',
  'PALIZZI': 'G277',
  'PALLAGORIO': 'G278',
  'PALLANZENO': 'G280',
  'PALLARE': 'G281',
  'PALMA DI MONTECHIARO': 'G282',
  'PALMA CAMPANIA': 'G283',
  'PALMANOVA': 'G284',
  'PALMARIGGI': 'G285',
  'PALMAS ARBOREA': 'G286',
  'SAN GIOVANNI SUERGIU': 'G287',
  'PALMI': 'G288',
  'PALMIANO': 'G289',
  'PALMOLI': 'G290',
  'PALO DEL COLLE': 'G291',
  'PALOMONTE': 'G292',
  'PALOMBARA SABINA': 'G293',
  'PALOMBARO': 'G294',
  'PALOSCO': 'G295',
  'PALU\' DEL FERSINA': 'G296',
  'PALU\'': 'G297',
  'PALUDI': 'G298',
  'PLAUS * PLAUS': 'G299',
  'PALUZZA': 'G300',
  'PAMPARATO': 'G302',
  'PANCALIERI': 'G303',
  'PANCARANA': 'G304',
  'PANCHIA\'': 'G305',
  'PANDINO': 'G306',
  'PANETTIERI': 'G307',
  'PANICALE': 'G308',
  'VILLARICCA': 'G309',
  'PANNARANO': 'G311',
  'PANNI': 'G312',
  'PANTELLERIA': 'G315',
  'PANTIGLIATE': 'G316',
  'PAOLA': 'G317',
  'PAOLISI': 'G318',
  'VALDERICE': 'G319',
  'PAPASIDERO': 'G320',
  'PAPOZZE': 'G323',
  'PARABIAGO': 'G324',
  'PARABITA': 'G325',
  'PARATICO': 'G327',
  'PARCINES * PARTSCHINS': 'G328',
  'PARE\'': 'G329',
  'PARELLA': 'G330',
  'PARENTI': 'G331',
  'PARETE': 'G333',
  'PARETO': 'G334',
  'PARGHELIA': 'G335',
  'PARLASCO': 'G336',
  'PARMA': 'G337',
  'PARODI LIGURE': 'G338',
  'PAROLDO': 'G339',
  'PAROLISE': 'G340',
  'PARONA': 'G342',
  'PARRANO': 'G344',
  'PARRE': 'G346',
  'PARTANNA': 'G347',
  'PARTINICO': 'G348',
  'PARUZZARO': 'G349',
  'PARZANICA': 'G350',
  'PASIAN DI PRATO': 'G352',
  'PASIANO DI PORDENONE': 'G353',
  'PASPARDO': 'G354',
  'PASSERANO MARMORITO': 'G358',
  'PASSIGNANO SUL TRASIMENO': 'G359',
  'PASSIRANO': 'G361',
  'PASTENA': 'G362',
  'PASTORANO': 'G364',
  'PASTRENGO': 'G365',
  'PASTURANA': 'G367',
  'PASTURO': 'G368',
  'PATERNOPOLI': 'G370',
  'PATERNO\'': 'G371',
  'PATERNO CALABRO': 'G372',
  'PATRICA': 'G374',
  'PATTADA': 'G376',
  'PATTI': 'G377',
  'PATU\'': 'G378',
  'PAU': 'G379',
  'PAULARO': 'G381',
  'PAULI ARBAREI': 'G382',
  'SAN NICOLO\' GERREI': 'G383',
  'PAULILATINO': 'G384',
  'PAULLO': 'G385',
  'PAUPISI': 'G386',
  'PAVAROLO': 'G387',
  'PAVIA': 'G388',
  'PAVIA DI UDINE': 'G389',
  'PAVONE DEL MELLA': 'G391',
  'PAVONE CANAVESE': 'G392',
  'PAVULLO NEL FRIGNANO': 'G393',
  'PAZZANO': 'G394',
  'PECCIOLI': 'G395',
  'PECCO': 'G396',
  'PECETTO DI VALENZA': 'G397',
  'PECETTO TORINESE': 'G398',
  'PECORARA': 'G399',
  'PEDACE': 'G400',
  'PEDARA': 'G402',
  'PEDASO': 'G403',
  'PEDAVENA': 'G404',
  'PEDEMONTE': 'G406',
  'SAN PAOLO': 'G407',
  'PEDEROBBA': 'G408',
  'PEDESINA': 'G410',
  'PEDIVIGLIANO': 'G411',
  'PEDRENGO': 'G412',
  'PEGLIO': 'G416',
  'PEGOGNAGA': 'G417',
  'PEIA': 'G418',
  'PEIO': 'G419',
  'PELAGO': 'G420',
  'PELLA': 'G421',
  'PELLEGRINO PARMENSE': 'G424',
  'PELLEZZANO': 'G426',
  'PELLIO INTELVI': 'G427',
  'PELLIZZANO': 'G428',
  'PELUGO': 'G429',
  'PENANGO': 'G430',
  'POGGIRIDENTI': 'G431',
  'PENNA IN TEVERINA': 'G432',
  'PENNABILLI': 'G433',
  'PENNADOMO': 'G434',
  'PENNAPIEDIMONTE': 'G435',
  'PENNA SAN GIOVANNI': 'G436',
  'PENNA SANT\'ANDREA': 'G437',
  'PENNE': 'G438',
  'PENTONE': 'G439',
  'PERANO': 'G441',
  'PERAROLO DI CADORE': 'G442',
  'PERCA * PERCHA': 'G443',
  'PERCILE': 'G444',
  'PERDASDEFOGU': 'G445',
  'PERDAXIUS': 'G446',
  'PERDIFUMO': 'G447',
  'PEREGO': 'G448',
  'PERETO': 'G449',
  'PERFUGAS': 'G450',
  'PERGINE VALDARNO': 'G451',
  'PERGINE VALSUGANA': 'G452',
  'PERGOLA': 'G453',
  'PERINALDO': 'G454',
  'PERITO': 'G455',
  'PERLEDO': 'G456',
  'PERLETTO': 'G457',
  'PERLO': 'G458',
  'PERLOZ': 'G459',
  'PERNUMIA': 'G461',
  'PEROSA CANAVESE': 'G462',
  'PEROSA ARGENTINA': 'G463',
  'PERRERO': 'G465',
  'SAN GIOVANNI IN PERSICETO': 'G467',
  'PERSICO DOSIMO': 'G469',
  'PERTENGO': 'G471',
  'PERTICA ALTA': 'G474',
  'PERTICA BASSA': 'G475',
  'PERTOSA': 'G476',
  'PERTUSIO': 'G477',
  'PERUGIA': 'G478',
  'PESARO': 'G479',
  'PESCAGLIA': 'G480',
  'PESCANTINA': 'G481',
  'PESCARA': 'G482',
  'PESCAROLO ED UNITI': 'G483',
  'PESCASSEROLI': 'G484',
  'PESCATE': 'G485',
  'PESCHE': 'G486',
  'PESCHICI': 'G487',
  'PESCHIERA BORROMEO': 'G488',
  'PESCHIERA DEL GARDA': 'G489',
  'PESCIA': 'G491',
  'PESCINA': 'G492',
  'PESCOCOSTANZO': 'G493',
  'PESCO SANNITA': 'G494',
  'PESCOLANCIANO': 'G495',
  'PESCOPAGANO': 'G496',
  'PESCOPENNATARO': 'G497',
  'PESCOROCCHIANO': 'G498',
  'PESCOSANSONESCO': 'G499',
  'PESCOSOLIDO': 'G500',
  'PESSANO CON BORNAGO': 'G502',
  'PESSINA CREMONESE': 'G504',
  'PESSINETTO': 'G505',
  'PETACCIATO': 'G506',
  'TURANIA': 'G507',
  'PETILIA POLICASTRO': 'G508',
  'PETINA': 'G509',
  'PETRALIA SOPRANA': 'G510',
  'PETRALIA SOTTANA': 'G511',
  'PETRELLA TIFERNINA': 'G512',
  'PETRELLA SALTO': 'G513',
  'PETRIANO': 'G514',
  'PETRIOLO': 'G515',
  'PETRITOLI': 'G516',
  'PETRIZZI': 'G517',
  'PETRONA\'': 'G518',
  'PETRURO IRPINO': 'G519',
  'PETTENASCO': 'G520',
  'PETTINENGO': 'G521',
  'PETTINEO': 'G522',
  'PETTORANELLO DEL MOLISE': 'G523',
  'PETTORANO SUL GIZIO': 'G524',
  'PETTORAZZA GRIMANI': 'G525',
  'PEVERAGNO': 'G526',
  'PEZZANA': 'G528',
  'PEZZAZE': 'G529',
  'PEZZOLO VALLE UZZONE': 'G532',
  'PIACENZA D\'ADIGE': 'G534',
  'PIACENZA': 'G535',
  'PIADENA': 'G536',
  'PIAGGE': 'G537',
  'PIAGGINE': 'G538',
  'VALLE DELL\'ANGELO': 'G540',
  'PIANA DI MONTE VERNA': 'G541',
  'PIANA CRIXIA': 'G542',
  'PIANA DEGLI ALBANESI': 'G543',
  'PONTBOSET': 'G545',
  'PIAN CAMUNO': 'G546',
  'PIANCASTAGNAIO': 'G547',
  'PIANCOGNO': 'G549',
  'PIANDIMELETO': 'G551',
  'PIAN DI SCO': 'G552',
  'PIANE CRATI': 'G553',
  'PIANELLA': 'G555',
  'PIANELLO DEL LARIO': 'G556',
  'PIANELLO VAL TIDONE': 'G557',
  'PIANENGO': 'G558',
  'PIANEZZA': 'G559',
  'PIANEZZE': 'G560',
  'PIANFEI': 'G561',
  'PIANICO': 'G564',
  'PIANIGA': 'G565',
  'SAN BENEDETTO VAL DI SAMBRO': 'G566',
  'PIANO DI SORRENTO': 'G568',
  'PIANORO': 'G570',
  'PIANSANO': 'G571',
  'PIANTEDO': 'G572',
  'PIARIO': 'G574',
  'PIASCO': 'G575',
  'PIATEDA': 'G576',
  'PIATTO': 'G577',
  'PIAZZA BREMBANA': 'G579',
  'PIAZZA ARMERINA': 'G580',
  'PIAZZA AL SERCHIO': 'G582',
  'PIAZZATORRE': 'G583',
  'PIAZZOLA SUL BRENTA': 'G587',
  'PIAZZOLO': 'G588',
  'PICCIANO': 'G589',
  'PICERNO': 'G590',
  'PICINISCO': 'G591',
  'PICO': 'G592',
  'PIEA': 'G593',
  'PIEDICAVALLO': 'G594',
  'PIEDIMONTE MATESE': 'G596',
  'PIEDIMONTE ETNEO': 'G597',
  'PIEDIMONTE SAN GERMANO': 'G598',
  'PIEDIMULERA': 'G600',
  'PIEGARO': 'G601',
  'PIENZA': 'G602',
  'PIERANICA': 'G603',
  'PIETRAMONTECORVINO': 'G604',
  'PIETRA LIGURE': 'G605',
  'PIETRABBONDANTE': 'G606',
  'PIETRABRUNA': 'G607',
  'PIETRACAMELA': 'G608',
  'PIETRACATELLA': 'G609',
  'PIETRACUPA': 'G610',
  'PIETRADEFUSI': 'G611',
  'PIETRA DE\' GIORGI': 'G612',
  'PIETRAFERRAZZANA': 'G613',
  'SATRIANO DI LUCANIA': 'G614',
  'PIETRAFITTA': 'G615',
  'PIETRAGALLA': 'G616',
  'PIETRALUNGA': 'G618',
  'PIETRA MARAZZI': 'G619',
  'PIETRAMELARA': 'G620',
  'PIETRANICO': 'G621',
  'PIETRAPAOLA': 'G622',
  'PIETRAPERTOSA': 'G623',
  'PIETRAPERZIA': 'G624',
  'PIETRAPORZIO': 'G625',
  'PIETRAROJA': 'G626',
  'PIETRARUBBIA': 'G627',
  'PIETRASANTA': 'G628',
  'PIETRASTORNINA': 'G629',
  'PIETRAVAIRANO': 'G630',
  'PIETRELCINA': 'G631',
  'PIEVE DI TECO': 'G632',
  'PIEVE DI CORIANO': 'G633',
  'PIEVE EMANUELE': 'G634',
  'PIEVE ALBIGNOLA': 'G635',
  'PIEVE A NIEVOLE': 'G636',
  'PIEVEBOVIGLIANA': 'G637',
  'PIEVE D\'ALPAGO': 'G638',
  'PIEVE DEL CAIRO': 'G639',
  'PIEVE DI BONO': 'G641',
  'PIEVE DI CADORE': 'G642',
  'PIEVE DI CENTO': 'G643',
  'PIEVE DI LEDRO': 'G644',
  'PIEVE DI SOLIGO': 'G645',
  'PIEVE LIGURE': 'G646',
  'PIEVE D\'OLMI': 'G647',
  'PIEVE FOSCIANA': 'G648',
  'PIEVEPELAGO': 'G649',
  'PIEVE PORTO MORONE': 'G650',
  'PIEVE SAN GIACOMO': 'G651',
  'PIEVE SANTO STEFANO': 'G653',
  'RAMISETO': 'G654',
  'PIEVE TESINO': 'G656',
  'PIEVE TORINA': 'G657',
  'PIEVE VERGONTE': 'G658',
  'PIGLIO': 'G659',
  'PIGNA': 'G660',
  'PIGNATARO MAGGIORE': 'G661',
  'PIGNATARO INTERAMNA': 'G662',
  'PIGNOLA': 'G663',
  'PIGNONE': 'G664',
  'PIGRA': 'G665',
  'PILA': 'G666',
  'PIMENTEL': 'G669',
  'PIMONTE': 'G670',
  'PINAROLO PO': 'G671',
  'PINASCA': 'G672',
  'PINCARA': 'G673',
  'PINEROLO': 'G674',
  'PINO D\'ASTI': 'G676',
  'PINO SULLA SPONDA DEL LAGO MAGGIORE': 'G677',
  'PINO TORINESE': 'G678',
  'PINZANO AL TAGLIAMENTO': 'G680',
  'PINZOLO': 'G681',
  'PIOBBICO': 'G682',
  'PIOBESI D\'ALBA': 'G683',
  'PIOBESI TORINESE': 'G684',
  'PIODE': 'G685',
  'PIOLTELLO': 'G686',
  'PIOMBINO': 'G687',
  'PIOMBINO DESE': 'G688',
  'PIORACO': 'G690',
  'PIOSSASCO': 'G691',
  'PIOVA\' MASSAIA': 'G692',
  'PIOVE DI SACCO': 'G693',
  'PIOVENE ROCCHETTE': 'G694',
  'PIOVERA': 'G695',
  'PIOZZANO': 'G696',
  'PIOZZO': 'G697',
  'PRIVERNO': 'G698',
  'PIRAINO': 'G699',
  'PISA': 'G702',
  'PISANO': 'G703',
  'PISONIANO': 'G704',
  'PISCINA': 'G705',
  'PISCIOTTA': 'G707',
  'PISOGNE': 'G710',
  'PISTICCI': 'G712',
  'PISTOIA': 'G713',
  'PITEGLIO': 'G715',
  'PITIGLIANO': 'G716',
  'PIUBEGA': 'G717',
  'PIURO': 'G718',
  'PIVERONE': 'G719',
  'PIZZALE': 'G720',
  'PIZZIGHETTONE': 'G721',
  'PIZZO': 'G722',
  'PIZZOFERRATO': 'G724',
  'PIZZOLI': 'G726',
  'PIZZONE': 'G727',
  'PIZZONI': 'G728',
  'PLACANICA': 'G729',
  'PLATACI': 'G733',
  'PLATANIA': 'G734',
  'PLATI\'': 'G735',
  'TAIPANA': 'G736',
  'PLESIO': 'G737',
  'PLOAGHE': 'G740',
  'PLODIO': 'G741',
  'POCAPAGLIA': 'G742',
  'POCENIA': 'G743',
  'PODENZANA': 'G746',
  'PODENZANO': 'G747',
  'POFI': 'G749',
  'POGGIARDO': 'G751',
  'POGGIBONSI': 'G752',
  'POGGIO RUSCO': 'G753',
  'POGGIO A CAIANO': 'G754',
  'POGGIO TORRIANA': 'G755',
  'POGGIO BUSTONE': 'G756',
  'POGGIO CATINO': 'G757',
  'POGGIODOMO': 'G758',
  'POGGIOFIORITO': 'G760',
  'POGGIO IMPERIALE': 'G761',
  'POGGIOMARINO': 'G762',
  'POGGIO MIRTETO': 'G763',
  'POGGIO MOIANO': 'G764',
  'POGGIO NATIVO': 'G765',
  'POGGIO PICENZE': 'G766',
  'POGGIOREALE': 'G767',
  'POGGIO RENATICO': 'G768',
  'POGGIORSINI': 'G769',
  'POGGIO SAN LORENZO': 'G770',
  'POGGIO SAN MARCELLO': 'G771',
  'POGLIANO MILANESE': 'G772',
  'POGNANA LARIO': 'G773',
  'POGNANO': 'G774',
  'POGNO': 'G775',
  'POIANA MAGGIORE': 'G776',
  'POIRINO': 'G777',
  'POLAVENO': 'G779',
  'POLCENIGO': 'G780',
  'POLESELLA': 'G782',
  'POLESINE PARMENSE': 'G783',
  'POLI': 'G784',
  'POLIA': 'G785',
  'POLICORO': 'G786',
  'POLIGNANO A MARE': 'G787',
  'SAN PIETRO IN CERRO': 'G788',
  'POLINAGO': 'G789',
  'POLINO': 'G790',
  'POLISTENA': 'G791',
  'POLIZZI GENEROSA': 'G792',
  'POLLA': 'G793',
  'POLLEIN': 'G794',
  'POLLENA TROCCHIA': 'G795',
  'POLLICA': 'G796',
  'POLLINA': 'G797',
  'POLLONE': 'G798',
  'POLLUTRI': 'G799',
  'POLONGHERA': 'G800',
  'POLPENAZZE DEL GARDA': 'G801',
  'POLVERARA': 'G802',
  'POLVERIGI': 'G803',
  'POMARANCE': 'G804',
  'POMARETTO': 'G805',
  'POMARICO': 'G806',
  'POMARO MONFERRATO': 'G807',
  'POMAROLO': 'G808',
  'POMBIA': 'G809',
  'POMEZIA': 'G811',
  'POMIGLIANO D\'ARCO': 'G812',
  'POMPEI': 'G813',
  'POMPEIANA': 'G814',
  'POMPIANO': 'G815',
  'POMPONESCO': 'G816',
  'POMPU': 'G817',
  'PONCARALE': 'G818',
  'PONDERANO': 'G820',
  'PONNA': 'G821',
  'PONSACCO': 'G822',
  'PONSO': 'G823',
  'PONTASSIEVE': 'G825',
  'PONT CANAVESE': 'G826',
  'PONTE': 'G828',
  'PONTE IN VALTELLINA': 'G829',
  'PONTE GARDENA * WAIDBRUCK': 'G830',
  'PONTEBBA': 'G831',
  'PONTE BUGGIANESE': 'G833',
  'PONTECAGNANO FAIANO': 'G834',
  'PONTECCHIO POLESINE': 'G836',
  'PONTECHIANALE': 'G837',
  'PONTECORVO': 'G838',
  'PONTECURONE': 'G839',
  'PONTEDASSIO': 'G840',
  'PONTE DELL\'OLIO': 'G842',
  'PONTEDERA': 'G843',
  'PONTE DI LEGNO': 'G844',
  'PONTE DI PIAVE': 'G846',
  'PONTE LAMBRO': 'G847',
  'PONTELANDOLFO': 'G848',
  'PONTELATONE': 'G849',
  'PONTELONGO': 'G850',
  'PONTE NIZZA': 'G851',
  'PONTENURE': 'G852',
  'PONTERANICA': 'G853',
  'PONT-SAINT-MARTIN': 'G854',
  'PONTE SAN NICOLO\'': 'G855',
  'PONTE SAN PIETRO': 'G856',
  'PONTESTURA': 'G858',
  'PONTEVICO': 'G859',
  'PONTEY': 'G860',
  'PONTI': 'G861',
  'PONTI SUL MINCIO': 'G862',
  'PONTIDA': 'G864',
  'PONTINIA': 'G865',
  'PONTINVREA': 'G866',
  'PONTIROLO NUOVO': 'G867',
  'PONTOGLIO': 'G869',
  'PONTREMOLI': 'G870',
  'PONZA': 'G871',
  'PONZANO MONFERRATO': 'G872',
  'PONZANO DI FERMO': 'G873',
  'PONZANO ROMANO': 'G874',
  'PONZANO VENETO': 'G875',
  'PONZONE': 'G877',
  'POPOLI': 'G878',
  'POPPI': 'G879',
  'PORANO': 'G881',
  'PORCARI': 'G882',
  'PORCIA': 'G886',
  'STELLA CILENTO': 'G887',
  'PORDENONE': 'G888',
  'PORLEZZA': 'G889',
  'PORNASSIO': 'G890',
  'PORPETTO': 'G891',
  'PORTACOMARO': 'G894',
  'PORTALBERA': 'G895',
  'PORTE': 'G900',
  'PORTICI': 'G902',
  'PORTICO DI CASERTA': 'G903',
  'PORTICO E SAN BENEDETTO': 'G904',
  'PORTIGLIOLA': 'G905',
  'PORTO CERESIO': 'G906',
  'PORTO VALTRAVAGLIA': 'G907',
  'PORTOBUFFOLE\'': 'G909',
  'PORTOCANNONE': 'G910',
  'PORTOFERRAIO': 'G912',
  'PORTOFINO': 'G913',
  'PORTOGRUARO': 'G914',
  'PORTOMAGGIORE': 'G916',
  'PORTO MANTOVANO': 'G917',
  'PORTO RECANATI': 'G919',
  'PORTO SAN GIORGIO': 'G920',
  'PORTO SANT\'ELPIDIO': 'G921',
  'PORTOSCUSO': 'G922',
  'PORTO TOLLE': 'G923',
  'PORTO TORRES': 'G924',
  'PORTOVENERE': 'G925',
  'PORTO VIRO': 'G926',
  'PORTULA': 'G927',
  'POSADA': 'G929',
  'POSINA': 'G931',
  'POSITANO': 'G932',
  'POSSAGNO': 'G933',
  'POSTA': 'G934',
  'POSTA FIBRENO': 'G935',
  'POSTAL * BURGSTALL': 'G936',
  'POSTALESIO': 'G937',
  'POSTIGLIONE': 'G939',
  'POSTUA': 'G940',
  'POTENZA': 'G942',
  'POVE DEL GRAPPA': 'G943',
  'POVEGLIANO': 'G944',
  'POVEGLIANO VERONESE': 'G945',
  'POVIGLIO': 'G947',
  'POVOLETTO': 'G949',
  'POZZA DI FASSA': 'G950',
  'POZZAGLIA SABINA': 'G951',
  'POZZALLO': 'G953',
  'POZZILLI': 'G954',
  'POZZO D\'ADDA': 'G955',
  'POZZOLEONE': 'G957',
  'POZZOLENGO': 'G959',
  'POZZOL GROPPO': 'G960',
  'POZZOLO FORMIGARO': 'G961',
  'POZZOMAGGIORE': 'G962',
  'POZZONOVO': 'G963',
  'POZZUOLI': 'G964',
  'POZZUOLO MARTESANA': 'G965',
  'POZZUOLO DEL FRIULI': 'G966',
  'PRADALUNGA': 'G968',
  'PRADAMANO': 'G969',
  'PRADLEVES': 'G970',
  'SASSO MARCONI': 'G972',
  'PRAGELATO': 'G973',
  'PRAY': 'G974',
  'PRAIA A MARE': 'G975',
  'PRAIANO': 'G976',
  'PRALBOINO': 'G977',
  'PRALI': 'G978',
  'PRALORMO': 'G979',
  'PRALUNGO': 'G980',
  'PRAMAGGIORE': 'G981',
  'PRAMOLLO': 'G982',
  'PRAROLO': 'G985',
  'PRAROSTINO': 'G986',
  'PRASCO': 'G987',
  'PRASCORSANO': 'G988',
  'PRASO': 'G989',
  'PRATA DI PRINCIPATO ULTRA': 'G990',
  'PRATA SANNITA': 'G991',
  'PRATA D\'ANSIDONIA': 'G992',
  'PRATA CAMPORTACCIO': 'G993',
  'PRATA DI PORDENONE': 'G994',
  'PRATELLA': 'G995',
  'PRATIGLIONE': 'G997',
  'PRATO': 'G999',
  'PRATO SESIA': 'H001',
  'PRATO CARNICO': 'H002',
  'PRATO ALLO STELVIO * PRAD AM STILFSERJOCH': 'H004',
  'PRATOLA SERRA': 'H006',
  'PRATOLA PELIGNA': 'H007',
  'PRATOVECCHIO': 'H008',
  'PRAVISDOMINI': 'H010',
  'PRAZZO': 'H011',
  'SAMO': 'H013',
  'PRECENICCO': 'H014',
  'PRECI': 'H015',
  'PREDAPPIO': 'H017',
  'PREDAZZO': 'H018',
  'PREDOI * PRETTAU': 'H019',
  'PREDORE': 'H020',
  'PREDOSA': 'H021',
  'PREGANZIOL': 'H022',
  'PREGNANA MILANESE': 'H026',
  'PRELA\'': 'H027',
  'PREMANA': 'H028',
  'PREMARIACCO': 'H029',
  'PREMENO': 'H030',
  'PREMIA': 'H033',
  'PREMILCUORE': 'H034',
  'PREMOLO': 'H036',
  'PREMOSELLO CHIOVENDA': 'H037',
  'PREONE': 'H038',
  'PREORE': 'H039',
  'PREPOTTO': 'H040',
  'PRE\'-SAINT-DIDIER': 'H042',
  'PRESEGLIE': 'H043',
  'PRESENZANO': 'H045',
  'PRESEZZO': 'H046',
  'PRESICCE': 'H047',
  'PRESSANA': 'H048',
  'PRESTINE': 'H050',
  'PRETORO': 'H052',
  'PREVALLE': 'H055',
  'PREZZA': 'H056',
  'PREZZO': 'H057',
  'PRIERO': 'H059',
  'PRIGNANO SULLA SECCHIA': 'H061',
  'PRIGNANO CILENTO': 'H062',
  'PRIMALUNA': 'H063',
  'PRIOCCA': 'H068',
  'PRIOLA': 'H069',
  'PRIZZI': 'H070',
  'PROCENO': 'H071',
  'PROCIDA': 'H072',
  'PROPATA': 'H073',
  'PROSERPIO': 'H074',
  'PROSSEDI': 'H076',
  'PROVAGLIO VAL SABBIA': 'H077',
  'PROVAGLIO D\'ISEO': 'H078',
  'PROVES * PROVEIS': 'H081',
  'PROVVIDENTI': 'H083',
  'PRUNETTO': 'H085',
  'PUEGNAGO SUL GARDA': 'H086',
  'PUGLIANELLO': 'H087',
  'PULA': 'H088',
  'PULFERO': 'H089',
  'PULSANO': 'H090',
  'PUMENENGO': 'H091',
  'PUOS D\'ALPAGO': 'H092',
  'PUSIANO': 'H094',
  'PUTIFIGARI': 'H095',
  'PUTIGNANO': 'H096',
  'QUADRELLE': 'H097',
  'QUADRI': 'H098',
  'QUAGLIUZZO': 'H100',
  'QUALIANO': 'H101',
  'QUARANTI': 'H102',
  'QUAREGNA': 'H103',
  'QUARGNENTO': 'H104',
  'QUARNA SOPRA': 'H106',
  'QUARNA SOTTO': 'H107',
  'QUARONA': 'H108',
  'QUARRATA': 'H109',
  'QUART': 'H110',
  'QUARTO': 'H114',
  'QUARTO D\'ALTINO': 'H117',
  'QUARTU SANT\'ELENA': 'H118',
  'QUARTUCCIU': 'H119',
  'QUASSOLO': 'H120',
  'QUATTORDIO': 'H121',
  'QUATTRO CASTELLA': 'H122',
  'VIRGILIO': 'H123',
  'QUERO': 'H124',
  'QUILIANO': 'H126',
  'QUINCINETTO': 'H127',
  'QUINDICI': 'H128',
  'QUINGENTOLE': 'H129',
  'QUINTANO': 'H130',
  'QUINTO DI TREVISO': 'H131',
  'QUINTO VERCELLESE': 'H132',
  'QUINTO VICENTINO': 'H134',
  'QUINZANO D\'OGLIO': 'H140',
  'QUISTELLO': 'H143',
  'QUITTENGO': 'H145',
  'RABBI': 'H146',
  'RACALE': 'H147',
  'RACALMUTO': 'H148',
  'RACCONIGI': 'H150',
  'RACCUJA': 'H151',
  'RACINES * RATSCHINGS': 'H152',
  'RADDA IN CHIANTI': 'H153',
  'RADDUSA': 'H154',
  'RADICOFANI': 'H156',
  'RADICONDOLI': 'H157',
  'RAFFADALI': 'H159',
  'RAGOGNA': 'H161',
  'RAGOLI': 'H162',
  'RAGUSA': 'H163',
  'RUVIANO': 'H165',
  'RAIANO': 'H166',
  'RAMACCA': 'H168',
  'RAMPONIO VERNA': 'H171',
  'RANCIO VALCUVIA': 'H173',
  'RANCO': 'H174',
  'RANDAZZO': 'H175',
  'RANICA': 'H176',
  'RANZANICO': 'H177',
  'RANZO': 'H181',
  'RAPAGNANO': 'H182',
  'RAPALLO': 'H183',
  'RAPINO': 'H184',
  'RAPOLANO TERME': 'H185',
  'RAPOLLA': 'H186',
  'RAPONE': 'H187',
  'RASSA': 'H188',
  'RASUN-ANTERSELVA * RASEN-ANTHOLZ': 'H189',
  'RASURA': 'H192',
  'RAVANUSA': 'H194',
  'RAVARINO': 'H195',
  'RAVASCLETTO': 'H196',
  'RAVELLO': 'H198',
  'RAVENNA': 'H199',
  'RAVEO': 'H200',
  'RAVISCANINA': 'H202',
  'RE': 'H203',
  'REA': 'H204',
  'REALMONTE': 'H205',
  'REANA DEL ROIALE': 'H206',
  'REANO': 'H207',
  'RECALE': 'H210',
  'RECANATI': 'H211',
  'RECCO': 'H212',
  'RECETTO': 'H213',
  'RECOARO TERME': 'H214',
  'REDAVALLE': 'H216',
  'REDONDESCO': 'H218',
  'REFRANCORE': 'H219',
  'REFRONTOLO': 'H220',
  'REGALBUTO': 'H221',
  'REGGELLO': 'H222',
  'REGGIO EMILIA': 'H223',
  'REGGIO CALABRIA': 'H224',
  'REGGIOLO': 'H225',
  'REINO': 'H227',
  'REITANO': 'H228',
  'REMANZACCO': 'H229',
  'REMEDELLO': 'H230',
  'RENATE': 'H233',
  'RENDE': 'H235',
  'RENON * RITTEN': 'H236',
  'RESANA': 'H238',
  'RESCALDINA': 'H240',
  'RESIA': 'H242',
  'ERCOLANO': 'H243',
  'RESIUTTA': 'H244',
  'RESUTTANO': 'H245',
  'RETORBIDO': 'H246',
  'REVELLO': 'H247',
  'REVERE': 'H248',
  'REVIGLIASCO D\'ASTI': 'H250',
  'REVINE LAGO': 'H253',
  'REVO\'': 'H254',
  'REZZAGO': 'H255',
  'REZZATO': 'H256',
  'REZZO': 'H257',
  'REZZOAGLIO': 'H258',
  'VAL REZZO': 'H259',
  'RHEMES-NOTRE-DAME': 'H262',
  'RHEMES-SAINT-GEORGES': 'H263',
  'RHO': 'H264',
  'RIACE': 'H265',
  'RIALTO': 'H266',
  'RIANO': 'H267',
  'RIARDO': 'H268',
  'RIBERA': 'H269',
  'RIBORDONE': 'H270',
  'RICADI': 'H271',
  'RICALDONE': 'H272',
  'RICCIA': 'H273',
  'RICCIONE': 'H274',
  'RICCO\' DEL GOLFO DI SPEZIA': 'H275',
  'RICENGO': 'H276',
  'RICIGLIANO': 'H277',
  'RIESE PIO X': 'H280',
  'RIESI': 'H281',
  'RIETI': 'H282',
  'RIFIANO * RIFFIAN': 'H284',
  'RIFREDDO': 'H285',
  'RIGNANO SULL\'ARNO': 'H286',
  'RIGNANO GARGANICO': 'H287',
  'RIGNANO FLAMINIO': 'H288',
  'RIGOLATO': 'H289',
  'RIMA SAN GIUSEPPE': 'H291',
  'RIMASCO': 'H292',
  'RIMELLA': 'H293',
  'RIMINI': 'H294',
  'RIO NELL\'ELBA': 'H297',
  'RIO SALICETO': 'H298',
  'RIO DI PUSTERIA * MUEHLBACH': 'H299',
  'RIOFREDDO': 'H300',
  'RIOLA SARDO': 'H301',
  'RIOLO TERME': 'H302',
  'RIOLUNATO': 'H303',
  'RIOMAGGIORE': 'H304',
  'RIO MARINA': 'H305',
  'RIONERO IN VULTURE': 'H307',
  'RIONERO SANNITICO': 'H308',
  'RIPABOTTONI': 'H311',
  'RIPACANDIDA': 'H312',
  'RIPALIMOSANI': 'H313',
  'RIPALTA ARPINA': 'H314',
  'RIPALTA CREMASCA': 'H315',
  'RIPALTA GUERINA': 'H316',
  'RIPARBELLA': 'H319',
  'RIPA TEATINA': 'H320',
  'RIPATRANSONE': 'H321',
  'RIPE': 'H322',
  'RIPE SAN GINESIO': 'H323',
  'RIPI': 'H324',
  'RIPOSTO': 'H325',
  'RITTANA': 'H326',
  'RIVAMONTE AGORDINO': 'H327',
  'RIVA LIGURE': 'H328',
  'RIVA VALDOBBIA': 'H329',
  'RIVA DEL GARDA': 'H330',
  'RIVA DI SOLTO': 'H331',
  'RIVALBA': 'H333',
  'RIVALTA BORMIDA': 'H334',
  'RIVALTA DI TORINO': 'H335',
  'RIVANAZZANO TERME': 'H336',
  'RIVA PRESSO CHIERI': 'H337',
  'RIVARA': 'H338',
  'RIVAROLO CANAVESE': 'H340',
  'RIVAROLO DEL RE ED UNITI': 'H341',
  'RIVAROLO MANTOVANO': 'H342',
  'RIVARONE': 'H343',
  'RIVAROSSA': 'H344',
  'RIVE': 'H346',
  'RIVE D\'ARCANO': 'H347',
  'RIVELLO': 'H348',
  'RIVERGARO': 'H350',
  'RIVIGNANO': 'H352',
  'RIVISONDOLI': 'H353',
  'RIVODUTRI': 'H354',
  'RIVOLI': 'H355',
  'RIVOLI VERONESE': 'H356',
  'RIVOLTA D\'ADDA': 'H357',
  'RIZZICONI': 'H359',
  'RO': 'H360',
  'ROANA': 'H361',
  'ROASCHIA': 'H362',
  'ROASCIO': 'H363',
  'ROVASENDA': 'H364',
  'ROASIO': 'H365',
  'ROATTO': 'H366',
  'ROBASSOMERO': 'H367',
  'ROBBIO': 'H369',
  'ROBECCHETTO CON INDUNO': 'H371',
  'ROBECCO D\'OGLIO': 'H372',
  'ROBECCO SUL NAVIGLIO': 'H373',
  'ROBECCO PAVESE': 'H375',
  'ROBELLA': 'H376',
  'ROBILANTE': 'H377',
  'ROBURENT': 'H378',
  'ROCCA PIETORE': 'H379',
  'ROCCAVALDINA': 'H380',
  'ROCCABASCERANA': 'H382',
  'ROCCABERNARDA': 'H383',
  'ROCCABIANCA': 'H384',
  'ROCCABRUNA': 'H385',
  'ROCCA CANAVESE': 'H386',
  'ROCCA CANTERANO': 'H387',
  'ROCCACASALE': 'H389',
  'ROCCAFLUVIONE': 'H390',
  'ROCCA CIGLIE\'': 'H391',
  'ROCCA D\'ARAZZO': 'H392',
  'ROCCADARCE': 'H393',
  'ROCCADASPIDE': 'H394',
  'ROCCA DE\' BALDI': 'H395',
  'ROCCA DE\' GIORGI': 'H396',
  'ROCCA D\'EVANDRO': 'H398',
  'ROCCA DI BOTTE': 'H399',
  'ROCCA DI CAMBIO': 'H400',
  'ROCCA DI CAVE': 'H401',
  'ROCCA DI MEZZO': 'H402',
  'ROCCA DI NETO': 'H403',
  'ROCCA DI PAPA': 'H404',
  'ROCCAFIORITA': 'H405',
  'ROCCAFORTE LIGURE': 'H406',
  'ROCCAFORTE MONDOVI\'': 'H407',
  'ROCCAFORTE DEL GRECO': 'H408',
  'ROCCAFORZATA': 'H409',
  'ROCCAFRANCA': 'H410',
  'ROCCAGIOVINE': 'H411',
  'ROCCAGLORIOSA': 'H412',
  'ROCCAGORGA': 'H413',
  'ROCCA GRIMALDA': 'H414',
  'ROCCA IMPERIALE': 'H416',
  'ROCCALBEGNA': 'H417',
  'ROCCALUMERA': 'H418',
  'ROCCAMANDOLFI': 'H420',
  'ROCCA MASSIMA': 'H421',
  'ROCCAMENA': 'H422',
  'ROCCAMONFINA': 'H423',
  'ROCCAMONTEPIANO': 'H424',
  'ROCCAMORICE': 'H425',
  'ROCCANOVA': 'H426',
  'ROCCANTICA': 'H427',
  'ROCCAPALUMBA': 'H428',
  'ROCCA PIA': 'H429',
  'ROCCAPIEMONTE': 'H431',
  'ROCCA PRIORA': 'H432',
  'ROCCARAINOLA': 'H433',
  'ROCCARASO': 'H434',
  'ROCCAROMANA': 'H436',
  'ROCCA SAN CASCIANO': 'H437',
  'ROCCA SAN FELICE': 'H438',
  'ROCCA SAN GIOVANNI': 'H439',
  'ROCCA SANTA MARIA': 'H440',
  'ROCCA SANTO STEFANO': 'H441',
  'ROCCASCALEGNA': 'H442',
  'ROCCASECCA': 'H443',
  'ROCCASECCA DEI VOLSCI': 'H444',
  'ROCCASICURA': 'H445',
  'ROCCA SINIBALDA': 'H446',
  'ROCCASPARVERA': 'H447',
  'ROCCASPINALVETI': 'H448',
  'ROCCASTRADA': 'H449',
  'ROCCA SUSELLA': 'H450',
  'ROCCAVERANO': 'H451',
  'ROCCAVIGNALE': 'H452',
  'ROCCAVIONE': 'H453',
  'ROCCAVIVARA': 'H454',
  'ROCCELLA VALDEMONE': 'H455',
  'ROCCELLA IONICA': 'H456',
  'ROCCHETTA A VOLTURNO': 'H458',
  'ROCCHETTA E CROCE': 'H459',
  'ROCCHETTA NERVINA': 'H460',
  'ROCCHETTA DI VARA': 'H461',
  'ROCCHETTA BELBO': 'H462',
  'ROCCHETTA LIGURE': 'H465',
  'ROCCHETTA PALAFEA': 'H466',
  'ROCCHETTA SANT\'ANTONIO': 'H467',
  'ROCCHETTA TANARO': 'H468',
  'RODANO': 'H470',
  'RODDI': 'H472',
  'RODDINO': 'H473',
  'RODELLO': 'H474',
  'RODENGO * RODENECK': 'H475',
  'RODENGO-SAIANO': 'H477',
  'RODERO': 'H478',
  'RODI\' MILICI': 'H479',
  'RODI GARGANICO': 'H480',
  'RODIGO': 'H481',
  'ROE\' VOLCIANO': 'H484',
  'ROFRANO': 'H485',
  'ROGENO': 'H486',
  'ROGGIANO GRAVINA': 'H488',
  'ROGHUDI': 'H489',
  'ROGLIANO': 'H490',
  'ROGNANO': 'H491',
  'ROGNO': 'H492',
  'ROGOLO': 'H493',
  'ROIATE': 'H494',
  'ROIO DEL SANGRO': 'H495',
  'ROISAN': 'H497',
  'ROLETTO': 'H498',
  'ROLO': 'H500',
  'ROMA': 'H501',
  'ROMAGNANO SESIA': 'H502',
  'ROMAGNANO AL MONTE': 'H503',
  'ROMAGNESE': 'H505',
  'ROMALLO': 'H506',
  'ROMANA': 'H507',
  'ROMANENGO': 'H508',
  'ROMANO DI LOMBARDIA': 'H509',
  'ROMANO CANAVESE': 'H511',
  'ROMANO D\'EZZELINO': 'H512',
  'ROMANS D\'ISONZO': 'H514',
  'ROMBIOLO': 'H516',
  'ROMENO': 'H517',
  'ROMENTINO': 'H518',
  'ROMETTA': 'H519',
  'RONAGO': 'H521',
  'RONCA\'': 'H522',
  'RONCADE': 'H523',
  'RONCADELLE': 'H525',
  'RONCARO': 'H527',
  'RONCEGNO': 'H528',
  'RONCELLO': 'H529',
  'RONCHI DEI LEGIONARI': 'H531',
  'RONCHI VALSUGANA': 'H532',
  'RONCHIS': 'H533',
  'RONCIGLIONE': 'H534',
  'RONCOBELLO': 'H535',
  'RONCO SCRIVIA': 'H536',
  'RONCO BRIANTINO': 'H537',
  'RONCO BIELLESE': 'H538',
  'RONCO CANAVESE': 'H539',
  'RONCO ALL\'ADIGE': 'H540',
  'RONCOFERRARO': 'H541',
  'RONCOFREDDO': 'H542',
  'RONCOLA': 'H544',
  'RONCONE': 'H545',
  'RONDANINA': 'H546',
  'RONDISSONE': 'H547',
  'RONSECCO': 'H549',
  'RONZONE': 'H552',
  'ROPPOLO': 'H553',
  'RORA\'': 'H554',
  'ROURE': 'H555',
  'ROSA\'': 'H556',
  'ROSARNO': 'H558',
  'ROSASCO': 'H559',
  'ROSATE': 'H560',
  'ROSAZZA': 'H561',
  'ROSCIANO': 'H562',
  'ROSCIGNO': 'H564',
  'ROSE': 'H565',
  'ROSELLO': 'H566',
  'ROSETO VALFORTORE': 'H568',
  'ROSIGNANO MONFERRATO': 'H569',
  'ROSIGNANO MARITTIMO': 'H570',
  'ROSETO CAPO SPULICO': 'H572',
  'ROSOLINA': 'H573',
  'ROSOLINI': 'H574',
  'ROSORA': 'H575',
  'ROSSA': 'H577',
  'ROSSANA': 'H578',
  'ROSSANO': 'H579',
  'ROSSANO VENETO': 'H580',
  'ROSSIGLIONE': 'H581',
  'ROSTA': 'H583',
  'ROTA D\'IMAGNA': 'H584',
  'ROTA GRECA': 'H585',
  'ROTELLA': 'H588',
  'ROTELLO': 'H589',
  'ROTONDA': 'H590',
  'ROTONDELLA': 'H591',
  'ROTONDI': 'H592',
  'ROTTOFRENO': 'H593',
  'ROTZO': 'H594',
  'ROVAGNATE': 'H596',
  'ROVATO': 'H598',
  'ROVEGNO': 'H599',
  'ROVELLASCA': 'H601',
  'ROVELLO PORRO': 'H602',
  'ROVERBELLA': 'H604',
  'ROVERCHIARA': 'H606',
  'ROVERE\' DELLA LUNA': 'H607',
  'ROVERE\' VERONESE': 'H608',
  'ROVEREDO IN PIANO': 'H609',
  'ROVEREDO DI GUA\'': 'H610',
  'ROVERETO': 'H611',
  'ROVESCALA': 'H614',
  'ROVETTA': 'H615',
  'ROVIANO': 'H618',
  'ROVIGO': 'H620',
  'ROVITO': 'H621',
  'ROVOLON': 'H622',
  'ROZZANO': 'H623',
  'RUBANO': 'H625',
  'RUBIANA': 'H627',
  'RUBIERA': 'H628',
  'RUDA': 'H629',
  'RUDIANO': 'H630',
  'RUEGLIO': 'H631',
  'RUFFANO': 'H632',
  'RUFFIA': 'H633',
  'RUFFRE\'': 'H634',
  'RUFINA': 'H635',
  'RUINO': 'H637',
  'RUMO': 'H639',
  'RUOTI': 'H641',
  'RUSSI': 'H642',
  'RUTIGLIANO': 'H643',
  'RUTINO': 'H644',
  'RUVO DI PUGLIA': 'H645',
  'RUVO DEL MONTE': 'H646',
  'SABAUDIA': 'H647',
  'SABBIA': 'H648',
  'SABBIO CHIESE': 'H650',
  'SABBIONETA': 'H652',
  'SACCO': 'M244',
  'SACCOLONGO': 'H655',
  'SACILE': 'H657',
  'SACROFANO': 'H658',
  'SADALI': 'H659',
  'SAGAMA': 'H661',
  'SAGLIANO MICCA': 'H662',
  'SAGRADO': 'H665',
  'SAGRON MIS': 'H666',
  'SAINT-CHRISTOPHE': 'H669',
  'SAINT-DENIS': 'H670',
  'SAINT-MARCEL': 'H671',
  'SAINT-NICOLAS': 'H672',
  'SAINT-OYEN': 'H673',
  'SAINT-PIERRE': 'H674',
  'SAINT-RHEMY-EN-BOSSES': 'H675',
  'SAINT-VINCENT': 'H676',
  'SALA MONFERRATO': 'H677',
  'SALA BOLOGNESE': 'H678',
  'SALA COMACINA': 'H679',
  'SALA BIELLESE': 'H681',
  'SALA BAGANZA': 'H682',
  'SALA CONSILINA': 'H683',
  'SALBERTRAND': 'H684',
  'SALENTO': 'H686',
  'SALANDRA': 'H687',
  'SALAPARUTA': 'H688',
  'SALARA': 'H689',
  'SALASCO': 'H690',
  'SALASSA': 'H691',
  'SALCITO': 'H693',
  'SALE': 'H694',
  'SALE DELLE LANGHE': 'H695',
  'SALE MARASINO': 'H699',
  'SALEMI': 'H700',
  'SALERANO SUL LAMBRO': 'H701',
  'SALERANO CANAVESE': 'H702',
  'SALERNO': 'H703',
  'SALE SAN GIOVANNI': 'H704',
  'SALETTO': 'H705',
  'SALGAREDA': 'H706',
  'SALI VERCELLESE': 'H707',
  'SALICE SALENTINO': 'H708',
  'SALICETO': 'H710',
  'SAN MAURO DI SALINE': 'H712',
  'SALISANO': 'H713',
  'SALIZZOLE': 'H714',
  'SALLE': 'H715',
  'SALMOUR': 'H716',
  'SALO\'': 'H717',
  'SALORNO * SALURN': 'H719',
  'SALSOMAGGIORE TERME': 'H720',
  'SALTARA': 'H721',
  'SALTRIO': 'H723',
  'SALUDECIO': 'H724',
  'SALUGGIA': 'H725',
  'SALUSSOLA': 'H726',
  'SALUZZO': 'H727',
  'SALVE': 'H729',
  'SAVOIA DI LUCANIA': 'H730',
  'SALVIROLA': 'H731',
  'SALVITELLE': 'H732',
  'SALZA IRPINA': 'H733',
  'SALZA DI PINEROLO': 'H734',
  'SALZANO': 'H735',
  'SAMARATE': 'H736',
  'SAMASSI': 'H738',
  'SAMATZAI': 'H739',
  'SAMBUCA DI SICILIA': 'H743',
  'SAMBUCA PISTOIESE': 'H744',
  'SAMBUCI': 'H745',
  'SAMBUCO': 'H746',
  'SAMMICHELE DI BARI': 'H749',
  'SAMOLACO': 'H752',
  'SAMONE': 'H754',
  'SAMPEYRE': 'H755',
  'SAMUGHEO': 'H756',
  'SANARICA': 'H757',
  'SAN BARTOLOMEO VAL CAVARGNA': 'H760',
  'SAN BARTOLOMEO AL MARE': 'H763',
  'SAN BARTOLOMEO IN GALDO': 'H764',
  'SAN BASILE': 'H765',
  'SAN BASILIO': 'H766',
  'SAN BASSANO': 'H767',
  'SAN BELLINO': 'H768',
  'SAN BENEDETTO DEL TRONTO': 'H769',
  'SAN BENEDETTO BELBO': 'H770',
  'SAN BENEDETTO PO': 'H771',
  'SAN BENEDETTO DEI MARSI': 'H772',
  'SAN BENEDETTO IN PERILLIS': 'H773',
  'SAN BENEDETTO ULLANO': 'H774',
  'SAN BENIGNO CANAVESE': 'H775',
  'SAN BERNARDINO VERBANO': 'H777',
  'SAN BIAGIO PLATANI': 'H778',
  'SAN BIAGIO SARACINISCO': 'H779',
  'SAN BIAGIO DELLA CIMA': 'H780',
  'SAN BIAGIO DI CALLALTA': 'H781',
  'SAN BIASE': 'H782',
  'SAN BONIFACIO': 'H783',
  'SAN BUONO': 'H784',
  'SAN CALOGERO': 'H785',
  'SAN CANDIDO * INNICHEN': 'H786',
  'SAN CANZIAN D\'ISONZO': 'H787',
  'SAN CARLO CANAVESE': 'H789',
  'SAN CASCIANO DEI BAGNI': 'H790',
  'SAN CASCIANO IN VAL DI PESA': 'H791',
  'SAN CATALDO': 'H792',
  'SAN CESARIO DI LECCE': 'H793',
  'SAN CESARIO SUL PANARO': 'H794',
  'SAN CHIRICO NUOVO': 'H795',
  'SAN CHIRICO RAPARO': 'H796',
  'SAN CIPIRELLO': 'H797',
  'SAN CIPRIANO D\'AVERSA': 'H798',
  'SAN CIPRIANO PO': 'H799',
  'SAN CIPRIANO PICENTINO': 'H800',
  'SAN CLEMENTE': 'H801',
  'SAN COLOMBANO CERTENOLI': 'H802',
  'SAN COLOMBANO AL LAMBRO': 'H803',
  'SAN COLOMBANO BELMONTE': 'H804',
  'SAN CONO': 'H805',
  'SAN COSMO ALBANESE': 'H806',
  'SAN COSTANTINO CALABRO': 'H807',
  'SAN COSTANTINO ALBANESE': 'H808',
  'SAN COSTANZO': 'H809',
  'SAN CRISTOFORO': 'H810',
  'SAN DAMIANO D\'ASTI': 'H811',
  'SAN DAMIANO MACRA': 'H812',
  'SAN DAMIANO AL COLLE': 'H814',
  'SAN DANIELE PO': 'H815',
  'SAN DANIELE DEL FRIULI': 'H816',
  'SAN DEMETRIO CORONE': 'H818',
  'SAN DEMETRIO NE\' VESTINI': 'H819',
  'SAN DIDERO': 'H820',
  'SANDIGLIANO': 'H821',
  'SAN DONACI': 'H822',
  'SAN DONA\' DI PIAVE': 'H823',
  'SAN DONATO VAL DI COMINO': 'H824',
  'SAN DONATO DI NINEA': 'H825',
  'SAN DONATO DI LECCE': 'H826',
  'SAN DONATO MILANESE': 'H827',
  'SANDRIGO': 'H829',
  'SAN FEDELE INTELVI': 'H830',
  'SAN FELE': 'H831',
  'SAN FELICE DEL MOLISE': 'H833',
  'SAN FELICE A CANCELLO': 'H834',
  'SAN FELICE SUL PANARO': 'H835',
  'SAN FELICE CIRCEO': 'H836',
  'SAN FELICE DEL BENACO': 'H838',
  'SAN FERDINANDO DI PUGLIA': 'H839',
  'SAN FERMO DELLA BATTAGLIA': 'H840',
  'SAN FILI': 'H841',
  'SAN FILIPPO DEL MELA': 'H842',
  'SAN FIOR': 'H843',
  'SAN FIORANO': 'H844',
  'SAN FLORIANO DEL COLLIO': 'H845',
  'SAN FLORO': 'H846',
  'SAN FRANCESCO AL CAMPO': 'H847',
  'AGLIENTU': 'H848',
  'SAN FRATELLO': 'H850',
  'SANFRE\'': 'H851',
  'SANFRONT': 'H852',
  'SANGANO': 'H855',
  'SAN GAVINO MONREALE': 'H856',
  'SAN GEMINI': 'H857',
  'SAN GENESIO ATESINO * JENESIEN': 'H858',
  'SAN GENESIO ED UNITI': 'H859',
  'SAN GENNARO VESUVIANO': 'H860',
  'SAN GERMANO VERCELLESE': 'H861',
  'SAN GERMANO CHISONE': 'H862',
  'SAN GERMANO DEI BERICI': 'H863',
  'SAN GERVASIO BRESCIANO': 'H865',
  'SAN GIACOMO DEGLI SCHIAVONI': 'H867',
  'SAN GIACOMO FILIPPO': 'H868',
  'SAN GIACOMO DELLE SEGNATE': 'H870',
  'SANGIANO': 'H872',
  'SAN GILLIO': 'H873',
  'SAN GIMIGNANO': 'H875',
  'SAN GINESIO': 'H876',
  'SANGINETO': 'H877',
  'SAN GIORGIO MONFERRATO': 'H878',
  'SAN GIORGIO A LIRI': 'H880',
  'SAN GIORGIO ALBANESE': 'H881',
  'SAN GIORGIO IONICO': 'H882',
  'SAN GIORGIO DI MANTOVA': 'H883',
  'SAN GIORGIO SU LEGNANO': 'H884',
  'SAN GIORGIO DI LOMELLINA': 'H885',
  'SAN GIORGIO DI PESARO': 'H886',
  'SAN GIORGIO PIACENTINO': 'H887',
  'SAN GIORGIO LUCANO': 'H888',
  'SAN GIORGIO MORGETO': 'H889',
  'SAN GIORGIO CANAVESE': 'H890',
  'SAN GIORGIO DELLA RICHINVELDA': 'H891',
  'SAN GIORGIO A CREMANO': 'H892',
  'SAN GIORGIO DELLE PERTICHE': 'H893',
  'SAN GIORGIO DEL SANNIO': 'H894',
  'SAN GIORGIO DI NOGARO': 'H895',
  'SAN GIORGIO DI PIANO': 'H896',
  'SAN GIORGIO IN BOSCO': 'H897',
  'SAN GIORGIO LA MOLARA': 'H898',
  'SAN GIORGIO SCARAMPI': 'H899',
  'SAN GIORIO DI SUSA': 'H900',
  'SAN GIOVANNI VALDARNO': 'H901',
  'SAN GIOVANNI DI GERACE': 'H903',
  'SAN GIOVANNI AL NATISONE': 'H906',
  'SAN GIOVANNI A PIRO': 'H907',
  'SAN GIOVANNI BIANCO': 'H910',
  'SAN GIOVANNI D\'ASSO': 'H911',
  'SAN GIOVANNI DEL DOSSO': 'H912',
  'VILLA SAN GIOVANNI IN TUSCIA': 'H913',
  'SAN GIOVANNI GEMINI': 'H914',
  'SAN GIOVANNI ILARIONE': 'H916',
  'SAN GIOVANNI INCARICO': 'H917',
  'SAN GIOVANNI IN CROCE': 'H918',
  'SAN GIOVANNI IN FIORE': 'H919',
  'SAN GIOVANNI IN GALDO': 'H920',
  'SAN GIOVANNI IN MARIGNANO': 'H921',
  'SAN GIOVANNI LA PUNTA': 'H922',
  'SAN GIOVANNI LIPIONI': 'H923',
  'SAN GIOVANNI LUPATOTO': 'H924',
  'SAN GIOVANNI ROTONDO': 'H926',
  'SAN GIULIANO DEL SANNIO': 'H928',
  'SAN GIULIANO DI PUGLIA': 'H929',
  'SAN GIULIANO MILANESE': 'H930',
  'SAN GIUSEPPE VESUVIANO': 'H931',
  'SAN GIUSEPPE JATO': 'H933',
  'SAN GIUSTINO': 'H935',
  'SAN GIUSTO CANAVESE': 'H936',
  'SAN GODENZO': 'H937',
  'SAN GREGORIO NELLE ALPI': 'H938',
  'SAN GREGORIO MATESE': 'H939',
  'SAN GREGORIO DI CATANIA': 'H940',
  'SAN GREGORIO D\'IPPONA': 'H941',
  'SAN GREGORIO DA SASSOLA': 'H942',
  'SAN GREGORIO MAGNO': 'H943',
  'SANGUINETTO': 'H944',
  'SAN LAZZARO DI SAVENA': 'H945',
  'SAN LEO': 'H949',
  'SAN LEONARDO': 'H951',
  'SAN LEONARDO IN PASSIRIA * SANKT LEONHARD IN PASSEIER': 'H952',
  'SAN LEUCIO DEL SANNIO': 'H953',
  'SAN LORENZELLO': 'H955',
  'SAN LORENZO DI SEBATO * SANKT LORENZEN': 'H956',
  'SAN LORENZO AL MARE': 'H957',
  'SAN LORENZO IN CAMPO': 'H958',
  'SAN LORENZO': 'H959',
  'SAN LORENZO BELLIZZI': 'H961',
  'SAN LORENZO DEL VALLO': 'H962',
  'SAN LORENZO ISONTINO': 'H964',
  'SAN LORENZO IN BANALE': 'H966',
  'SAN LORENZO MAGGIORE': 'H967',
  'SAN LORENZO NUOVO': 'H969',
  'SAN LUCA': 'H970',
  'SAN LUCIDO': 'H971',
  'SAN LUPO': 'H973',
  'SANLURI': 'H974',
  'SAN MANGO SUL CALORE': 'H975',
  'SAN MANGO D\'AQUINO': 'H976',
  'SAN MANGO PIEMONTE': 'H977',
  'SAN MARCELLINO': 'H978',
  'SAN MARCELLO': 'H979',
  'SAN MARCELLO PISTOIESE': 'H980',
  'SAN MARCO ARGENTANO': 'H981',
  'SAN MARCO D\'ALUNZIO': 'H982',
  'SAN MARCO DEI CAVOTI': 'H984',
  'SAN MARCO IN LAMIS': 'H985',
  'SAN MARCO LA CATOLA': 'H986',
  'SAN MARTINO ALFIERI': 'H987',
  'SAN MARTINO IN BADIA * SANKT MARTIN IN THURN': 'H988',
  'SAN MARTINO IN PASSIRIA * SANKT MARTIN IN PASSEIER': 'H989',
  'SAN MARTINO IN PENSILIS': 'H990',
  'SAN MARTINO SULLA MARRUCINA': 'H991',
  'SAN MARTINO DI FINITA': 'H992',
  'SAN MARTINO D\'AGRI': 'H994',
  'SAN MARTINO DI VENEZZE': 'H996',
  'SAN MARTINO CANAVESE': 'H997',
  'SAN MARTINO AL TAGLIAMENTO': 'H999',
  'SAN MARTINO SANNITA': 'I002',
  'SAN MARTINO BUON ALBERGO': 'I003',
  'SAN MARTINO DALL\'ARGINE': 'I005',
  'SAN MARTINO DEL LAGO': 'I007',
  'SAN MARTINO DI LUPARI': 'I008',
  'SAN MARTINO IN RIO': 'I011',
  'SAN MARTINO IN STRADA': 'I012',
  'SAN MARTINO SICCOMARIO': 'I014',
  'SAN MARTINO VALLE CAUDINA': 'I016',
  'SAN MARZANO OLIVETO': 'I017',
  'SAN MARZANO DI SAN GIUSEPPE': 'I018',
  'SAN MARZANO SUL SARNO': 'I019',
  'SAN MASSIMO': 'I023',
  'SAN MAURIZIO CANAVESE': 'I024',
  'SAN MAURIZIO D\'OPAGLIO': 'I025',
  'SAN MAURO MARCHESATO': 'I026',
  'SAN MAURO PASCOLI': 'I027',
  'SAN MAURO CASTELVERDE': 'I028',
  'SAN MAURO FORTE': 'I029',
  'SAN MAURO TORINESE': 'I030',
  'SAN MAURO CILENTO': 'I031',
  'SAN MAURO LA BRUCA': 'I032',
  'SAN MICHELE DI SERINO': 'I034',
  'SAN MICHELE DI GANZARIA': 'I035',
  'SAN MICHELE MONDOVI\'': 'I037',
  'SAN MICHELE AL TAGLIAMENTO': 'I040',
  'SAN MICHELE ALL\'ADIGE': 'I042',
  'SAN MICHELE SALENTINO': 'I045',
  'SAN MINIATO': 'I046',
  'SAN NAZARIO': 'I047',
  'SANNAZZARO DE\' BURGONDI': 'I048',
  'SAN NAZZARO': 'I049',
  'SAN NAZZARO VAL CAVARGNA': 'I051',
  'SAN NAZZARO SESIA': 'I052',
  'SANNICANDRO DI BARI': 'I053',
  'SANNICANDRO GARGANICO': 'I054',
  'SAN NICOLA LA STRADA': 'I056',
  'SAN NICOLA DELL\'ALTO': 'I057',
  'SAN NICOLA DA CRISSA': 'I058',
  'SANNICOLA': 'I059',
  'SAN NICOLA ARCELLA': 'I060',
  'SAN NICOLA BARONIA': 'I061',
  'SAN NICOLA MANFREDI': 'I062',
  'SAN NICOLO\' DI COMELICO': 'I063',
  'SAN PANCRAZIO * SANKT PANKRAZ': 'I065',
  'SAN PANCRAZIO SALENTINO': 'I066',
  'SAN PAOLO DI JESI': 'I071',
  'SAN PAOLO DI CIVITATE': 'I072',
  'SAN PAOLO BEL SITO': 'I073',
  'SAN PAOLO CERVO': 'I074',
  'SAN PAOLO SOLBRITO': 'I076',
  'SAN PELLEGRINO TERME': 'I079',
  'SAN PIER D\'ISONZO': 'I082',
  'SAN PIER NICETO': 'I084',
  'SAN PIERO A SIEVE': 'I085',
  'SAN PIERO PATTI': 'I086',
  'SAN PIETRO DI CADORE': 'I088',
  'SAN PIETRO AL TANAGRO': 'I089',
  'SAN PIETRO VAL LEMINA': 'I090',
  'SAN PIETRO AL NATISONE': 'I092',
  'SAN PIETRO A MAIDA': 'I093',
  'SAN PIETRO APOSTOLO': 'I095',
  'SAN PIETRO AVELLANA': 'I096',
  'SAN PIETRO CLARENZA': 'I098',
  'SAN PIETRO DI CARIDA\'': 'I102',
  'SAN PIETRO DI FELETTO': 'I103',
  'SAN PIETRO DI MORUBIO': 'I105',
  'SAN PIETRO IN GU': 'I107',
  'SAN PIETRO IN AMANTEA': 'I108',
  'SAN PIETRO IN CARIANO': 'I109',
  'SAN PIETRO IN CASALE': 'I110',
  'SAN PIETRO INFINE': 'I113',
  'SAN PIETRO IN GUARANO': 'I114',
  'SAN PIETRO IN LAMA': 'I115',
  'SAN PIETRO MOSEZZO': 'I116',
  'SAN PIETRO MUSSOLINO': 'I117',
  'VILLA SAN PIETRO': 'I118',
  'SAN PIETRO VERNOTICO': 'I119',
  'SAN PIETRO VIMINARIO': 'I120',
  'SAN PIO DELLE CAMERE': 'I121',
  'SAN POLO MATESE': 'I122',
  'SAN POLO D\'ENZA': 'I123',
  'SAN POLO DI PIAVE': 'I124',
  'SAN POLO DEI CAVALIERI': 'I125',
  'SAN PONSO': 'I126',
  'SAN POSSIDONIO': 'I128',
  'SAN POTITO ULTRA': 'I129',
  'SAN POTITO SANNITICO': 'I130',
  'SAN PRISCO': 'I131',
  'SAN PROCOPIO': 'I132',
  'SAN PROSPERO': 'I133',
  'SAN QUIRICO D\'ORCIA': 'I135',
  'SAN QUIRINO': 'I136',
  'SAN RAFFAELE CIMENA': 'I137',
  'SANREMO': 'I138',
  'SAN ROBERTO': 'I139',
  'SAN ROCCO AL PORTO': 'I140',
  'SAN ROMANO IN GARFAGNANA': 'I142',
  'SAN RUFO': 'I143',
  'SAN SALVATORE MONFERRATO': 'I144',
  'SAN SALVATORE TELESINO': 'I145',
  'SAN SALVATORE DI FITALIA': 'I147',
  'SAN SALVO': 'I148',
  'SAN SEBASTIANO CURONE': 'I150',
  'SAN SEBASTIANO AL VESUVIO': 'I151',
  'SAN SEBASTIANO DA PO': 'I152',
  'SAN SECONDO PARMENSE': 'I153',
  'SAN SECONDO DI PINEROLO': 'I154',
  'SANSEPOLCRO': 'I155',
  'SAN SEVERINO MARCHE': 'I156',
  'SAN SEVERINO LUCANO': 'I157',
  'SAN SEVERO': 'I158',
  'SAN SIRO': 'I162',
  'SAN SOSSIO BARONIA': 'I163',
  'SAN SOSTENE': 'I164',
  'SAN SOSTI': 'I165',
  'SAN SPERATE': 'I166',
  'SANTA BRIGIDA': 'I168',
  'SANTA CATERINA VILLARMOSA': 'I169',
  'SANTA CATERINA DELLO IONIO': 'I170',
  'SANTA CATERINA ALBANESE': 'I171',
  'SANTA CESAREA TERME': 'I172',
  'SANTA CRISTINA VALGARDENA * SANKTA CHRISTINA IN GROEDEN': 'I173',
  'SANTA CRISTINA GELA': 'I174',
  'SANTA CRISTINA E BISSONE': 'I175',
  'SANTA CRISTINA D\'ASPROMONTE': 'I176',
  'SANTA CROCE SULL\'ARNO': 'I177',
  'SANTA CROCE CAMERINA': 'I178',
  'SANTA CROCE DEL SANNIO': 'I179',
  'SANTA CROCE DI MAGLIANO': 'I181',
  'SANTADI': 'I182',
  'SANTA DOMENICA TALAO': 'I183',
  'SANTA DOMENICA VITTORIA': 'I184',
  'SANTA ELISABETTA': 'I185',
  'SANTA FIORA': 'I187',
  'SANTA FLAVIA': 'I188',
  'SANT\'AGAPITO': 'I189',
  'SANT\'AGATA FOSSILI': 'I190',
  'SANT\'AGATA BOLOGNESE': 'I191',
  'SANT\'AGATA DI ESARO': 'I192',
  'SANT\'AGATA DI PUGLIA': 'I193',
  'SANT\'AGATA SUL SANTERNO': 'I196',
  'SANT\'AGATA DE\' GOTI': 'I197',
  'SANT\'AGATA DEL BIANCO': 'I198',
  'SANT\'AGATA DI MILITELLO': 'I199',
  'SANT\'AGATA FELTRIA': 'I201',
  'SANT\'AGATA LI BATTIATI': 'I202',
  'SANTA GIULETTA': 'I203',
  'SANTA GIUSTA': 'I205',
  'SANTA GIUSTINA': 'I206',
  'SANTA GIUSTINA IN COLLE': 'I207',
  'SANT\'AGNELLO': 'I208',
  'SANT\'AGOSTINO': 'I209',
  'SANT\'ALBANO STURA': 'I210',
  'SANT\'ALESSIO CON VIALONE': 'I213',
  'SANT\'ALESSIO IN ASPROMONTE': 'I214',
  'SANT\'ALESSIO SICULO': 'I215',
  'SANT\'ALFIO': 'I216',
  'SANTA LUCE': 'I217',
  'SANTA LUCIA DI SERINO': 'I219',
  'SANTA LUCIA DEL MELA': 'I220',
  'SANTA LUCIA DI PIAVE': 'I221',
  'SANTA MARGHERITA DI BELICE': 'I224',
  'SANTA MARGHERITA LIGURE': 'I225',
  'SANTA MARGHERITA D\'ADIGE': 'I226',
  'SANTA MARGHERITA DI STAFFORA': 'I230',
  'SANTA MARIA A MONTE': 'I232',
  'SANTA MARIA A VICO': 'I233',
  'SANTA MARIA CAPUA VETERE': 'I234',
  'TRAVACO\' SICCOMARIO': 'I236',
  'SANTA MARIA DELLA VERSA': 'I237',
  'SANTA MARIA DEL MOLISE': 'I238',
  'SANTA MARIA DI LICODIA': 'I240',
  'SANTA MARIA DI SALA': 'I242',
  'SANTA MARIA HOE\'': 'I243',
  'SANTA MARIA IMBARO': 'I244',
  'SANTA MARIA LA FOSSA': 'I247',
  'SANTA MARIA LA LONGA': 'I248',
  'SANTA MARIA MAGGIORE': 'I249',
  'SANTA MARIA NUOVA': 'I251',
  'SANTA MARINA': 'I253',
  'SANTA MARINA SALINA': 'I254',
  'SANTA MARINELLA': 'I255',
  'SANT\'AMBROGIO SUL GARIGLIANO': 'I256',
  'SANT\'AMBROGIO DI TORINO': 'I258',
  'SANT\'AMBROGIO DI VALPOLICELLA': 'I259',
  'SANTOMENNA': 'I260',
  'SAN TAMMARO': 'I261',
  'SANT\'ANASTASIA': 'I262',
  'SANT\'ANATOLIA DI NARCO': 'I263',
  'SANT\'ANDREA DI CONZA': 'I264',
  'SANT\'ANDREA DEL GARIGLIANO': 'I265',
  'SANT\'ANDREA APOSTOLO DELLO IONIO': 'I266',
  'SANT\'ANDREA FRIUS': 'I271',
  'SANT\'ANGELO D\'ALIFE': 'I273',
  'SANT\'ANGELO LODIGIANO': 'I274',
  'SANT\'ANGELO DI PIOVE DI SACCO': 'I275',
  'SANT\'ANGELO LOMELLINA': 'I276',
  'SANT\'ANGELO A CUPOLO': 'I277',
  'SANT\'ANGELO A FASANELLA': 'I278',
  'SANT\'ANGELO ALL\'ESCA': 'I279',
  'SANT\'ANGELO A SCALA': 'I280',
  'SANT\'ANGELO DEI LOMBARDI': 'I281',
  'SANT\'ANGELO DEL PESCO': 'I282',
  'SANT\'ANGELO DI BROLO': 'I283',
  'SANT\'ANGELO ROMANO': 'I284',
  'SANT\'ANGELO IN LIZZOLA': 'I285',
  'SANT\'ANGELO IN PONTANO': 'I286',
  'SANT\'ANGELO IN VADO': 'I287',
  'SANT\'ANGELO LE FRATTE': 'I288',
  'SANT\'ANGELO LIMOSANO': 'I289',
  'SANT\'ANGELO MUXARO': 'I290',
  'SANTA NINFA': 'I291',
  'SANT\'ANNA D\'ALFAEDO': 'I292',
  'SANT\'ANTIMO': 'I293',
  'SANT\'ANTIOCO': 'I294',
  'SANT\'ANTONINO DI SUSA': 'I296',
  'VILLA SANT\'ANTONIO': 'I298',
  'SANT\'ANTONIO ABATE': 'I300',
  'SANTA PAOLINA': 'I301',
  'SANT\'APOLLINARE': 'I302',
  'SANTARCANGELO DI ROMAGNA': 'I304',
  'SANT\'ARCANGELO': 'I305',
  'SANT\'ARPINO': 'I306',
  'SANT\'ARSENIO': 'I307',
  'SANTA SEVERINA': 'I308',
  'SANTA SOFIA D\'EPIRO': 'I309',
  'SANTA SOFIA': 'I310',
  'SANTA TERESA DI RIVA': 'I311',
  'SANTA TERESA GALLURA': 'I312',
  'SANTA VENERINA': 'I314',
  'SANTA VITTORIA IN MATENANO': 'I315',
  'SANTA VITTORIA D\'ALBA': 'I316',
  'SANT\'EGIDIO DEL MONTE ALBINO': 'I317',
  'SANT\'EGIDIO ALLA VIBRATA': 'I318',
  'SANT\'ELENA': 'I319',
  'SANT\'ELIA A PIANISI': 'I320',
  'SANT\'ELIA FIUMERAPIDO': 'I321',
  'VALLEFIORITA': 'I322',
  'SANT\'ELPIDIO A MARE': 'I324',
  'SANTE MARIE': 'I326',
  'SANTENA': 'I327',
  'SAN TEODORO': 'I329',
  'SANTERAMO IN COLLE': 'I330',
  'SANT\'EUFEMIA A MAIELLA': 'I332',
  'SANT\'EUFEMIA D\'ASPROMONTE': 'I333',
  'SANT\'EUSANIO DEL SANGRO': 'I335',
  'SANT\'EUSANIO FORCONESE': 'I336',
  'SANTHIA\'': 'I337',
  'SANTI COSMA E DAMIANO': 'I339',
  'SANT\'ILARIO DELLO IONIO': 'I341',
  'SANT\'ILARIO D\'ENZA': 'I342',
  'SANT\'IPPOLITO': 'I344',
  'ZOLDO ALTO': 'I345',
  'SANT\'OLCESE': 'I346',
  'SAN TOMASO AGORDINO': 'I347',
  'SANT\'OMERO': 'I348',
  'SANT\'OMOBONO IMAGNA': 'I349',
  'SANT\'ONOFRIO': 'I350',
  'SANTOPADRE': 'I351',
  'SANT\'ORESTE': 'I352',
  'SANTORSO': 'I353',
  'SANT\'ORSOLA TERME': 'I354',
  'SANTO STEFANO QUISQUINA': 'I356',
  'SANTO STEFANO DEL SOLE': 'I357',
  'SANTO STEFANO DI ROGLIANO': 'I359',
  'SANTO STEFANO DI SESSANIO': 'I360',
  'SANTO STEFANO TICINO': 'I361',
  'SANTO STEFANO LODIGIANO': 'I362',
  'SANTO STEFANO DI MAGRA': 'I363',
  'VILLA SANTO STEFANO': 'I364',
  'SANTO STEFANO AL MARE': 'I365',
  'SANTO STEFANO BELBO': 'I367',
  'SANTO STEFANO D\'AVETO': 'I368',
  'SANTO STEFANO DI CAMASTRA': 'I370',
  'SANTO STEFANO IN ASPROMONTE': 'I371',
  'SANTO STEFANO ROERO': 'I372',
  'SANTO STINO DI LIVENZA': 'I373',
  'SANTU LUSSURGIU': 'I374',
  'SANT\'URBANO': 'I375',
  'SAN VALENTINO IN ABRUZZO CITERIORE': 'I376',
  'SAN VALENTINO TORIO': 'I377',
  'SAN VENANZO': 'I381',
  'SAN VENDEMIANO': 'I382',
  'SAN VERO MILIS': 'I384',
  'SAN VINCENZO LA COSTA': 'I388',
  'SAN VINCENZO VALLE ROVETO': 'I389',
  'SAN VINCENZO': 'I390',
  'SAN VITALIANO': 'I391',
  'SAN VITO DI CADORE': 'I392',
  'SAN VITO SULLO IONIO': 'I393',
  'SAN VITO CHIETINO': 'I394',
  'SAN VITO DEI NORMANNI': 'I396',
  'SAN VITO ROMANO': 'I400',
  'SAN VITO DI LEGUZZANO': 'I401',
  'SAN VITO': 'I402',
  'SAN VITO AL TAGLIAMENTO': 'I403',
  'SAN VITO AL TORRE': 'I404',
  'SAN VITO DI FAGAGNA': 'I405',
  'SAN VITO LO CAPO': 'I407',
  'SAN VITTORE DEL LAZIO': 'I408',
  'SAN VITTORE OLONA': 'I409',
  'SANZA': 'I410',
  'SANZENO': 'I411',
  'SAN ZENO NAVIGLIO': 'I412',
  'SAN ZENO DI MONTAGNA': 'I414',
  'SAN ZENONE AL LAMBRO': 'I415',
  'SAN ZENONE AL PO': 'I416',
  'SAN ZENONE DEGLI EZZELINI': 'I417',
  'SAONARA': 'I418',
  'SAPONARA': 'I420',
  'SAPPADA': 'I421',
  'SAPRI': 'I422',
  'SARACENA': 'I423',
  'SARACINESCO': 'I424',
  'SARCEDO': 'I425',
  'SARCONI': 'I426',
  'SARDARA': 'I428',
  'SARDIGLIANO': 'I429',
  'SAREGO': 'I430',
  'SARENTINO * SARNTAL': 'I431',
  'SAREZZANO': 'I432',
  'SAREZZO': 'I433',
  'SARMATO': 'I434',
  'SARMEDE': 'I435',
  'SARNANO': 'I436',
  'SARNICO': 'I437',
  'SARNO': 'I438',
  'SARNONICO': 'I439',
  'SARONNO': 'I441',
  'SARRE': 'I442',
  'SARROCH': 'I443',
  'SARSINA': 'I444',
  'SARTEANO': 'I445',
  'SARTIRANA LOMELLINA': 'I447',
  'SARULE': 'I448',
  'SARZANA': 'I449',
  'SASSANO': 'I451',
  'SASSARI': 'I452',
  'SASSELLO': 'I453',
  'SASSETTA': 'I454',
  'SASSINORO': 'I455',
  'SASSO DI CASTALDA': 'I457',
  'SASSOCORVARO': 'I459',
  'SASSOFELTRIO': 'I460',
  'SASSOFERRATO': 'I461',
  'SASSUOLO': 'I462',
  'SATRIANO': 'I463',
  'SAURIS': 'I464',
  'SAUZE DI CESANA': 'I465',
  'SAUZE D\'OULX': 'I466',
  'SAVA': 'I467',
  'SAVELLI': 'I468',
  'SAVIANO': 'I469',
  'SAVIGLIANO': 'I470',
  'SAVIGNANO IRPINO': 'I471',
  'SAVIGNANO SUL RUBICONE': 'I472',
  'SAVIGNANO SUL PANARO': 'I473',
  'SAVIGNO': 'I474',
  'SAVIGNONE': 'I475',
  'SAVIORE DELL\'ADAMELLO': 'I476',
  'SAVOCA': 'I477',
  'SAVOGNA': 'I478',
  'SAVOGNA D\'ISONZO': 'I479',
  'SAVONA': 'I480',
  'SCAFA': 'I482',
  'SCAFATI': 'I483',
  'SCAGNELLO': 'I484',
  'SCALA COELI': 'I485',
  'SCALA': 'I486',
  'SCALDASOLE': 'I487',
  'SCALEA': 'I489',
  'SCALENGHE': 'I490',
  'SCALETTA ZANCLEA': 'I492',
  'SCAMPITELLA': 'I493',
  'SCANDALE': 'I494',
  'SCANDIANO': 'I496',
  'SCANDOLARA RAVARA': 'I497',
  'SCANDOLARA RIPA D\'OGLIO': 'I498',
  'SCANDRIGLIA': 'I499',
  'SCANNO': 'I501',
  'SCANO DI MONTIFERRO': 'I503',
  'SCANSANO': 'I504',
  'SCANZOROSCIATE': 'I506',
  'SCAPOLI': 'I507',
  'SCARLINO': 'I510',
  'SCARMAGNO': 'I511',
  'SCARNAFIGI': 'I512',
  'SCARPERIA': 'I514',
  'SCENA * SCHENNA': 'I519',
  'SCERNI': 'I520',
  'SCHEGGIA E PASCELUPO': 'I522',
  'SCHEGGINO': 'I523',
  'SCHIAVI DI ABRUZZO': 'I526',
  'SCHIAVON': 'I527',
  'SCHIGNANO': 'I529',
  'SCHILPARIO': 'I530',
  'SCHIO': 'I531',
  'SCHIVENOGLIA': 'I532',
  'SCIACCA': 'I533',
  'SCIARA': 'I534',
  'SCICLI': 'I535',
  'SCIDO': 'I536',
  'SCILLA': 'I537',
  'SCILLATO': 'I538',
  'SCIOLZE': 'I539',
  'SCISCIANO': 'I540',
  'SCLAFANI BAGNI': 'I541',
  'SCONTRONE': 'I543',
  'SCOPA': 'I544',
  'SCOPELLO': 'I545',
  'SCOPPITO': 'I546',
  'SCORDIA': 'I548',
  'SCORRANO': 'I549',
  'TORRIANA': 'I550',
  'SCORZE\'': 'I551',
  'SCURCOLA MARSICANA': 'I553',
  'SCURELLE': 'I554',
  'SCURZOLENGO': 'I555',
  'SEBORGA': 'I556',
  'SECINARO': 'I558',
  'SECLI\'': 'I559',
  'SECUGNAGO': 'I561',
  'SEDEGLIANO': 'I562',
  'SEDICO': 'I563',
  'SEDILO': 'I564',
  'SEDINI': 'I565',
  'SEDRIANO': 'I566',
  'SEDRINA': 'I567',
  'SEFRO': 'I569',
  'SEGARIU': 'I570',
  'SEGGIANO': 'I571',
  'SEGNI': 'I573',
  'SEGONZANO': 'I576',
  'SEGRATE': 'I577',
  'SEGUSINO': 'I578',
  'SELARGIUS': 'I580',
  'SELCI': 'I581',
  'SELEGAS': 'I582',
  'SELLANO': 'I585',
  'SELLERO': 'I588',
  'SELLIA': 'I589',
  'SELLIA MARINA': 'I590',
  'SELVA DI VAL GARDENA * WOLKENSTEIN IN GROEDEN': 'I591',
  'SELVA DI CADORE': 'I592',
  'SELVA DEI MOLINI * MUEHLWALD': 'I593',
  'SELVA DI PROGNO': 'I594',
  'SELVAZZANO DENTRO': 'I595',
  'SELVE MARCONE': 'I596',
  'SELVINO': 'I597',
  'SEMESTENE': 'I598',
  'SEMIANA': 'I599',
  'SEMINARA': 'I600',
  'SEMPRONIANO': 'I601',
  'SENAGO': 'I602',
  'SENALE-SAN FELICE * UNSERE LIEBE FRAU IM WALDE-SANKT FELIX': 'I603',
  'SENALES * SCHNALS': 'I604',
  'SENEGHE': 'I605',
  'SENERCHIA': 'I606',
  'SENIGA': 'I607',
  'SENIGALLIA': 'I608',
  'SENIS': 'I609',
  'SENISE': 'I610',
  'SENNA COMASCO': 'I611',
  'SENNA LODIGIANA': 'I612',
  'SENNARIOLO': 'I613',
  'SENNORI': 'I614',
  'SENORBI\'': 'I615',
  'SEPINO': 'I618',
  'SEPPIANA': 'I619',
  'SEQUALS': 'I621',
  'SERAVEZZA': 'I622',
  'SERDIANA': 'I624',
  'SEREGNO': 'I625',
  'SEREN DEL GRAPPA': 'I626',
  'SERGNANO': 'I627',
  'SERIATE': 'I628',
  'SERINA': 'I629',
  'SERINO': 'I630',
  'SERLE': 'I631',
  'SERMIDE': 'I632',
  'SIRMIONE': 'I633',
  'SERMONETA': 'I634',
  'SERNAGLIA DELLA BATTAGLIA': 'I635',
  'SERNIO': 'I636',
  'SEROLE': 'I637',
  'SERRA SAN BRUNO': 'I639',
  'SERRA RICCO\'': 'I640',
  'SERRACAPRIOLA': 'I641',
  'SERRA D\'AIELLO': 'I642',
  'SERRA DE\' CONTI': 'I643',
  'SERRADIFALCO': 'I644',
  'SERRALUNGA DI CREA': 'I645',
  'SERRALUNGA D\'ALBA': 'I646',
  'SERRAMANNA': 'I647',
  'SERRAMEZZANA': 'I648',
  'SERRAMONACESCA': 'I649',
  'SERRA PEDACE': 'I650',
  'SERRAPETRONA': 'I651',
  'SERRARA FONTANA': 'I652',
  'SERRA SAN QUIRICO': 'I653',
  'SERRA SANT\'ABBONDIO': 'I654',
  'SERRASTRETTA': 'I655',
  'SERRATA': 'I656',
  'SERRAVALLE SCRIVIA': 'I657',
  'SERRAVALLE LANGHE': 'I659',
  'SERRAVALLE PISTOIESE': 'I660',
  'SERRAVALLE DI CHIENTI': 'I661',
  'SERRAVALLE A PO': 'I662',
  'SERRAVALLE SESIA': 'I663',
  'SERRE': 'I666',
  'SERRENTI': 'I667',
  'SERRI': 'I668',
  'SERRONE': 'I669',
  'SERRUNGARINA': 'I670',
  'SERSALE': 'I671',
  'SOVRAMONTE': 'I673',
  'SESSA AURUNCA': 'I676',
  'SESSA CILENTO': 'I677',
  'SESSAME': 'I678',
  'SESSANO DEL MOLISE': 'I679',
  'SESTINO': 'I681',
  'SESTO CAMPANO': 'I682',
  'SESTO ED UNITI': 'I683',
  'SESTO FIORENTINO': 'I684',
  'SESTO AL REGHENA': 'I686',
  'SESTO * SEXTEN': 'I687',
  'SESTO CALENDE': 'I688',
  'SESTOLA': 'I689',
  'SESTO SAN GIOVANNI': 'I690',
  'SESTRIERE': 'I692',
  'SESTRI LEVANTE': 'I693',
  'SESTU': 'I695',
  'SETTALA': 'I696',
  'SETTEFRATI': 'I697',
  'SETTIME': 'I698',
  'SETTIMO SAN PIETRO': 'I699',
  'SETTIMO MILANESE': 'I700',
  'SETTIMO ROTTARO': 'I701',
  'SETTIMO VITTONE': 'I702',
  'SETTIMO TORINESE': 'I703',
  'SETTINGIANO': 'I704',
  'SETZU': 'I705',
  'SEUI': 'I706',
  'SEULO': 'I707',
  'SEVESO': 'I709',
  'SEZZADIO': 'I711',
  'SEZZE': 'I712',
  'SFRUZ': 'I714',
  'SGONICO': 'I715',
  'SGURGOLA': 'I716',
  'SIAMAGGIORE': 'I717',
  'SIAMANNA': 'I718',
  'SIANO': 'I720',
  'SIAPICCIA': 'I721',
  'SICULIANA': 'I723',
  'SIDDI': 'I724',
  'SIDERNO': 'I725',
  'SIENA': 'I726',
  'SIGILLO': 'I727',
  'SIGNA': 'I728',
  'SILANDRO * SCHLANDERS': 'I729',
  'SILANUS': 'I730',
  'SILIGO': 'I732',
  'SILIQUA': 'I734',
  'SILIUS': 'I735',
  'SILLAVENGO': 'I736',
  'SILLANO': 'I737',
  'SILVANO D\'ORBA': 'I738',
  'SILVANO PIETRA': 'I739',
  'SILVI': 'I741',
  'SIMALA': 'I742',
  'SIMAXIS': 'I743',
  'SIMBARIO': 'I744',
  'SIMERI CRICHI': 'I745',
  'SINAGRA': 'I747',
  'SINDIA': 'I748',
  'SINI': 'I749',
  'SINIO': 'I750',
  'SINISCOLA': 'I751',
  'SINNAI': 'I752',
  'SINOPOLI': 'I753',
  'SIRACUSA': 'I754',
  'SIRIGNANO': 'I756',
  'SIRIS': 'I757',
  'SIROLO': 'I758',
  'SIRONE': 'I759',
  'SIROR': 'I760',
  'SIRTORI': 'I761',
  'SISSA': 'I763',
  'SIURGUS DONIGALA': 'I765',
  'SIZZANO': 'I767',
  'SLUDERNO * SCHLUDERNS': 'I771',
  'SMARANO': 'I772',
  'SMERILLO': 'I774',
  'SOAVE': 'I775',
  'SOCCHIEVE': 'I777',
  'SODDI\'': 'I778',
  'SOGLIANO AL RUBICONE': 'I779',
  'SOGLIANO CAVOUR': 'I780',
  'SOGLIO': 'I781',
  'SOIANO DEL LAGO': 'I782',
  'SOLAGNA': 'I783',
  'SOLARINO': 'I785',
  'SOLARO': 'I786',
  'SOLAROLO': 'I787',
  'SOLAROLO RAINERIO': 'I790',
  'SOLARUSSA': 'I791',
  'SOLBIATE': 'I792',
  'SOLBIATE ARNO': 'I793',
  'SOLBIATE OLONA': 'I794',
  'SOLDANO': 'I796',
  'SOLEMINIS': 'I797',
  'SOLERO': 'I798',
  'SOLESINO': 'I799',
  'SOLETO': 'I800',
  'SOLFERINO': 'I801',
  'SOLIERA': 'I802',
  'SOLIGNANO': 'I803',
  'SULMONA': 'I804',
  'SOLOFRA': 'I805',
  'SOLONGHELLO': 'I808',
  'SOLOPACA': 'I809',
  'SOLTO COLLINA': 'I812',
  'SOLZA': 'I813',
  'SOMAGLIA': 'I815',
  'SOMANO': 'I817',
  'SOMMA LOMBARDO': 'I819',
  'SOMMA VESUVIANA': 'I820',
  'SOMMACAMPAGNA': 'I821',
  'SOMMARIVA BOSCO': 'I822',
  'SOMMARIVA PERNO': 'I823',
  'SOMMATINO': 'I824',
  'SOMMO': 'I825',
  'SONA': 'I826',
  'SONCINO': 'I827',
  'SONDALO': 'I828',
  'SONDRIO': 'I829',
  'SONGAVAZZO': 'I830',
  'SONICO': 'I831',
  'SONNINO': 'I832',
  'SOPRANA': 'I835',
  'SORA': 'I838',
  'SORAGA': 'I839',
  'SORAGNA': 'I840',
  'SORANO': 'I841',
  'SORBO SERPICO': 'I843',
  'SORBO SAN BASILE': 'I844',
  'SORBOLO': 'I845',
  'SORDEVOLO': 'I847',
  'SORDIO': 'I848',
  'SORESINA': 'I849',
  'SORGA\'': 'I850',
  'SORGONO': 'I851',
  'SORI': 'I852',
  'SORIANELLO': 'I853',
  'SORIANO CALABRO': 'I854',
  'SORIANO NEL CIMINO': 'I855',
  'SORICO': 'I856',
  'SORISO': 'I857',
  'SORISOLE': 'I858',
  'SORMANO': 'I860',
  'SORRADILE': 'I861',
  'SORRENTO': 'I862',
  'SORSO': 'I863',
  'SORTINO': 'I864',
  'SOSPIRO': 'I865',
  'SOSPIROLO': 'I866',
  'SOSSANO': 'I867',
  'SOSTEGNO': 'I868',
  'SOTTO IL MONTE GIOVANNI XXIII': 'I869',
  'SOVER': 'I871',
  'SOVERATO': 'I872',
  'SOVERE': 'I873',
  'SOVERIA MANNELLI': 'I874',
  'SOVERIA SIMERI': 'I875',
  'SOVERZENE': 'I876',
  'SOVICILLE': 'I877',
  'SOVICO': 'I878',
  'SOVIZZO': 'I879',
  'SOZZAGO': 'I880',
  'SPADAFORA': 'I881',
  'SPADOLA': 'I884',
  'SPARANISE': 'I885',
  'SPARONE': 'I886',
  'SPECCHIA': 'I887',
  'SPELLO': 'I888',
  'SPERA': 'I889',
  'SPERLINGA': 'I891',
  'SPERLONGA': 'I892',
  'SPERONE': 'I893',
  'SPESSA': 'I894',
  'SPEZZANO ALBANESE': 'I895',
  'SPEZZANO DELLA SILA': 'I896',
  'SPEZZANO PICCOLO': 'I898',
  'SPIAZZO': 'I899',
  'SPIGNO MONFERRATO': 'I901',
  'SPIGNO SATURNIA': 'I902',
  'SPILAMBERTO': 'I903',
  'SPILIMBERGO': 'I904',
  'SPILINGA': 'I905',
  'SPINADESCO': 'I906',
  'SPINAZZOLA': 'I907',
  'SPINEA': 'I908',
  'SPINEDA': 'I909',
  'SPINETE': 'I910',
  'SPINETO SCRIVIA': 'I911',
  'SPINETOLI': 'I912',
  'SPINO D\'ADDA': 'I914',
  'SPINONE AL LAGO': 'I916',
  'SPINOSO': 'I917',
  'SPIRANO': 'I919',
  'SPOLETO': 'I921',
  'SPOLTORE': 'I922',
  'SPONGANO': 'I923',
  'SPORMAGGIORE': 'I924',
  'SPORMINORE': 'I925',
  'SPOTORNO': 'I926',
  'SPRESIANO': 'I927',
  'SPRIANA': 'I928',
  'SQUILLACE': 'I929',
  'SQUINZANO': 'I930',
  'STAFFOLO': 'I932',
  'STAGNO LOMBARDO': 'I935',
  'STAITI': 'I936',
  'STALETTI': 'I937',
  'STANGHELLA': 'I938',
  'STARANZANO': 'I939',
  'STAZZANO': 'I941',
  'STAZZEMA': 'I942',
  'STAZZONA': 'I943',
  'STEFANACONI': 'I945',
  'STELLA': 'I946',
  'STELLANELLO': 'I947',
  'STELVIO * STILFS': 'I948',
  'STENICO': 'I949',
  'STERNATIA': 'I950',
  'STEZZANO': 'I951',
  'STIA': 'I952',
  'STIENTA': 'I953',
  'STIGLIANO': 'I954',
  'STIGNANO': 'I955',
  'STILO': 'I956',
  'STIMIGLIANO': 'I959',
  'STIO': 'I960',
  'STORNARA': 'I962',
  'STORNARELLA': 'I963',
  'STORO': 'I964',
  'STRA': 'I965',
  'STRADELLA': 'I968',
  'STRAMBINELLO': 'I969',
  'STRAMBINO': 'I970',
  'STRANGOLAGALLI': 'I973',
  'STREGNA': 'I974',
  'STREMBO': 'I975',
  'STRESA': 'I976',
  'STREVI': 'I977',
  'STRIANO': 'I978',
  'STRIGNO': 'I979',
  'STRONA': 'I980',
  'STRONCONE': 'I981',
  'STRONGOLI': 'I982',
  'STROPPIANA': 'I984',
  'STROPPO': 'I985',
  'STROZZA': 'I986',
  'STURNO': 'I990',
  'SUBBIANO': 'I991',
  'SUBIACO': 'I992',
  'SUCCIVO': 'I993',
  'SUEGLIO': 'I994',
  'SUELLI': 'I995',
  'SUELLO': 'I996',
  'SUISIO': 'I997',
  'SULBIATE': 'I998',
  'SULZANO': 'L002',
  'SUMIRAGO': 'L003',
  'SUMMONTE': 'L004',
  'SUNI': 'L006',
  'SUNO': 'L007',
  'SUPERSANO': 'L008',
  'SUPINO': 'L009',
  'SURANO': 'L010',
  'SURBO': 'L011',
  'SUSA': 'L013',
  'SUSEGANA': 'L014',
  'SUSTINENTE': 'L015',
  'SUTERA': 'L016',
  'SUTRI': 'L017',
  'SUTRIO': 'L018',
  'SUVERETO': 'L019',
  'SUZZARA': 'L020',
  'TACENO': 'L022',
  'TADASUNI': 'L023',
  'TAGGIA': 'L024',
  'TAGLIACOZZO': 'L025',
  'TAGLIO DI PO': 'L026',
  'TAGLIOLO MONFERRATO': 'L027',
  'TAIBON AGORDINO': 'L030',
  'TAINO': 'L032',
  'TAIO': 'L033',
  'TALAMELLO': 'L034',
  'TALAMONA': 'L035',
  'TALANA': 'L036',
  'TALEGGIO': 'L037',
  'TALLA': 'L038',
  'TALMASSONS': 'L039',
  'TAMBRE': 'L040',
  'TAORMINA': 'L042',
  'TARANO': 'L046',
  'TARANTA PELIGNA': 'L047',
  'TARANTASCA': 'L048',
  'TARANTO': 'L049',
  'TARCENTO': 'L050',
  'TARSIA': 'L055',
  'TARTANO': 'L056',
  'TARVISIO': 'L057',
  'TARZO': 'L058',
  'TASSAROLO': 'L059',
  'TASSULLO': 'L060',
  'TAURANO': 'L061',
  'TAURASI': 'L062',
  'TAURIANOVA': 'L063',
  'TAURISANO': 'L064',
  'TAVAGNACCO': 'L065',
  'TAVAGNASCO': 'L066',
  'TAVARNELLE VAL DI PESA': 'L067',
  'TAVENNA': 'L069',
  'TAVERNA': 'L070',
  'TAVERNERIO': 'L071',
  'TAVERNOLA BERGAMASCA': 'L073',
  'TAVIANO': 'L074',
  'TAVIGLIANO': 'L075',
  'TAVOLETO': 'L078',
  'TAVULLIA': 'L081',
  'TEANA': 'L082',
  'TEANO': 'L083',
  'TEGLIO': 'L084',
  'TEGLIO VENETO': 'L085',
  'TELESE TERME': 'L086',
  'TELGATE': 'L087',
  'TELTI': 'L088',
  'TELVE': 'L089',
  'TELVE DI SOPRA': 'L090',
  'TEMPIO PAUSANIA': 'L093',
  'TEMU\'': 'L094',
  'TENNA': 'L096',
  'TENNO': 'L097',
  'TEOLO': 'L100',
  'TEOR': 'L101',
  'TEORA': 'L102',
  'TERAMO': 'L103',
  'TERDOBBIATE': 'L104',
  'TERELLE': 'L105',
  'TERENTO * TERENTEN': 'L106',
  'TERLAGO': 'L107',
  'TERLANO * TERLAN': 'L108',
  'TERLIZZI': 'L109',
  'TERMENO STRADA VINO-TRAMIN AN DER WEINSTRASSE': 'L111',
  'TERMINI IMERESE': 'L112',
  'TERMOLI': 'L113',
  'TERNATE': 'L115',
  'TERNENGO': 'L116',
  'TERNI': 'L117',
  'TERNO D\'ISOLA': 'L118',
  'TERRACINA': 'L120',
  'TERRAGNOLO': 'L121',
  'TERRALBA': 'L122',
  'TERRANUOVA BRACCIOLINI': 'L123',
  'TERRANOVA DA SIBARI': 'L124',
  'TERRANOVA DEI PASSERINI': 'L125',
  'TERRANOVA DI POLLINO': 'L126',
  'TERRANOVA SAPPO MINULIO': 'L127',
  'TERRASINI': 'L131',
  'TERRASSA PADOVANA': 'L132',
  'TERRAVECCHIA': 'L134',
  'TERRAZZO': 'L136',
  'TERRES': 'L137',
  'TERRICCIOLA': 'L138',
  'TERRUGGIA': 'L139',
  'TERTENIA': 'L140',
  'TERZIGNO': 'L142',
  'TERZO': 'L143',
  'TERZO DI AQUILEIA': 'L144',
  'TERZOLAS': 'L145',
  'TERZORIO': 'L146',
  'TESERO': 'L147',
  'TESIMO * TISENS': 'L149',
  'TESSENNANO': 'L150',
  'TESTICO': 'L152',
  'TETI': 'L153',
  'TEULADA': 'L154',
  'TEVEROLA': 'L155',
  'TEZZE SUL BRENTA': 'L156',
  'THIENE': 'L157',
  'THIESI': 'L158',
  'TIANA': 'L160',
  'TIARNO DI SOPRA': 'L162',
  'TIARNO DI SOTTO': 'L163',
  'TICENGO': 'L164',
  'TICINETO': 'L165',
  'TIGGIANO': 'L166',
  'TIGLIETO': 'L167',
  'TIGLIOLE': 'L168',
  'TIGNALE': 'L169',
  'TINNURA': 'L172',
  'TIONE DEGLI ABRUZZI': 'L173',
  'TIONE DI TRENTO': 'L174',
  'TIRANO': 'L175',
  'TIRES * TIERS': 'L176',
  'TIRIOLO': 'L177',
  'TIROLO * TIROL': 'L178',
  'TISSI': 'L180',
  'TITO': 'L181',
  'TIVOLI': 'L182',
  'TIZZANO VAL PARMA': 'L183',
  'TOANO': 'L184',
  'TOCCO CAUDIO': 'L185',
  'TOCCO DA CASAURIA': 'L186',
  'TOCENO': 'L187',
  'TODI': 'L188',
  'TOFFIA': 'L189',
  'TOIRANO': 'L190',
  'TOLENTINO': 'L191',
  'TOLFA': 'L192',
  'TOLLEGNO': 'L193',
  'TOLLO': 'L194',
  'TOLMEZZO': 'L195',
  'TOLVE': 'L197',
  'TOMBOLO': 'L199',
  'TON': 'L200',
  'TONADICO': 'L201',
  'TONARA': 'L202',
  'TONCO': 'L203',
  'TONENGO': 'L204',
  'TORA E PICCILLI': 'L205',
  'TORANO CASTELLO': 'L206',
  'TORANO NUOVO': 'L207',
  'TORBOLE CASAGLIA': 'L210',
  'TORCEGNO': 'L211',
  'TORCHIARA': 'L212',
  'TORCHIAROLO': 'L213',
  'TORELLA DEI LOMBARDI': 'L214',
  'TORELLA DEL SANNIO': 'L215',
  'TORGIANO': 'L216',
  'TORGNON': 'L217',
  'TORINO DI SANGRO': 'L218',
  'TORINO': 'L219',
  'TORITTO': 'L220',
  'TORLINO VIMERCATI': 'L221',
  'TORNACO': 'L223',
  'TORNARECCIO': 'L224',
  'TORNATA': 'L225',
  'TORNIMPARTE': 'L227',
  'TORNO': 'L228',
  'TORNOLO': 'L229',
  'TORO': 'L230',
  'TORPE\'': 'L231',
  'TORRACA': 'L233',
  'TORRALBA': 'L235',
  'TORRAZZA COSTE': 'L237',
  'TORRAZZA PIEMONTE': 'L238',
  'TORRAZZO': 'L239',
  'TORRE DI RUGGIERO': 'L240',
  'TORRE MONDOVI\'': 'L241',
  'TORRE CAJETANI': 'L243',
  'TORRE DI SANTA MARIA': 'L244',
  'TORRE ANNUNZIATA': 'L245',
  'TORREANO': 'L246',
  'TORRE CANAVESE': 'L247',
  'TORREBELVICINO': 'L248',
  'TORRE BERETTI E CASTELLARO': 'L250',
  'TORRE BOLDONE': 'L251',
  'TORRE BORMIDA': 'L252',
  'TORREBRUNA': 'L253',
  'TORRECUSO': 'L254',
  'TORRE D\'ARESE': 'L256',
  'TORRE DE\' BUSI': 'L257',
  'TORRE DE\' PICENARDI': 'L258',
  'TORRE DEL GRECO': 'L259',
  'TORRE DE\' NEGRI': 'L262',
  'TORRE DE\' PASSERI': 'L263',
  'TORRE DE\' ROVERI': 'L265',
  'TORRE DI MOSTO': 'L267',
  'TORRE D\'ISOLA': 'L269',
  'TORREGLIA': 'L270',
  'TORREGROTTA': 'L271',
  'TORRE LE NOCELLE': 'L272',
  'TORREMAGGIORE': 'L273',
  'TORRE ORSAIA': 'L274',
  'TORRE PALLAVICINA': 'L276',
  'TORRE PELLICE': 'L277',
  'TORRE SAN GIORGIO': 'L278',
  'TORRE SAN PATRIZIO': 'L279',
  'TORRE SANTA SUSANNA': 'L280',
  'TORRESINA': 'L281',
  'TORRETTA': 'L282',
  'TORREVECCHIA TEATINA': 'L284',
  'TORREVECCHIA PIA': 'L285',
  'TORRI IN SABINA': 'L286',
  'TORRI DEL BENACO': 'L287',
  'TORRICE': 'L290',
  'TORRICELLA PELIGNA': 'L291',
  'TORRICELLA VERZATE': 'L292',
  'TORRICELLA IN SABINA': 'L293',
  'TORRICELLA': 'L294',
  'TORRICELLA SICURA': 'L295',
  'TORRICELLA DEL PIZZO': 'L296',
  'TORRI DI QUARTESOLO': 'L297',
  'TORRIGLIA': 'L298',
  'TORRILE': 'L299',
  'TORRIONI': 'L301',
  'TORRITA TIBERINA': 'L302',
  'TORRITA DI SIENA': 'L303',
  'TORTONA': 'L304',
  'TORTORA': 'L305',
  'TORTORELLA': 'L306',
  'TORTORETO': 'L307',
  'TORTORICI': 'L308',
  'TORVISCOSA': 'L309',
  'TUSCANIA': 'L310',
  'TOSCOLANO-MADERNO': 'L312',
  'TOSSICIA': 'L314',
  'TOVO SAN GIACOMO': 'L315',
  'TOVO DI SANT\'AGATA': 'L316',
  'TRABIA': 'L317',
  'TRADATE': 'L319',
  'TRAMATZA': 'L321',
  'TRAMBILENO': 'L322',
  'TRAMONTI': 'L323',
  'TRAMONTI DI SOPRA': 'L324',
  'TRAMONTI DI SOTTO': 'L325',
  'TRAMUTOLA': 'L326',
  'TRANA': 'L327',
  'TRANI': 'L328',
  'TRANSACQUA': 'L329',
  'TRAONA': 'L330',
  'TRAPANI': 'L331',
  'TRAPPETO': 'L332',
  'TRAREGO VIGGIONA': 'L333',
  'TRASACCO': 'L334',
  'TRASAGHIS': 'L335',
  'TRASQUERA': 'L336',
  'TRATALIAS': 'L337',
  'TRAUSELLA': 'L338',
  'TRAVAGLIATO': 'L339',
  'TRAVES': 'L340',
  'TRAVEDONA-MONATE': 'L342',
  'TRAVERSELLA': 'L345',
  'TRAVERSETOLO': 'L346',
  'TRAVESIO': 'L347',
  'TRAVO': 'L348',
  'TREBASELEGHE': 'L349',
  'TREBISACCE': 'L353',
  'TRECASALI': 'L354',
  'TRECASTAGNI': 'L355',
  'TRECATE': 'L356',
  'TRECCHINA': 'L357',
  'TRECENTA': 'L359',
  'TREDOZIO': 'L361',
  'TREGLIO': 'L363',
  'TREGNAGO': 'L364',
  'TREIA': 'L366',
  'TREISO': 'L367',
  'TREMENICO': 'L368',
  'TREMESTIERI ETNEO': 'L369',
  'TREMEZZO': 'L371',
  'TREMOSINE': 'L372',
  'TRENTA': 'L375',
  'TRENTINARA': 'L377',
  'TRENTO': 'L378',
  'TRENTOLA DUCENTA': 'L379',
  'TRENZANO': 'L380',
  'TREPPO CARNICO': 'L381',
  'TREPPO GRANDE': 'L382',
  'TREPUZZI': 'L383',
  'TREQUANDA': 'L384',
  'TRES': 'L385',
  'TRESANA': 'L386',
  'TRESCORE BALNEARIO': 'L388',
  'TRESCORE CREMASCO': 'L389',
  'TRESIGALLO': 'L390',
  'TRESIVIO': 'L392',
  'TRESNURAGHES': 'L393',
  'TREVENZUOLO': 'L396',
  'TREVI': 'L397',
  'TREVI NEL LAZIO': 'L398',
  'TREVICO': 'L399',
  'TREVIGLIO': 'L400',
  'TREVIGNANO ROMANO': 'L401',
  'TREVIGNANO': 'L402',
  'TREVILLE': 'L403',
  'TREVIOLO': 'L404',
  'TREVISO BRESCIANO': 'L406',
  'TREVISO': 'L407',
  'TREZZANO ROSA': 'L408',
  'TREZZANO SUL NAVIGLIO': 'L409',
  'TREZZO TINELLA': 'L410',
  'TREZZO SULL\'ADDA': 'L411',
  'TREZZONE': 'L413',
  'TRIBANO': 'L414',
  'TRIBIANO': 'L415',
  'TRIBOGNA': 'L416',
  'TRICARICO': 'L418',
  'TRICASE': 'L419',
  'TRICERRO': 'L420',
  'TRICESIMO': 'L421',
  'TRICHIANA': 'L422',
  'TRIEI': 'L423',
  'TRIESTE': 'L424',
  'TRIGGIANO': 'L425',
  'TRIGOLO': 'L426',
  'TRINITA\'': 'L427',
  'TRINITA\' D\'AGULTU E VIGNOLA': 'L428',
  'TRINO VERCELLESE': 'L429',
  'TRIORA': 'L430',
  'TRIPI': 'L431',
  'TRISOBBIO': 'L432',
  'TRISSINO': 'L433',
  'TRIUGGIO': 'L434',
  'TRIVENTO': 'L435',
  'TRIVERO': 'L436',
  'TRIVIGLIANO': 'L437',
  'TRIVIGNANO UDINESE': 'L438',
  'TRIVIGNO': 'L439',
  'TRIVOLZIO': 'L440',
  'TRODENA * TRUDEN': 'L444',
  'TROFARELLO': 'L445',
  'TROIA': 'L447',
  'TROINA': 'L448',
  'TROMELLO': 'L449',
  'TRONTANO': 'L450',
  'TRONZANO VERCELLESE': 'L451',
  'TROPEA': 'L452',
  'TROVO': 'L453',
  'TRUCCAZZANO': 'L454',
  'TUBRE * TAUFERS': 'L455',
  'TUENNO': 'L457',
  'TUFARA': 'L458',
  'TUFILLO': 'L459',
  'TUFINO': 'L460',
  'TUFO': 'L461',
  'TUGLIE': 'L462',
  'TUILI': 'L463',
  'TULA': 'L464',
  'TUORO SUL TRASIMENO': 'L466',
  'VALVESTINO': 'L468',
  'TURANO LODIGIANO': 'L469',
  'TURATE': 'L470',
  'TURBIGO': 'L471',
  'TURI': 'L472',
  'TURRI': 'L473',
  'TURRIACO': 'L474',
  'TURRIVALIGNANI': 'L475',
  'TURSI': 'L477',
  'TUSA': 'L478',
  'UBOLDO': 'L480',
  'UCRIA': 'L482',
  'UDINE': 'L483',
  'UGENTO': 'L484',
  'UGGIANO LA CHIESA': 'L485',
  'UGGIATE-TREVANO': 'L487',
  'ULA\' TIRSO': 'L488',
  'ULASSAI': 'L489',
  'ULTIMO * ULTEN': 'L490',
  'UMBRIATICO': 'L492',
  'URAGO D\'OGLIO': 'L494',
  'URAS': 'L496',
  'URBANA': 'L497',
  'URBANIA': 'L498',
  'URBE': 'L499',
  'URBINO': 'L500',
  'URBISAGLIA': 'L501',
  'URGNANO': 'L502',
  'URI': 'L503',
  'URURI': 'L505',
  'URZULEI': 'L506',
  'USCIO': 'L507',
  'USELLUS': 'L508',
  'USINI': 'L509',
  'USMATE VELATE': 'L511',
  'USSANA': 'L512',
  'USSARAMANNA': 'L513',
  'USSASSAI': 'L514',
  'USSEAUX': 'L515',
  'USSEGLIO': 'L516',
  'USSITA': 'L517',
  'USTICA': 'L519',
  'UTA': 'L521',
  'UZZANO': 'L522',
  'VACCARIZZO ALBANESE': 'L524',
  'VACONE': 'L525',
  'VACRI': 'L526',
  'VADENA * PFATTEN': 'L527',
  'VADO LIGURE': 'L528',
  'VAGLIA': 'L529',
  'VAGLIO SERRA': 'L531',
  'VAGLIO BASILICATA': 'L532',
  'VAGLI SOTTO': 'L533',
  'VAIANO CREMASCO': 'L535',
  'VAIANO': 'L537',
  'VAIE': 'L538',
  'VAILATE': 'L539',
  'VAIRANO PATENORA': 'L540',
  'VALBONDIONE': 'L544',
  'VALBREMBO': 'L545',
  'VALBREVENNA': 'L546',
  'VALBRONA': 'L547',
  'VICO CANAVESE': 'L548',
  'VALDA': 'L550',
  'VALDAGNO': 'L551',
  'VALDAORA * OLANG': 'L552',
  'VALDASTICO': 'L554',
  'VAL DELLA TORRE': 'L555',
  'VALDENGO': 'L556',
  'VALDIDENTRO': 'L557',
  'VALDIERI': 'L558',
  'VALDINA': 'L561',
  'VAL DI NIZZA': 'L562',
  'VALDISOTTO': 'L563',
  'VAL DI VIZZE * PFITSCH': 'L564',
  'VALDOBBIADENE': 'L565',
  'VALDUGGIA': 'L566',
  'VALEGGIO SUL MINCIO': 'L567',
  'VALEGGIO': 'L568',
  'VALENTANO': 'L569',
  'VALENZA': 'L570',
  'VALENZANO': 'L571',
  'VALERA FRATTA': 'L572',
  'VALFABBRICA': 'L573',
  'VALFENERA': 'L574',
  'VALFLORIANA': 'L575',
  'VALFURVA': 'L576',
  'VALGANNA': 'L577',
  'VALGIOIE': 'L578',
  'VALGOGLIO': 'L579',
  'VALGRANA': 'L580',
  'VALGREGHENTINO': 'L581',
  'VALGRISENCHE': 'L582',
  'VALGUARNERA CAROPEPE': 'L583',
  'VALLADA AGORDINA': 'L584',
  'VALLANZENGO': 'L586',
  'VALLARSA': 'L588',
  'VALLATA': 'L589',
  'VALLE DI CADORE': 'L590',
  'VALLE DI MADDALONI': 'L591',
  'VALLE LOMELLINA': 'L593',
  'VALLE AGRICOLA': 'L594',
  'VALLE AURINA * AHRNTAL': 'L595',
  'VALLEBONA': 'L596',
  'VALLE CASTELLANA': 'L597',
  'VALLECORSA': 'L598',
  'VALLECROSIA': 'L599',
  'VALLE DI CASIES * GSIES': 'L601',
  'VALLEDOLMO': 'L603',
  'VALLEDORIA': 'L604',
  'VALLEMAIO': 'L605',
  'VALLE MOSSO': 'L606',
  'VALLELONGA': 'L607',
  'VALLELUNGA PRATAMENO': 'L609',
  'VALLEPIETRA': 'L611',
  'VALLERANO': 'L612',
  'VALLERMOSA': 'L613',
  'VALLEROTONDA': 'L614',
  'VALLESACCARDA': 'L616',
  'VALLE SALIMBENE': 'L617',
  'VALLE SAN NICOLAO': 'L620',
  'VALLEVE': 'L623',
  'VALLI DEL PASUBIO': 'L624',
  'VALLINFREDA': 'L625',
  'VALLIO TERME': 'L626',
  'VALLO DI NERA': 'L627',
  'VALLO DELLA LUCANIA': 'L628',
  'VALLO TORINESE': 'L629',
  'VALLORIATE': 'L631',
  'VALMACCA': 'L633',
  'VALMADRERA': 'L634',
  'VALMALA': 'L636',
  'VAL MASINO': 'L638',
  'VALMONTONE': 'L639',
  'VALMOREA': 'L640',
  'VALMOZZOLA': 'L641',
  'VALNEGRA': 'L642',
  'VALPELLINE': 'L643',
  'VALPERGA': 'L644',
  'VALSAVARENCHE': 'L647',
  'VALSECCA': 'L649',
  'VALSTAGNA': 'L650',
  'VALSTRONA': 'L651',
  'VALTOPINA': 'L653',
  'VALTOURNENCHE': 'L654',
  'VALTORTA': 'L655',
  'VALVA': 'L656',
  'VALVASONE': 'L657',
  'VALVERDE': 'L659',
  'VANDOIES * VINTL': 'L660',
  'VANZAGHELLO': 'L664',
  'VANZAGO': 'L665',
  'VANZONE CON SAN CARLO': 'L666',
  'VAPRIO D\'ADDA': 'L667',
  'VAPRIO D\'AGOGNA': 'L668',
  'VARALLO': 'L669',
  'VARALLO POMBIA': 'L670',
  'VARANO BORGHI': 'L671',
  'VARANO DE\' MELEGARI': 'L672',
  'VARAPODIO': 'L673',
  'VARAZZE': 'L675',
  'VARCO SABINO': 'L676',
  'VAREDO': 'L677',
  'VARENA': 'L678',
  'VARENNA': 'L680',
  'VARESE LIGURE': 'L681',
  'VARESE': 'L682',
  'VARISELLA': 'L685',
  'VARMO': 'L686',
  'VARNA * VAHRN': 'L687',
  'VARSI': 'L689',
  'VARZI': 'L690',
  'VARZO': 'L691',
  'VAS': 'L692',
  'VASIA': 'L693',
  'VASTOGIRARDI': 'L696',
  'VATTARO': 'L697',
  'VAUDA CANAVESE': 'L698',
  'VAZZANO': 'L699',
  'VAZZOLA': 'L700',
  'VECCHIANO': 'L702',
  'VEDANO OLONA': 'L703',
  'VEDANO AL LAMBRO': 'L704',
  'VEDDASCA': 'L705',
  'VEDELAGO': 'L706',
  'VEDESETA': 'L707',
  'VEDUGGIO CON COLZANO': 'L709',
  'VEGGIANO': 'L710',
  'VEGLIE': 'L711',
  'VEGLIO': 'L712',
  'VEJANO': 'L713',
  'VELESO': 'L715',
  'VELEZZO LOMELLINA': 'L716',
  'VELLETRI': 'L719',
  'VELLEZZO BELLINI': 'L720',
  'VELO VERONESE': 'L722',
  'VELO D\'ASTICO': 'L723',
  'VELTURNO * FELDTHURNS': 'L724',
  'VENAFRO': 'L725',
  'VENAUS': 'L726',
  'VENARIA REALE': 'L727',
  'VENAROTTA': 'L728',
  'VENASCA': 'L729',
  'VENDONE': 'L730',
  'VENDROGNO': 'L731',
  'VENEGONO INFERIORE': 'L733',
  'VENEGONO SUPERIORE': 'L734',
  'VENETICO': 'L735',
  'VENEZIA': 'L736',
  'VENIANO': 'L737',
  'VENOSA': 'L738',
  'VENTICANO': 'L739',
  'VENTIMIGLIA DI SICILIA': 'L740',
  'VENTIMIGLIA': 'L741',
  'VENTOTENE': 'L742',
  'VENZONE': 'L743',
  'VERANO BRIANZA': 'L744',
  'VERANO * VOERAN': 'L745',
  'VERBANIA': 'L746',
  'VERBICARO': 'L747',
  'VERCANA': 'L748',
  'VERCEIA': 'L749',
  'VERCELLI': 'L750',
  'VERCURAGO': 'L751',
  'VERDELLINO': 'L752',
  'VERDELLO': 'L753',
  'VERDERIO INFERIORE': 'L755',
  'VERDERIO SUPERIORE': 'L756',
  'VERDUNO': 'L758',
  'VERGATO': 'L762',
  'VERGEMOLI': 'L763',
  'VERGHERETO': 'L764',
  'VERGIATE': 'L765',
  'VERMEZZO': 'L768',
  'VERMIGLIO': 'L769',
  'VERNANTE': 'L771',
  'VERNASCA': 'L772',
  'VERNATE': 'L773',
  'VERNAZZA': 'L774',
  'VERNIO': 'L775',
  'VERNOLE': 'L776',
  'VEROLANUOVA': 'L777',
  'VEROLAVECCHIA': 'L778',
  'VEROLENGO': 'L779',
  'VEROLI': 'L780',
  'VERONA': 'L781',
  'VERRAYES': 'L783',
  'VERRETTO': 'L784',
  'VERRONE': 'L785',
  'VERRUA SAVOIA': 'L787',
  'VERRUA PO': 'L788',
  'VERTEMATE CON MINOPRIO': 'L792',
  'VERTOVA': 'L795',
  'VERUCCHIO': 'L797',
  'VERUNO': 'L798',
  'VERVIO': 'L799',
  'VERVO\'': 'L800',
  'VERZEGNIS': 'L801',
  'VERZINO': 'L802',
  'VERZUOLO': 'L804',
  'VESCOVANA': 'L805',
  'VESCOVATO': 'L806',
  'VESIME': 'L807',
  'VESPOLATE': 'L808',
  'VESSALICO': 'L809',
  'VESTENANOVA': 'L810',
  'VESTIGNE\'': 'L811',
  'VESTONE': 'L812',
  'VESTRENO': 'L813',
  'VETRALLA': 'L814',
  'VETTO': 'L815',
  'VEZZA D\'OGLIO': 'L816',
  'VEZZA D\'ALBA': 'L817',
  'VEZZANO LIGURE': 'L819',
  'VEZZANO SUL CROSTOLO': 'L820',
  'VEZZANO': 'L821',
  'VEZZI PORTIO': 'L823',
  'VIADANA': 'L826',
  'VIADANICA': 'L827',
  'VIAGRANDE': 'L828',
  'VIALE D\'ASTI': 'L829',
  'VIALFRE\'': 'L830',
  'VIANO': 'L831',
  'VIAREGGIO': 'L833',
  'VIARIGI': 'L834',
  'VIBONATI': 'L835',
  'VICALVI': 'L836',
  'VICARI': 'L837',
  'VICCHIO': 'L838',
  'VICENZA': 'L840',
  'VICOFORTE': 'L841',
  'VICO DEL GARGANO': 'L842',
  'VICO NEL LAZIO': 'L843',
  'VILLA LITERNO': 'L844',
  'VICO EQUENSE': 'L845',
  'VICOLI': 'L846',
  'VICOLUNGO': 'L847',
  'ZIANO PIACENTINO': 'L848',
  'VICOPISANO': 'L850',
  'VICOVARO': 'L851',
  'VIDIGULFO': 'L854',
  'VIDOR': 'L856',
  'VIDRACCO': 'L857',
  'VIESTE': 'L858',
  'VIETRI DI POTENZA': 'L859',
  'VIETRI SUL MARE': 'L860',
  'VIGANELLA': 'L864',
  'VIGANO SAN MARTINO': 'L865',
  'VIGANO\'': 'L866',
  'VIGARANO MAINARDA': 'L868',
  'VIGASIO': 'L869',
  'VIGEVANO': 'L872',
  'VIGGIANELLO': 'L873',
  'VIGGIANO': 'L874',
  'VIGGIU\'': 'L876',
  'VIGHIZZOLO D\'ESTE': 'L878',
  'VIGLIANO D\'ASTI': 'L879',
  'VIGLIANO BIELLESE': 'L880',
  'VIGNALE MONFERRATO': 'L881',
  'VIGNANELLO': 'L882',
  'VIGNATE': 'L883',
  'VIGNOLA': 'L884',
  'VIGNOLA FALESINA': 'L886',
  'VIGNOLE BORBERA': 'L887',
  'VIGNOLO': 'L888',
  'VIGNONE': 'L889',
  'VIGO DI CADORE': 'L890',
  'VIGODARZERE': 'L892',
  'VIGO DI FASSA': 'L893',
  'VIGOLO': 'L894',
  'VIGOLO VATTARO': 'L896',
  'VIGOLZONE': 'L897',
  'VIGONE': 'L898',
  'VIGONOVO': 'L899',
  'VIGONZA': 'L900',
  'VIGO RENDENA': 'L903',
  'VIGUZZOLO': 'L904',
  'VILLA SANTA LUCIA': 'L905',
  'VILLADOSSOLA': 'L906',
  'VILLA DI CHIAVENNA': 'L907',
  'VILLA DI TIRANO': 'L908',
  'VILLA SANTINA': 'L909',
  'VILLA AGNEDO': 'L910',
  'VILLA BARTOLOMEA': 'L912',
  'VILLA BASILICA': 'L913',
  'VILLABASSA * NIEDERDORF': 'L915',
  'VILLABATE': 'L916',
  'VILLA BISCOSSI': 'L917',
  'VILLA CARCINA': 'L919',
  'VILLA CASTELLI': 'L920',
  'VILLA CELIERA': 'L922',
  'VILLACHIARA': 'L923',
  'VILLACIDRO': 'L924',
  'VILLA COLLEMANDINA': 'L926',
  'VILLA CORTESE': 'L928',
  'VILLA D\'ADDA': 'L929',
  'VILLADEATI': 'L931',
  'VILLA DEL BOSCO': 'L933',
  'VILLA DEL CONTE': 'L934',
  'VILLA DI SERIO': 'L936',
  'VILLA ESTENSE': 'L937',
  'VILLA D\'OGNA': 'L938',
  'VILLADOSE': 'L939',
  'VILLAFALLETTO': 'L942',
  'VILLA FARALDI': 'L943',
  'VILLAFRANCA SICULA': 'L944',
  'VILLAFRANCA D\'ASTI': 'L945',
  'VILLAFRANCA IN LUNIGIANA': 'L946',
  'VILLAFRANCA PADOVANA': 'L947',
  'VILLAFRANCA PIEMONTE': 'L948',
  'VILLAFRANCA DI VERONA': 'L949',
  'VILLAFRANCA TIRRENA': 'L950',
  'VILLAFRATI': 'L951',
  'VILLAGA': 'L952',
  'VILLAGRANDE STRISAILI': 'L953',
  'VILLA GUARDIA': 'L955',
  'VILLA LAGARINA': 'L957',
  'VILLALAGO': 'L958',
  'VILLALBA': 'L959',
  'VILLALFONSINA': 'L961',
  'VILLALVERNIA': 'L963',
  'VILLAMAGNA': 'L964',
  'VILLAMAINA': 'L965',
  'VILLAMAR': 'L966',
  'VILLAMARZANA': 'L967',
  'VILLAMASSARGIA': 'L968',
  'VILLA MINOZZO': 'L969',
  'VILLAMIROGLIO': 'L970',
  'VILLANDRO * VILLANDERS': 'L971',
  'VILLANOVA MONFERRATO': 'L972',
  'VILLANOVA DEL BATTISTA': 'L973',
  'VILLANOVA MONDOVI\'': 'L974',
  'VILLANOVA D\'ALBENGA': 'L975',
  'VILLANOVA DEL SILLARO': 'L977',
  'VILLANOVA BIELLESE': 'L978',
  'VILLANOVA DI CAMPOSAMPIERO': 'L979',
  'VILLANOVA SULL\'ARDA': 'L980',
  'VILLENEUVE': 'L981',
  'VILLANOVA CANAVESE': 'L982',
  'VILLANOVA D\'ARDENGHI': 'L983',
  'VILLANOVA D\'ASTI': 'L984',
  'VILLANOVA DEL GHEBBO': 'L985',
  'VILLANOVAFORRU': 'L986',
  'VILLANOVAFRANCA': 'L987',
  'VILLANOVA MARCHESANA': 'L988',
  'VILLANOVA MONTELEONE': 'L989',
  'VILLANOVA SOLARO': 'L990',
  'VILLANOVA TRUSCHEDU': 'L991',
  'VILLANOVA TULO': 'L992',
  'VILLANTERIO': 'L994',
  'VILLANUOVA SUL CLISI': 'L995',
  'VILLAPUTZU': 'L998',
  'VILLAR DORA': 'L999',
  'VILLARBASSE': 'M002',
  'VILLARBOIT': 'M003',
  'VILLAREGGIA': 'M004',
  'VILLA RENDENA': 'M006',
  'VILLAR FOCCHIARDO': 'M007',
  'VILLAROMAGNANO': 'M009',
  'VILLAROSA': 'M011',
  'VILLAR PELLICE': 'M013',
  'VILLAR PEROSA': 'M014',
  'VILLAR SAN COSTANZO': 'M015',
  'VILLASALTO': 'M016',
  'VILLASANTA': 'M017',
  'VILLA SAN GIOVANNI': 'M018',
  'VILLA SAN SECONDO': 'M019',
  'VILLA SANTA LUCIA DEGLI ABRUZZI': 'M021',
  'VILLA SANTA MARIA': 'M022',
  'VILLA SANT\'ANGELO': 'M023',
  'VILLASOR': 'M025',
  'VILLASPECIOSA': 'M026',
  'VILLASTELLONE': 'M027',
  'VILLATA': 'M028',
  'VILLAURBANA': 'M030',
  'VILLAVALLELONGA': 'M031',
  'VILLAVERLA': 'M032',
  'VILLA VICENTINA': 'M034',
  'VILLETTA BARREA': 'M041',
  'VILLETTE': 'M042',
  'VILLESSE': 'M043',
  'VILLIMPENTA': 'M044',
  'VILLONGO': 'M045',
  'VILLORBA': 'M048',
  'VILMINORE DI SCALVE': 'M050',
  'VIMERCATE': 'M052',
  'VIMODRONE': 'M053',
  'VINADIO': 'M055',
  'VINCHIATURO': 'M057',
  'VINCHIO': 'M058',
  'VINCI': 'M059',
  'VINOVO': 'M060',
  'VINZAGLIO': 'M062',
  'VIOLA': 'M063',
  'VIONE': 'M065',
  'VIPITENO * STERZING': 'M067',
  'VIRLE PIEMONTE': 'M069',
  'VISANO': 'M070',
  'VISCHE': 'M071',
  'VISCIANO': 'M072',
  'VISCO': 'M073',
  'VISONE': 'M077',
  'VISSO': 'M078',
  'VISTARINO': 'M079',
  'VISTRORIO': 'M080',
  'VITA': 'M081',
  'VITERBO': 'M082',
  'VITICUSO': 'M083',
  'VITO D\'ASIO': 'M085',
  'VITORCHIANO': 'M086',
  'VITTORIA': 'M088',
  'VITTORIO VENETO': 'M089',
  'VITTORITO': 'M090',
  'VITTUONE': 'M091',
  'VITULAZIO': 'M092',
  'VITULANO': 'M093',
  'VIU\'': 'M094',
  'VIVARO ROMANO': 'M095',
  'VIVARO': 'M096',
  'VIVERONE': 'M098',
  'VIZZINI': 'M100',
  'VIZZOLA TICINO': 'M101',
  'VIZZOLO PREDABISSI': 'M102',
  'VO': 'M103',
  'VOBARNO': 'M104',
  'VOBBIA': 'M105',
  'VOCCA': 'M106',
  'VODO DI CADORE': 'M108',
  'VOGHERA': 'M109',
  'VOGHIERA': 'M110',
  'VOGOGNA': 'M111',
  'VOLANO': 'M113',
  'VOLLA': 'M115',
  'VOLONGO': 'M116',
  'VOLPAGO DEL MONTELLO': 'M118',
  'VOLPARA': 'M119',
  'VOLPEDO': 'M120',
  'VOLPEGLINO': 'M121',
  'VOLPIANO': 'M122',
  'VOLTAGGIO': 'M123',
  'VOLTAGO AGORDINO': 'M124',
  'VOLTA MANTOVANA': 'M125',
  'VOLTERRA': 'M126',
  'VOLTIDO': 'M127',
  'VOLTURARA IRPINA': 'M130',
  'VOLTURARA APPULA': 'M131',
  'VOLTURINO': 'M132',
  'VOLVERA': 'M133',
  'VOTTIGNASCO': 'M136',
  'ZACCANOPOLI': 'M138',
  'ZAFFERANA ETNEA': 'M139',
  'ZAGARISE': 'M140',
  'ZAGAROLO': 'M141',
  'ZAMBANA': 'M142',
  'ZAMBRONE': 'M143',
  'ZANDOBBIO': 'M144',
  'ZANE\'': 'M145',
  'ZANICA': 'M147',
  'ZAVATTARELLO': 'M150',
  'ZECCONE': 'M152',
  'ZEDDIANI': 'M153',
  'ZELBIO': 'M156',
  'ZELO BUON PERSICO': 'M158',
  'ZELO SURRIGONE': 'M160',
  'ZEME': 'M161',
  'ZENEVREDO': 'M162',
  'ZENSON DI PIAVE': 'M163',
  'ZERBA': 'M165',
  'ZERBO': 'M166',
  'ZERBOLO\'': 'M167',
  'ZERFALIU': 'M168',
  'ZERI': 'M169',
  'ZERMEGHEDO': 'M170',
  'ZERO BRANCO': 'M171',
  'ZEVIO': 'M172',
  'ZIANO DI FIEMME': 'M173',
  'ZIBELLO': 'M174',
  'ZIBIDO SAN GIACOMO': 'M176',
  'ZIGNAGO': 'M177',
  'ZIMELLA': 'M178',
  'ZIMONE': 'M179',
  'ZINASCO': 'M180',
  'ZOAGLI': 'M182',
  'ZOCCA': 'M183',
  'ZOGNO': 'M184',
  'ZOLA PREDOSA': 'M185',
  'ZOLLINO': 'M187',
  'ZONE': 'M188',
  'ZOPPE\' DI CADORE': 'M189',
  'ZOPPOLA': 'M190',
  'ZOVENCEDO': 'M194',
  'ZUBIENA': 'M196',
  'ZUCCARELLO': 'M197',
  'ZUCLO': 'M198',
  'ZUGLIANO': 'M199',
  'ZUGLIO': 'M200',
  'ZUMAGLIA': 'M201',
  'ZUMPANO': 'M202',
  'ZUNGOLI': 'M203',
  'ZUNGRI': 'M204',
  'LARIANO': 'M207',
  'LAMEZIA TERME': 'M208',
  'SANT\'ANNA ARRESI': 'M209',
  'TERME VIGLIATORE': 'M210',
  'ACQUEDOLCI': 'M211',
  'LADISPOLI': 'M212',
  'ARDEA': 'M213',
  'BADESI': 'M214',
  'SICIGNANO DEGLI ALBURNI': 'M253',
  'MOLINA ATERNO': 'M255',
  'SCANZANO JONICO': 'M256',
  'PORTOPALO DI CAPO PASSERO': 'M257',
  'AVIGLIANO UMBRO': 'M258',
  'VIDDALBA': 'M259',
  'CASAPESENNA': 'M260',
  'CELLOLE': 'M262',
  'PORTO CESAREO': 'M263',
  'SAN CASSIANO': 'M264',
  'VAJONT': 'M265',
  'ORDONA': 'M266',
  'ZAPPONETA': 'M267',
  'BLUFI': 'M268',
  'PATERNO': 'M269',
  'MASAINAS': 'M270',
  'MAZZARRONE': 'M271',
  'CIAMPINO': 'M272',
  'SANTA MARIA LA CARITA\'': 'M273',
  'GOLFO ARANCI': 'M274',
  'LOIRI PORTO SAN PAOLO': 'M275',
  'SANT\'ANTONIO DI GALLURA': 'M276',
  'SAN FERDINANDO': 'M277',
  'VILLAPERUCCIO': 'M278',
  'PRIOLO GARGALLO': 'M279',
  'TRECASE': 'M280',
  'PETROSINO': 'M281',
  'TERGU': 'M282',
  'MANIACE': 'M283',
  'SANTA MARIA COGHINAS': 'M284',
  'CARDEDU': 'M285',
  'TORRENOVA': 'M286',
  'RAGALNA': 'M287',
  'CASTIADAS': 'M288',
  'MASSA DI SOMMA': 'M289',
  'STINTINO': 'M290',
  'PISCINAS': 'M291',
  'ERULA': 'M292',
  'BELLIZZI': 'M294',
  'SAN CESAREO': 'M295',
  'FIUMICINO': 'M297',
  'STATTE': 'M298',
  'DUE CARRARE': 'M300',
  'PADRU': 'M301',
  'MONTIGLIO MONFERRATO': 'M302',
  'RONZO-CHIENIS': 'M303',
  'MOSSO': 'M304',
  'CAVALLINO-TREPORTI': 'M308',
  'FONTE NUOVA': 'M309',
  'CAMPOLONGO TAPOGLIANO': 'M311',
  'ABBADIA SOPRA ADDA': 'A002',
  'ABBADIA ALPINA': 'A003',
  'ABBAZIA': 'A009',
  'ABBIATEGUAZZONE': 'A011',
  'ACERETO * AHORNACH': 'A021',
  'ACQUA': 'A030',
  'ACQUALUNGA': 'A036',
  'ACQUALUNGA BADONA': 'A037',
  'ACQUATE': 'A046',
  'AFFORI': 'A063',
  'AGARO': 'A066',
  'AGLIATE': 'A073',
  'AGNELLENGO': 'A078',
  'AGNONA': 'A079',
  'AGRANO': 'A086',
  'AGRONE': 'A090',
  'AIBA': 'A095',
  'AIDUSSINA': 'A099',
  'AIELLO IN CALABRIA': 'A104',
  'AIZURRO': 'A114',
  'ALBANOVA': 'A133',
  'SANT\'ANDREA DI CAVASAGRA': 'A136',
  'ALBARETTO VALLE DI MACRA': 'A140',
  'ALBARO VESCOVA': 'A141',
  'ALBATE': 'A142',
  'ALBEGNO': 'A144',
  'TRIBURGO': 'A147',
  'ALBER DI SESANA': 'A148',
  'ALBES * ALBEINS': 'A151',
  'ALBESE': 'A152',
  'ALBIANO MAGRA': 'A156',
  'ALBOGASIO': 'A168',
  'ALBOGNO': 'A169',
  'ALBONA': 'A170',
  'ALBUSCIAGO': 'A174',
  'ALFIANO ED UNITI': 'A190',
  'ALLIZ * ALLITZ': 'A209',
  'ALMA': 'A212',
  'ALMAZZAGO': 'A213',
  'ALONE': 'A219',
  'ALTETA': 'A232',
  'ALZANO MAGGIORE': 'A247',
  'ALZANO SOPRA': 'A248',
  'ALZATE CON LINDUNO': 'A250',
  'ANDOGNO': 'A276',
  'ANDONNO': 'A277',
  'ANDORNO CACCIORNA': 'A279',
  'ANFURRO': 'A289',
  'ANICOVA CORADA': 'A298',
  'ANTERSELVA * ANTHOLZ': 'A307',
  'ANTIGNANA': 'A311',
  'ANTRONAPIANA': 'A316',
  'ANZINO': 'A322',
  'APPARIZIONE': 'A331',
  'APRIANO': 'A336',
  'APUANIA': 'A342',
  'ARA': 'A349',
  'ARANCO': 'A353',
  'ARBIZZO': 'A356',
  'ARCAGNA': 'A361',
  'ARCAGNANO': 'A362',
  'ARCELLASCO': 'A364',
  'ARCUMEGGIA': 'A378',
  'ARDENA': 'A381',
  'ARDOLE SAN MARINO': 'A384',
  'BRESSANA': 'A395',
  'ARIENZO SANFELICE': 'A404',
  'ARISCHIA': 'A406',
  'ARIXI': 'A408',
  'ARIZZANO INFERIORE': 'A410',
  'ARIZZANO SUPERIORE': 'A411',
  'ARMIO': 'A416',
  'ARNAGO': 'A420',
  'ARNATE': 'A423',
  'BONDO BREGUZZO': 'A426',
  'AROLO': 'A428',
  'ARSIA': 'A442',
  'ARTO': 'A450',
  'ARZENO D\'ONEGLIA': 'A457',
  'ASNAGO': 'A469',
  'ATELLA DI NAPOLI': 'A483',
  'AUREMO DI SOPRA': 'A498',
  'AURISINA': 'A500',
  'AUZATE': 'A504',
  'AUZZA': 'A505',
  'AVENONE': 'A510',
  'AVESA': 'A513',
  'AVUGLIONE E VERNONE': 'A524',
  'BAGAGGERA': 'A543',
  'BAGGIO': 'A545',
  'BAGNAIA': 'A548',
  'BAGNARA DI BENEVENTO': 'A549',
  'BAGNAROLO': 'A554',
  'BAGNASCO D\'ASTI': 'A556',
  'BAGNO': 'A563',
  'BAIEDO': 'A582',
  'BAIO DORA': 'A583',
  'BAIRO TORRE': 'A585',
  'BALLABIO INFERIORE': 'A595',
  'BALLABIO SUPERIORE': 'A596',
  'BALLARATE': 'A598',
  'BALSAMO': 'A602',
  'BANCO': 'A608',
  'BANTINE': 'A611',
  'BARATE': 'A620',
  'BARATONIA': 'A622',
  'BARBAIANA': 'A623',
  'BARBANA D\'ISTRIA': 'A624',
  'BARBISELLE': 'A636',
  'BARCO': 'A641',
  'BARCONE': 'A642',
  'BARDASSANO': 'A644',
  'BARDINO NUOVO': 'A648',
  'BARDINO VECCHIO': 'A649',
  'BARESI': 'A654',
  'BARGANO': 'A659',
  'BARONA': 'A672',
  'BARRA': 'A675',
  'BARZIZZA': 'A679',
  'BARTESATE': 'A680',
  'BARZA': 'A682',
  'BARZANIGA': 'A685',
  'BARZOLA': 'A688',
  'BASELGA DI VEZZANO': 'A693',
  'BASELICA BOLOGNA': 'A695',
  'BATTAGLIA DELLA BAINSIZZA': 'A715',
  'BAUSO': 'A723',
  'BAVARI': 'A724',
  'BEAULARD': 'A727',
  'BELLEDO': 'A748',
  'BELLIZZI IRPINO': 'A753',
  'BELLOMBRA': 'A754',
  'BELLUNO VERONESE': 'A758',
  'BEL PRATO': 'A767',
  'BELVEDERE AL PO': 'A775',
  'BERDO SAN GIOVANNI': 'A790',
  'BERGOGNA': 'A797',
  'BERNAGA': 'A800',
  'BERNATE ROSALES': 'A803',
  'BERSEZIO': 'A807',
  'BESENO': 'A822',
  'BERSEZIO DEL QUARNARO': 'A824',
  'BESTAGNO': 'A828',
  'BESTAZZO': 'A829',
  'BETTENESCO': 'A830',
  'BEURA': 'A833',
  'BEVILACQUA BOSCHI': 'A838',
  'BIACESA': 'A840',
  'BIEGNO': 'A858',
  'BIENATE': 'A860',
  'BIESTRO': 'A865',
  'BIGLIA': 'A867',
  'BIGLIANA': 'A868',
  'BIGLIO': 'A869',
  'BINANUOVA': 'A871',
  'BINDO': 'A873',
  'BINZAGO': 'A875',
  'BIRAGO': 'A879',
  'BISENTRATE': 'A886',
  'BISIO': 'A888',
  'BISTERZA': 'A890',
  'BIZZOZERO': 'A899',
  'BLEGGIO': 'A900',
  'BOARA POLESINE': 'A907',
  'BOBBIATE': 'A908',
  'BOCCHIGNANO': 'A913',
  'BOCCOLO DEI TASSI': 'A915',
  'BODIO': 'A917',
  'BOFFETTO': 'A921',
  'BOGLIASCO PIEVE': 'A923',
  'BOGLIUNO': 'A924',
  'BOGNANCO DENTRO': 'A926',
  'BOGNANCO FUORI': 'A927',
  'BOGNO': 'A928',
  'BOLDINASCO': 'A934',
  'BOLENTINA': 'A935',
  'BOLETO': 'A936',
  'BOLGIANO': 'A938',
  'BOLLADELLO': 'A939',
  'BOLLONE': 'A943',
  'BOLZANETO': 'A951',
  'BONDIONE': 'A966',
  'BONDO PETELLO': 'A969',
  'BONIROLA': 'A974',
  'BONZO': 'A980',
  'BORDOGNA': 'A985',
  'BORGHETTO SAN NICOLO\'': 'A994',
  'BORGHETTO': 'A997',
  'BORGIO': 'B004',
  'BORGONATO': 'B022',
  'BORGONE D\'OSSOLA': 'B023',
  'BORGO PANIGALE': 'B027',
  'BORGO SAN BERNARDINO': 'B032',
  'BORGO SANT\'AGATA': 'B039',
  'BORGOUNITO': 'B045',
  'BORIANO': 'B047',
  'BORNAGO': 'B050',
  'BORNATE': 'B052',
  'BORNATO': 'B053',
  'BORSANO': 'B059',
  'BORSEA': 'B060',
  'BORZAGO': 'B065',
  'BORZOLI': 'B066',
  'BOSCO VALTRAVAGLIA': 'B072',
  'BOSCOMARE': 'B074',
  'BOTTAIANO': 'B087',
  'BOTTARONE': 'B089',
  'BOTTEDO': 'B090',
  'BOTTICINO MATTINA': 'B092',
  'BOTTICINO SERA': 'B093',
  'BOTTRIGHE': 'B095',
  'BOUSSON': 'B096',
  'BOVILE': 'B103',
  'BOZZANA': 'B108',
  'BRACCA DI COSTA SERINA': 'B113',
  'BRANCERE': 'B119',
  'BRANDUZZO': 'B122',
  'BRAZZANO': 'B125',
  'BRECCIA': 'B127',
  'BREDA GUAZZONE': 'B130',
  'BREGLIA': 'B133',
  'BREMBATE DI SOTTO': 'B139',
  'BRENNO USERIA': 'B146',
  'BRENNO DELLA TORRE': 'B147',
  'SOMBRENO': 'B148',
  'BRENTINO': 'B151',
  'BREONIO': 'B155',
  'BRESTOVIZZA IN VALLE': 'B163',
  'BRETTO': 'B164',
  'BRIANZOLA': 'B168',
  'BRIAVACCA': 'B170',
  'BRIGA MARITTIMA': 'B174',
  'BRIGNANO DEL CURONE': 'B177',
  'BRIONI MAGGIORE': 'B186',
  'BRISINO': 'B189',
  'BRISSAGO': 'B190',
  'BROLPASINO': 'B199',
  'BROVELLO': 'B206',
  'BROVIDA': 'B208',
  'BROZZI': 'B210',
  'BROZZO': 'B211',
  'BRUNTINO': 'B222',
  'BRUSASCHETTO': 'B224',
  'BRUSASCO CAVAGNOLO': 'B226',
  'BRUSUGLIO': 'B231',
  'BRUZZANO DEI DUE BORGHI': 'B233',
  'BUCCINIGO': 'B241',
  'BUCUIE': 'B244',
  'BUDAGNE': 'B245',
  'BUGGIOLO': 'B252',
  'BUGIALLO': 'B253',
  'MONTEBUGLIO': 'B254',
  'BUGNATE': 'B257',
  'BUIE D\'ISTRIA': 'B260',
  'BULGORELLO': 'B263',
  'BURAGO RIVIERA': 'B271',
  'BURANO': 'B273',
  'BURGUSIO * BURGEIS': 'B277',
  'BUSO SARZANO': 'B290',
  'BUSSANA': 'B291',
  'BUSSOLINO GASSINESE': 'B298',
  'BUSTIGHERA': 'B299',
  'BUTTIRAGO': 'B307',
  'BUTTOGNO': 'B308',
  'CAMPOVERDE': 'B316',
  'VILLA CACCIA': 'B318',
  'CADDO': 'B321',
  'CA\' DE\' BONAVOGLI': 'B322',
  'CA\' DE\' CAGGI': 'B323',
  'CA\' DE\' CORTI': 'B324',
  'CADEGLIANO': 'B325',
  'CA\' DEI BOLLI': 'B327',
  'CA\' DELL\'ACQUA': 'B329',
  'CA\' DELLA TERRA': 'B330',
  'CA\' DE\' MAZZI': 'B331',
  'CA\' DE\' QUINZANI': 'B333',
  'CADERO CON GRAGLIO': 'B334',
  'CA\' DE\' SFONDRATI': 'B336',
  'CA\' DE\' SORESINI': 'B337',
  'CA\' DE\' STAOLI': 'B338',
  'CA\' DE\' STEFANI': 'B339',
  'CA\' DE\' TEDIOLI': 'B340',
  'CA\' DE\' ZECCHI': 'B341',
  'CA\' DI DAVID': 'B342',
  'CADIGNANO': 'B343',
  'CADINE': 'B344',
  'CA\' EMO': 'B348',
  'CAGLIANO': 'B353',
  'CAGNA': 'B356',
  'CAIDATE': 'B363',
  'CAIRO LOMELLINO': 'B370',
  'CAJELLO': 'B372',
  'CAJONVICO': 'B373',
  'CAL DI CANALE': 'B401',
  'CALEPIO': 'B407',
  'CALICE OSSOLANO': 'B411',
  'CALIGNANO': 'B412',
  'CALINO': 'B414',
  'CALO\'': 'B420',
  'CALOGNA': 'B421',
  'CALOLZIO': 'B422',
  'CALVARUSO': 'B438',
  'CALVI SAN NAZZARO': 'B449',
  'CALVISIO': 'B451',
  'CAMAGNA DI TORINO': 'B454',
  'CAMARDA': 'B458',
  'CAMASCO': 'B459',
  'CAMBIO\'': 'B464',
  'CAMERLATA': 'B475',
  'CAMIGNONE': 'B478',
  'CAMINATA DI TURES * KEMATEN': 'B480',
  'CAMNAGO VOLTA': 'B487',
  'CAMNAGO FALOPPIA': 'B488',
  'CAMPAGNANO VEDASCA': 'B495',
  'CAMPELLO MONTI': 'B503',
  'CAMPO CANAVESE': 'B517',
  'CAMPO': 'B518',
  'CAMPOCHIESA': 'B523',
  'CAMPOLONGO AL TORRE': 'B545',
  'CAMPOLUNGO': 'B548',
  'CAMPOMORTO': 'B552',
  'CAMPO RINALDO': 'B558',
  'CAMPOROSSO IN VALCANALE': 'B560',
  'CAMPOSPINOSO ALBAREDO': 'B568',
  'CAMPOVICO': 'B571',
  'CANALE D\'ISONZO': 'B575',
  'CANDEASCO': 'B583',
  'CANDELARA': 'B585',
  'CANEPA': 'B596',
  'CANEZZA': 'B600',
  'CANFANARO': 'B601',
  'CANNETO DI BARI': 'B611',
  'CANNITELLO': 'B614',
  'CANOVA DEL MORBASCO': 'B622',
  'CANOVA OLZANO': 'B623',
  'CANSERO': 'B625',
  'CANTONALE': 'B638',
  'CAPIAGO': 'B652',
  'CAPIATE': 'B654',
  'CAPITELLO': 'B657',
  'CAPITONE': 'B659',
  'CAPODISTRIA': 'B665',
  'CAPOLAGO': 'B668',
  'CAPORETTO': 'B673',
  'CAPRADOSSO': 'B683',
  'CAPRIANO DI BRIANZA': 'B699',
  'CAPRIANO-AZZANO': 'B700',
  'CAPRIATE D\'ADDA': 'B702',
  'CAPRIVA DEL CARSO': 'B713',
  'CAPRONNO': 'B714',
  'CARAMAGNA LIGURE': 'B721',
  'CARATE LARIO': 'B728',
  'CARBONARA DI BARI': 'B737',
  'CARCACI': 'B746',
  'CARCANO': 'B747',
  'CARCIATO': 'B750',
  'CARCINA': 'B751',
  'CARDANA': 'B753',
  'CARDEZZA': 'B757',
  'CARELLA CON MARIAGA': 'B761',
  'CARENO': 'B764',
  'CAREZZANO SUPERIORE': 'B770',
  'CARGIAGO': 'B773',
  'CARIDA\'': 'B775',
  'CARLAZZO VALSOLDA': 'B786',
  'CAMIGNA': 'B793',
  'CARNAIOLA': 'B797',
  'CAROBBIO': 'B800',
  'CARONNO CORBELLARO': 'B806',
  'CARPANETA CON DOSIMO': 'B811',
  'CARPE': 'B815',
  'CARPIGNAGO': 'B821',
  'CARPUGNINO': 'B831',
  'CARRARA SAN GIORGIO': 'B833',
  'CARRARA SANTO STEFANO': 'B834',
  'CARRETTO': 'B837',
  'CARTARI E CALDERARA': 'B843',
  'CARUBERTO': 'B849',
  'CARUGO AROSIO': 'B852',
  'CARZAGO DELLA RIVIERA': 'B855',
  'CASALBA': 'B863',
  'CASALE CREMASCO': 'B874',
  'CASALEGGIO CASTELLAZZO': 'B884',
  'CASALORZO GEROLDI': 'B908',
  'CASALPOGLIO': 'B909',
  'CASALSIGONE': 'B913',
  'CASANOVA LANZA': 'B926',
  'CA\' SANTO SPIRITO DELLA BAINSIZZA': 'B930',
  'CASANUOVA OFFREDI': 'B931',
  'CASATICO': 'B944',
  'CASCINE DI STRA': 'B951',
  'CASELLE D\'OZERO': 'B957',
  'CASEZ': 'B964',
  'CASIRAGO': 'B970',
  'CASIRATE OLONA': 'B972',
  'CASLETTO': 'B973',
  'CASLINO AL PIANO': 'B975',
  'CASNATE': 'B976',
  'CASOLATE': 'B981',
  'CASONE': 'B986',
  'CASOTTO': 'B992',
  'CASSAGO': 'B995',
  'CASSANO ALBESE': 'C001',
  'CASSINA ALIPRANDI': 'C008',
  'CASSINA AMATA': 'C009',
  'CASSINA BARAGGIA': 'C010',
  'CASSINA DE\' BRACCHI': 'C011',
  'CASSINA DE\' GATTI': 'C012',
  'CASSINA FERRARA': 'C015',
  'CASSINA MARIAGA': 'C016',
  'CASSINA NUOVA': 'C017',
  'CASSINA PERTUSELLA': 'C018',
  'CASSINA POBBIA': 'C019',
  'CASSINA SAVINA': 'C021',
  'CASSINA TRIULZA': 'C023',
  'CASSINA VERGHERA': 'C025',
  'CASCINE': 'C026',
  'CASSINE CALDERARI': 'C028',
  'CASCINE GANDINI': 'C029',
  'CASSINE SIRIGARI': 'C031',
  'CASSINE TOLENTINE': 'C032',
  'CASSINO PO': 'C035',
  'CASSINO D\'ALBERI': 'C036',
  'CASTAGNA': 'C039',
  'CASTAGNATE OLONA': 'C042',
  'CASTAGNE\'': 'C043',
  'CASTEGNATE OLONA': 'C054',
  'CASTELBELLO * KASTELBELL': 'C061',
  'CASTEL CELLESI': 'C068',
  'CASTELDARNE * EHRENBURG': 'C077',
  'CASTEL DEL MONTE UDINESE': 'C084',
  'CASTEL DE\' RATTI': 'C087',
  'CASTEL DI CROCE': 'C088',
  'CASTEL DI LAGO': 'C092',
  'CASTELDIMEZZO': 'C095',
  'CASTEL DOBRA': 'C099',
  'CASTELFRANCO D\'OGLIO': 'C109',
  'CASTEL IABLANIZZA': 'C124',
  'CASTEL LAMBRO': 'C131',
  'CASTELLAMMARE ADRIATICO': 'C132',
  'CASTELLANO': 'C138',
  'CASTELLARO DE\' GIORGI': 'C144',
  'CASTELLAZZO DE\' BARZI': 'C150',
  'CASTELLENGO': 'C151',
  'CASTELLETTO MENDOSIO': 'C159',
  'CASTELLETTO MONFORTE': 'C163',
  'CASTELLETTO PO': 'C164',
  'CASTELLETTO VILLA': 'C168',
  'CASTELLI CUSIANI': 'C171',
  'CASTELLO VALSOLDA': 'C179',
  'CASTELLO SOPRA LECCO': 'C180',
  'CASTELLO': 'C182',
  'CASTELLONE AL VOLTURNO': 'C192',
  'CASTELLONORATO': 'C193',
  'CASTELLUCCIO': 'C196',
  'CASTELNOVATE': 'C212',
  'CASTELNUOVO CREMASCO': 'C221',
  'CASTELNUOVO DEL VESCOVO': 'C233',
  'CASTELNUOVO DEL ZAPPA': 'C234',
  'CASTELNUOVO D\'ISTRIA': 'C238',
  'CASTELNUOVO GHERARDI': 'C239',
  'CASTELPONZONE': 'C249',
  'CASTEL RUGGERO': 'C256',
  'CASTEL SAN BENEDETTO REATINO': 'C257',
  'CASTEL SAN FELICE': 'C258',
  'CASTEL SAN GIOVANNI DI SPOLETO': 'C260',
  'CASTEL SAN PIETRO MONFERRATO': 'C264',
  'CASTELVECCHIO DI SANTA MARIA MAGGIORE': 'C277',
  'CASTELVERO D\'ASTI': 'C281',
  'CASTIGLIONE D\'ASTI': 'C295',
  'CASTIGLIONE D\'OSSOLA': 'C305',
  'CASTIGLION UBERTINI': 'C320',
  'CASTIONE VERONESE': 'C326',
  'CASTIRAGA DA REGGIO': 'C328',
  'CASTREZZONE': 'C333',
  'CATAFORIO': 'C350',
  'CATONA': 'C355',
  'CAURIA * GFRILL': 'C358',
  'CAVAGLIO SAN DONNINO': 'C366',
  'CAVAGNERA': 'C368',
  'CAVAIONE': 'C371',
  'CAVALLARA': 'C373',
  'CAVANDONE': 'C379',
  'CAVA TIGOZZI': 'C386',
  'CAVE AUREMIANE': 'C391',
  'CAVERSACCIO': 'C397',
  'CAVIAGA': 'C399',
  'COVELANO * GOEFLAN': 'C401',
  'CAVONA': 'C402',
  'CAVORETTO': 'C403',
  'CAZZANO BESANA': 'C411',
  'CECONICO': 'C416',
  'CEDRATE': 'C419',
  'CEGLIE DEL CAMPO': 'C423',
  'CEGLIE': 'C425',
  'CELENTINO': 'C427',
  'CELINA': 'C431',
  'CELLA': 'C433',
  'CELLA DI BOBBIO': 'C434',
  'CELLEDIZZO': 'C445',
  'CELPENCHIO': 'C451',
  'CENATE': 'C454',
  'CENATE D\'ARGON': 'C455',
  'CENEDA': 'C460',
  'CENESI': 'C462',
  'CENGLES * TSCHENGLS': 'C464',
  'CENOVA': 'C465',
  'CENTEMERO': 'C468',
  'CENTRISOLA': 'C473',
  'CEPINO': 'C475',
  'CEPPEDA': 'C477',
  'CERCHIARA DI SABINA': 'C490',
  'CERCHIATE': 'C491',
  'CEREDA': 'C499',
  'CERNIZZA GORIZIANA': 'C519',
  'CERNUSCO MONTEVECCHIA': 'C522',
  'CERRO LAGO MAGGIORE': 'C535',
  'CERVAROLO': 'C546',
  'CESCLANS': 'C570',
  'CESELLI': 'C571',
  'CESELLO BRIANZA': 'C572',
  'CESI': 'C575',
  'CESNOLA': 'C579',
  'CETO-CERVENO': 'C586',
  'CEVES * TSCHOEFS': 'C590',
  'CHALLANT SAINT ANSELME ET CHALLANT SAINT VICTOR': 'C592',
  'CHAMPLAS DU COL': 'C597',
  'CHERSO': 'C601',
  'CHIABRANO': 'C602',
  'CHIAIANO ED UNITI': 'C603',
  'CHIANCHETELLE': 'C607',
  'CHIAPOVANO': 'C611',
  'CHIARAVALLE MILANESE': 'C617',
  'CHIAVAZZA': 'C622',
  'CHIENIS': 'C626',
  'CHIGNOLO VERBANO': 'C636',
  'CHIOSI D\'ADDA VIGADORE': 'C642',
  'CHIOSI DI PORTA D\'ADDA': 'C643',
  'CHIOSI PORTA CREMONESE': 'C644',
  'CHIOSI PORTA REGALE': 'C645',
  'CHIOSI UNITI CON BOTTEDO': 'C646',
  'CHIRIGNAGO': 'C647',
  'CHIUSO': 'C664',
  'CHIZZOLA': 'C666',
  'CIAGO': 'C667',
  'CIARDES * TSCHARS': 'C671',
  'CIGNANO': 'C682',
  'CIGNONE': 'C683',
  'CILIVERGHE': 'C687',
  'CIMA': 'C688',
  'CIMAMULERA': 'C690',
  'CIMBERGO-PASPARDO': 'C692',
  'CIMBRO': 'C693',
  'CINISELLO': 'C706',
  'CIRCHINA': 'C720',
  'CIREGGIO': 'C721',
  'CISERIIS': 'C731',
  'CISORE': 'C736',
  'ISSENGO * ISSING': 'C737',
  'CITTANOVA D\'ISTRIA': 'C748',
  'CIVELLO': 'C753',
  'CIVIDATE-MALEGNO': 'C761',
  'CIVIGLIO': 'C762',
  'CIVITELLA LICINIO': 'C775',
  'CIZZAGO': 'C786',
  'CLANA': 'C788',
  'CLUSANE SUL LAGO': 'C798',
  'CLUSIO * SCHLEIS': 'C799',
  'COAZZANO': 'C802',
  'COBBIA': 'C805',
  'COCCONITO': 'C808',
  'COCQUIO': 'C809',
  'COGNOLA': 'C822',
  'COGOLO': 'C825',
  'COIMO': 'C827',
  'COIROMONTE': 'C828',
  'COLCAVAGNO': 'C831',
  'COLCIAGO': 'C832',
  'COLDRANO * GOLDRAIN': 'C833',
  'COLDIRODI': 'C834',
  'COLFOSCO * COLFUSCHG': 'C837',
  'SEGNACCO': 'C842',
  'COLLEBACCARO': 'C849',
  'COLLE IN CASIES * PICHL IN GSIES': 'C861',
  'COLLEMANCIO': 'C863',
  'COLLESCIPOLI': 'C873',
  'COLLESTATTE': 'C874',
  'COLLI IN PUSTERIA * PICHLERN': 'C881',
  'COLNAGO': 'C887',
  'COLOGNA': 'C892',
  'COLOGNA CAVAZZO': 'C891',
  'COLOGNOLA DEL PIANO': 'C896',
  'COLOMBARO': 'C898',
  'COLOMBAROLO': 'C899',
  'COL SAN GIOVANNI': 'C906',
  'COLSANO * GALSAUN': 'C907',
  'COLZANO': 'C909',
  'COMAIRANO': 'C913',
  'COMASINE': 'C916',
  'COMENO': 'C921',
  'COMERO': 'C923',
  'COMEZZANO': 'C924',
  'COMNAGO': 'C932',
  'CONCADIRAME': 'C942',
  'CONCENEDO': 'C945',
  'CONCESA': 'C947',
  'CONIO': 'C961',
  'CONSONNO': 'C966',
  'CONTARINA': 'C967',
  'CONTRA': 'C970',
  'COPRENO': 'C981',
  'CORBESATE': 'C985',
  'CORCIAGO': 'C989',
  'CORENNO PLINIO': 'C997',
  'CORGENO': 'D001',
  'CORGNALE': 'D002',
  'CORNELIANO BERTARIO': 'D023',
  'CORNIGLIANO LIGURE': 'D025',
  'CORONA': 'D031',
  'CURON * GRAUN': 'D032',
  'CORPI SANTI DI CREMONA': 'D034',
  'CORPI SANTI DI MILANO': 'D035',
  'CORPI SANTI DI PAVIA': 'D036',
  'CORREZZO': 'D039',
  'CORTABBIO': 'D047',
  'CORTE': 'D053',
  'CORTE DE\' CORTESI': 'D055',
  'CORTI IN PUSTERIA * HOFERN': 'D059',
  'CORTE MADAMA': 'D060',
  'CORTENEDOLO': 'D063',
  'CORTERANZO': 'D069',
  'CORTE SANT\'ANDREA': 'D070',
  'CORTETANO': 'D071',
  'CORTICELLE PIEVE': 'D073',
  'CORTILE SAN MARTINO': 'D074',
  'CORVARA IN PASSIRIA * RABENSTEIN': 'D080',
  'CORCES * KORTSCH': 'D083',
  'COSBANA NEL COLLIO': 'D084',
  'COSSANA': 'D090',
  'DUE COSSANI': 'D091',
  'COSSILA': 'D097',
  'COSSIRANO': 'D098',
  'COSTA DI ONEGLIA': 'D104',
  'COSTA AL LAMBRO': 'D106',
  'COSTA SANT\'ABRAMO': 'D115',
  'COSTASAVINA': 'D116',
  'COVELO': 'D125',
  'CRANA': 'D129',
  'CRANA CATTUGNO': 'D130',
  'CRAVEGNA': 'D135',
  'CREDA': 'D138',
  'CREDERA': 'D140',
  'CREMEZZANO': 'D146',
  'CREMNAGO': 'D148',
  'CRENNA': 'D152',
  'CRENOVIZZA': 'D153',
  'CRESCENZAGO': 'D155',
  'CRESSOGNO': 'D163',
  'CRETO': 'D164',
  'CREVENNA': 'D167',
  'CREVOLA SESIA': 'D169',
  'CROCE': 'D173',
  'CROCE DI MOSSO': 'D174',
  'CROCETTA': 'D176',
  'CRODO MOZZIO': 'D178',
  'CROSARA': 'D183',
  'CRUGNOLA': 'D190',
  'CRUSINALLO': 'D191',
  'CUQUELLO': 'D212',
  'QUARAZZE * GRATSCH': 'D213',
  'CURDOMO': 'D215',
  'CURNASCO': 'D220',
  'CURSOLO': 'D224',
  'CUVIRONE': 'D240',
  'CUZZAGO': 'D241',
  'DAGNENTE': 'D242',
  'DARDINE': 'D249',
  'DARZO': 'D252',
  'DASIO': 'D254',
  'DEGAGNA': 'D262',
  'DEGGIANO': 'D263',
  'DERCOLO': 'D274',
  'DERGANO': 'D275',
  'DERMULO': 'D276',
  'DESCLA': 'D282',
  'DESENZANO AL SERIO': 'D283',
  'DESERTES': 'D285',
  'DEZZO DI SCALVE': 'D288',
  'DIANO BORELLO': 'D294',
  'DIANO CALDERINA': 'D295',
  'DIGNANO D\'ISTRIA': 'D301',
  'DISSIMO': 'D306',
  'DIVACCIA GROTTE DEL TIMAVO': 'D307',
  'DIVACCIA SAN CANZIANO': 'D308',
  'DOCCIO': 'D313',
  'DOLE': 'D320',
  'DOL GRANDE': 'D322',
  'DOL OTTELZA': 'D326',
  'DOMUSNOVAS CANALES': 'D335',
  'DONADA': 'D337',
  'DONELASCO': 'D340',
  'DONIGALA FENUGHEDU': 'D342',
  'DONIGALA SIURGUS': 'D343',
  'DOSSO BAROARDO': 'D353',
  'DOSSO DE\' FRATI': 'D354',
  'DOZIO': 'D359',
  'DRAGUCCIO': 'D362',
  'DRANO': 'D363',
  'DRESENZA': 'D368',
  'DRUSACCO': 'D375',
  'DUEMIGLIA': 'D378',
  'DUGNANO': 'D381',
  'DUINO': 'D382',
  'DUSINO': 'D387',
  'DUTTOGLIANO': 'D389',
  'ELENA': 'D393',
  'ELLE * ELLEN': 'D396',
  'ELLERA': 'D397',
  'ELSANE': 'D400',
  'ENDENNA': 'D404',
  'ENDINE': 'D405',
  'ENGUISO': 'D409',
  'EORES * AFERS': 'D413',
  'ERBA INCINO': 'D417',
  'ERBANNO': 'D418',
  'ERPELLE-COSINA': 'D425',
  'ERSEL IN MONTE': 'D427',
  'ESCOVEDU': 'D432',
  'ESINO INFERIORE': 'D435',
  'ESINO SUPERIORE': 'D437',
  'ESIO': 'D438',
  'ESMATE': 'D439',
  'FABIASCO': 'D446',
  'FABBRICA DURINI': 'D448',
  'FAETTO': 'D460',
  'FAGNANO SUL NAVIGLIO': 'D466',
  'FALESINA': 'D478',
  'FALLASCOSO': 'D479',
  'FAMIE': 'D485',
  'FARFENGO': 'D498',
  'FARINATE': 'D500',
  'FASANA': 'D507',
  'FAVARO VENETO': 'D515',
  'FAVERZANO': 'D517',
  'FAOGNA DI SOTTO * UNTERFENNBERG': 'D519',
  'FAVRIA-OGLIANICO': 'D521',
  'FELETTO UMBERTO': 'D525',
  'FENGO': 'D533',
  'FENIGLI': 'D534',
  'FENILE': 'D535',
  'FENILS': 'D536',
  'FERRUTA': 'D556',
  'FERTILIA': 'D558',
  'FIANONA': 'D563',
  'FIGINO DI MILANO': 'D580',
  'MIRABELLO COMASCO': 'D581',
  'FIGU': 'D584',
  'FINALBORGO': 'D598',
  'FINALMARINA': 'D601',
  'FINALPIA': 'D602',
  'FINERO': 'D603',
  'FIORENZUOLA DI FOCARA': 'D610',
  'FISTO': 'D616',
  'FIUMANA': 'D618',
  'FIUME': 'D620',
  'FIUMENERO': 'D625',
  'FIUMICELLO URAGO': 'D626',
  'FLECCHIA': 'D632',
  'FLERES * PFLERSCH': 'D633',
  'FOCE': 'D642',
  'FOGNA': 'D647',
  'FOIANA * VOELLAN': 'D648',
  'FOLSOGNO': 'D657',
  'FOLZANO': 'D658',
  'FOMARCO': 'D659',
  'FONDRA': 'D664',
  'FONTANA DEL CONTE': 'D669',
  'FOPPA': 'D687',
  'FORCELLO': 'D692',
  'FORESTO SESIA': 'D698',
  'FORESTO DI SUSA': 'D699',
  'FORNERO': 'D716',
  'FORNI IN VAL D\'ASTICO': 'D721',
  'FORNO': 'D723',
  'FORNO ALPI GRAIE': 'D724',
  'FOROTONDO': 'D729',
  'FOSSA GUAZZONA': 'D739',
  'FOSSARMATO': 'D743',
  'FOSSENO': 'D747',
  'FRACCHIA': 'D753',
  'FRASCATA': 'D772',
  'FRASSINELLO-OLIVOLA': 'D778',
  'FRASSINERE': 'D779',
  'FRAVEGGIO': 'D792',
  'FREROLA': 'D795',
  'FRIGNANO MAGGIORE': 'D800',
  'FRONTIGNANO': 'D806',
  'FRONTONE-SERRA': 'D809',
  'FUIPIANO AL BREMBO': 'D816',
  'FUNDRES * PFUNDERS': 'D820',
  'FURATO': 'D822',
  'FUSINE IN VALROMANA': 'D831',
  'GABBIONETA': 'D833',
  'GABRIA': 'D837',
  'GABROVIZZA': 'D838',
  'GADESCO': 'D840',
  'GAGGINO': 'D846',
  'GAIOLA-MOIOLA': 'D857',
  'GALDO': 'D866',
  'GALLICO': 'D877',
  'GALLINA': 'D880',
  'GALLUZZO': 'D887',
  'GAMBARARE': 'D893',
  'GAMBINA BARCHETTI': 'D900',
  'GANDINI': 'D904',
  'GARABIOLO': 'D908',
  'GARBATOLA': 'D914',
  'GARDOLO': 'D916',
  'GAREGNANO': 'D919',
  'GARGARO': 'D922',
  'GAROFAI': 'D929',
  'GATTERA MAIOCCA': 'D936',
  'GAUNA': 'D939',
  'GAZZADA': 'D950',
  'GAZZANO': 'D953',
  'GAZZELLI': 'D954',
  'GAZZO': 'D955',
  'GERE DEL PESCE': 'D979',
  'GERMANEDO': 'D985',
  'GEROLANUOVA': 'D989',
  'GERRE CHIOZZO': 'D992',
  'GHEVIO': 'E002',
  'GHILARZA-ABBASANTA': 'E005',
  'IONIA': 'E018',
  'GIMINO': 'E032',
  'GINESTRETO': 'E035',
  'GIOIACI': 'E042',
  'GIOVENZANO': 'E046',
  'GODOVICI': 'E073',
  'GOGLIONE SOPRA': 'E075',
  'GOGLIONE SOTTO': 'E076',
  'GOIDO': 'E077',
  'GOLESE': 'E080',
  'GORIANO': 'E095',
  'GORIANO VALLI': 'E097',
  'GORLA PRECOTTO': 'E099',
  'GORNATE SUPERIORE': 'E105',
  'GORRA': 'E108',
  'GORRINO': 'E110',
  'GORZONE': 'E112',
  'GOTTRO': 'E117',
  'GOZZA': 'E119',
  'GRACOVA SERRAVALLE': 'E121',
  'GRADELLA': 'E123',
  'GRAGLIA PIANA': 'E129',
  'GRANCINO': 'E137',
  'GRANDOLA': 'E140',
  'GRAZZANELLO': 'E157',
  'GRECO MILANESE': 'E162',
  'GRESSONEY': 'E166',
  'GRIES * GRIES': 'E174',
  'GRIGNANO': 'E175',
  'GRIGNANO DI POLESINE': 'E176',
  'GRIMALDO * GREINWALDEN': 'E181',
  'GRISIGNANA': 'E183',
  'GRISOLIA CIPOLLINA': 'E186',
  'GRONA': 'E190',
  'GRONTORTO': 'E194',
  'GROPPELLO D\'ADDA': 'E197',
  'GROPPO': 'E198',
  'GROTTE DI SANTO STEFANO': 'E211',
  'GRUMELLO DEI ZANCHI': 'E218',
  'GRUMELLO DEL PIANO': 'E220',
  'GRUMO': 'E225',
  'GUALDRASCO': 'E231',
  'GUARDIA PIEMONTESE TERME': 'E247',
  'GUAZZINA': 'E254',
  'GUDON * GUFIDAUN': 'E257',
  'GUGNANO': 'E260',
  'GUIDOMANDRI': 'E262',
  'GUINZANO': 'E267',
  'GURONE': 'E268',
  'IATRINOLI': 'E275',
  'JAVRE\'': 'E276',
  'IDRESCA D\'ISONZO': 'E277',
  'IDRIA': 'E278',
  'IDRIA DI SOTTO': 'E279',
  'IMBERIDO': 'E286',
  'INCINO': 'E293',
  'INCIRANO': 'E294',
  'INDOVERO': 'E298',
  'INDUNO TICINO': 'E300',
  'INTIMIANO': 'E302',
  'INTRA': 'E303',
  'INVERSO PORTE': 'E312',
  'INVORIO INFERIORE': 'E315',
  'INVORIO SUPERIORE': 'E316',
  'INZINO': 'E318',
  'IOANNIS': 'E319',
  'IPPLIS': 'E322',
  'IRGOLI DI GALTELLI': 'E324',
  'ISOLA BALBA': 'E344',
  'ISOLA COMACINA': 'E347',
  'ISOLA DI FANO': 'E352',
  'ISOLA D\'ISTRIA': 'E355',
  'ISOLA PESCAROLI': 'E357',
  'ISOLA SAN GIULIO': 'E359',
  'ISOLELLA': 'E361',
  'ISOLELLO': 'E362',
  'JERAGO': 'E383',
  'JERAGO CON BESNATE': 'E384',
  'JERAGO CON BESNATE ED ORAGO': 'E385',
  'LACINIGO * LATSCHINIG': 'E399',
  'LAGLESIE SAN LEOPOLDO': 'E404',
  'SAN GIORGIO DI LAGO': 'E408',
  'LAGOSTA': 'E411',
  'LAINO BRUZIO': 'E418',
  'LAMBRATE': 'E427',
  'LANISCHIE MONT\'AQUILA': 'E440',
  'LANZA': 'E442',
  'LAORCA': 'E446',
  'LAPPAGO * LAPPACH': 'E449',
  'LARDERA': 'E453',
  'LASE': 'E460',
  'LAUDES * LAATSCH': 'E477',
  'LAURANA': 'E478',
  'LAVENO': 'E495',
  'LAVINA': 'E499',
  'LAZFONS * LATZFONS': 'E501',
  'VILLABELLA': 'E503',
  'LEDINE': 'E508',
  'LEGGIUNO-SANGIANO': 'E511',
  'LEGNAIA': 'E513',
  'LEGOS': 'E516',
  'LEMNA': 'E521',
  'LENZIMA': 'E533',
  'LENZUMO': 'E534',
  'LESA-BELGIRATE': 'E545',
  'LETOJANNI GALLODORO': 'E556',
  'LEVATA': 'E561',
  'LEVRANGE': 'E567',
  'LEZZA': 'E568',
  'LIBUSSINA': 'E572',
  'LICENGO': 'E575',
  'LICIGNANO DI NAPOLI': 'E577',
  'LICONASCO': 'E579',
  'LICUSATI': 'E580',
  'LIETO COLLE': 'E582',
  'LIMITO': 'E595',
  'LIMONTA': 'E598',
  'LINATE AL LAMBRO': 'E601',
  'LINGUEGLIETTA': 'E603',
  'LINZANICO': 'E604',
  'LISANZA': 'E609',
  'LISCIANO DEL TRONTO': 'E612',
  'LISSAGO': 'E616',
  'LIVEMMO': 'E619',
  'LIZZANA': 'E628',
  'LIZZOLA': 'E631',
  'LOCADI': 'E634',
  'LOCARNO': 'E636',
  'LOCATE BERGAMASCO': 'E637',
  'LOCAVIZZA DI AIDUSSINA': 'E641',
  'LOCAVIZZA DI CANALE': 'E642',
  'LOCCA': 'E643',
  'LODISIO': 'E650',
  'LODRONE': 'E653',
  'LOMANIGA': 'E657',
  'LON': 'E663',
  'LONGARDORE': 'E670',
  'LONGIARU\' * KAMPILL': 'E676',
  'LORENTINO': 'E686',
  'LOSE': 'E696',
  'LOSETO': 'E697',
  'LOTTULO': 'E699',
  'LOVENO GRUMELLO': 'E701',
  'LOVENO SOPRA MENAGGIO': 'E702',
  'LOVER': 'E703',
  'LOZZO': 'E710',
  'LUCERNATE': 'E717',
  'LUCINICO': 'E720',
  'LUCINO': 'E721',
  'LUDRIANO': 'E725',
  'VAZIA': 'E728',
  'LUICO': 'E732',
  'LUIGNANO': 'E733',
  'LUMEZZANE PIEVE': 'E739',
  'LUMEZZANE SAN SEBASTIANO': 'E740',
  'LUMEZZANE SANT\'APOLLONIO': 'E741',
  'LUNDO': 'E744',
  'LUSCIANO E DUCENTA': 'E755',
  'LUSSINGRANDE': 'E765',
  'LUSSINPICCOLO': 'E766',
  'LUTAGO * LUTTACH': 'E768',
  'LUZZANO': 'E771',
  'LUZZOGNO': 'E774',
  'MACCAGNO INFERIORE': 'E776',
  'MACCIO': 'E781',
  'MADERNO': 'E792',
  'MADRANO': 'E796',
  'MADRUZZO': 'E797',
  'MAGGIANICO': 'E802',
  'PORTIO': 'E822',
  'MAGNO SOPRA INZINO': 'E823',
  'MAGOGNINO': 'E824',
  'MAGRAS': 'E826',
  'MAGRE\' * MARGREID': 'E827',
  'MAGRE VICENTINO': 'E828',
  'MAIA ALTA * OBERMAIS': 'E831',
  'MAIA BASSA * UNTERMAIS': 'E832',
  'MALAMOCCO': 'E845',
  'MALBORGHETTO': 'E846',
  'MALCHINA': 'E849',
  'MALGOLO': 'E857',
  'MALLES * MALS': 'E861',
  'MALPOTREMO': 'E867',
  'MALVINO': 'E871',
  'MANDRINO': 'E881',
  'MANGIALUPO': 'E886',
  'MANIGLIA': 'E890',
  'MANTANA * MONTAL': 'E895',
  'MARANO': 'E909',
  'MARANOLA': 'E913',
  'MARANZA * MERANSEN': 'E916',
  'MARASSI': 'E918',
  'MARCALLO': 'E920',
  'MARCELLISE': 'E926',
  'MARCO': 'E935',
  'MARCORENGO': 'E937',
  'MARESEGO': 'E942',
  'MARETA * MAREIT': 'E943',
  'MARGONE': 'E948',
  'MARIANO AL BREMBO': 'E950',
  'MARMORITO': 'E964',
  'MARO CASTELLO': 'E966',
  'MARORE': 'E969',
  'MARTINA OLBA': 'E985',
  'MARZALENGO': 'E996',
  'MASCIAGO MILANESE': 'F008',
  'MASI DI VIGO': 'F014',
  'MASNAGO': 'F018',
  'MASSAMA': 'F031',
  'MASSARI-MELZI': 'F034',
  'MASSA SUPERIORE': 'F036',
  'MASSE DI CITTA\'': 'F038',
  'MASSE DI SAN MARTINO': 'F039',
  'MASSE DI SIENA': 'F040',
  'MASTELLINA': 'F049',
  'MATTARELLO': 'F056',
  'MATTERIA': 'F057',
  'MATTUGLIE': 'F060',
  'MAZIA * MATSCH': 'F062',
  'MAZZO MILANESE': 'F069',
  'MAZZOLENI E FALGHERA': 'F071',
  'MAZZUNNO': 'F072',
  'MEANO': 'F076',
  'MECHEL': 'F077',
  'MEDANA': 'F079',
  'PIEDIPATERNO SUL NERA': 'F090',
  'MELEGNANELLO': 'F099',
  'MELEZET': 'F103',
  'MENDATICA-MONTEGROSSO': 'F124',
  'MENTOULLES': 'F128',
  'MENZAGO': 'F129',
  'MERCUGNANO': 'F142',
  'MERCURAGO': 'F143',
  'MERNA': 'F150',
  'MESTRE': 'F159',
  'MESTRIAGO': 'F160',
  'METTONE': 'F163',
  'MEZZANA CASATI': 'F166',
  'MEZZANA SUPERIORE': 'F169',
  'MEZZANO IMER': 'F177',
  'MEZZANO PARPANESE': 'F178',
  'MEZZANO PASSONE': 'F179',
  'MEZZANO SICCOMARIO': 'F180',
  'MEZZOLAGO': 'F185',
  'MIGIANDONE': 'F195',
  'MIGLIANO': 'F197',
  'MIGNETE': 'F204',
  'MILLAN-SARNES * MILLAND-SARNS': 'F211',
  'MILLAURES': 'F212',
  'MILZANELLO': 'F215',
  'MINOPRIO': 'F222',
  'MIOLA': 'F227',
  'MIONE': 'F228',
  'MIRABELLO CIRIA': 'F234',
  'MIRABELLO SAN BERNARDINO': 'F236',
  'MIRABELLO ED UNITI DI PAVIA': 'F237',
  'MISANO OLONA': 'F245',
  'MIZZOLE': 'F252',
  'MOANO': 'F253',
  'MOCCHIE': 'F255',
  'MOERNA': 'F264',
  'MOIANA': 'F273',
  'MOLASSANA': 'F282',
  'MOLINA': 'F285',
  'MOLINI DI COLOGNOLA': 'F289',
  'MOLINI DI TURES * MUEHLEN': 'F291',
  'MOLINO ALZANO': 'F292',
  'MOLLARO': 'F296',
  'MOLLIERES': 'F298',
  'MOLO DI BORBERA': 'F300',
  'MONTEGRAZIE': 'F302',
  'MOLTEDO SUPERIORE': 'F303',
  'MOMBELLO LAGO MAGGIORE': 'F314',
  'MOMPIANO': 'F321',
  'MONASTEROLO TORINESE': 'F331',
  'MONATE': 'F334',
  'NOVELLO MONCHIERO': 'F339',
  'MONCUCCO VECCHIO': 'F344',
  'MONCUCCO DI MONZA': 'F345',
  'MONDONICO': 'F349',
  'MONDONIO': 'F350',
  'MONDRONE': 'F353',
  'MONGHEZZO DI FUORI * GETZENBERG': 'F362',
  'MONGIARDINO SILLARO': 'F366',
  'MONTADAMO': 'F389',
  'MONTALERO': 'F412',
  'MONTALFOGLIO': 'F413',
  'MONTALTO TARUGO': 'F418',
  'MONTANARA': 'F421',
  'MONTANO COMASCO': 'F425',
  'MONTASSILONE * TESSELBERG': 'F431',
  'MONTESIRO': 'F435',
  'MONTE DI MEZZODI\' * SONNENBERG': 'F436',
  'MONTE DI TRAMONTANA * NOERDERSBERG': 'F438',
  'MONTEBELLO METAURENSE': 'F439',
  'MONTE BOLOGNOLA': 'F444',
  'MONTECALVO DEL CASTELLANO': 'F447',
  'MONTECALVOLI': 'F451',
  'MONTECATINI VAL DI NIEVOLE': 'F459',
  'MONTECELIO': 'F466',
  'MONTECHIARO * LICHTENBERG': 'F470',
  'MONTECHIARO DENICE': 'F472',
  'MONTE DI CAPODISTRIA': 'F485',
  'MONTEFABBRI': 'F490',
  'MONTEFONTANA * TOMBERG': 'F505',
  'MONTEGIOVE': 'F521',
  'MONTEGRINO': 'F525',
  'MONTEGUIDUCCIO': 'F530',
  'MONTELEONE SUI COLLI PAVESI': 'F539',
  'MONTEMAGGIORE': 'F554',
  'MONTE MONTANARO': 'F571',
  'MONTENATE': 'F575',
  'MONTENERO D\'IDRIA': 'F577',
  'MONTE OLIMPINO': 'F583',
  'MONTE OSSOLANO': 'F584',
  'MONTEPONENTE * PFEFFERSBERG': 'F588',
  'MONTEROLO': 'F602',
  'MONTERUBBIAGLIO': 'F613',
  'MONTES': 'F615',
  'MONTE SAN CANDIDO * INNICHBERG': 'F617',
  'MONTESANO AL PIANO': 'F624',
  'MONTE SANTA MARIA IN SABINA': 'F630',
  'MONTESANTO VIGI': 'F633',
  'MONTESECCO ANTICO': 'F643',
  'MONTESICURO': 'F645',
  'MONTESILVANO MARINA': 'F647',
  'MONTESPINO': 'F649',
  'MONTESTRUTTO': 'F650',
  'MONTE URABICE': 'F652',
  'MONTEVECCHIO': 'F658',
  'MONTEVIASCO': 'F663',
  'MONTICELLI RIPA D\'OGLIO': 'F673',
  'MONTIGLIO': 'F678',
  'MONTONA': 'F683',
  'MONTONATE': 'F684',
  'MONTORIO VERONESE': 'F691',
  'MONTORSO': 'F695',
  'MONTRIGIASCO': 'F699',
  'MONTRONE': 'F700',
  'MONTU\' BERCHIELLI': 'F702',
  'MORCA': 'F714',
  'MOREGNANO': 'F719',
  'MORONDO': 'F741',
  'MOROSOLO': 'F742',
  'MORSENCHIO': 'F752',
  'MORTANO': 'F753',
  'MORTASO': 'F755',
  'MORTER * MORTER': 'F757',
  'MORTIZZA': 'F759',
  'MOSCHIENA': 'F763',
  'MOSSO SANTA MARIA': 'F769',
  'MOTTA SAN DAMIANO': 'F778',
  'MOTTA VIGANA': 'F782',
  'MOZZANO': 'F787',
  'MOZZIO': 'F790',
  'MU': 'F792',
  'MUCENO': 'F794',
  'MUGGIANO': 'F796',
  'MULARGIA': 'F800',
  'MULES * MAULS': 'F803',
  'MULTEDO': 'F805',
  'MURANO': 'F807',
  'MURIAGLIO': 'F812',
  'MUSADINO': 'F819',
  'MUSCOLO-STRASSOLDO': 'F821',
  'MUSELLARO': 'F823',
  'MUSIANO': 'F824',
  'MUSIGNANO': 'F825',
  'MUSOCCO': 'F827',
  'NACLA SAN MAURIZIO': 'F834',
  'NAVA': 'F850',
  'NAVONO': 'F854',
  'NAZ * NATZ': 'F855',
  'NEGARINE': 'F860',
  'NERESINE': 'F869',
  'NERVI': 'F873',
  'NESE': 'F875',
  'NETTUNIA': 'F879',
  'NICASTRO': 'F888',
  'NIGOLINE-BONOMELLI': 'F896',
  'NIGUARDA': 'F897',
  'NIZZOLINA': 'F903',
  'NOARNA': 'F905',
  'NOCCO': 'F909',
  'NOGARE\'': 'F919',
  'NOMESINO': 'F928',
  'NORIGLIO': 'F936',
  'NOSADELLO': 'F938',
  'NOSEDO': 'F940',
  'NOVACELLA * NEUSTIFT': 'F945',
  'NOVALE': 'F946',
  'NOVAREGLIA': 'F953',
  'NOVATE BRIANZA': 'F954',
  'NOVEGRO': 'F959',
  'NOVILARA': 'F969',
  'NOZZA': 'F971',
  'NUCHIS': 'F973',
  'NURAXINIEDDU': 'F984',
  'OLATE': 'G013',
  'OLBA': 'G014',
  'OLCIO': 'G017',
  'OLGIA': 'G024',
  'OLGIATE CALCO': 'G027',
  'OLGINASIO': 'G029',
  'TAVERNETTE': 'G033',
  'OLIVASTRI': 'G035',
  'OLIVETO IN SABINA': 'G038',
  'OLTREPOVO': 'G051',
  'OLTRESARCA': 'G052',
  'OLTRESONZIA': 'G053',
  'OLTRESSENDA BASSA': 'G055',
  'OLTRONA AL LAGO': 'G057',
  'OMATE': 'G059',
  'OMBRIANO': 'G060',
  'ONEGLIA': 'G067',
  'ONIES * ONACH': 'G069',
  'ONNO': 'G072',
  'ONO DEGNO': 'G073',
  'OPACCHIASELLA': 'G077',
  'ORASSO': 'G085',
  'ORCO': 'G091',
  'ORENO': 'G092',
  'OREZZO': 'G094',
  'ORIANO': 'G099',
  'ORIANO DI BRIANZA': 'G100',
  'ORIANO SOPRA TICINO': 'G101',
  'ORIGIOSO': 'G104',
  'ORINO AZZIO': 'G106',
  'ORIS * EYRS': 'G112',
  'ORSERA': 'G127',
  'ORTA NOVARESE': 'G132',
  'ORTI': 'G138',
  'OSOLI': 'G162',
  'OSSALENGO': 'G172',
  'OSSANESGA': 'G174',
  'OSSECCA VITTUGLIA': 'G175',
  'OSSEGLIANO SAN MICHELE': 'G176',
  'OSSERO': 'G177',
  'OSSOLARO': 'G180',
  'PADERNELLO': 'G216',
  'PADERNO CREMONESE': 'G219',
  'PAGANICA': 'G231',
  'PAGLIARE': 'G235',
  'PAGLIERES': 'G236',
  'PAGNANO VALSASSINA': 'G239',
  'PAINA': 'G244',
  'PAIRANA': 'G245',
  'PAISCO': 'G246',
  'PALANZO': 'G256',
  'PALAZZOLO MILANESE': 'G265',
  'PALAZZO PIVERONE': 'G269',
  'PALLANZA': 'G279',
  'PALVARETO': 'G301',
  'PANIQUA': 'G310',
  'PANNONE': 'G313',
  'PANTASINA': 'G314',
  'PAPIAGO': 'G321',
  'PAPIGNO': 'G322',
  'PARACORIO': 'G326',
  'PARENZO': 'G332',
  'PARONA DI VALPOLICELLA': 'G341',
  'PARONE': 'G343',
  'PARRAVICINO': 'G345',
  'PASCELUPO': 'G351',
  'PASSARERA': 'G355',
  'RIVOLTO': 'G356',
  'PASSERANO': 'G357',
  'PASSIRANA MILANESE': 'G360',
  'PASTENE': 'G363',
  'PASTURAGO': 'G366',
  'PATERNO D\'ANCONA': 'G369',
  'PATONE': 'G373',
  'PATRIGNONE': 'G375',
  'PAUGNANO': 'G380',
  'PAVONE D\'ALESSANDRIA': 'G390',
  'PEDANEA': 'G401',
  'PEDAVOLI': 'G405',
  'PEDERSANO': 'G409',
  'PEDRIANO': 'G413',
  'PEGLI': 'G414',
  'PELLARO': 'G422',
  'PELLEGRINO DA CAREGGI': 'G423',
  'PELLESTRINA': 'G425',
  'PENZANO': 'G440',
  'PERNO': 'G460',
  'PERA': 'G464',
  'PERRILLO': 'G466',
  'PERSICO': 'G468',
  'PERSONE': 'G470',
  'PERTEOLE': 'G472',
  'PERTI': 'G473',
  'PESCHIERA MARAGLIO': 'G490',
  'PESSANO': 'G501',
  'PESSINA VALSASSINA': 'G503',
  'PEVERANZA': 'G527',
  'PEZZOLO DE\' CODAZZI': 'G530',
  'PEZZOLO DI TAVAZZANO': 'G531',
  'PEZZORO': 'G533',
  'PIAGGINE SOPRANE': 'G539',
  'PIANAVIA': 'G544',
  'PIANCERI': 'G548',
  'PIAN D\'ARTOGNE': 'G550',
  'PIANE SESIA': 'G554',
  'PIAN GAIANO': 'G562',
  'PIANI': 'G563',
  'PIANO PORLEZZA': 'G567',
  'PIANO': 'G569',
  'PIANURA': 'G573',
  'PIAVON': 'G578',
  'PIAZZA SANTO STEFANO': 'G581',
  'PIAZZO': 'G584',
  'PIAZZO ALTO': 'G585',
  'PIAZZO BASSO': 'G586',
  'PIEDILUCO': 'G595',
  'PIEDIMONTE DEL CALVARIO': 'G599',
  'PIETRA GAVINA': 'G617',
  'PIEVE DELMONA': 'G640',
  'PIEVE SAN MAURIZIO': 'G652',
  'PIEVE TERZAGNI': 'G655',
  'PILCANTE': 'G667',
  'PILZONE': 'G668',
  'PINGUENTE': 'G675',
  'PINZANO': 'G679',
  'PIONE': 'G689',
  'PIRANO': 'G700',
  'PIRRI': 'G701',
  'PISCINOLA': 'G706',
  'PISCOPIO': 'G708',
  'PISINO': 'G709',
  'PISSARELLO': 'G711',
  'PISTOLESA': 'G714',
  'PIZZOCORNO': 'G723',
  'PIZZOLANO': 'G725',
  'PLANOL * PLANEIL': 'G730',
  'PLANINA': 'G731',
  'PLATA * PLATT': 'G732',
  'PLEZZO': 'G738',
  'PLISCOVIZZA DELLA MADONNA': 'G739',
  'POCRAI DEL PERO': 'G744',
  'PODARGONI': 'G745',
  'PODRAGA': 'G748',
  'POGGI': 'G750',
  'POGGIO FIDONI': 'G759',
  'POLA': 'G778',
  'POLENGO': 'G781',
  'POMETO': 'G810',
  'PONCARALE FLERO': 'G819',
  'PONTAGNA': 'G824',
  'PONTEBBA NOVA': 'G832',
  'PONTE CARATE': 'G835',
  'PONTEDECIMO': 'G841',
  'PONTE DI NOSSA': 'G845',
  'PONTESESTO': 'G857',
  'PONTICELLI': 'G863',
  'PONTIROLO CAPREDONI': 'G868',
  'PONZATE': 'G876',
  'POR': 'G880',
  'PORCHIA': 'G883',
  'PORCHIANO DEL MONTE': 'G884',
  'PORCHIANO DELL\'ASCENSIONE': 'G885',
  'PORTA AL BORGO': 'G892',
  'PORTA CARRATICA': 'G893',
  'PORTA LUCCHESE': 'G896',
  'PORTA OMBRIANO': 'G897',
  'PORTARIA': 'G898',
  'PORTA SAN MARCO': 'G899',
  'PORTESE': 'G901',
  'PORTO D\'ADDA': 'G908',
  'PORTO CIVITANOVA': 'G911',
  'PORTOLE': 'G915',
  'PORTO MAURIZIO': 'G918',
  'PORZANO': 'G928',
  'POSCANTE': 'G930',
  'POSTICCIOLA': 'G938',
  'POSTUMIA GROTTE': 'G941',
  'POVERIO': 'G946',
  'POVO': 'G948',
  'POZZAGLIO': 'G952',
  'POZZO ALTO': 'G956',
  'POZZO BARONZIO': 'G958',
  'PRA': 'G967',
  'PRADO': 'G971',
  'PRANDAGLIO': 'G983',
  'PRANZO': 'G984',
  'PRATI * WIESEN': 'G996',
  'PRATO MUZIO': 'G998',
  'PRATO ALLA DRAVA * WINNEBACH': 'H003',
  'PRATOVECCHIO-STIA': 'H009',
  'PRE\'': 'H012',
  'PRECOTTO': 'H016',
  'PREGASINA': 'H023',
  'PREGHENA': 'H024',
  'PREGLIA': 'H025',
  'PREMENUGO': 'H031',
  'PREMEZZO': 'H032',
  'PREMIONE': 'H035',
  'PREQUARTERA': 'H041',
  'PRESEGNO': 'H044',
  'PRESSON': 'H049',
  'PRESTINONE': 'H051',
  'PRETURO': 'H053',
  'PREVACINA': 'H054',
  'PRIACCO': 'H058',
  'PRIERO-MONTEZEMOLO': 'H060',
  'PRIMANO': 'H064',
  'PRIMEGLIO SCHIERANO': 'H065',
  'PRIMIERO': 'H066',
  'PRIO\'': 'H067',
  'PROSPIANO': 'H075',
  'PROVAGLIO SOPRA': 'H079',
  'PROVAGLIO SOTTO': 'H080',
  'PROVEZZE': 'H082',
  'PRUN': 'H084',
  'PURIA': 'H093',
  'QUAGLIETTA': 'H099',
  'QUARNA': 'H105',
  'QUARTI': 'H111',
  'QUARTIANO': 'H112',
  'QUARTO ASTESE': 'H113',
  'QUARTO DEI MILLE': 'H115',
  'QUARTO CAGNINO': 'H116',
  'QUETTA': 'H125',
  'QUINTO DI VALPANTENA': 'H133',
  'QUINTO AL MARE': 'H135',
  'QUINTODECIMO': 'H136',
  'QUINTO ROMANO': 'H137',
  'QUINTOSOLE': 'H138',
  'QUINZANELLO': 'H139',
  'QUINZANO SAN PIETRO': 'H141',
  'QUINZANO VERONESE': 'H142',
  'QUISTRO': 'H144',
  'RACCOLANA': 'H149',
  'RADICENA': 'H155',
  'RAFFA': 'H158',
  'RAGGIOLO': 'H160',
  'RAGUSA IBLA': 'H164',
  'RISCONE * REISCHACH': 'H167',
  'RAMO DI PALO': 'H169',
  'RAMPONIO': 'H170',
  'RANCIO DI LECCO': 'H172',
  'RANZIANO': 'H178',
  'RANZI PIETRA': 'H179',
  'RASUN DI SOPRA * OBERRASEN': 'H190',
  'RASUN DI SOTTO * NIEDERRASEN': 'H191',
  'RATECEVO IN MONTE': 'H193',
  'RAVELLINO': 'H197',
  'RAVINA': 'H201',
  'REBBIO': 'H208',
  'REBECCU': 'H209',
  'RECORFANO': 'H215',
  'REDONA': 'H217',
  'REGINA FITTAREZZA': 'H226',
  'REMEDELLO SOPRA': 'H231',
  'REMEDELLO SOTTO': 'H232',
  'RENATE VEDUGGIO': 'H234',
  'RUPINGRANDE': 'H237',
  'RESCALDA': 'H239',
  'RESIA * RESCHEN': 'H241',
  'FOLAS-REVIAN': 'H249',
  'REVIGLIASCO TORINESE': 'H251',
  'REVINE': 'H252',
  'REZZONICO': 'H260',
  'RHEMES': 'H261',
  'RICLARETTO': 'H278',
  'RIDANNA * RIDNAUN': 'H279',
  'RIFEMBERGO': 'H283',
  'RIGOSA': 'H290',
  'RINA * WELSCHELLEN': 'H295',
  'RINCO': 'H296',
  'RIO MOLINO * MUEHLBACH': 'H306',
  'RIOZZO': 'H309',
  'RIPABERARDA': 'H310',
  'RIPALTA NUOVA': 'H317',
  'RIPALTA VECCHIA': 'H318',
  'RIVA DI TURES * REIN': 'H332',
  'RIVAROLO LIGURE': 'H339',
  'RIVA SANTO STEFANO': 'H345',
  'RIVERA': 'H349',
  'RIVIERA D\'ADDA': 'H351',
  'RIVOLTELLA SUL GARDA': 'H358',
  'ROBBIANO': 'H368',
  'ROBECCHETTO': 'H370',
  'ROBECCO LODIGIANO': 'H374',
  'ROCCA PIETRA': 'H381',
  'ROCCACARAMANICO': 'H388',
  'ROCCA DEL COLLE': 'H397',
  'ROCCAGUGLIELMA': 'H415',
  'ROCCALVECCE': 'H419',
  'ROCCAPIATTA': 'H430',
  'ROCCAREONILE': 'H435',
  'ROCCHEMOLLES': 'H457',
  'ROCCHETTA CAIRO': 'H463',
  'ROCCHETTA CENGIO': 'H464',
  'ROCCHETTE IN SABINA': 'H469',
  'RODDA': 'H471',
  'RODENGO': 'H476',
  'RODITTI': 'H482',
  'RODORETTO': 'H483',
  'ROGGIANO VALTRAVAGLIA': 'H487',
  'ROIO PIANO': 'H496',
  'ROLLIERES': 'H499',
  'ROMAGNANO': 'H504',
  'ROMANO BRIANZA': 'H510',
  'ROMANS': 'H513',
  'ROMARZOLLO': 'H515',
  'ROMPREZZAGNO': 'H520',
  'RONCA DE\' GOLFERANI': 'H524',
  'RONCADELLO D\'ADDA': 'H526',
  'RONCHETTO': 'H530',
  'RONCOGNO': 'H543',
  'RONGIO': 'H548',
  'RONZINA': 'H550',
  'RONZO': 'H551',
  'ROSALI': 'H557',
  'ROSCIATE': 'H563',
  'ROSERIO': 'H567',
  'ROSINGO': 'H571',
  'ROSORA MERGO': 'H576',
  'ROSSINO': 'H582',
  'ROTA DENTRO': 'H586',
  'ROTA FUORI': 'H587',
  'ROVAGNASCO': 'H595',
  'ROVATE': 'H597',
  'ROVEGRO': 'H600',
  'ROVENNA': 'H603',
  'ROVER CARBONARE': 'H605',
  'ROVERSANO': 'H613',
  'ROVETTA CON FINO': 'H616',
  'ROVEZZANO': 'H617',
  'ROVIGNO D\'ISTRIA': 'H619',
  'ROZZO': 'H624',
  'RUBBIANO': 'H626',
  'RUGINELLO': 'H636',
  'RUMIANCA': 'H638',
  'RUNO': 'H640',
  'SABBIO BERGAMASCO': 'H649',
  'SABBIONCELLO': 'H651',
  'SABLE GRANDE': 'H653',
  'SACCONAGO': 'H656',
  'SAGA': 'H660',
  'SAGLIANO DI CRENNA': 'H663',
  'SAGORIA': 'H664',
  'SAGUEDO': 'H667',
  'SAIANO': 'H668',
  'SALA AL BARRO': 'H680',
  'SALABUE': 'H685',
  'SALCANO': 'H692',
  'SALE CANISCHIO': 'H696',
  'SALE CASTELNUOVO': 'H697',
  'SALECCHIO': 'H698',
  'SALICE CALABRO': 'H709',
  'SALINA': 'H711',
  'SALONA D\'ISONZO': 'H718',
  'SALTO': 'H722',
  'SALVATERRA': 'H728',
  'SAMARIA': 'H737',
  'SAMBASSO': 'H740',
  'SAMBATELLO': 'H741',
  'SAMBIASE': 'H742',
  'SAMBUCO PIETRAPORZIO': 'H747',
  'SAMBUGHETTO': 'H748',
  'SAMOCLEVO': 'H750',
  'SAMO DI CALABRIA': 'H751',
  'SAN BARBATO': 'H758',
  'SAN BARTOLOMEO': 'H759',
  'SAN BARTOLOMEO AL BOSCO': 'H761',
  'SAN BARTOLOMEO VALMARA': 'H762',
  'SAN BERNARDINO': 'H776',
  'SAN CARLO D\'OSSOLA': 'H788',
  'SAN DAMIANO DI MONZA': 'H813',
  'SAN DANIELE DEL CARSO': 'H817',
  'SAN DONATO D\'ENZA': 'H828',
  'SAN FELICE DI SCOVOLO': 'H832',
  'SAN FELICE * SANKT FELIX': 'H837',
  'SAN FRANCESCO D\'ALBARO': 'H849',
  'SAN FRUTTUOSO': 'H853',
  'SAN GALLO': 'H854',
  'SAN GERVASIO D\'ADDA': 'H864',
  'SAN GIACOMO * SANKT JAKOB IN AHRN': 'H866',
  'SAN GIACOMO': 'H869',
  'SAN GIACOMO IN COLLE': 'H871',
  'SAN GILLIO TORINESE': 'H874',
  'SAN GIORGIO * SANKT GEORG': 'H879',
  'SAN GIOVANNI * SANKT JOHANN IN AHRN': 'H902',
  'SAN GIOVANNI PELLICE': 'H904',
  'SAN GIOVANNI ALLA CASTAGNA': 'H905',
  'SAN GIOVANNI A TEDUCCIO': 'H908',
  'SAN GIOVANNI BATTISTA': 'H909',
  'SAN GIOVANNI DI GALERNO': 'H915',
  'SAN GIOVANNI REATINO': 'H925',
  'SAN GIULIANO': 'H927',
  'SAN GIUSEPPE DI CASTO': 'H932',
  'VILLA SAN GIUSEPPE': 'H934',
  'SAN LAZZARO REALE': 'H946',
  'SAN LAZZARO ALBERONI': 'H947',
  'SAN LAZZARO PARMENSE': 'H948',
  'SAN LEONARDO * SANKT LEONHARD': 'H950',
  'SAN LEUCIO': 'H954',
  'SAN LORENZO AROLDO': 'H960',
  'SAN LORENZO DE\' PICENARDI': 'H963',
  'SAN LORENZO GUAZZONE': 'H965',
  'SAN LORENZO MONDINARI': 'H968',
  'SAN LUGANO': 'H972',
  'SAN MARCO A MONTI': 'H983',
  'SAN MARTINO IN VALLE': 'H993',
  'SAN MARTINO AL CIMINO': 'H995',
  'SAN MARTINO DI PERRERO': 'H998',
  'SAN MARTINO AL MONTE * SANKT MARTIN AM VORBERG': 'I001',
  'SAN MARTINO D\'ALBARO': 'I004',
  'SAN MARTINO DE\' CALVI': 'I006',
  'SAN MARTINO IN BELISETO': 'I009',
  'SAN MARTINO IN CASIES * SANKT MARTIN IN GSIES': 'I010',
  'SAN MARTINO QUISCA': 'I013',
  'SAN MARTINO SINZANO': 'I015',
  'SAN MARZANO MOASCA': 'I020',
  'SAN MARZANOTTO': 'I021',
  'SAN MASSIMO ALL\'ADIGE': 'I022',
  'SAN MICHELE D\'ASTI': 'I033',
  'SAN MICHELE CREMASCO': 'I036',
  'SAN MICHELE PRAZZO': 'I038',
  'SAN MICHELE IN TEVERINA': 'I039',
  'SAN MICHELE EXTRA': 'I041',
  'SAN MICHELE DELLE BADESSE': 'I043',
  'SAN MICHELE DI POSTUMIA': 'I044',
  'SAN NAZZARO MELLA': 'I050',
  'SAN NICANDRO D\'AQUILA': 'I055',
  'SAN NOVO': 'I064',
  'SAN PANCRAZIO AL COLLE': 'I067',
  'SAN PANCRAZIO PARMENSE': 'I068',
  'SAN PANTALEO': 'I069',
  'SAN PAOLO DELLA VALLE': 'I070',
  'SAN PAOLO RIPA D\'OGLIO': 'I075',
  'SAN PEDRINO': 'I077',
  'SAN PELAGIO': 'I078',
  'SAN PERONE': 'I080',
  'SAN PIER D\'ARENA': 'I081',
  'SAN PIER FEDELE': 'I083',
  'SAN PIETRO * SANKT PETER': 'I087',
  'SAN PIETRO DI GORIZIA': 'I091',
  'SAN PIETRO A PATIERNO': 'I094',
  'SAN PIETRO BESTAZZO': 'I097',
  'SAN PIETRO CUSICO': 'I099',
  'SAN PIETRO DEL CARSO': 'I100',
  'SAN PIETRO DI BARBOZZA': 'I101',
  'SAN PIETRO DI MONTEROSSO': 'I104',
  'SAN PIETRO D\'ORZIO': 'I106',
  'SAN PIETRO IN CUROLIS': 'I111',
  'SAN PIETRO IRPINO': 'I112',
  'SAN PONZO SEMOLA': 'I127',
  'SAN QUIRICO IN VAL DI POLCEVERA': 'I134',
  'SAN SALVATORE': 'I146',
  'SAN SAVINO': 'I149',
  'SAN SIGISMONDO * SANKT SIGMUND': 'I159',
  'SAN SILLO': 'I160',
  'SAN SILVESTRO': 'I161',
  'SANT\'ABBONDIO': 'I167',
  'SANTA CROCE DI AIDUSSINA': 'I180',
  'SANT\'EUFEMIA DELLA FONTE': 'I186',
  'SANT\'AGATA MARTESANA': 'I194',
  'SANT\'AGATA SOPRA CANNOBIO': 'I195',
  'SANT\'AGATA IRPINA': 'I200',
  'SANTA GIULIA': 'I204',
  'SANT\'ALBANO DI BOBBIO': 'I211',
  'SANT\'ALESSANDRO': 'I212',
  'SANTA LUCE-ORCIANO': 'I218',
  'SANTA LUCIA D\'ISONZO': 'I222',
  'SANTA MADDALENA IN CASIES * SANKTA MAGDALENA IN GSIES': 'I223',
  'SANTA MARGHERITA DI BOBBIO': 'I227',
  'SANTA MARGHERITA PO': 'I228',
  'SANTA MARGHERITA': 'I229',
  'SANTA MARIA DEL TRONTO': 'I231',
  'SANTA MARIA DELLA CROCE': 'I235',
  'SANTA MARIA DEL MONTE': 'I239',
  'SANTA MARIA DI ROVAGNATE': 'I241',
  'SANTA MARIA IN PRATO': 'I245',
  'SANTA MARIA IN STELLE': 'I246',
  'SANTA MARIA MAGGIORE E CRANA': 'I250',
  'SANTA MARIA REZZONICO': 'I252',
  'SANT\'AMBROGIO-OLONA': 'I257',
  'SANT\'ANDREA DI SUASA': 'I268',
  'SANT\'ANDREA DI GORIZIA': 'I269',
  'SANT\'ANDREA DI VALLEFREDDA': 'I270',
  'SANT\'ANDREA IN MONTE * SANKT ANDRAE': 'I272',
  'SANT\'ANTONINO TICINO': 'I295',
  'SANT\'ANTONIO D\'ADDA': 'I297',
  'SANT\'ANTONIO A TREBBIA': 'I299',
  'SANT\'APOLLINARE CON SELVA': 'I303',
  'SANTA VALERIA': 'I313',
  'SANT\'ELIA REATINO': 'I323',
  'SANT\'ELPIDIO MORICO': 'I325',
  'SANT\'ERASMO': 'I331',
  'SANT\'EUFEMIA LAMEZIA': 'I334',
  'SANTICOLO': 'I338',
  'SANT\'ILARIO LIGURE': 'I340',
  'SANTINO': 'I343',
  'SANTO SPIRITO DELLA BAINSIZZA': 'I355',
  'SANTO STEFANO DEL MONTE DEGLI ANGELI': 'I358',
  'SANTO STEFANO AL MARE CON CASTELLARO': 'I366',
  'SANTO STEFANO DI BRIGA': 'I369',
  'SAN VALENTINO AL BRENNERO * BRENNER': 'I378',
  'SAN VALENTINO ALLA MUTTA * SANKT VALENTIN AUF DER HAIDE': 'I379',
  'SAN VARESE': 'I380',
  'SAN VERO CONGIUS': 'I383',
  'SAN VIGILIO': 'I385',
  'SANVINCENTI': 'I386',
  'SAN VINCENZO A VOLTURNO': 'I387',
  'SAN VITO E MODESTO': 'I395',
  'SAN VITO E MARTA': 'I397',
  'SAN VITO IN MONTE': 'I398',
  'SAN VITO SUL CESANO': 'I399',
  'SAN VITO DI VIPACCO': 'I406',
  'SAN ZENO E FOPPA': 'I413',
  'SAONE': 'I419',
  'SARDAGNA': 'I427',
  'SAROLA': 'I440',
  'SARTIRANA BRIANTEA': 'I446',
  'SASSA': 'I450',
  'SASSO DI BORDIGHERA': 'I456',
  'SASSO': 'I458',
  'SAVOULX': 'I481',
  'SCALERES * SCHALDER': 'I488',
  'SCALETTA UZZONE': 'I491',
  'SCANDELUZZA': 'I495',
  'SCANNABUE': 'I500',
  'SCANO AL BREMBO': 'I502',
  'SCANZO': 'I505',
  'SCARENNA': 'I508',
  'SCARIA': 'I509',
  'SCARNAFIGI-RUFFIA': 'I513',
  'SCARPIZZOLO': 'I515',
  'SCIAVES * SCHABS': 'I516',
  'SCAVOLINO': 'I517',
  'SCLEMO': 'I518',
  'SCHEGGIA': 'I521',
  'SCHERBINA': 'I524',
  'SCHIANNO': 'I525',
  'SCHIERANCO': 'I528',
  'SCODAVACCA': 'I542',
  'SCOPPO': 'I547',
  'SCRILLA': 'I552',
  'SEBREGLIE': 'I557',
  'SECONDIGLIANO': 'I560',
  'SEDULA': 'I568',
  'SEGHEBBIA': 'I572',
  'SEGNO': 'I575',
  'SEIO': 'I579',
  'SELINO': 'I583',
  'SELLA DELLE TRINCEE': 'I584',
  'SELLANUOVA': 'I586',
  'SELLERE': 'I587',
  'SENOSECCHIA': 'I616',
  'SEO': 'I617',
  'SEPRIO': 'I620',
  'SERBARIU': 'I623',
  'SERPENIZZA': 'I638',
  'SERRAVALLE D\'ASTI': 'I658',
  'SERRAVALLE': 'I664',
  'SERRAVALLE ALL\'ADIGE': 'I665',
  'SERSO': 'I672',
  'SESANA': 'I674',
  'SESONA': 'I675',
  'SESSANT': 'I680',
  'SESTO PERGOLA': 'I685',
  'SESTO ULTERIANO': 'I691',
  'SESTRI PONENTE': 'I694',
  'SEUNI': 'I708',
  'SEVIGNANO': 'I710',
  'SFORZATICA': 'I713',
  'SIAMANNA SIAPICCIA': 'I719',
  'SICCI SAN BIAGIO': 'I722',
  'SILI': 'I731',
  'SILUM MONT\'AQUILA': 'I733',
  'SILVELLA': 'I740',
  'SINADOLE': 'I746',
  'SIRICO': 'I755',
  'SISINI': 'I762',
  'SIURGUS': 'I764',
  'SIVIANO': 'I766',
  'SLAPPE-ZORZI': 'I768',
  'SLINGIA * SCHLINIG': 'I769',
  'SLIVIA': 'I770',
  'SMERIA': 'I773',
  'SOCCAVO': 'I776',
  'SOLANAS': 'I784',
  'SOLAROLO DEL PERSICO': 'I788',
  'SOLAROLO MONASTEROLO': 'I789',
  'SOLBRITO': 'I795',
  'SOLOGNO': 'I806',
  'SOLOMIAC': 'I807',
  'SOLTARICO': 'I810',
  'SOLTO': 'I811',
  'SOLZAGO': 'I814',
  'SOMANA': 'I816',
  'SOMENDENNA': 'I818',
  'SONZIA': 'I833',
  'SOPRAMONTE': 'I834',
  'SOPRAPONTE': 'I836',
  'SOPRAZOCCO': 'I837',
  'SORBANO': 'I842',
  'SORBOLONGO': 'I846',
  'SORLI': 'I859',
  'SOVAZZA': 'I870',
  'SPADAFORA SAN MARTINO': 'I882',
  'SPADAFORA SAN PIETRO': 'I883',
  'SPERCENIGO': 'I890',
  'SPEZZANO GRANDE': 'I897',
  'SPINGA * SPINGES': 'I900',
  'SPINO AL BREMBO': 'I913',
  'SPINONE': 'I915',
  'SPIRAGO': 'I918',
  'SPOCCIA': 'I920',
  'STABELLO': 'I931',
  'STAGHIGLIONE': 'I933',
  'STAGLIENO': 'I934',
  'STAVA * STABEN': 'I940',
  'STAZZONA-GERMASINO': 'I944',
  'STILO DE\' MARIANI': 'I957',
  'STILVES * STILFES': 'I958',
  'STORIE': 'I961',
  'STRACONDOLO': 'I966',
  'STRADA': 'I967',
  'STRAMBINO ROMANO': 'I971',
  'STRAMENTIZZO': 'I972',
  'STROPINO': 'I983',
  'STRUPPA': 'I987',
  'STUMIAGA': 'I988',
  'STURIA DELLE FUSINE': 'I989',
  'SULBIATE INFERIORE': 'I999',
  'SULBIATE SUPERIORE': 'L001',
  'SUNA': 'L005',
  'SUSA\'': 'L012',
  'TABLA\' * TABLAND': 'L021',
  'TAGLIOLO-BELFORTE': 'L028',
  'TAGLIUNO': 'L029',
  'TAINATE': 'L031',
  'TANAS * TANAS': 'L041',
  'TAPIGLIANO': 'L043',
  'TAPOGLIANO': 'L044',
  'TAPPIA': 'L045',
  'TARCES * TARTSCH': 'L051',
  'TARCETTA': 'L052',
  'TARNOVA DELLA SELVA': 'L053',
  'TARRES * TARSCH': 'L054',
  'TAVAZZANO': 'L068',
  'TAVERNOLA SAN FELICE': 'L072',
  'TAVODO': 'L076',
  'TAVOLE': 'L077',
  'TAVON': 'L079',
  'TAVORDO': 'L080',
  'TELVES * TELFES': 'L091',
  'TEMENIZZA': 'L092',
  'TENDA': 'L095',
  'TEODONE * DIETENHEIM': 'L098',
  'TEODORANO': 'L099',
  'TERMENAGO': 'L110',
  'TERMON': 'L114',
  'TERNOVA D\'ISONZO': 'L119',
  'TERRANOVA DI BISTERZA': 'L128',
  'TERRAROSSA': 'L129',
  'TERRASA': 'L130',
  'TERRATI': 'L133',
  'TERRAZZANO': 'L135',
  'TERZANO': 'L141',
  'TESIDO * TAISTEN': 'L148',
  'TESTACCIO D\'ISCHIA': 'L151',
  'THURES': 'L159',
  'TIARNO': 'L161',
  'TIMOLINE': 'L170',
  'TINA': 'L171',
  'TISO * TEIS': 'L179',
  'TOLMINO': 'L196',
  'TOMADIO': 'L198',
  'TORBA': 'L208',
  'TORBIATO': 'L209',
  'TORMO': 'L222',
  'TORNAVENTO': 'L226',
  'TORRA': 'L232',
  'TORRADELLO': 'L234',
  'TORRAZZA': 'L236',
  'TORRE SAN MARCO': 'L242',
  'TORRE BERETTI': 'L249',
  'TORRE D\'ANGIOLINI': 'L255',
  'TORRE DEL MANGANO': 'L260',
  'TORRE DEL MONTE': 'L261',
  'TORRE DE\' RATTI': 'L264',
  'TORRE DE\' TORTI': 'L266',
  'TORRE DI PALME': 'L268',
  'TORRE ORSINA': 'L275',
  'TORRE UZZONE': 'L283',
  'TORRIA': 'L288',
  'TORRIANO': 'L289',
  'TORRINO': 'L300',
  'TOSCOLANO': 'L311',
  'TOSS': 'L313',
  'TRABUCHELLO': 'L318',
  'TRAFFIUME': 'L320',
  'TRAVEDONA': 'L341',
  'TRAVERSA': 'L343',
  'TRAVERSE': 'L344',
  'TREBBIANO NIZZA': 'L350',
  'TREBECCO': 'L351',
  'TREBIANO MAGRA': 'L352',
  'TRECELLA': 'L358',
  'TREDOSSI': 'L360',
  'TREGASIO': 'L362',
  'TREGOLO': 'L365',
  'TREMEZZINA': 'L370',
  'TRENNO': 'L373',
  'TRENS * TRENS': 'L374',
  'TRENTA D\'ISONZO': 'L376',
  'TRESCHE-CONCA': 'L387',
  'TRESILICO': 'L391',
  'TRETTO': 'L394',
  'TREVANO': 'L395',
  'TREVISAGO': 'L405',
  'TREZZOLASCO': 'L412',
  'TRIBUSSA': 'L417',
  'TRIVULZA': 'L441',
  'TRIVULZINA': 'L442',
  'TROBASO': 'L443',
  'TROGNANO': 'L446',
  'TUENETTO': 'L456',
  'TUNES * THUINS': 'L465',
  'TURAGO BORDONE': 'L467',
  'TURRO MILANESE': 'L476',
  'UBAGA': 'L479',
  'UGOVIZZA VALBRUNA': 'L481',
  'UGGIATE': 'L486',
  'UMAGO': 'L491',
  'UNCHIO': 'L493',
  'URAGO MELLA': 'L495',
  'URIO': 'L504',
  'USMATE': 'L510',
  'USSOLO': 'L518',
  'USTIE': 'L520',
  'VACCARIZZA': 'L523',
  'VAGLIERANO': 'L530',
  'VAGNA': 'L534',
  'VAIANO VALLE': 'L536',
  'VAIRANO CREMASCO': 'L541',
  'VAIRANO PAVESE': 'L542',
  'VALAS * FLAAS': 'L543',
  'VALCHIUSELLA': 'L549',
  'VALDARSA': 'L553',
  'VALGIOVO * JAUFENTAL': 'L559',
  'VALDIGNA D\'AOSTA': 'L560',
  'VALL\'ALTA': 'L585',
  'VALLARGA * WEITENTAL': 'L587',
  'VALLE GUIDINO': 'L592',
  'VALLECROSIA CON SAN BIAGIO DELLA CIMA': 'L600',
  'VALLE D\'ISTRIA': 'L602',
  'VALLELUNGA * LANGTAUFERS': 'L608',
  'VALLENONCELLO': 'L610',
  'VALLES * VALS': 'L615',
  'VALLE SAN FELICE': 'L618',
  'VALLE SAN GIOVANNI': 'L619',
  'VALLE SAN SILVESTRO * VAHLEN': 'L621',
  'VALLE SUPERIORE MOSSO': 'L622',
  'VALLONARA': 'L630',
  'VALLORIA MARITTIMA': 'L632',
  'VALMAGGIA': 'L635',
  'VAL MARCHIROLO': 'L637',
  'VALPRATO': 'L645',
  'VALROVINA': 'L646',
  'VALSAVIORE': 'L648',
  'VALTESSE': 'L652',
  'VANDOIES DI SOPRA * OBERVINTL': 'L661',
  'VANDOIES DI SOTTO * NIEDERVINTL': 'L662',
  'VANGA * WANGEN': 'L663',
  'VARARO': 'L674',
  'VARENGO': 'L679',
  'VARGO': 'L683',
  'VARIGOTTI': 'L684',
  'VARONI': 'L688',
  'VASIO': 'L694',
  'VASSENA': 'L695',
  'VECCANA': 'L701',
  'VEDUGGIO': 'L708',
  'VELATE': 'L714',
  'VELLANO': 'L717',
  'VELLEGO': 'L718',
  'VELLO': 'L721',
  'VENEGONO': 'L732',
  'VERDERIO': 'L754',
  'VERDESINA': 'L757',
  'VEREZZI': 'L759',
  'VILLA VERGANO': 'L760',
  'VERGANO NOVARESE': 'L761',
  'VERGO': 'L766',
  'VERGOBBIO': 'L767',
  'VERNA': 'L770',
  'VERPOGLIANO': 'L782',
  'VERRUA SICCOMARIO': 'L786',
  'VERSA': 'L789',
  'VERSCIAGO * VIERSCHACH': 'L790',
  'VERTEMATE': 'L791',
  'VERTENEGLIO': 'L793',
  'VERTOIBA IN CAMPI': 'L794',
  'VERTOVINO': 'L796',
  'VERZI PIETRA': 'L803',
  'VEZZANO * VEZZAN': 'L818',
  'VEZZI': 'L822',
  'VEZZO': 'L824',
  'VHO': 'L825',
  'VIARAGO': 'L832',
  'VICENO': 'L839',
  'VICONAGO': 'L849',
  'VIDARDO': 'L852',
  'VIDICETO CON GURATA': 'L853',
  'VIDOLASCO': 'L855',
  'VIGADORE': 'L861',
  'VIGALFO': 'L862',
  'VIGALZANO': 'L863',
  'VIGANO CERTOSINO': 'L867',
  'VIGATTO': 'L870',
  'VIGENTINO': 'L871',
  'VIGGIONA': 'L875',
  'VIGHIZZOLO': 'L877',
  'VIGO D\'ANAUNIA': 'L891',
  'VIGOLO BASELGA': 'L895',
  'VIGONZINO': 'L901',
  'VIGONZONE': 'L902',
  'VILLA BANALE': 'L911',
  'VILLABASSA': 'L914',
  'VILLA D\'ADIGE': 'L918',
  'VILLA CASTELNUOVO': 'L921',
  'VILLA COGOZZO': 'L925',
  'VILLA CORSIONE': 'L927',
  'VILLA D\'ALLEGNO': 'L930',
  'VILLA DECANI': 'L932',
  'VILLA DEL NEVOSO': 'L935',
  'VILLA DOSIA': 'L940',
  'VILLA OTTONE * UTTENHEIM': 'L941',
  'VILLAGRECA': 'L954',
  'VILL\'ALBESE': 'L960',
  'VILLALUNGA': 'L962',
  'VILLANOVA VIMERCATE': 'L976',
  'VILLANOVAVETTA': 'L993',
  'VILLA PIZZONE': 'L996',
  'VILLA POMPEIANA': 'L997',
  'VILLA RAVERIO': 'M001',
  'VILLAREGGIO': 'M005',
  'VILLAROCCA': 'M008',
  'VILLA ROMANO': 'M010',
  'VILLA ROSSA': 'M012',
  'VILLA SANTA CATERINA * AUFHOFEN': 'M020',
  'VILLA SLAVINA': 'M024',
  'VILLA TALLA': 'M029',
  'VILLA VIANI': 'M033',
  'VILLA VOLTURNO': 'M035',
  'VILLAZZANO': 'M036',
  'VILLE DEL MONTE': 'M037',
  'VILLE MONTEVECCHIO': 'M038',
  'VILLE SAN PIETRO': 'M039',
  'VILLE SAN SEBASTIANO': 'M040',
  'VILLONGO SAN FILASTRO': 'M046',
  'VILLONGO SANT\'ALESSANDRO': 'M047',
  'VILMINORE': 'M049',
  'VIMANONE': 'M051',
  'VIMOGNO': 'M054',
  'VINAGO': 'M056',
  'VINTEBBIO': 'M061',
  'VION': 'M064',
  'VIPACCO': 'M066',
  'VIRLE TRE PONTI': 'M068',
  'VISIGNANO': 'M074',
  'VISINADA': 'M075',
  'VISINO': 'M076',
  'VITICUSO E ACQUAFONDATA': 'M084',
  'VITTADONE': 'M087',
  'VIVENTE': 'M097',
  'VIZZE * PFITSCH': 'M099',
  'VOCOGNO E PRESTINONE': 'M107',
  'VOISSIZZA DI COMENO': 'M112',
  'VOLDOMINO': 'M114',
  'VOLOSCA': 'M117',
  'VOLTORRE': 'M128',
  'VOLTRI': 'M129',
  'VOLZANA': 'M134',
  'VOSCHIA': 'M135',
  'XITTA': 'M137',
  'ZANENGO': 'M146',
  'ZAPPELLO CON BOLZONE': 'M148',
  'ZARA': 'M149',
  'ZAVATTARELLO VALVERDE': 'M151',
  'ZELARINO': 'M154',
  'ZELATA': 'M155',
  'ZELBIO VELESO': 'M157',
  'ZELO FORAMAGNO': 'M159',
  'ZEPPARA': 'M164',
  'ZIBIDO AL LAMBRO': 'M175',
  'ZIVIDO': 'M181',
  'ZOLLA': 'M186',
  'ZORLESCO': 'M191',
  'ZORNASCO': 'M192',
  'ZORZINO': 'M193',
  'ZOVERALLO': 'M195',
  'ZUNICO': 'M205',
  'ZURI': 'M206',
  'BALBIDO': 'M215',
  'BALLINO': 'M216',
  'BARCESINO': 'M217',
  'BONDONE STORO': 'M218',
  'BRANCOLINO': 'M220',
  'BRUSINO': 'M221',
  'CARES': 'M223',
  'CASANOVA DEL MORBASCO': 'M224',
  'CASTELPIETRA': 'M225',
  'CAVRASTO': 'M226',
  'COMIGHELLO': 'M227',
  'DASINDO': 'M228',
  'DUVREDO': 'M229',
  'FAVRIO': 'M230',
  'GODENZO': 'M231',
  'LAGUNA MUSTE\'': 'M232',
  'LARIDO': 'M233',
  'LASES': 'M234',
  'LONA': 'M235',
  'MADICE': 'M236',
  'MALA': 'M237',
  'MENAS': 'M238',
  'MONTEVACCINO': 'M239',
  'ORTISE\'': 'M240',
  'POIA': 'M241',
  'RANGO': 'M242',
  'RONCHI DI ALA': 'M243',
  'SAVIGNANO': 'M245',
  'STRAVINO': 'M246',
  'TIGNERONE': 'M247',
  'VARANO': 'M248',
  'VIGO CAVEDINE': 'M249',
  'VIGO LOMASO': 'M250',
  'VILLAMONTAGNA': 'M251',
  'CREDERA CON ROVERETO': 'M252',
  'VAL SANTAMARINA': 'M254',
  'VEGLIA': 'M293',
  'PIEMONTE D\'ISTRIA': 'M296',
  'BOVILLE': 'M299',
  'ALME\' CON VILLA': 'M305',
  'COLLE ISARCO * GOSSENSASS': 'M306',
  'RASUN VALDAORA * RASEN OLANG': 'M307',
  'SEBENICO': 'M310',
  'LONATO DEL GARDA': 'M312',
  'VALSAMOGGIA': 'M320'
} as Record<string, string>